var immanens = immanens || {}; immanens["pv5"] = immanens["pv5"] || {}; immanens["pv5"]["ReaderBnd"] =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 15);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Backbone.js 1.3.3

//     (c) 2010-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Backbone may be freely distributed under the MIT license.
//     For all details and documentation:
//     http://backbonejs.org

(function(factory) {

  // Establish the root object, `window` (`self`) in the browser, or `global` on the server.
  // We use `self` instead of `window` for `WebWorker` support.
  var root = (typeof self == 'object' && self.self === self && self) ||
            (typeof global == 'object' && global.global === global && global);

  // Set up Backbone appropriately for the environment. Start with AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(0), __webpack_require__(3), exports], __WEBPACK_AMD_DEFINE_RESULT__ = (function(_, $, exports) {
      // Export global even in AMD case in case this script is loaded with
      // others that may still expect a global Backbone.
      root.Backbone = factory(root, exports, _, $);
    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Next for Node.js or CommonJS. jQuery may not be needed as a module.
  } else if (typeof exports !== 'undefined') {
    var _ = require('underscore'), $;
    try { $ = require('jquery'); } catch (e) {}
    factory(root, exports, _, $);

  // Finally, as a browser global.
  } else {
    root.Backbone = factory(root, {}, root._, (root.jQuery || root.Zepto || root.ender || root.$));
  }

})(function(root, Backbone, _, $) {

  // Initial Setup
  // -------------

  // Save the previous value of the `Backbone` variable, so that it can be
  // restored later on, if `noConflict` is used.
  var previousBackbone = root.Backbone;

  // Create a local reference to a common array method we'll want to use later.
  var slice = Array.prototype.slice;

  // Current version of the library. Keep in sync with `package.json`.
  Backbone.VERSION = '1.3.3';

  // For Backbone's purposes, jQuery, Zepto, Ender, or My Library (kidding) owns
  // the `$` variable.
  Backbone.$ = $;

  // Runs Backbone.js in *noConflict* mode, returning the `Backbone` variable
  // to its previous owner. Returns a reference to this Backbone object.
  Backbone.noConflict = function() {
    root.Backbone = previousBackbone;
    return this;
  };

  // Turn on `emulateHTTP` to support legacy HTTP servers. Setting this option
  // will fake `"PATCH"`, `"PUT"` and `"DELETE"` requests via the `_method` parameter and
  // set a `X-Http-Method-Override` header.
  Backbone.emulateHTTP = false;

  // Turn on `emulateJSON` to support legacy servers that can't deal with direct
  // `application/json` requests ... this will encode the body as
  // `application/x-www-form-urlencoded` instead and will send the model in a
  // form param named `model`.
  Backbone.emulateJSON = false;

  // Proxy Backbone class methods to Underscore functions, wrapping the model's
  // `attributes` object or collection's `models` array behind the scenes.
  //
  // collection.filter(function(model) { return model.get('age') > 10 });
  // collection.each(this.addView);
  //
  // `Function#apply` can be slow so we use the method's arg count, if we know it.
  var addMethod = function(length, method, attribute) {
    switch (length) {
      case 1: return function() {
        return _[method](this[attribute]);
      };
      case 2: return function(value) {
        return _[method](this[attribute], value);
      };
      case 3: return function(iteratee, context) {
        return _[method](this[attribute], cb(iteratee, this), context);
      };
      case 4: return function(iteratee, defaultVal, context) {
        return _[method](this[attribute], cb(iteratee, this), defaultVal, context);
      };
      default: return function() {
        var args = slice.call(arguments);
        args.unshift(this[attribute]);
        return _[method].apply(_, args);
      };
    }
  };
  var addUnderscoreMethods = function(Class, methods, attribute) {
    _.each(methods, function(length, method) {
      if (_[method]) Class.prototype[method] = addMethod(length, method, attribute);
    });
  };

  // Support `collection.sortBy('attr')` and `collection.findWhere({id: 1})`.
  var cb = function(iteratee, instance) {
    if (_.isFunction(iteratee)) return iteratee;
    if (_.isObject(iteratee) && !instance._isModel(iteratee)) return modelMatcher(iteratee);
    if (_.isString(iteratee)) return function(model) { return model.get(iteratee); };
    return iteratee;
  };
  var modelMatcher = function(attrs) {
    var matcher = _.matches(attrs);
    return function(model) {
      return matcher(model.attributes);
    };
  };

  // Backbone.Events
  // ---------------

  // A module that can be mixed in to *any object* in order to provide it with
  // a custom event channel. You may bind a callback to an event with `on` or
  // remove with `off`; `trigger`-ing an event fires all callbacks in
  // succession.
  //
  //     var object = {};
  //     _.extend(object, Backbone.Events);
  //     object.on('expand', function(){ alert('expanded'); });
  //     object.trigger('expand');
  //
  var Events = Backbone.Events = {};

  // Regular expression used to split event strings.
  var eventSplitter = /\s+/;

  // Iterates over the standard `event, callback` (as well as the fancy multiple
  // space-separated events `"change blur", callback` and jQuery-style event
  // maps `{event: callback}`).
  var eventsApi = function(iteratee, events, name, callback, opts) {
    var i = 0, names;
    if (name && typeof name === 'object') {
      // Handle event maps.
      if (callback !== void 0 && 'context' in opts && opts.context === void 0) opts.context = callback;
      for (names = _.keys(name); i < names.length ; i++) {
        events = eventsApi(iteratee, events, names[i], name[names[i]], opts);
      }
    } else if (name && eventSplitter.test(name)) {
      // Handle space-separated event names by delegating them individually.
      for (names = name.split(eventSplitter); i < names.length; i++) {
        events = iteratee(events, names[i], callback, opts);
      }
    } else {
      // Finally, standard events.
      events = iteratee(events, name, callback, opts);
    }
    return events;
  };

  // Bind an event to a `callback` function. Passing `"all"` will bind
  // the callback to all events fired.
  Events.on = function(name, callback, context) {
    return internalOn(this, name, callback, context);
  };

  // Guard the `listening` argument from the public API.
  var internalOn = function(obj, name, callback, context, listening) {
    obj._events = eventsApi(onApi, obj._events || {}, name, callback, {
      context: context,
      ctx: obj,
      listening: listening
    });

    if (listening) {
      var listeners = obj._listeners || (obj._listeners = {});
      listeners[listening.id] = listening;
    }

    return obj;
  };

  // Inversion-of-control versions of `on`. Tell *this* object to listen to
  // an event in another object... keeping track of what it's listening to
  // for easier unbinding later.
  Events.listenTo = function(obj, name, callback) {
    if (!obj) return this;
    var id = obj._listenId || (obj._listenId = _.uniqueId('l'));
    var listeningTo = this._listeningTo || (this._listeningTo = {});
    var listening = listeningTo[id];

    // This object is not listening to any other events on `obj` yet.
    // Setup the necessary references to track the listening callbacks.
    if (!listening) {
      var thisId = this._listenId || (this._listenId = _.uniqueId('l'));
      listening = listeningTo[id] = {obj: obj, objId: id, id: thisId, listeningTo: listeningTo, count: 0};
    }

    // Bind callbacks on obj, and keep track of them on listening.
    internalOn(obj, name, callback, this, listening);
    return this;
  };

  // The reducing API that adds a callback to the `events` object.
  var onApi = function(events, name, callback, options) {
    if (callback) {
      var handlers = events[name] || (events[name] = []);
      var context = options.context, ctx = options.ctx, listening = options.listening;
      if (listening) listening.count++;

      handlers.push({callback: callback, context: context, ctx: context || ctx, listening: listening});
    }
    return events;
  };

  // Remove one or many callbacks. If `context` is null, removes all
  // callbacks with that function. If `callback` is null, removes all
  // callbacks for the event. If `name` is null, removes all bound
  // callbacks for all events.
  Events.off = function(name, callback, context) {
    if (!this._events) return this;
    this._events = eventsApi(offApi, this._events, name, callback, {
      context: context,
      listeners: this._listeners
    });
    return this;
  };

  // Tell this object to stop listening to either specific events ... or
  // to every object it's currently listening to.
  Events.stopListening = function(obj, name, callback) {
    var listeningTo = this._listeningTo;
    if (!listeningTo) return this;

    var ids = obj ? [obj._listenId] : _.keys(listeningTo);

    for (var i = 0; i < ids.length; i++) {
      var listening = listeningTo[ids[i]];

      // If listening doesn't exist, this object is not currently
      // listening to obj. Break out early.
      if (!listening) break;

      listening.obj.off(name, callback, this);
    }

    return this;
  };

  // The reducing API that removes a callback from the `events` object.
  var offApi = function(events, name, callback, options) {
    if (!events) return;

    var i = 0, listening;
    var context = options.context, listeners = options.listeners;

    // Delete all events listeners and "drop" events.
    if (!name && !callback && !context) {
      var ids = _.keys(listeners);
      for (; i < ids.length; i++) {
        listening = listeners[ids[i]];
        delete listeners[listening.id];
        delete listening.listeningTo[listening.objId];
      }
      return;
    }

    var names = name ? [name] : _.keys(events);
    for (; i < names.length; i++) {
      name = names[i];
      var handlers = events[name];

      // Bail out if there are no events stored.
      if (!handlers) break;

      // Replace events if there are any remaining.  Otherwise, clean up.
      var remaining = [];
      for (var j = 0; j < handlers.length; j++) {
        var handler = handlers[j];
        if (
          callback && callback !== handler.callback &&
            callback !== handler.callback._callback ||
              context && context !== handler.context
        ) {
          remaining.push(handler);
        } else {
          listening = handler.listening;
          if (listening && --listening.count === 0) {
            delete listeners[listening.id];
            delete listening.listeningTo[listening.objId];
          }
        }
      }

      // Update tail event if the list has any events.  Otherwise, clean up.
      if (remaining.length) {
        events[name] = remaining;
      } else {
        delete events[name];
      }
    }
    return events;
  };

  // Bind an event to only be triggered a single time. After the first time
  // the callback is invoked, its listener will be removed. If multiple events
  // are passed in using the space-separated syntax, the handler will fire
  // once for each event, not once for a combination of all events.
  Events.once = function(name, callback, context) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.off, this));
    if (typeof name === 'string' && context == null) callback = void 0;
    return this.on(events, callback, context);
  };

  // Inversion-of-control versions of `once`.
  Events.listenToOnce = function(obj, name, callback) {
    // Map the event into a `{event: once}` object.
    var events = eventsApi(onceMap, {}, name, callback, _.bind(this.stopListening, this, obj));
    return this.listenTo(obj, events);
  };

  // Reduces the event callbacks into a map of `{event: onceWrapper}`.
  // `offer` unbinds the `onceWrapper` after it has been called.
  var onceMap = function(map, name, callback, offer) {
    if (callback) {
      var once = map[name] = _.once(function() {
        offer(name, once);
        callback.apply(this, arguments);
      });
      once._callback = callback;
    }
    return map;
  };

  // Trigger one or many events, firing all bound callbacks. Callbacks are
  // passed the same arguments as `trigger` is, apart from the event name
  // (unless you're listening on `"all"`, which will cause your callback to
  // receive the true name of the event as the first argument).
  Events.trigger = function(name) {
    if (!this._events) return this;

    var length = Math.max(0, arguments.length - 1);
    var args = Array(length);
    for (var i = 0; i < length; i++) args[i] = arguments[i + 1];

    eventsApi(triggerApi, this._events, name, void 0, args);
    return this;
  };

  // Handles triggering the appropriate event callbacks.
  var triggerApi = function(objEvents, name, callback, args) {
    if (objEvents) {
      var events = objEvents[name];
      var allEvents = objEvents.all;
      if (events && allEvents) allEvents = allEvents.slice();
      if (events) triggerEvents(events, args);
      if (allEvents) triggerEvents(allEvents, [name].concat(args));
    }
    return objEvents;
  };

  // A difficult-to-believe, but optimized internal dispatch function for
  // triggering events. Tries to keep the usual cases speedy (most internal
  // Backbone events have 3 arguments).
  var triggerEvents = function(events, args) {
    var ev, i = -1, l = events.length, a1 = args[0], a2 = args[1], a3 = args[2];
    switch (args.length) {
      case 0: while (++i < l) (ev = events[i]).callback.call(ev.ctx); return;
      case 1: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1); return;
      case 2: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2); return;
      case 3: while (++i < l) (ev = events[i]).callback.call(ev.ctx, a1, a2, a3); return;
      default: while (++i < l) (ev = events[i]).callback.apply(ev.ctx, args); return;
    }
  };

  // Aliases for backwards compatibility.
  Events.bind   = Events.on;
  Events.unbind = Events.off;

  // Allow the `Backbone` object to serve as a global event bus, for folks who
  // want global "pubsub" in a convenient place.
  _.extend(Backbone, Events);

  // Backbone.Model
  // --------------

  // Backbone **Models** are the basic data object in the framework --
  // frequently representing a row in a table in a database on your server.
  // A discrete chunk of data and a bunch of useful, related methods for
  // performing computations and transformations on that data.

  // Create a new model with the specified attributes. A client id (`cid`)
  // is automatically generated and assigned for you.
  var Model = Backbone.Model = function(attributes, options) {
    var attrs = attributes || {};
    options || (options = {});
    this.cid = _.uniqueId(this.cidPrefix);
    this.attributes = {};
    if (options.collection) this.collection = options.collection;
    if (options.parse) attrs = this.parse(attrs, options) || {};
    var defaults = _.result(this, 'defaults');
    attrs = _.defaults(_.extend({}, defaults, attrs), defaults);
    this.set(attrs, options);
    this.changed = {};
    this.initialize.apply(this, arguments);
  };

  // Attach all inheritable methods to the Model prototype.
  _.extend(Model.prototype, Events, {

    // A hash of attributes whose current and previous value differ.
    changed: null,

    // The value returned during the last failed validation.
    validationError: null,

    // The default name for the JSON `id` attribute is `"id"`. MongoDB and
    // CouchDB users may want to set this to `"_id"`.
    idAttribute: 'id',

    // The prefix is used to create the client id which is used to identify models locally.
    // You may want to override this if you're experiencing name clashes with model ids.
    cidPrefix: 'c',

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Return a copy of the model's `attributes` object.
    toJSON: function(options) {
      return _.clone(this.attributes);
    },

    // Proxy `Backbone.sync` by default -- but override this if you need
    // custom syncing semantics for *this* particular model.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Get the value of an attribute.
    get: function(attr) {
      return this.attributes[attr];
    },

    // Get the HTML-escaped value of an attribute.
    escape: function(attr) {
      return _.escape(this.get(attr));
    },

    // Returns `true` if the attribute contains a value that is not null
    // or undefined.
    has: function(attr) {
      return this.get(attr) != null;
    },

    // Special-cased proxy to underscore's `_.matches` method.
    matches: function(attrs) {
      return !!_.iteratee(attrs, this)(this.attributes);
    },

    // Set a hash of model attributes on the object, firing `"change"`. This is
    // the core primitive operation of a model, updating the data and notifying
    // anyone who needs to know about the change in state. The heart of the beast.
    set: function(key, val, options) {
      if (key == null) return this;

      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options || (options = {});

      // Run validation.
      if (!this._validate(attrs, options)) return false;

      // Extract attributes and options.
      var unset      = options.unset;
      var silent     = options.silent;
      var changes    = [];
      var changing   = this._changing;
      this._changing = true;

      if (!changing) {
        this._previousAttributes = _.clone(this.attributes);
        this.changed = {};
      }

      var current = this.attributes;
      var changed = this.changed;
      var prev    = this._previousAttributes;

      // For each `set` attribute, update or delete the current value.
      for (var attr in attrs) {
        val = attrs[attr];
        if (!_.isEqual(current[attr], val)) changes.push(attr);
        if (!_.isEqual(prev[attr], val)) {
          changed[attr] = val;
        } else {
          delete changed[attr];
        }
        unset ? delete current[attr] : current[attr] = val;
      }

      // Update the `id`.
      if (this.idAttribute in attrs) this.id = this.get(this.idAttribute);

      // Trigger all relevant attribute changes.
      if (!silent) {
        if (changes.length) this._pending = options;
        for (var i = 0; i < changes.length; i++) {
          this.trigger('change:' + changes[i], this, current[changes[i]], options);
        }
      }

      // You might be wondering why there's a `while` loop here. Changes can
      // be recursively nested within `"change"` events.
      if (changing) return this;
      if (!silent) {
        while (this._pending) {
          options = this._pending;
          this._pending = false;
          this.trigger('change', this, options);
        }
      }
      this._pending = false;
      this._changing = false;
      return this;
    },

    // Remove an attribute from the model, firing `"change"`. `unset` is a noop
    // if the attribute doesn't exist.
    unset: function(attr, options) {
      return this.set(attr, void 0, _.extend({}, options, {unset: true}));
    },

    // Clear all attributes on the model, firing `"change"`.
    clear: function(options) {
      var attrs = {};
      for (var key in this.attributes) attrs[key] = void 0;
      return this.set(attrs, _.extend({}, options, {unset: true}));
    },

    // Determine if the model has changed since the last `"change"` event.
    // If you specify an attribute name, determine if that attribute has changed.
    hasChanged: function(attr) {
      if (attr == null) return !_.isEmpty(this.changed);
      return _.has(this.changed, attr);
    },

    // Return an object containing all the attributes that have changed, or
    // false if there are no changed attributes. Useful for determining what
    // parts of a view need to be updated and/or what attributes need to be
    // persisted to the server. Unset attributes will be set to undefined.
    // You can also pass an attributes object to diff against the model,
    // determining if there *would be* a change.
    changedAttributes: function(diff) {
      if (!diff) return this.hasChanged() ? _.clone(this.changed) : false;
      var old = this._changing ? this._previousAttributes : this.attributes;
      var changed = {};
      for (var attr in diff) {
        var val = diff[attr];
        if (_.isEqual(old[attr], val)) continue;
        changed[attr] = val;
      }
      return _.size(changed) ? changed : false;
    },

    // Get the previous value of an attribute, recorded at the time the last
    // `"change"` event was fired.
    previous: function(attr) {
      if (attr == null || !this._previousAttributes) return null;
      return this._previousAttributes[attr];
    },

    // Get all of the attributes of the model at the time of the previous
    // `"change"` event.
    previousAttributes: function() {
      return _.clone(this._previousAttributes);
    },

    // Fetch the model from the server, merging the response with the model's
    // local attributes. Any changed attributes will trigger a "change" event.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var model = this;
      var success = options.success;
      options.success = function(resp) {
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (!model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Set a hash of model attributes, and sync the model to the server.
    // If the server returns an attributes hash that differs, the model's
    // state will be `set` again.
    save: function(key, val, options) {
      // Handle both `"key", value` and `{key: value}` -style arguments.
      var attrs;
      if (key == null || typeof key === 'object') {
        attrs = key;
        options = val;
      } else {
        (attrs = {})[key] = val;
      }

      options = _.extend({validate: true, parse: true}, options);
      var wait = options.wait;

      // If we're not waiting and attributes exist, save acts as
      // `set(attr).save(null, opts)` with validation. Otherwise, check if
      // the model will be valid when the attributes, if any, are set.
      if (attrs && !wait) {
        if (!this.set(attrs, options)) return false;
      } else if (!this._validate(attrs, options)) {
        return false;
      }

      // After a successful server-side save, the client is (optionally)
      // updated with the server-side state.
      var model = this;
      var success = options.success;
      var attributes = this.attributes;
      options.success = function(resp) {
        // Ensure attributes are restored during synchronous saves.
        model.attributes = attributes;
        var serverAttrs = options.parse ? model.parse(resp, options) : resp;
        if (wait) serverAttrs = _.extend({}, attrs, serverAttrs);
        if (serverAttrs && !model.set(serverAttrs, options)) return false;
        if (success) success.call(options.context, model, resp, options);
        model.trigger('sync', model, resp, options);
      };
      wrapError(this, options);

      // Set temporary attributes if `{wait: true}` to properly find new ids.
      if (attrs && wait) this.attributes = _.extend({}, attributes, attrs);

      var method = this.isNew() ? 'create' : (options.patch ? 'patch' : 'update');
      if (method === 'patch' && !options.attrs) options.attrs = attrs;
      var xhr = this.sync(method, this, options);

      // Restore attributes.
      this.attributes = attributes;

      return xhr;
    },

    // Destroy this model on the server if it was already persisted.
    // Optimistically removes the model from its collection, if it has one.
    // If `wait: true` is passed, waits for the server to respond before removal.
    destroy: function(options) {
      options = options ? _.clone(options) : {};
      var model = this;
      var success = options.success;
      var wait = options.wait;

      var destroy = function() {
        model.stopListening();
        model.trigger('destroy', model, model.collection, options);
      };

      options.success = function(resp) {
        if (wait) destroy();
        if (success) success.call(options.context, model, resp, options);
        if (!model.isNew()) model.trigger('sync', model, resp, options);
      };

      var xhr = false;
      if (this.isNew()) {
        _.defer(options.success);
      } else {
        wrapError(this, options);
        xhr = this.sync('delete', this, options);
      }
      if (!wait) destroy();
      return xhr;
    },

    // Default URL for the model's representation on the server -- if you're
    // using Backbone's restful methods, override this to change the endpoint
    // that will be called.
    url: function() {
      var base =
        _.result(this, 'urlRoot') ||
        _.result(this.collection, 'url') ||
        urlError();
      if (this.isNew()) return base;
      var id = this.get(this.idAttribute);
      return base.replace(/[^\/]$/, '$&/') + encodeURIComponent(id);
    },

    // **parse** converts a response into the hash of attributes to be `set` on
    // the model. The default implementation is just to pass the response along.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new model with identical attributes to this one.
    clone: function() {
      return new this.constructor(this.attributes);
    },

    // A model is new if it has never been saved to the server, and lacks an id.
    isNew: function() {
      return !this.has(this.idAttribute);
    },

    // Check if the model is currently in a valid state.
    isValid: function(options) {
      return this._validate({}, _.extend({}, options, {validate: true}));
    },

    // Run validation against the next complete set of model attributes,
    // returning `true` if all is well. Otherwise, fire an `"invalid"` event.
    _validate: function(attrs, options) {
      if (!options.validate || !this.validate) return true;
      attrs = _.extend({}, this.attributes, attrs);
      var error = this.validationError = this.validate(attrs, options) || null;
      if (!error) return true;
      this.trigger('invalid', this, error, _.extend(options, {validationError: error}));
      return false;
    }

  });

  // Underscore methods that we want to implement on the Model, mapped to the
  // number of arguments they take.
  var modelMethods = {keys: 1, values: 1, pairs: 1, invert: 1, pick: 0,
      omit: 0, chain: 1, isEmpty: 1};

  // Mix in each Underscore method as a proxy to `Model#attributes`.
  addUnderscoreMethods(Model, modelMethods, 'attributes');

  // Backbone.Collection
  // -------------------

  // If models tend to represent a single row of data, a Backbone Collection is
  // more analogous to a table full of data ... or a small slice or page of that
  // table, or a collection of rows that belong together for a particular reason
  // -- all of the messages in this particular folder, all of the documents
  // belonging to this particular author, and so on. Collections maintain
  // indexes of their models, both in order, and for lookup by `id`.

  // Create a new **Collection**, perhaps to contain a specific type of `model`.
  // If a `comparator` is specified, the Collection will maintain
  // its models in sort order, as they're added and removed.
  var Collection = Backbone.Collection = function(models, options) {
    options || (options = {});
    if (options.model) this.model = options.model;
    if (options.comparator !== void 0) this.comparator = options.comparator;
    this._reset();
    this.initialize.apply(this, arguments);
    if (models) this.reset(models, _.extend({silent: true}, options));
  };

  // Default options for `Collection#set`.
  var setOptions = {add: true, remove: true, merge: true};
  var addOptions = {add: true, remove: false};

  // Splices `insert` into `array` at index `at`.
  var splice = function(array, insert, at) {
    at = Math.min(Math.max(at, 0), array.length);
    var tail = Array(array.length - at);
    var length = insert.length;
    var i;
    for (i = 0; i < tail.length; i++) tail[i] = array[i + at];
    for (i = 0; i < length; i++) array[i + at] = insert[i];
    for (i = 0; i < tail.length; i++) array[i + length + at] = tail[i];
  };

  // Define the Collection's inheritable methods.
  _.extend(Collection.prototype, Events, {

    // The default model for a collection is just a **Backbone.Model**.
    // This should be overridden in most cases.
    model: Model,

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // The JSON representation of a Collection is an array of the
    // models' attributes.
    toJSON: function(options) {
      return this.map(function(model) { return model.toJSON(options); });
    },

    // Proxy `Backbone.sync` by default.
    sync: function() {
      return Backbone.sync.apply(this, arguments);
    },

    // Add a model, or list of models to the set. `models` may be Backbone
    // Models or raw JavaScript objects to be converted to Models, or any
    // combination of the two.
    add: function(models, options) {
      return this.set(models, _.extend({merge: false}, options, addOptions));
    },

    // Remove a model, or a list of models from the set.
    remove: function(models, options) {
      options = _.extend({}, options);
      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();
      var removed = this._removeModels(models, options);
      if (!options.silent && removed.length) {
        options.changes = {added: [], merged: [], removed: removed};
        this.trigger('update', this, options);
      }
      return singular ? removed[0] : removed;
    },

    // Update a collection by `set`-ing a new list of models, adding new ones,
    // removing models that are no longer present, and merging models that
    // already exist in the collection, as necessary. Similar to **Model#set**,
    // the core operation for updating the data contained by the collection.
    set: function(models, options) {
      if (models == null) return;

      options = _.extend({}, setOptions, options);
      if (options.parse && !this._isModel(models)) {
        models = this.parse(models, options) || [];
      }

      var singular = !_.isArray(models);
      models = singular ? [models] : models.slice();

      var at = options.at;
      if (at != null) at = +at;
      if (at > this.length) at = this.length;
      if (at < 0) at += this.length + 1;

      var set = [];
      var toAdd = [];
      var toMerge = [];
      var toRemove = [];
      var modelMap = {};

      var add = options.add;
      var merge = options.merge;
      var remove = options.remove;

      var sort = false;
      var sortable = this.comparator && at == null && options.sort !== false;
      var sortAttr = _.isString(this.comparator) ? this.comparator : null;

      // Turn bare objects into model references, and prevent invalid models
      // from being added.
      var model, i;
      for (i = 0; i < models.length; i++) {
        model = models[i];

        // If a duplicate is found, prevent it from being added and
        // optionally merge it into the existing model.
        var existing = this.get(model);
        if (existing) {
          if (merge && model !== existing) {
            var attrs = this._isModel(model) ? model.attributes : model;
            if (options.parse) attrs = existing.parse(attrs, options);
            existing.set(attrs, options);
            toMerge.push(existing);
            if (sortable && !sort) sort = existing.hasChanged(sortAttr);
          }
          if (!modelMap[existing.cid]) {
            modelMap[existing.cid] = true;
            set.push(existing);
          }
          models[i] = existing;

        // If this is a new, valid model, push it to the `toAdd` list.
        } else if (add) {
          model = models[i] = this._prepareModel(model, options);
          if (model) {
            toAdd.push(model);
            this._addReference(model, options);
            modelMap[model.cid] = true;
            set.push(model);
          }
        }
      }

      // Remove stale models.
      if (remove) {
        for (i = 0; i < this.length; i++) {
          model = this.models[i];
          if (!modelMap[model.cid]) toRemove.push(model);
        }
        if (toRemove.length) this._removeModels(toRemove, options);
      }

      // See if sorting is needed, update `length` and splice in new models.
      var orderChanged = false;
      var replace = !sortable && add && remove;
      if (set.length && replace) {
        orderChanged = this.length !== set.length || _.some(this.models, function(m, index) {
          return m !== set[index];
        });
        this.models.length = 0;
        splice(this.models, set, 0);
        this.length = this.models.length;
      } else if (toAdd.length) {
        if (sortable) sort = true;
        splice(this.models, toAdd, at == null ? this.length : at);
        this.length = this.models.length;
      }

      // Silently sort the collection if appropriate.
      if (sort) this.sort({silent: true});

      // Unless silenced, it's time to fire all appropriate add/sort/update events.
      if (!options.silent) {
        for (i = 0; i < toAdd.length; i++) {
          if (at != null) options.index = at + i;
          model = toAdd[i];
          model.trigger('add', model, this, options);
        }
        if (sort || orderChanged) this.trigger('sort', this, options);
        if (toAdd.length || toRemove.length || toMerge.length) {
          options.changes = {
            added: toAdd,
            removed: toRemove,
            merged: toMerge
          };
          this.trigger('update', this, options);
        }
      }

      // Return the added (or merged) model (or models).
      return singular ? models[0] : models;
    },

    // When you have more items than you want to add or remove individually,
    // you can reset the entire set with a new list of models, without firing
    // any granular `add` or `remove` events. Fires `reset` when finished.
    // Useful for bulk operations and optimizations.
    reset: function(models, options) {
      options = options ? _.clone(options) : {};
      for (var i = 0; i < this.models.length; i++) {
        this._removeReference(this.models[i], options);
      }
      options.previousModels = this.models;
      this._reset();
      models = this.add(models, _.extend({silent: true}, options));
      if (!options.silent) this.trigger('reset', this, options);
      return models;
    },

    // Add a model to the end of the collection.
    push: function(model, options) {
      return this.add(model, _.extend({at: this.length}, options));
    },

    // Remove a model from the end of the collection.
    pop: function(options) {
      var model = this.at(this.length - 1);
      return this.remove(model, options);
    },

    // Add a model to the beginning of the collection.
    unshift: function(model, options) {
      return this.add(model, _.extend({at: 0}, options));
    },

    // Remove a model from the beginning of the collection.
    shift: function(options) {
      var model = this.at(0);
      return this.remove(model, options);
    },

    // Slice out a sub-array of models from the collection.
    slice: function() {
      return slice.apply(this.models, arguments);
    },

    // Get a model from the set by id, cid, model object with id or cid
    // properties, or an attributes object that is transformed through modelId.
    get: function(obj) {
      if (obj == null) return void 0;
      return this._byId[obj] ||
        this._byId[this.modelId(obj.attributes || obj)] ||
        obj.cid && this._byId[obj.cid];
    },

    // Returns `true` if the model is in the collection.
    has: function(obj) {
      return this.get(obj) != null;
    },

    // Get the model at the given index.
    at: function(index) {
      if (index < 0) index += this.length;
      return this.models[index];
    },

    // Return models with matching attributes. Useful for simple cases of
    // `filter`.
    where: function(attrs, first) {
      return this[first ? 'find' : 'filter'](attrs);
    },

    // Return the first model with matching attributes. Useful for simple cases
    // of `find`.
    findWhere: function(attrs) {
      return this.where(attrs, true);
    },

    // Force the collection to re-sort itself. You don't need to call this under
    // normal circumstances, as the set will maintain sort order as each item
    // is added.
    sort: function(options) {
      var comparator = this.comparator;
      if (!comparator) throw new Error('Cannot sort a set without a comparator');
      options || (options = {});

      var length = comparator.length;
      if (_.isFunction(comparator)) comparator = _.bind(comparator, this);

      // Run sort based on type of `comparator`.
      if (length === 1 || _.isString(comparator)) {
        this.models = this.sortBy(comparator);
      } else {
        this.models.sort(comparator);
      }
      if (!options.silent) this.trigger('sort', this, options);
      return this;
    },

    // Pluck an attribute from each model in the collection.
    pluck: function(attr) {
      return this.map(attr + '');
    },

    // Fetch the default set of models for this collection, resetting the
    // collection when they arrive. If `reset: true` is passed, the response
    // data will be passed through the `reset` method instead of `set`.
    fetch: function(options) {
      options = _.extend({parse: true}, options);
      var success = options.success;
      var collection = this;
      options.success = function(resp) {
        var method = options.reset ? 'reset' : 'set';
        collection[method](resp, options);
        if (success) success.call(options.context, collection, resp, options);
        collection.trigger('sync', collection, resp, options);
      };
      wrapError(this, options);
      return this.sync('read', this, options);
    },

    // Create a new instance of a model in this collection. Add the model to the
    // collection immediately, unless `wait: true` is passed, in which case we
    // wait for the server to agree.
    create: function(model, options) {
      options = options ? _.clone(options) : {};
      var wait = options.wait;
      model = this._prepareModel(model, options);
      if (!model) return false;
      if (!wait) this.add(model, options);
      var collection = this;
      var success = options.success;
      options.success = function(m, resp, callbackOpts) {
        if (wait) collection.add(m, callbackOpts);
        if (success) success.call(callbackOpts.context, m, resp, callbackOpts);
      };
      model.save(null, options);
      return model;
    },

    // **parse** converts a response into a list of models to be added to the
    // collection. The default implementation is just to pass it through.
    parse: function(resp, options) {
      return resp;
    },

    // Create a new collection with an identical list of models as this one.
    clone: function() {
      return new this.constructor(this.models, {
        model: this.model,
        comparator: this.comparator
      });
    },

    // Define how to uniquely identify models in the collection.
    modelId: function(attrs) {
      return attrs[this.model.prototype.idAttribute || 'id'];
    },

    // Private method to reset all internal state. Called when the collection
    // is first initialized or reset.
    _reset: function() {
      this.length = 0;
      this.models = [];
      this._byId  = {};
    },

    // Prepare a hash of attributes (or other model) to be added to this
    // collection.
    _prepareModel: function(attrs, options) {
      if (this._isModel(attrs)) {
        if (!attrs.collection) attrs.collection = this;
        return attrs;
      }
      options = options ? _.clone(options) : {};
      options.collection = this;
      var model = new this.model(attrs, options);
      if (!model.validationError) return model;
      this.trigger('invalid', this, model.validationError, options);
      return false;
    },

    // Internal method called by both remove and set.
    _removeModels: function(models, options) {
      var removed = [];
      for (var i = 0; i < models.length; i++) {
        var model = this.get(models[i]);
        if (!model) continue;

        var index = this.indexOf(model);
        this.models.splice(index, 1);
        this.length--;

        // Remove references before triggering 'remove' event to prevent an
        // infinite loop. #3693
        delete this._byId[model.cid];
        var id = this.modelId(model.attributes);
        if (id != null) delete this._byId[id];

        if (!options.silent) {
          options.index = index;
          model.trigger('remove', model, this, options);
        }

        removed.push(model);
        this._removeReference(model, options);
      }
      return removed;
    },

    // Method for checking whether an object should be considered a model for
    // the purposes of adding to the collection.
    _isModel: function(model) {
      return model instanceof Model;
    },

    // Internal method to create a model's ties to a collection.
    _addReference: function(model, options) {
      this._byId[model.cid] = model;
      var id = this.modelId(model.attributes);
      if (id != null) this._byId[id] = model;
      model.on('all', this._onModelEvent, this);
    },

    // Internal method to sever a model's ties to a collection.
    _removeReference: function(model, options) {
      delete this._byId[model.cid];
      var id = this.modelId(model.attributes);
      if (id != null) delete this._byId[id];
      if (this === model.collection) delete model.collection;
      model.off('all', this._onModelEvent, this);
    },

    // Internal method called every time a model in the set fires an event.
    // Sets need to update their indexes when models change ids. All other
    // events simply proxy through. "add" and "remove" events that originate
    // in other collections are ignored.
    _onModelEvent: function(event, model, collection, options) {
      if (model) {
        if ((event === 'add' || event === 'remove') && collection !== this) return;
        if (event === 'destroy') this.remove(model, options);
        if (event === 'change') {
          var prevId = this.modelId(model.previousAttributes());
          var id = this.modelId(model.attributes);
          if (prevId !== id) {
            if (prevId != null) delete this._byId[prevId];
            if (id != null) this._byId[id] = model;
          }
        }
      }
      this.trigger.apply(this, arguments);
    }

  });

  // Underscore methods that we want to implement on the Collection.
  // 90% of the core usefulness of Backbone Collections is actually implemented
  // right here:
  var collectionMethods = {forEach: 3, each: 3, map: 3, collect: 3, reduce: 0,
      foldl: 0, inject: 0, reduceRight: 0, foldr: 0, find: 3, detect: 3, filter: 3,
      select: 3, reject: 3, every: 3, all: 3, some: 3, any: 3, include: 3, includes: 3,
      contains: 3, invoke: 0, max: 3, min: 3, toArray: 1, size: 1, first: 3,
      head: 3, take: 3, initial: 3, rest: 3, tail: 3, drop: 3, last: 3,
      without: 0, difference: 0, indexOf: 3, shuffle: 1, lastIndexOf: 3,
      isEmpty: 1, chain: 1, sample: 3, partition: 3, groupBy: 3, countBy: 3,
      sortBy: 3, indexBy: 3, findIndex: 3, findLastIndex: 3};

  // Mix in each Underscore method as a proxy to `Collection#models`.
  addUnderscoreMethods(Collection, collectionMethods, 'models');

  // Backbone.View
  // -------------

  // Backbone Views are almost more convention than they are actual code. A View
  // is simply a JavaScript object that represents a logical chunk of UI in the
  // DOM. This might be a single item, an entire list, a sidebar or panel, or
  // even the surrounding frame which wraps your whole app. Defining a chunk of
  // UI as a **View** allows you to define your DOM events declaratively, without
  // having to worry about render order ... and makes it easy for the view to
  // react to specific changes in the state of your models.

  // Creating a Backbone.View creates its initial element outside of the DOM,
  // if an existing element is not provided...
  var View = Backbone.View = function(options) {
    this.cid = _.uniqueId('view');
    _.extend(this, _.pick(options, viewOptions));
    this._ensureElement();
    this.initialize.apply(this, arguments);
  };

  // Cached regex to split keys for `delegate`.
  var delegateEventSplitter = /^(\S+)\s*(.*)$/;

  // List of view options to be set as properties.
  var viewOptions = ['model', 'collection', 'el', 'id', 'attributes', 'className', 'tagName', 'events'];

  // Set up all inheritable **Backbone.View** properties and methods.
  _.extend(View.prototype, Events, {

    // The default `tagName` of a View's element is `"div"`.
    tagName: 'div',

    // jQuery delegate for element lookup, scoped to DOM elements within the
    // current view. This should be preferred to global lookups where possible.
    $: function(selector) {
      return this.$el.find(selector);
    },

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // **render** is the core function that your view should override, in order
    // to populate its element (`this.el`), with the appropriate HTML. The
    // convention is for **render** to always return `this`.
    render: function() {
      return this;
    },

    // Remove this view by taking the element out of the DOM, and removing any
    // applicable Backbone.Events listeners.
    remove: function() {
      this._removeElement();
      this.stopListening();
      return this;
    },

    // Remove this view's element from the document and all event listeners
    // attached to it. Exposed for subclasses using an alternative DOM
    // manipulation API.
    _removeElement: function() {
      this.$el.remove();
    },

    // Change the view's element (`this.el` property) and re-delegate the
    // view's events on the new element.
    setElement: function(element) {
      this.undelegateEvents();
      this._setElement(element);
      this.delegateEvents();
      return this;
    },

    // Creates the `this.el` and `this.$el` references for this view using the
    // given `el`. `el` can be a CSS selector or an HTML string, a jQuery
    // context or an element. Subclasses can override this to utilize an
    // alternative DOM manipulation API and are only required to set the
    // `this.el` property.
    _setElement: function(el) {
      this.$el = el instanceof Backbone.$ ? el : Backbone.$(el);
      this.el = this.$el[0];
    },

    // Set callbacks, where `this.events` is a hash of
    //
    // *{"event selector": "callback"}*
    //
    //     {
    //       'mousedown .title':  'edit',
    //       'click .button':     'save',
    //       'click .open':       function(e) { ... }
    //     }
    //
    // pairs. Callbacks will be bound to the view, with `this` set properly.
    // Uses event delegation for efficiency.
    // Omitting the selector binds the event to `this.el`.
    delegateEvents: function(events) {
      events || (events = _.result(this, 'events'));
      if (!events) return this;
      this.undelegateEvents();
      for (var key in events) {
        var method = events[key];
        if (!_.isFunction(method)) method = this[method];
        if (!method) continue;
        var match = key.match(delegateEventSplitter);
        this.delegate(match[1], match[2], _.bind(method, this));
      }
      return this;
    },

    // Add a single event listener to the view's element (or a child element
    // using `selector`). This only works for delegate-able events: not `focus`,
    // `blur`, and not `change`, `submit`, and `reset` in Internet Explorer.
    delegate: function(eventName, selector, listener) {
      this.$el.on(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Clears all callbacks previously bound to the view by `delegateEvents`.
    // You usually don't need to use this, but may wish to if you have multiple
    // Backbone views attached to the same DOM element.
    undelegateEvents: function() {
      if (this.$el) this.$el.off('.delegateEvents' + this.cid);
      return this;
    },

    // A finer-grained `undelegateEvents` for removing a single delegated event.
    // `selector` and `listener` are both optional.
    undelegate: function(eventName, selector, listener) {
      this.$el.off(eventName + '.delegateEvents' + this.cid, selector, listener);
      return this;
    },

    // Produces a DOM element to be assigned to your view. Exposed for
    // subclasses using an alternative DOM manipulation API.
    _createElement: function(tagName) {
      return document.createElement(tagName);
    },

    // Ensure that the View has a DOM element to render into.
    // If `this.el` is a string, pass it through `$()`, take the first
    // matching element, and re-assign it to `el`. Otherwise, create
    // an element from the `id`, `className` and `tagName` properties.
    _ensureElement: function() {
      if (!this.el) {
        var attrs = _.extend({}, _.result(this, 'attributes'));
        if (this.id) attrs.id = _.result(this, 'id');
        if (this.className) attrs['class'] = _.result(this, 'className');
        this.setElement(this._createElement(_.result(this, 'tagName')));
        this._setAttributes(attrs);
      } else {
        this.setElement(_.result(this, 'el'));
      }
    },

    // Set attributes from a hash on this view's element.  Exposed for
    // subclasses using an alternative DOM manipulation API.
    _setAttributes: function(attributes) {
      this.$el.attr(attributes);
    }

  });

  // Backbone.sync
  // -------------

  // Override this function to change the manner in which Backbone persists
  // models to the server. You will be passed the type of request, and the
  // model in question. By default, makes a RESTful Ajax request
  // to the model's `url()`. Some possible customizations could be:
  //
  // * Use `setTimeout` to batch rapid-fire updates into a single request.
  // * Send up the models as XML instead of JSON.
  // * Persist models via WebSockets instead of Ajax.
  //
  // Turn on `Backbone.emulateHTTP` in order to send `PUT` and `DELETE` requests
  // as `POST`, with a `_method` parameter containing the true HTTP method,
  // as well as all requests with the body as `application/x-www-form-urlencoded`
  // instead of `application/json` with the model in a param named `model`.
  // Useful when interfacing with server-side languages like **PHP** that make
  // it difficult to read the body of `PUT` requests.
  Backbone.sync = function(method, model, options) {
    var type = methodMap[method];

    // Default options, unless specified.
    _.defaults(options || (options = {}), {
      emulateHTTP: Backbone.emulateHTTP,
      emulateJSON: Backbone.emulateJSON
    });

    // Default JSON-request options.
    var params = {type: type, dataType: 'json'};

    // Ensure that we have a URL.
    if (!options.url) {
      params.url = _.result(model, 'url') || urlError();
    }

    // Ensure that we have the appropriate request data.
    if (options.data == null && model && (method === 'create' || method === 'update' || method === 'patch')) {
      params.contentType = 'application/json';
      params.data = JSON.stringify(options.attrs || model.toJSON(options));
    }

    // For older servers, emulate JSON by encoding the request into an HTML-form.
    if (options.emulateJSON) {
      params.contentType = 'application/x-www-form-urlencoded';
      params.data = params.data ? {model: params.data} : {};
    }

    // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
    // And an `X-HTTP-Method-Override` header.
    if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
      params.type = 'POST';
      if (options.emulateJSON) params.data._method = type;
      var beforeSend = options.beforeSend;
      options.beforeSend = function(xhr) {
        xhr.setRequestHeader('X-HTTP-Method-Override', type);
        if (beforeSend) return beforeSend.apply(this, arguments);
      };
    }

    // Don't process data on a non-GET request.
    if (params.type !== 'GET' && !options.emulateJSON) {
      params.processData = false;
    }

    // Pass along `textStatus` and `errorThrown` from jQuery.
    var error = options.error;
    options.error = function(xhr, textStatus, errorThrown) {
      options.textStatus = textStatus;
      options.errorThrown = errorThrown;
      if (error) error.call(options.context, xhr, textStatus, errorThrown);
    };

    // Make the request, allowing the user to override any Ajax options.
    var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
    model.trigger('request', model, xhr, options);
    return xhr;
  };

  // Map from CRUD to HTTP for our default `Backbone.sync` implementation.
  var methodMap = {
    'create': 'POST',
    'update': 'PUT',
    'patch': 'PATCH',
    'delete': 'DELETE',
    'read': 'GET'
  };

  // Set the default implementation of `Backbone.ajax` to proxy through to `$`.
  // Override this if you'd like to use a different library.
  Backbone.ajax = function() {
    return Backbone.$.ajax.apply(Backbone.$, arguments);
  };

  // Backbone.Router
  // ---------------

  // Routers map faux-URLs to actions, and fire events when routes are
  // matched. Creating a new one sets its `routes` hash, if not set statically.
  var Router = Backbone.Router = function(options) {
    options || (options = {});
    if (options.routes) this.routes = options.routes;
    this._bindRoutes();
    this.initialize.apply(this, arguments);
  };

  // Cached regular expressions for matching named param parts and splatted
  // parts of route strings.
  var optionalParam = /\((.*?)\)/g;
  var namedParam    = /(\(\?)?:\w+/g;
  var splatParam    = /\*\w+/g;
  var escapeRegExp  = /[\-{}\[\]+?.,\\\^$|#\s]/g;

  // Set up all inheritable **Backbone.Router** properties and methods.
  _.extend(Router.prototype, Events, {

    // Initialize is an empty function by default. Override it with your own
    // initialization logic.
    initialize: function(){},

    // Manually bind a single named route to a callback. For example:
    //
    //     this.route('search/:query/p:num', 'search', function(query, num) {
    //       ...
    //     });
    //
    route: function(route, name, callback) {
      if (!_.isRegExp(route)) route = this._routeToRegExp(route);
      if (_.isFunction(name)) {
        callback = name;
        name = '';
      }
      if (!callback) callback = this[name];
      var router = this;
      Backbone.history.route(route, function(fragment) {
        var args = router._extractParameters(route, fragment);
        if (router.execute(callback, args, name) !== false) {
          router.trigger.apply(router, ['route:' + name].concat(args));
          router.trigger('route', name, args);
          Backbone.history.trigger('route', router, name, args);
        }
      });
      return this;
    },

    // Execute a route handler with the provided parameters.  This is an
    // excellent place to do pre-route setup or post-route cleanup.
    execute: function(callback, args, name) {
      if (callback) callback.apply(this, args);
    },

    // Simple proxy to `Backbone.history` to save a fragment into the history.
    navigate: function(fragment, options) {
      Backbone.history.navigate(fragment, options);
      return this;
    },

    // Bind all defined routes to `Backbone.history`. We have to reverse the
    // order of the routes here to support behavior where the most general
    // routes can be defined at the bottom of the route map.
    _bindRoutes: function() {
      if (!this.routes) return;
      this.routes = _.result(this, 'routes');
      var route, routes = _.keys(this.routes);
      while ((route = routes.pop()) != null) {
        this.route(route, this.routes[route]);
      }
    },

    // Convert a route string into a regular expression, suitable for matching
    // against the current location hash.
    _routeToRegExp: function(route) {
      route = route.replace(escapeRegExp, '\\$&')
                   .replace(optionalParam, '(?:$1)?')
                   .replace(namedParam, function(match, optional) {
                     return optional ? match : '([^/?]+)';
                   })
                   .replace(splatParam, '([^?]*?)');
      return new RegExp('^' + route + '(?:\\?([\\s\\S]*))?$');
    },

    // Given a route, and a URL fragment that it matches, return the array of
    // extracted decoded parameters. Empty or unmatched parameters will be
    // treated as `null` to normalize cross-browser behavior.
    _extractParameters: function(route, fragment) {
      var params = route.exec(fragment).slice(1);
      return _.map(params, function(param, i) {
        // Don't decode the search params.
        if (i === params.length - 1) return param || null;
        return param ? decodeURIComponent(param) : null;
      });
    }

  });

  // Backbone.History
  // ----------------

  // Handles cross-browser history management, based on either
  // [pushState](http://diveintohtml5.info/history.html) and real URLs, or
  // [onhashchange](https://developer.mozilla.org/en-US/docs/DOM/window.onhashchange)
  // and URL fragments. If the browser supports neither (old IE, natch),
  // falls back to polling.
  var History = Backbone.History = function() {
    this.handlers = [];
    this.checkUrl = _.bind(this.checkUrl, this);

    // Ensure that `History` can be used outside of the browser.
    if (typeof window !== 'undefined') {
      this.location = window.location;
      this.history = window.history;
    }
  };

  // Cached regex for stripping a leading hash/slash and trailing space.
  var routeStripper = /^[#\/]|\s+$/g;

  // Cached regex for stripping leading and trailing slashes.
  var rootStripper = /^\/+|\/+$/g;

  // Cached regex for stripping urls of hash.
  var pathStripper = /#.*$/;

  // Has the history handling already been started?
  History.started = false;

  // Set up all inheritable **Backbone.History** properties and methods.
  _.extend(History.prototype, Events, {

    // The default interval to poll for hash changes, if necessary, is
    // twenty times a second.
    interval: 50,

    // Are we at the app root?
    atRoot: function() {
      var path = this.location.pathname.replace(/[^\/]$/, '$&/');
      return path === this.root && !this.getSearch();
    },

    // Does the pathname match the root?
    matchRoot: function() {
      var path = this.decodeFragment(this.location.pathname);
      var rootPath = path.slice(0, this.root.length - 1) + '/';
      return rootPath === this.root;
    },

    // Unicode characters in `location.pathname` are percent encoded so they're
    // decoded for comparison. `%25` should not be decoded since it may be part
    // of an encoded parameter.
    decodeFragment: function(fragment) {
      return decodeURI(fragment.replace(/%25/g, '%2525'));
    },

    // In IE6, the hash fragment and search params are incorrect if the
    // fragment contains `?`.
    getSearch: function() {
      var match = this.location.href.replace(/#.*/, '').match(/\?.+/);
      return match ? match[0] : '';
    },

    // Gets the true hash value. Cannot use location.hash directly due to bug
    // in Firefox where location.hash will always be decoded.
    getHash: function(window) {
      var match = (window || this).location.href.match(/#(.*)$/);
      return match ? match[1] : '';
    },

    // Get the pathname and search params, without the root.
    getPath: function() {
      var path = this.decodeFragment(
        this.location.pathname + this.getSearch()
      ).slice(this.root.length - 1);
      return path.charAt(0) === '/' ? path.slice(1) : path;
    },

    // Get the cross-browser normalized URL fragment from the path or hash.
    getFragment: function(fragment) {
      if (fragment == null) {
        if (this._usePushState || !this._wantsHashChange) {
          fragment = this.getPath();
        } else {
          fragment = this.getHash();
        }
      }
      return fragment.replace(routeStripper, '');
    },

    // Start the hash change handling, returning `true` if the current URL matches
    // an existing route, and `false` otherwise.
    start: function(options) {
      if (History.started) throw new Error('Backbone.history has already been started');
      History.started = true;

      // Figure out the initial configuration. Do we need an iframe?
      // Is pushState desired ... is it available?
      this.options          = _.extend({root: '/'}, this.options, options);
      this.root             = this.options.root;
      this._wantsHashChange = this.options.hashChange !== false;
      this._hasHashChange   = 'onhashchange' in window && (document.documentMode === void 0 || document.documentMode > 7);
      this._useHashChange   = this._wantsHashChange && this._hasHashChange;
      this._wantsPushState  = !!this.options.pushState;
      this._hasPushState    = !!(this.history && this.history.pushState);
      this._usePushState    = this._wantsPushState && this._hasPushState;
      this.fragment         = this.getFragment();

      // Normalize root to always include a leading and trailing slash.
      this.root = ('/' + this.root + '/').replace(rootStripper, '/');

      // Transition from hashChange to pushState or vice versa if both are
      // requested.
      if (this._wantsHashChange && this._wantsPushState) {

        // If we've started off with a route from a `pushState`-enabled
        // browser, but we're currently in a browser that doesn't support it...
        if (!this._hasPushState && !this.atRoot()) {
          var rootPath = this.root.slice(0, -1) || '/';
          this.location.replace(rootPath + '#' + this.getPath());
          // Return immediately as browser will do redirect to new url
          return true;

        // Or if we've started out with a hash-based route, but we're currently
        // in a browser where it could be `pushState`-based instead...
        } else if (this._hasPushState && this.atRoot()) {
          this.navigate(this.getHash(), {replace: true});
        }

      }

      // Proxy an iframe to handle location events if the browser doesn't
      // support the `hashchange` event, HTML5 history, or the user wants
      // `hashChange` but not `pushState`.
      if (!this._hasHashChange && this._wantsHashChange && !this._usePushState) {
        this.iframe = document.createElement('iframe');
        this.iframe.src = 'javascript:0';
        this.iframe.style.display = 'none';
        this.iframe.tabIndex = -1;
        var body = document.body;
        // Using `appendChild` will throw on IE < 9 if the document is not ready.
        var iWindow = body.insertBefore(this.iframe, body.firstChild).contentWindow;
        iWindow.document.open();
        iWindow.document.close();
        iWindow.location.hash = '#' + this.fragment;
      }

      // Add a cross-platform `addEventListener` shim for older browsers.
      var addEventListener = window.addEventListener || function(eventName, listener) {
        return attachEvent('on' + eventName, listener);
      };

      // Depending on whether we're using pushState or hashes, and whether
      // 'onhashchange' is supported, determine how we check the URL state.
      if (this._usePushState) {
        addEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        addEventListener('hashchange', this.checkUrl, false);
      } else if (this._wantsHashChange) {
        this._checkUrlInterval = setInterval(this.checkUrl, this.interval);
      }

      if (!this.options.silent) return this.loadUrl();
    },

    // Disable Backbone.history, perhaps temporarily. Not useful in a real app,
    // but possibly useful for unit testing Routers.
    stop: function() {
      // Add a cross-platform `removeEventListener` shim for older browsers.
      var removeEventListener = window.removeEventListener || function(eventName, listener) {
        return detachEvent('on' + eventName, listener);
      };

      // Remove window listeners.
      if (this._usePushState) {
        removeEventListener('popstate', this.checkUrl, false);
      } else if (this._useHashChange && !this.iframe) {
        removeEventListener('hashchange', this.checkUrl, false);
      }

      // Clean up the iframe if necessary.
      if (this.iframe) {
        document.body.removeChild(this.iframe);
        this.iframe = null;
      }

      // Some environments will throw when clearing an undefined interval.
      if (this._checkUrlInterval) clearInterval(this._checkUrlInterval);
      History.started = false;
    },

    // Add a route to be tested when the fragment changes. Routes added later
    // may override previous routes.
    route: function(route, callback) {
      this.handlers.unshift({route: route, callback: callback});
    },

    // Checks the current URL to see if it has changed, and if it has,
    // calls `loadUrl`, normalizing across the hidden iframe.
    checkUrl: function(e) {
      var current = this.getFragment();

      // If the user pressed the back button, the iframe's hash will have
      // changed and we should use that for comparison.
      if (current === this.fragment && this.iframe) {
        current = this.getHash(this.iframe.contentWindow);
      }

      if (current === this.fragment) return false;
      if (this.iframe) this.navigate(current);
      this.loadUrl();
    },

    // Attempt to load the current URL fragment. If a route succeeds with a
    // match, returns `true`. If no defined routes matches the fragment,
    // returns `false`.
    loadUrl: function(fragment) {
      // If the root doesn't match, no routes can match either.
      if (!this.matchRoot()) return false;
      fragment = this.fragment = this.getFragment(fragment);
      return _.some(this.handlers, function(handler) {
        if (handler.route.test(fragment)) {
          handler.callback(fragment);
          return true;
        }
      });
    },

    // Save a fragment into the hash history, or replace the URL state if the
    // 'replace' option is passed. You are responsible for properly URL-encoding
    // the fragment in advance.
    //
    // The options object can contain `trigger: true` if you wish to have the
    // route callback be fired (not usually desirable), or `replace: true`, if
    // you wish to modify the current URL without adding an entry to the history.
    navigate: function(fragment, options) {
      if (!History.started) return false;
      if (!options || options === true) options = {trigger: !!options};

      // Normalize the fragment.
      fragment = this.getFragment(fragment || '');

      // Don't include a trailing slash on the root.
      var rootPath = this.root;
      if (fragment === '' || fragment.charAt(0) === '?') {
        rootPath = rootPath.slice(0, -1) || '/';
      }
      var url = rootPath + fragment;

      // Strip the hash and decode for matching.
      fragment = this.decodeFragment(fragment.replace(pathStripper, ''));

      if (this.fragment === fragment) return;
      this.fragment = fragment;

      // If pushState is available, we use it to set the fragment as a real URL.
      if (this._usePushState) {
        this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

      // If hash changes haven't been explicitly disabled, update the hash
      // fragment to store history.
      } else if (this._wantsHashChange) {
        this._updateHash(this.location, fragment, options.replace);
        if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
          var iWindow = this.iframe.contentWindow;

          // Opening and closing the iframe tricks IE7 and earlier to push a
          // history entry on hash-tag change.  When replace is true, we don't
          // want this.
          if (!options.replace) {
            iWindow.document.open();
            iWindow.document.close();
          }

          this._updateHash(iWindow.location, fragment, options.replace);
        }

      // If you've told us that you explicitly don't want fallback hashchange-
      // based history, then `navigate` becomes a page refresh.
      } else {
        return this.location.assign(url);
      }
      if (options.trigger) return this.loadUrl(fragment);
    },

    // Update the hash location, either replacing the current entry, or adding
    // a new one to the browser history.
    _updateHash: function(location, fragment, replace) {
      if (replace) {
        var href = location.href.replace(/(javascript:|#).*$/, '');
        location.replace(href + '#' + fragment);
      } else {
        // Some browsers require that `hash` contains a leading #.
        location.hash = '#' + fragment;
      }
    }

  });

  // Create the default Backbone.history.
  Backbone.history = new History;

  // Helpers
  // -------

  // Helper function to correctly set up the prototype chain for subclasses.
  // Similar to `goog.inherits`, but uses a hash of prototype properties and
  // class properties to be extended.
  var extend = function(protoProps, staticProps) {
    var parent = this;
    var child;

    // The constructor function for the new subclass is either defined by you
    // (the "constructor" property in your `extend` definition), or defaulted
    // by us to simply call the parent constructor.
    if (protoProps && _.has(protoProps, 'constructor')) {
      child = protoProps.constructor;
    } else {
      child = function(){ return parent.apply(this, arguments); };
    }

    // Add static properties to the constructor function, if supplied.
    _.extend(child, parent, staticProps);

    // Set the prototype chain to inherit from `parent`, without calling
    // `parent`'s constructor function and add the prototype properties.
    child.prototype = _.create(parent.prototype, protoProps);
    child.prototype.constructor = child;

    // Set a convenience property in case the parent's prototype is needed
    // later.
    child.__super__ = parent.prototype;

    return child;
  };

  // Set up inheritance for the model, collection, router, view and history.
  Model.extend = Collection.extend = Router.extend = View.extend = History.extend = extend;

  // Throw an error when a URL is needed, and none is supplied.
  var urlError = function() {
    throw new Error('A "url" property or function must be specified');
  };

  // Wrap an optional error callback with a fallback error event.
  var wrapError = function(model, options) {
    var error = options.error;
    options.error = function(resp) {
      if (error) error.call(options.context, model, resp, options);
      model.trigger('error', model, resp, options);
    };
  };

  return Backbone;
});


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(20);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.3.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2018-01-20T17:24Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

      // Support: Chrome <=57, Firefox <=52
      // In some browsers, typeof returns "function" for HTML <object> elements
      // (i.e., `typeof document.createElement( "object" ) === "function"`).
      // We don't want to classify *any* DOM node as a function.
      return typeof obj === "function" && typeof obj.nodeType !== "number";
  };


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};




	var preservedScriptAttributes = {
		type: true,
		src: true,
		noModule: true
	};

	function DOMEval( code, doc, node ) {
		doc = doc || document;

		var i,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {
				if ( node[ i ] ) {
					script[ i ] = node[ i ];
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.3.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && Array.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;



function nodeName( elem, name ) {

  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

};
var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
        if ( nodeName( elem, "iframe" ) ) {
            return elem.contentDocument;
        }

        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
        // Treat the template element as a regular one in browsers that
        // don't support it.
        if ( nodeName( elem, "template" ) ) {
            elem = elem.content || elem;
        }

        return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc, node );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		div.style.position = "absolute";
		scrollboxSizeVal = div.offsetWidth === 36 || "absolute";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, #12537)
	//   .css('--customProperty) (#3144)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	rcustomProp = /^--/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a property mapped along what jQuery.cssProps suggests or to
// a vendor prefixed property.
function finalPropName( name ) {
	var ret = jQuery.cssProps[ name ];
	if ( !ret ) {
		ret = jQuery.cssProps[ name ] = vendorPropName( name ) || name;
	}
	return ret;
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		if ( box === "margin" ) {
			delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5
		) );
	}

	return delta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),
		val = curCSS( elem, dimension, styles ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox;

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}

	// Check for style in case a browser which returns unreliable values
	// for getComputedStyle silently falls back to the reliable elem.style
	valueIsBorderBox = valueIsBorderBox &&
		( support.boxSizingReliable() || val === elem.style[ dimension ] );

	// Fall back to offsetWidth/offsetHeight when value is "auto"
	// This happens for inline elements with no explicit setting (gh-3571)
	// Support: Android <=4.1 - 4.3 only
	// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
	if ( val === "auto" ||
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) {

		val = elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ];

		// offsetWidth/offsetHeight provide border-box values
		valueIsBorderBox = true;
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, dimension, extra );
						} ) :
						getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),
				isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra && boxModelAdjustment(
					elem,
					dimension,
					extra,
					isBorderBox,
					styles
				);

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && support.scrollboxSize() === styles.position ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classes = classesToArray( value );

		if ( classes.length ) {
			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( isValidValue ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = classesToArray( value );

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


support.focusin = "onfocusin" in window;


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = Date.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extend = extend;
exports.indexOf = indexOf;
exports.escapeExpression = escapeExpression;
exports.isEmpty = isEmpty;
exports.createFrame = createFrame;
exports.blockParams = blockParams;
exports.appendContextPath = appendContextPath;
var escape = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '=': '&#x3D;'
};

var badChars = /[&<>"'`=]/g,
    possible = /[&<>"'`=]/;

function escapeChar(chr) {
  return escape[chr];
}

function extend(obj /* , ...source */) {
  for (var i = 1; i < arguments.length; i++) {
    for (var key in arguments[i]) {
      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
        obj[key] = arguments[i][key];
      }
    }
  }

  return obj;
}

var toString = Object.prototype.toString;

exports.toString = toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */
if (isFunction(/x/)) {
  exports.isFunction = isFunction = function (value) {
    return typeof value === 'function' && toString.call(value) === '[object Function]';
  };
}
exports.isFunction = isFunction;

/* eslint-enable func-style */

/* istanbul ignore next */
var isArray = Array.isArray || function (value) {
  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
};

exports.isArray = isArray;
// Older IE versions do not directly support indexOf so we must implement our own, sadly.

function indexOf(array, value) {
  for (var i = 0, len = array.length; i < len; i++) {
    if (array[i] === value) {
      return i;
    }
  }
  return -1;
}

function escapeExpression(string) {
  if (typeof string !== 'string') {
    // don't escape SafeStrings, since they're already safe
    if (string && string.toHTML) {
      return string.toHTML();
    } else if (string == null) {
      return '';
    } else if (!string) {
      return string + '';
    }

    // Force a string conversion as this will be done by the append regardless and
    // the regex test will do this transparently behind the scenes, causing issues if
    // an object's to string has escaped characters in it.
    string = '' + string;
  }

  if (!possible.test(string)) {
    return string;
  }
  return string.replace(badChars, escapeChar);
}

function isEmpty(value) {
  if (!value && value !== 0) {
    return true;
  } else if (isArray(value) && value.length === 0) {
    return true;
  } else {
    return false;
  }
}

function createFrame(object) {
  var frame = extend({}, object);
  frame._parent = object;
  return frame;
}

function blockParams(params, ids) {
  params.path = ids;
  return params;
}

function appendContextPath(contextPath, id) {
  return (contextPath ? contextPath + '.' : '') + id;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL3V0aWxzLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7QUFBQSxJQUFNLE1BQU0sR0FBRztBQUNiLEtBQUcsRUFBRSxPQUFPO0FBQ1osS0FBRyxFQUFFLE1BQU07QUFDWCxLQUFHLEVBQUUsTUFBTTtBQUNYLEtBQUcsRUFBRSxRQUFRO0FBQ2IsS0FBRyxFQUFFLFFBQVE7QUFDYixLQUFHLEVBQUUsUUFBUTtBQUNiLEtBQUcsRUFBRSxRQUFRO0NBQ2QsQ0FBQzs7QUFFRixJQUFNLFFBQVEsR0FBRyxZQUFZO0lBQzNCLFFBQVEsR0FBRyxXQUFXLENBQUM7O0FBRXpCLFNBQVMsVUFBVSxDQUFDLEdBQUcsRUFBRTtBQUN2QixTQUFPLE1BQU0sQ0FBQyxHQUFHLENBQUMsQ0FBQztDQUNwQjs7QUFFTSxTQUFTLE1BQU0sQ0FBQyxHQUFHLG9CQUFvQjtBQUM1QyxPQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsU0FBUyxDQUFDLE1BQU0sRUFBRSxDQUFDLEVBQUUsRUFBRTtBQUN6QyxTQUFLLElBQUksR0FBRyxJQUFJLFNBQVMsQ0FBQyxDQUFDLENBQUMsRUFBRTtBQUM1QixVQUFJLE1BQU0sQ0FBQyxTQUFTLENBQUMsY0FBYyxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLEVBQUUsR0FBRyxDQUFDLEVBQUU7QUFDM0QsV0FBRyxDQUFDLEdBQUcsQ0FBQyxHQUFHLFNBQVMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQztPQUM5QjtLQUNGO0dBQ0Y7O0FBRUQsU0FBTyxHQUFHLENBQUM7Q0FDWjs7QUFFTSxJQUFJLFFBQVEsR0FBRyxNQUFNLENBQUMsU0FBUyxDQUFDLFFBQVEsQ0FBQzs7Ozs7O0FBS2hELElBQUksVUFBVSxHQUFHLG9CQUFTLEtBQUssRUFBRTtBQUMvQixTQUFPLE9BQU8sS0FBSyxLQUFLLFVBQVUsQ0FBQztDQUNwQyxDQUFDOzs7QUFHRixJQUFJLFVBQVUsQ0FBQyxHQUFHLENBQUMsRUFBRTtBQUNuQixVQU9PLFVBQVUsR0FQakIsVUFBVSxHQUFHLFVBQVMsS0FBSyxFQUFFO0FBQzNCLFdBQ0UsT0FBTyxLQUFLLEtBQUssVUFBVSxJQUMzQixRQUFRLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFLLG1CQUFtQixDQUM1QztHQUNILENBQUM7Q0FDSDtRQUNRLFVBQVUsR0FBVixVQUFVOzs7OztBQUlaLElBQU0sT0FBTyxHQUNsQixLQUFLLENBQUMsT0FBTyxJQUNiLFVBQVMsS0FBSyxFQUFFO0FBQ2QsU0FBTyxLQUFLLElBQUksT0FBTyxLQUFLLEtBQUssUUFBUSxHQUNyQyxRQUFRLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFLLGdCQUFnQixHQUN6QyxLQUFLLENBQUM7Q0FDWCxDQUFDOzs7OztBQUdHLFNBQVMsT0FBTyxDQUFDLEtBQUssRUFBRSxLQUFLLEVBQUU7QUFDcEMsT0FBSyxJQUFJLENBQUMsR0FBRyxDQUFDLEVBQUUsR0FBRyxHQUFHLEtBQUssQ0FBQyxNQUFNLEVBQUUsQ0FBQyxHQUFHLEdBQUcsRUFBRSxDQUFDLEVBQUUsRUFBRTtBQUNoRCxRQUFJLEtBQUssQ0FBQyxDQUFDLENBQUMsS0FBSyxLQUFLLEVBQUU7QUFDdEIsYUFBTyxDQUFDLENBQUM7S0FDVjtHQUNGO0FBQ0QsU0FBTyxDQUFDLENBQUMsQ0FBQztDQUNYOztBQUVNLFNBQVMsZ0JBQWdCLENBQUMsTUFBTSxFQUFFO0FBQ3ZDLE1BQUksT0FBTyxNQUFNLEtBQUssUUFBUSxFQUFFOztBQUU5QixRQUFJLE1BQU0sSUFBSSxNQUFNLENBQUMsTUFBTSxFQUFFO0FBQzNCLGFBQU8sTUFBTSxDQUFDLE1BQU0sRUFBRSxDQUFDO0tBQ3hCLE1BQU0sSUFBSSxNQUFNLElBQUksSUFBSSxFQUFFO0FBQ3pCLGFBQU8sRUFBRSxDQUFDO0tBQ1gsTUFBTSxJQUFJLENBQUMsTUFBTSxFQUFFO0FBQ2xCLGFBQU8sTUFBTSxHQUFHLEVBQUUsQ0FBQztLQUNwQjs7Ozs7QUFLRCxVQUFNLEdBQUcsRUFBRSxHQUFHLE1BQU0sQ0FBQztHQUN0Qjs7QUFFRCxNQUFJLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsRUFBRTtBQUMxQixXQUFPLE1BQU0sQ0FBQztHQUNmO0FBQ0QsU0FBTyxNQUFNLENBQUMsT0FBTyxDQUFDLFFBQVEsRUFBRSxVQUFVLENBQUMsQ0FBQztDQUM3Qzs7QUFFTSxTQUFTLE9BQU8sQ0FBQyxLQUFLLEVBQUU7QUFDN0IsTUFBSSxDQUFDLEtBQUssSUFBSSxLQUFLLEtBQUssQ0FBQyxFQUFFO0FBQ3pCLFdBQU8sSUFBSSxDQUFDO0dBQ2IsTUFBTSxJQUFJLE9BQU8sQ0FBQyxLQUFLLENBQUMsSUFBSSxLQUFLLENBQUMsTUFBTSxLQUFLLENBQUMsRUFBRTtBQUMvQyxXQUFPLElBQUksQ0FBQztHQUNiLE1BQU07QUFDTCxXQUFPLEtBQUssQ0FBQztHQUNkO0NBQ0Y7O0FBRU0sU0FBUyxXQUFXLENBQUMsTUFBTSxFQUFFO0FBQ2xDLE1BQUksS0FBSyxHQUFHLE1BQU0sQ0FBQyxFQUFFLEVBQUUsTUFBTSxDQUFDLENBQUM7QUFDL0IsT0FBSyxDQUFDLE9BQU8sR0FBRyxNQUFNLENBQUM7QUFDdkIsU0FBTyxLQUFLLENBQUM7Q0FDZDs7QUFFTSxTQUFTLFdBQVcsQ0FBQyxNQUFNLEVBQUUsR0FBRyxFQUFFO0FBQ3ZDLFFBQU0sQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDO0FBQ2xCLFNBQU8sTUFBTSxDQUFDO0NBQ2Y7O0FBRU0sU0FBUyxpQkFBaUIsQ0FBQyxXQUFXLEVBQUUsRUFBRSxFQUFFO0FBQ2pELFNBQU8sQ0FBQyxXQUFXLEdBQUcsV0FBVyxHQUFHLEdBQUcsR0FBRyxFQUFFLENBQUEsR0FBSSxFQUFFLENBQUM7Q0FDcEQiLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBlc2NhcGUgPSB7XG4gICcmJzogJyZhbXA7JyxcbiAgJzwnOiAnJmx0OycsXG4gICc+JzogJyZndDsnLFxuICAnXCInOiAnJnF1b3Q7JyxcbiAgXCInXCI6ICcmI3gyNzsnLFxuICAnYCc6ICcmI3g2MDsnLFxuICAnPSc6ICcmI3gzRDsnXG59O1xuXG5jb25zdCBiYWRDaGFycyA9IC9bJjw+XCInYD1dL2csXG4gIHBvc3NpYmxlID0gL1smPD5cIidgPV0vO1xuXG5mdW5jdGlvbiBlc2NhcGVDaGFyKGNocikge1xuICByZXR1cm4gZXNjYXBlW2Nocl07XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBleHRlbmQob2JqIC8qICwgLi4uc291cmNlICovKSB7XG4gIGZvciAobGV0IGkgPSAxOyBpIDwgYXJndW1lbnRzLmxlbmd0aDsgaSsrKSB7XG4gICAgZm9yIChsZXQga2V5IGluIGFyZ3VtZW50c1tpXSkge1xuICAgICAgaWYgKE9iamVjdC5wcm90b3R5cGUuaGFzT3duUHJvcGVydHkuY2FsbChhcmd1bWVudHNbaV0sIGtleSkpIHtcbiAgICAgICAgb2JqW2tleV0gPSBhcmd1bWVudHNbaV1ba2V5XTtcbiAgICAgIH1cbiAgICB9XG4gIH1cblxuICByZXR1cm4gb2JqO1xufVxuXG5leHBvcnQgbGV0IHRvU3RyaW5nID0gT2JqZWN0LnByb3RvdHlwZS50b1N0cmluZztcblxuLy8gU291cmNlZCBmcm9tIGxvZGFzaFxuLy8gaHR0cHM6Ly9naXRodWIuY29tL2Jlc3RpZWpzL2xvZGFzaC9ibG9iL21hc3Rlci9MSUNFTlNFLnR4dFxuLyogZXNsaW50LWRpc2FibGUgZnVuYy1zdHlsZSAqL1xubGV0IGlzRnVuY3Rpb24gPSBmdW5jdGlvbih2YWx1ZSkge1xuICByZXR1cm4gdHlwZW9mIHZhbHVlID09PSAnZnVuY3Rpb24nO1xufTtcbi8vIGZhbGxiYWNrIGZvciBvbGRlciB2ZXJzaW9ucyBvZiBDaHJvbWUgYW5kIFNhZmFyaVxuLyogaXN0YW5idWwgaWdub3JlIG5leHQgKi9cbmlmIChpc0Z1bmN0aW9uKC94LykpIHtcbiAgaXNGdW5jdGlvbiA9IGZ1bmN0aW9uKHZhbHVlKSB7XG4gICAgcmV0dXJuIChcbiAgICAgIHR5cGVvZiB2YWx1ZSA9PT0gJ2Z1bmN0aW9uJyAmJlxuICAgICAgdG9TdHJpbmcuY2FsbCh2YWx1ZSkgPT09ICdbb2JqZWN0IEZ1bmN0aW9uXSdcbiAgICApO1xuICB9O1xufVxuZXhwb3J0IHsgaXNGdW5jdGlvbiB9O1xuLyogZXNsaW50LWVuYWJsZSBmdW5jLXN0eWxlICovXG5cbi8qIGlzdGFuYnVsIGlnbm9yZSBuZXh0ICovXG5leHBvcnQgY29uc3QgaXNBcnJheSA9XG4gIEFycmF5LmlzQXJyYXkgfHxcbiAgZnVuY3Rpb24odmFsdWUpIHtcbiAgICByZXR1cm4gdmFsdWUgJiYgdHlwZW9mIHZhbHVlID09PSAnb2JqZWN0J1xuICAgICAgPyB0b1N0cmluZy5jYWxsKHZhbHVlKSA9PT0gJ1tvYmplY3QgQXJyYXldJ1xuICAgICAgOiBmYWxzZTtcbiAgfTtcblxuLy8gT2xkZXIgSUUgdmVyc2lvbnMgZG8gbm90IGRpcmVjdGx5IHN1cHBvcnQgaW5kZXhPZiBzbyB3ZSBtdXN0IGltcGxlbWVudCBvdXIgb3duLCBzYWRseS5cbmV4cG9ydCBmdW5jdGlvbiBpbmRleE9mKGFycmF5LCB2YWx1ZSkge1xuICBmb3IgKGxldCBpID0gMCwgbGVuID0gYXJyYXkubGVuZ3RoOyBpIDwgbGVuOyBpKyspIHtcbiAgICBpZiAoYXJyYXlbaV0gPT09IHZhbHVlKSB7XG4gICAgICByZXR1cm4gaTtcbiAgICB9XG4gIH1cbiAgcmV0dXJuIC0xO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gZXNjYXBlRXhwcmVzc2lvbihzdHJpbmcpIHtcbiAgaWYgKHR5cGVvZiBzdHJpbmcgIT09ICdzdHJpbmcnKSB7XG4gICAgLy8gZG9uJ3QgZXNjYXBlIFNhZmVTdHJpbmdzLCBzaW5jZSB0aGV5J3JlIGFscmVhZHkgc2FmZVxuICAgIGlmIChzdHJpbmcgJiYgc3RyaW5nLnRvSFRNTCkge1xuICAgICAgcmV0dXJuIHN0cmluZy50b0hUTUwoKTtcbiAgICB9IGVsc2UgaWYgKHN0cmluZyA9PSBudWxsKSB7XG4gICAgICByZXR1cm4gJyc7XG4gICAgfSBlbHNlIGlmICghc3RyaW5nKSB7XG4gICAgICByZXR1cm4gc3RyaW5nICsgJyc7XG4gICAgfVxuXG4gICAgLy8gRm9yY2UgYSBzdHJpbmcgY29udmVyc2lvbiBhcyB0aGlzIHdpbGwgYmUgZG9uZSBieSB0aGUgYXBwZW5kIHJlZ2FyZGxlc3MgYW5kXG4gICAgLy8gdGhlIHJlZ2V4IHRlc3Qgd2lsbCBkbyB0aGlzIHRyYW5zcGFyZW50bHkgYmVoaW5kIHRoZSBzY2VuZXMsIGNhdXNpbmcgaXNzdWVzIGlmXG4gICAgLy8gYW4gb2JqZWN0J3MgdG8gc3RyaW5nIGhhcyBlc2NhcGVkIGNoYXJhY3RlcnMgaW4gaXQuXG4gICAgc3RyaW5nID0gJycgKyBzdHJpbmc7XG4gIH1cblxuICBpZiAoIXBvc3NpYmxlLnRlc3Qoc3RyaW5nKSkge1xuICAgIHJldHVybiBzdHJpbmc7XG4gIH1cbiAgcmV0dXJuIHN0cmluZy5yZXBsYWNlKGJhZENoYXJzLCBlc2NhcGVDaGFyKTtcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGlzRW1wdHkodmFsdWUpIHtcbiAgaWYgKCF2YWx1ZSAmJiB2YWx1ZSAhPT0gMCkge1xuICAgIHJldHVybiB0cnVlO1xuICB9IGVsc2UgaWYgKGlzQXJyYXkodmFsdWUpICYmIHZhbHVlLmxlbmd0aCA9PT0gMCkge1xuICAgIHJldHVybiB0cnVlO1xuICB9IGVsc2Uge1xuICAgIHJldHVybiBmYWxzZTtcbiAgfVxufVxuXG5leHBvcnQgZnVuY3Rpb24gY3JlYXRlRnJhbWUob2JqZWN0KSB7XG4gIGxldCBmcmFtZSA9IGV4dGVuZCh7fSwgb2JqZWN0KTtcbiAgZnJhbWUuX3BhcmVudCA9IG9iamVjdDtcbiAgcmV0dXJuIGZyYW1lO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gYmxvY2tQYXJhbXMocGFyYW1zLCBpZHMpIHtcbiAgcGFyYW1zLnBhdGggPSBpZHM7XG4gIHJldHVybiBwYXJhbXM7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBhcHBlbmRDb250ZXh0UGF0aChjb250ZXh0UGF0aCwgaWQpIHtcbiAgcmV0dXJuIChjb250ZXh0UGF0aCA/IGNvbnRleHRQYXRoICsgJy4nIDogJycpICsgaWQ7XG59XG4iXX0=


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var errorProps = ['description', 'fileName', 'lineNumber', 'endLineNumber', 'message', 'name', 'number', 'stack'];

function Exception(message, node) {
  var loc = node && node.loc,
      line = undefined,
      endLineNumber = undefined,
      column = undefined,
      endColumn = undefined;

  if (loc) {
    line = loc.start.line;
    endLineNumber = loc.end.line;
    column = loc.start.column;
    endColumn = loc.end.column;

    message += ' - ' + line + ':' + column;
  }

  var tmp = Error.prototype.constructor.call(this, message);

  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
  for (var idx = 0; idx < errorProps.length; idx++) {
    this[errorProps[idx]] = tmp[errorProps[idx]];
  }

  /* istanbul ignore else */
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, Exception);
  }

  try {
    if (loc) {
      this.lineNumber = line;
      this.endLineNumber = endLineNumber;

      // Work around issue under safari where we can't directly set the column value
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(this, 'column', {
          value: column,
          enumerable: true
        });
        Object.defineProperty(this, 'endColumn', {
          value: endColumn,
          enumerable: true
        });
      } else {
        this.column = column;
        this.endColumn = endColumn;
      }
    }
  } catch (nop) {
    /* Ignore if the browser is very particular */
  }
}

Exception.prototype = new Error();

exports['default'] = Exception;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);

/**
 * BaseModel : add a flag when model is fetching/fetched
 */

module.exports = Backbone.Model.extend({

    hasChangedSinceLastSync: false,

    fetched: false,
    fetching: false,
    token: null,
    cookie: null,
    mtime: 0,
    withCredentials: false,

    initialize: function (attributes, options) {
        Backbone.Model.prototype.initialize.apply(this, arguments);

        // on autorise l'injection de ajax et jquery pour que la classe puisse être utilisée aussi côté server
        if (options) {
            if (options.jQuery) {
                Backbone.$ = options.jQuery;
            }
            if (options.ajax) {
                Backbone.ajax = options.ajax;
            }
        }
    },

    fetch: function (options) {
        var T = this,
            new_options = options ? _.clone(options) : {},
            success_cb = new_options.success,
            error_cb = new_options.error;

        if (T.withCredentials) {
            new_options.xhrFields = new_options.xhrFields || {};
            new_options.xhrFields.withCredentials = true; // pour autoriser les cookies avec les requêtes ajax
        }

        T.fetching = true;
        new_options.success = function (model, response, options) {
            T.fetched = true;
            T.fetching = false;
            if (success_cb) {
                success_cb(model, response, options);
            }
        };
        new_options.error = function (model, response, options) {
            T.fetching = false;
            if (error_cb) {
                error_cb(model, response, options);
            }
        };

        return Backbone.Model.prototype.fetch.call(T, new_options);
    },

    sync: function (method, model, options) {
        var T = this,
            new_options = options ? _.clone(options) : {};

        if (!new_options.headers) {
            new_options.headers = {};
        }

        if (T.token) {
            new_options.headers["x-access-token"] = T.token;
        }

        if (T.cookie) {
            new_options.headers.cookie = T.cookie;
        }

        var success = new_options.success;
        new_options.success = function (resp) {
            if (success) {
                success(resp);
            }
            model.hasChangedSinceLastSync = false;
        };

        return Backbone.Model.prototype.sync.call(T, method, model, new_options);
    },

    addQueryStringArrayToUrl:function(base_url,query_string){
        if(query_string.length){
            base_url+="?"+query_string.join("&");
        }
        return base_url;
    }
});

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

/**
 * Liste de phrases ou de fonctions utilisées pour la localisation
 * à utiliser comme ceci : STR.string_id après avoir initialisé la langue dans la fonction init()
 */

var Strings = function () {
};

/**
 * init à appeler une fois tout au début de l'app
 * @param  {String} lang selon ci-dessous, "fr" ou "en" au moins
 */
Strings.prototype.init = function (lang) {
    if (!strings[lang]) {
        lang = "fr"; // langue par défaut
    }
    if (strings[lang]) {
        _.extend(this, strings[lang]);
        strings = []; // plus besoin des strings après la première initialisation, permet de libérer un peu de mémoire
    }
    return lang;
};

function capitalize(s) {
    if (typeof s !== 'string') return '';
    return s.charAt(0).toUpperCase() + s.slice(1);
}

var strings = {
    fr: {
        month_1: "janvier",
        month_2: "février",
        month_3: "mars",
        month_4: "avril",
        month_5: "mai",
        month_6: "juin",
        month_7: "juillet",
        month_8: "août",
        month_9: "septembre",
        month_10: "octobre",
        month_11: "novembre",
        month_12: "décembre",
        document_not_found: "Document non trouvé",
        token_lost: "Cette page va se recharger dans quelques secondes pour réactiver votre autorisation ...",
        token_error: "Document non autorisé",
        date: function (date, removeDay) {
            if (!date) return;
            var datearray = date.split("-"),
                dateFR = "";
            if (datearray.length == 3) {
                if (!removeDay) {
                    dateFR = datearray[2] + " ";
                }
                dateFR += capitalize(new_strings["month_" + parseInt(datearray[1])]) + " " + datearray[0];
            }
            return dateFR;
        },
        tour_skip: "ignorer",
        tour_next: "suivant",
        tour_first_time_title: "Première fois ici?",
        tour_first_time_text: "Prenez en main rapidement la lecture de ce magazine en suivant ce tutoriel.",
        search: "Rechercher",
        print: "Imprimer",
        print_active_page: "Page active",
        print_selected_pages: "Pages sélectionnées",
        print_all_pages: "Toutes les pages",
        annotate: "Annoter",
        print_example: "Par exemple : a-V, 8, 11-13",
        print_error: "Impossible d'imprimer, réessayez plus tard svp",
        print_not_authorized: "L'impression n'est pas autorisée sur ce document pour le moment",
        wrong_syntax_pages: "Veuillez vérifier la syntaxe des pages sélectionnées",
        print_period_w: "semaine",
        print_period_w_plurial: "semaines",
        print_period_h: "heure",
        print_period_h_plurial: "heures",
        print_period_m: "mois",
        print_period_m_plurial: "mois",
        print_period_d: "jour",
        print_period_d_plurial: "jours",
        print_quota_exceeded: "Le quota d'impression est dépassé",
        toc: "Sommaire",
        about: "À propos",
        search_in_progress: "Recherche en cours ...",
        search_previous_page: "P. précédente",
        search_next_page: "P. suivante",
        search_error: "Une erreur est survenue, veuillez réessayer plus tard",
        search_not_found: " non trouvé dans ce document",
        search_found: function (phrase, nb_results) {
            return '«' + phrase + '»' + " trouvé dans " + nb_results + " page" + (nb_results > 1 ? "s" : "");
        },
        voice_not_found: "La langue de ce document n'est pas supportée par ce système",
        copy: "Copier / Coller",
        copy_text: "Copier le texte",
        copy_select_zone: "Sélectionnez une zone de texte à copier dans la page. Vous pourrez alors coller ce texte dans un autre document en cliquant sur le bouton ci-dessous.",
        copy_move_ctrl: "Utilisez la touche CTRL pour vous déplacer.",
        copy_ok: "Le texte est dans le presse-papier",
        copy_nok: "Impossible de copier le texte dans le presse-papier",
        copy_no_text: "Pas de texte trouvé dans cette sélection",
        copy_no_clip: "Votre navigateur ne supporte pas le presse-papier",
        print_pwd: "Votre code pour ce document",
        goto_page: "Aller à la page",
        default_content_auth_message: "<p>Ce contenu n'est pas autorisé dans ce contexte.</p>",
        print_pages_not_authorized: "Certaines pages demandées pour l'impression ne sont pas autorisées dans ce contexte.<br>Veuillez vérifier votre saisie.",
        preferences: "Préférences",
        refresh: "Actualiser cette page",
        pref_display_label: "Qualité d'affichage",
        pref_display_normal: "Toujours standard",
        pref_display_auto: "Auto-adaptée",
        pref_display_high: "Toujours haute",
        pref_note: "Ces paramètres seront pris en compte lors du prochain chargement de cette page.",
        search_placeholder: "Mots recherchés dans ce document",
        switch_page: "Page",
        switch_article: "Article",
        print_copy_code: "Copier le code",
        print_next: "Suivant",
        lang_label_fr: "Français",
        lang_label_it: "Italiano",
        lang_label_en: "English",
        print_quota: "Quota",
        print_quota_consumed: "Consommé",
        print_quota_reset: "Remise à zéro le",
        print_quota_rule: function (nb_pages, period) {
            return nb_pages + " pages par période de " + period;
        },
        print_counter: function (nb_pages) {
            return nb_pages + " page" + (nb_pages > 1 ? "s" : "");
        },
        default_content_web_clipper_message: "<p>Pour enrichir avec des citations vos rapports, présentations, blogs etc… utilisez l'extension Immanens Web Clipper (Chrome seulement).</p><p><em>Attention le contenu partagé peut être soumis à copyright.</em></p>",
        web_clipper: "Web Clipper",
        goto_web_clipper: "Installer l'extension",
        thumbnails: "Mosaïque",
        server_pdf_max_pages: function (max_pages) {
            return "(limité à " + max_pages + ")";
        },
        pref_navigation_label: "Barre de navigation",
        pref_navigation_show: "Afficher",
        pref_navigation_hide: "Ne pas afficher",
        pref_font_size_label: "Taille des textes",
        pref_by_default:"valeur par défaut",
        page_history_stop: "Historique de page vide",
        share: "Copier l'URL",
        share_select: "Vous pouvez désormais copier l'URL du document actif : <br>• Avec le bouton droit de la souris<br>• Avec les raccourcis clavier (Ctrl C)<br>• En cliquant sur le bouton « Copier »",
        share_url: "Copier",
        authorize_popup: "Veuillez autoriser les popups de ce site pour pouvoir imprimer."
    }
};

var new_strings = new Strings();

module.exports = new_strings; // attention on exporte un objet unique

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var base64_url_decode = __webpack_require__(18);

function InvalidTokenError(message) {
  this.message = message;
}

InvalidTokenError.prototype = new Error();
InvalidTokenError.prototype.name = 'InvalidTokenError';

module.exports = function (token,options) {
  if (typeof token !== 'string') {
    throw new InvalidTokenError('Invalid token specified');
  }

  options = options || {};
  var pos = options.header === true ? 0 : 1;
  try {
    return JSON.parse(base64_url_decode(token.split('.')[pos]));
  } catch (e) {
    throw new InvalidTokenError('Invalid token specified: ' + e.message);
  }
};

module.exports.InvalidTokenError = InvalidTokenError;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HandlebarsEnvironment = HandlebarsEnvironment;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(4);

var _exception = __webpack_require__(5);

var _exception2 = _interopRequireDefault(_exception);

var _helpers = __webpack_require__(10);

var _decorators = __webpack_require__(30);

var _logger = __webpack_require__(11);

var _logger2 = _interopRequireDefault(_logger);

var _internalProtoAccess = __webpack_require__(12);

var VERSION = '4.7.7';
exports.VERSION = VERSION;
var COMPILER_REVISION = 8;
exports.COMPILER_REVISION = COMPILER_REVISION;
var LAST_COMPATIBLE_COMPILER_REVISION = 7;

exports.LAST_COMPATIBLE_COMPILER_REVISION = LAST_COMPATIBLE_COMPILER_REVISION;
var REVISION_CHANGES = {
  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
  2: '== 1.0.0-rc.3',
  3: '== 1.0.0-rc.4',
  4: '== 1.x.x',
  5: '== 2.0.0-alpha.x',
  6: '>= 2.0.0-beta.1',
  7: '>= 4.0.0 <4.3.0',
  8: '>= 4.3.0'
};

exports.REVISION_CHANGES = REVISION_CHANGES;
var objectType = '[object Object]';

function HandlebarsEnvironment(helpers, partials, decorators) {
  this.helpers = helpers || {};
  this.partials = partials || {};
  this.decorators = decorators || {};

  _helpers.registerDefaultHelpers(this);
  _decorators.registerDefaultDecorators(this);
}

HandlebarsEnvironment.prototype = {
  constructor: HandlebarsEnvironment,

  logger: _logger2['default'],
  log: _logger2['default'].log,

  registerHelper: function registerHelper(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple helpers');
      }
      _utils.extend(this.helpers, name);
    } else {
      this.helpers[name] = fn;
    }
  },
  unregisterHelper: function unregisterHelper(name) {
    delete this.helpers[name];
  },

  registerPartial: function registerPartial(name, partial) {
    if (_utils.toString.call(name) === objectType) {
      _utils.extend(this.partials, name);
    } else {
      if (typeof partial === 'undefined') {
        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
      }
      this.partials[name] = partial;
    }
  },
  unregisterPartial: function unregisterPartial(name) {
    delete this.partials[name];
  },

  registerDecorator: function registerDecorator(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple decorators');
      }
      _utils.extend(this.decorators, name);
    } else {
      this.decorators[name] = fn;
    }
  },
  unregisterDecorator: function unregisterDecorator(name) {
    delete this.decorators[name];
  },
  /**
   * Reset the memory of illegal property accesses that have already been logged.
   * @deprecated should only be used in handlebars test-cases
   */
  resetLoggedPropertyAccesses: function resetLoggedPropertyAccesses() {
    _internalProtoAccess.resetLoggedProperties();
  }
};

var log = _logger2['default'].log;

exports.log = log;
exports.createFrame = _utils.createFrame;
exports.logger = _logger2['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultHelpers = registerDefaultHelpers;
exports.moveHelperToHooks = moveHelperToHooks;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _helpersBlockHelperMissing = __webpack_require__(23);

var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

var _helpersEach = __webpack_require__(24);

var _helpersEach2 = _interopRequireDefault(_helpersEach);

var _helpersHelperMissing = __webpack_require__(25);

var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

var _helpersIf = __webpack_require__(26);

var _helpersIf2 = _interopRequireDefault(_helpersIf);

var _helpersLog = __webpack_require__(27);

var _helpersLog2 = _interopRequireDefault(_helpersLog);

var _helpersLookup = __webpack_require__(28);

var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

var _helpersWith = __webpack_require__(29);

var _helpersWith2 = _interopRequireDefault(_helpersWith);

function registerDefaultHelpers(instance) {
  _helpersBlockHelperMissing2['default'](instance);
  _helpersEach2['default'](instance);
  _helpersHelperMissing2['default'](instance);
  _helpersIf2['default'](instance);
  _helpersLog2['default'](instance);
  _helpersLookup2['default'](instance);
  _helpersWith2['default'](instance);
}

function moveHelperToHooks(instance, helperName, keepHelper) {
  if (instance.helpers[helperName]) {
    instance.hooks[helperName] = instance.helpers[helperName];
    if (!keepHelper) {
      delete instance.helpers[helperName];
    }
  }
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(4);

var logger = {
  methodMap: ['debug', 'info', 'warn', 'error'],
  level: 'info',

  // Maps a given level value to the `methodMap` indexes above.
  lookupLevel: function lookupLevel(level) {
    if (typeof level === 'string') {
      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
      if (levelMap >= 0) {
        level = levelMap;
      } else {
        level = parseInt(level, 10);
      }
    }

    return level;
  },

  // Can be overridden in the host environment
  log: function log(level) {
    level = logger.lookupLevel(level);

    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
      var method = logger.methodMap[level];
      // eslint-disable-next-line no-console
      if (!console[method]) {
        method = 'log';
      }

      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        message[_key - 1] = arguments[_key];
      }

      console[method].apply(console, message); // eslint-disable-line no-console
    }
  }
};

exports['default'] = logger;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createProtoAccessControl = createProtoAccessControl;
exports.resultIsAllowed = resultIsAllowed;
exports.resetLoggedProperties = resetLoggedProperties;
// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _createNewLookupObject = __webpack_require__(32);

var _logger = __webpack_require__(11);

var logger = _interopRequireWildcard(_logger);

var loggedProperties = Object.create(null);

function createProtoAccessControl(runtimeOptions) {
  var defaultMethodWhiteList = Object.create(null);
  defaultMethodWhiteList['constructor'] = false;
  defaultMethodWhiteList['__defineGetter__'] = false;
  defaultMethodWhiteList['__defineSetter__'] = false;
  defaultMethodWhiteList['__lookupGetter__'] = false;

  var defaultPropertyWhiteList = Object.create(null);
  // eslint-disable-next-line no-proto
  defaultPropertyWhiteList['__proto__'] = false;

  return {
    properties: {
      whitelist: _createNewLookupObject.createNewLookupObject(defaultPropertyWhiteList, runtimeOptions.allowedProtoProperties),
      defaultValue: runtimeOptions.allowProtoPropertiesByDefault
    },
    methods: {
      whitelist: _createNewLookupObject.createNewLookupObject(defaultMethodWhiteList, runtimeOptions.allowedProtoMethods),
      defaultValue: runtimeOptions.allowProtoMethodsByDefault
    }
  };
}

function resultIsAllowed(result, protoAccessControl, propertyName) {
  if (typeof result === 'function') {
    return checkWhiteList(protoAccessControl.methods, propertyName);
  } else {
    return checkWhiteList(protoAccessControl.properties, propertyName);
  }
}

function checkWhiteList(protoAccessControlForType, propertyName) {
  if (protoAccessControlForType.whitelist[propertyName] !== undefined) {
    return protoAccessControlForType.whitelist[propertyName] === true;
  }
  if (protoAccessControlForType.defaultValue !== undefined) {
    return protoAccessControlForType.defaultValue;
  }
  logUnexpecedPropertyAccessOnce(propertyName);
  return false;
}

function logUnexpecedPropertyAccessOnce(propertyName) {
  if (loggedProperties[propertyName] !== true) {
    loggedProperties[propertyName] = true;
    logger.log('error', 'Handlebars: Access has been denied to resolve the property "' + propertyName + '" because it is not an "own property" of its parent.\n' + 'You can add a runtime option to disable the check or this warning:\n' + 'See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details');
  }
}

function resetLoggedProperties() {
  Object.keys(loggedProperties).forEach(function (propertyName) {
    delete loggedProperties[propertyName];
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $         = __webpack_require__(3);            

/**
 * DOM utility class
 */
var DomUtil = {

    /**
     * Determine vendor specific css properties. 
     * This function create a div element, so it uses a lot of resources, result must be cached
     * @param  {String} prop "borderRadius" for exemple
     * @return {String}      return appropriate css property name
     */
    styleSupport:function ( prop ) {
        var vendorProp, supportedProp,

        // Capitalize first character of the prop to test vendor prefix
        capProp = prop.charAt( 0 ).toUpperCase() + prop.slice( 1 ),
        prefixes = [ "Moz", "Webkit", "O", "ms" ],
        div = document.createElement( "div" );

        if ( prop in div.style ) {
            // Browser supports standard CSS property name
            supportedProp = prop;
        }
        else {
            // Otherwise test support for vendor-prefixed property names
            for ( var i = 0; i < prefixes.length; i++ ) {
                vendorProp = prefixes[ i ] + capProp;
                if ( vendorProp in div.style ) {
                    supportedProp = vendorProp;
                    break;
                }
            }
        }

        // Avoid memory leak in IE
        div = null;

        return supportedProp;
    },

    /**
     * Determine which input events must be supported
     * @return {String} touch, pointer, or mouse
     */
    inputSupport:function () {
        var input;
        if("ontouchstart" in window){
            input="touch";
        }
        else if(window.navigator.pointerEnabled){
            input="pointer";            
        }
        else{
            input="mouse";
        }
        return input;
    },

    /**
     * Check if an element is partially visible in viewport
     * http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport/7557433#7557433
     * @param  {HTMLElement}  el 
     * @return {Boolean}    
     */
    isElementInViewport:function(el) {
        var rect = el.getBoundingClientRect();
        return !(
            rect.bottom <= 0 ||
            rect.top >= $(window).height()
        );
    },

    /**
     * check if current key down/up event occurs in an edit box like
     * @param  {Event}  e event fom keydow or keyup event
     * @return {Boolean}        [description]
     */
    isEditing:function(e){
        return (/input|textarea|select/i.test(e.target.nodeName) || e.target.contentEditable=="true");
    },

    /**
     * scroll to a position smoothly
     * @param  {Number} pos 
     */
    scrollTo:function(pos){
        $("html, body").animate({
            scrollTop: pos
        }, 500);
    },

    /**
     * Transforme duplique les events click en touchstart. C'est necessaire sur ipad car le système attends 400 ms 
     * avant de déclencher un click pour le différencier d'un drag ce qui donne une impression de lenteur
     * Attention a mettre un preventDefault dans la fonction pour ne pas avoir 2 events dans le cas où le device est à la fois tactile et souris
     * @param  {Object} events [description]
     * @return {Object}        [description]
     */
    clickToTouch:function(events){
        if(this.inputSupport()=="touch"){
            // transform click to touch events
            for (var key in events) {  
                if(key.indexOf("click")===0){  
                    var method=events[key];
                    var new_key=key.replace("click","touchstart");
                    events[new_key]=method;
                }
            }
        }
        return events;
    }

    
};

module.exports = DomUtil;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// Load modules


// Declare internals

var internals = {};
internals.hexTable = new Array(256);
for (var h = 0; h < 256; ++h) {
    internals.hexTable[h] = '%' + ((h < 16 ? '0' : '') + h.toString(16)).toUpperCase();
}


exports.arrayToObject = function (source, options) {

    var obj = options.plainObjects ? Object.create(null) : {};
    for (var i = 0, il = source.length; i < il; ++i) {
        if (typeof source[i] !== 'undefined') {

            obj[i] = source[i];
        }
    }

    return obj;
};


exports.merge = function (target, source, options) {

    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (Array.isArray(target)) {
            target.push(source);
        }
        else if (typeof target === 'object') {
            target[source] = true;
        }
        else {
            target = [target, source];
        }

        return target;
    }

    if (typeof target !== 'object') {
        target = [target].concat(source);
        return target;
    }

    if (Array.isArray(target) &&
        !Array.isArray(source)) {

        target = exports.arrayToObject(target, options);
    }

    var keys = Object.keys(source);
    for (var k = 0, kl = keys.length; k < kl; ++k) {
        var key = keys[k];
        var value = source[key];

        if (!Object.prototype.hasOwnProperty.call(target, key)) {
            target[key] = value;
        }
        else {
            target[key] = exports.merge(target[key], value, options);
        }
    }

    return target;
};


exports.decode = function (str) {

    try {
        return decodeURIComponent(str.replace(/\+/g, ' '));
    } catch (e) {
        return str;
    }
};

exports.encode = function (str) {

    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    if (typeof str !== 'string') {
        str = '' + str;
    }

    var out = '';
    for (var i = 0, il = str.length; i < il; ++i) {
        var c = str.charCodeAt(i);

        if (c === 0x2D || // -
            c === 0x2E || // .
            c === 0x5F || // _
            c === 0x7E || // ~
            (c >= 0x30 && c <= 0x39) || // 0-9
            (c >= 0x41 && c <= 0x5A) || // a-z
            (c >= 0x61 && c <= 0x7A)) { // A-Z

            out += str[i];
            continue;
        }

        if (c < 0x80) {
            out += internals.hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out += internals.hexTable[0xC0 | (c >> 6)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out += internals.hexTable[0xE0 | (c >> 12)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
            continue;
        }

        ++i;
        c = 0x10000 + (((c & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
        out += internals.hexTable[0xF0 | (c >> 18)] + internals.hexTable[0x80 | ((c >> 12) & 0x3F)] + internals.hexTable[0x80 | ((c >> 6) & 0x3F)] + internals.hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

exports.compact = function (obj, refs) {

    if (typeof obj !== 'object' ||
        obj === null) {

        return obj;
    }

    refs = refs || [];
    var lookup = refs.indexOf(obj);
    if (lookup !== -1) {
        return refs[lookup];
    }

    refs.push(obj);

    if (Array.isArray(obj)) {
        var compacted = [];

        for (var i = 0, il = obj.length; i < il; ++i) {
            if (typeof obj[i] !== 'undefined') {
                compacted.push(obj[i]);
            }
        }

        return compacted;
    }

    var keys = Object.keys(obj);
    for (i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        obj[key] = exports.compact(obj[key], refs);
    }

    return obj;
};


exports.isRegExp = function (obj) {

    return Object.prototype.toString.call(obj) === '[object RegExp]';
};


exports.isBuffer = function (obj) {

    if (obj === null ||
        typeof obj === 'undefined') {

        return false;
    }

    return !!(obj.constructor &&
              obj.constructor.isBuffer &&
              obj.constructor.isBuffer(obj));
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(3);
var Router = __webpack_require__(16);

var UrlUtil = __webpack_require__(71);
__webpack_require__(75);

var debug = __webpack_require__(2)("app"); //https://github.com/visionmedia/debug

var STR = __webpack_require__(7); // initialisation de la table des messages

__webpack_require__(76);

/**
 * 
 */
var ReaderApp = function (options) {
    var T = this;

    T.pv5api = null;
    T.version = "1.1.3";
    T.name = "pv5js-reader-bnd";
    T.lang = "fr";
    T.homeUrl = null;
    T.documentId = null;
    T.token = null;
    T.publicationId = null;
    T.useRouter = true;
    T.onPageChanged = null;
    T.onHomeClicked = null;
    T.onTrackingEvent = null;
    T.theme = "rbn-bnd";
    T.path = null;
    T.search = null; // {query: "Procédure SAUF pénal"}
    T.allowVecto = true; // en true par défaut le 25/11/2020 (+ blacklist côté serveur)
    T.vectoMinimalBandwidth = 8;
    T.currentUrl = null;
    
    // activate debug message, use debug=* for all messages
    var query_obj = UrlUtil.parseQueryString(window.location.search.replace("?", ""), ["debug"]);
    if (query_obj.debug == "true") {
        localStorage.debug = "*";
    } else if (query_obj.debug == "false") {
        delete (localStorage.debug);
    } else if (query_obj.debug) {
        localStorage.debug = query_obj.debug;
    }

    $.extend(true, T, options); // attention, c'est le deep extend de jquery qu'on utilise ici
    _.extend(T, Backbone.Events); // trigger stuff

    T.themeApi = T.pv5api;
   
    T.lang = STR.init(T.lang);

    T.webClipperMessage = T.webClipperMessage || STR.default_content_web_clipper_message;
    
    debug(T.name +" " + T.version);
    debug("debug enable " + localStorage.debug);

    T.router = new Router({
        app: this
    });

    if (T.useRouter) {

        var history_options;
        if (T.path) {
            history_options = {
                pushState: true,
                root: T.path
            };
        }

        Backbone.history.start(history_options);
    }
    else {
        T.router.reader(T.publicationId, T.documentId, T.page);
    }

};

ReaderApp.prototype.notify = function (data) {
    this.trigger("app:notify", data);
};

/**
 * désalloue tout ce qui a été créé
 */
ReaderApp.prototype.close = function () {
    var T = this;
    if (T.useRouter) {
        Backbone.history.stop();
    }
    T.router.app = null;
    T.router.close();
    T.router = null;
};

module.exports = ReaderApp;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone                = __webpack_require__(1);
var ReaderView              = __webpack_require__(17);
var $                       = __webpack_require__(3);

// Router
var Router = Backbone.Router.extend({

    routes: {
        "(/):publication_id/:document_id/:page"     : "reader",
        "(/):publication_id/:document_id"           : "reader",
        "(/):page"                                  : "readerPage",
        "(/)"                                       : "readerPage",
        "*error"                                    : "error404"
    },

    initialize: function(options){
        this.app=options.app;
    },

    readerPage: function(page) {
        this.reader(null,null,page);
    },

    reader: function(publication_id,document_id,page) {
        
        var route_template;

        if(this.view){
            this.view.close(); //close previous view
        }

        if(!page){
            page=1;
        }

        if(this.app.publicationId&&this.app.documentId){
            // on écrase les paramètres du hash par les paramètres passés par le js
            publication_id=this.app.publicationId;
            document_id=this.app.documentId;
            route_template="<%=page%>";
        }
        else{
            route_template="<%=publicationId%>/<%=documentId%>/<%=page%>";
        }

        this.view = new ReaderView({
            app:this.app,
            publicationId:publication_id,
            documentId:document_id,
            page:page,
            routeTemplate:route_template
        });

        $(this.app.el).html(this.view.render().el); // replace dom

    },

    error404:function(xxx){
        console.error("'"+xxx+"' is not a recognized route");
    },

    close:function(){
        if(this.view){
            this.view.close(); //close previous view
            this.view=null;
        }
    }
});

 module.exports = Router;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(3);
var STR = __webpack_require__(7);
var jwt_decode = __webpack_require__(8);

Backbone.$ = $;

var debug = __webpack_require__(2)("views:ReaderView"); //https://github.com/visionmedia/debug

// init handlebars
var hbs = __webpack_require__(22)["default"]; // https://github.com/wycats/handlebars.js
window.Handlebars = hbs;
Handlebars.$ = $; // pour que handlebars puisse utiliser underscore et jquery
Handlebars._ = _;

// From pv5js
var DocumentModel = __webpack_require__(37);
var PrintQuotaModel = __webpack_require__(41);
var PrintPasswordModel = __webpack_require__(42);
var DocumentView = __webpack_require__(43);
var StringUtil = __webpack_require__(45);
var OverlayLinksView = __webpack_require__(46);
var quota = __webpack_require__(47);
var PageSliderView = __webpack_require__(48);

var OverlayBarcodeView = __webpack_require__(49);
var OverlaySelectView = __webpack_require__(50);
var SearchInputView = __webpack_require__(51);
var BufferScramble = __webpack_require__(52);
var TokenUserPrintModel = __webpack_require__(53);
var ThumbnailsView = __webpack_require__(54);
var BookmarksModel = __webpack_require__(55);

var ThemeLoaderBw = __webpack_require__(56);

// From project
var ModalView = __webpack_require__(57);
var PrintPasswordView = __webpack_require__(59);
var BookmarksView = __webpack_require__(61);
var BndPageQueryModel = __webpack_require__(62);
var OverlayBndSearchView = __webpack_require__(63);

var templates = {
    reader: __webpack_require__(64),
    page: __webpack_require__(65),
    pageSliderKnob: __webpack_require__(66),
    pageSliderThumb: __webpack_require__(67),
    pageAuthorization: __webpack_require__(68),
    thumbnail: __webpack_require__(69),
    thumbnailCell: __webpack_require__(70)
};

/**
 */
module.exports = Backbone.View.extend({

    app: null, // store a reference to global app (mainly for configuration access)
    documentId: 0, //
    publicationId: 0, //
    page: 1, // starting page
    zoomFav: 1,
    fontSize: 15,
    minFontSize: 10,
    maxFontSize: 20,
    className: "app-reader",
    routeTemplate: "<%=publicationId%>/<%=documentId%>/<%=page%>",
    menuDisplayed: false,
    printQuota: null,
    sidePanel: false,
    mode: "page",
    scrollbarWidth: 0,
    isPhone: false,
    allowText: false,
    selectOverlayStatus: false,
    copyPasteMode: false,
    printCrypted: false,
    chunkSize: 1024,
    rangeSize: 256 * 1024,
    authorizedPages: null,
    displayQuality: "auto",
    webClipper: false, // affichage de l'entrée webclipper dans le menu
    bandwidth: 0,
    vectoLoadingTask: null,
    navigationBar: "show", // show/hide
    pageHistory: null,
    isSampler: false,
    displayedMenuLine: null,
    copiedText: null,

    events: {
        "click .tb-right .rbn-full-screen": "onFullscreenClicked",
        "click .tb-right .rbn-page-history": "onPageHistoryClicked",
        "click .tb-right .rbn-zoom-in": "onZoomInClicked",
        "click .tb-right .rbn-zoom-out": "onZoomOutClicked",
        "click .tb-right .rbn-next-page": "onNextPage",
        "click .tb-right .rbn-previous-page": "onPreviousPage",
        "click .tb-right .rbn-thumbnail": "onThumbnailCliked",
        "click .tb-top .rbn-home": "onHomeClicked",
        "click .tb-top .menu": "onMenuClicked",
        "click .tb-top .menu .line .header": "onMenuLineClicked",
        "click .tb-top .menu .print-document": "onPrintClicked",
        "click .tb-top .menu .copy-text": "onCopyClicked",
        "click .tb-top .menu .share-url": "onShareUrlClicked",
        "click #print-text-some-pages": "onPrintFocus",
        "click .tb-top .rbn-shortcut-print": "onShortcutPrintClicked",
        "click .tb-top .rbn-shortcut-search": "onShortcutSearchClicked",
        "click .tb-top .rbn-shortcut-copy": "onShortcutCopyClicked",
        "click .tb-top .rbn-shortcut-share": "onShortcutShareClicked",
        "click .tb-bottom .toc": "onTocClicked",
        "click .result .search-next": "onNextResult",
        "click .result .search-previous": "onPreviousResult",
        "click .tb-top .menu .refresh": "onRefreshClicked",
        "change .tb-top .menu #pref-display": "onPrefDisplayChanged",
        "change .tb-top .menu #pref-navigation": "onPrefNavigationChanged",
        "submit .tb-bottom .rbn-page-edit-form": "onPageEditSubmited",
        "click .side-panel .rbn-bookmarks-close": "onBookmarksCloseClicked",
        "click .tb-top .menu .search-go": "onSubmitSearch"
    },

    subViews: null, // array of subviews
    overlayViews: null, // array of page overlay views

    /**
     * @param  {Object} options must contains an "app" object and "query" from url
     */
    initialize: function (options) {
        var T = this;

        _.extend(T, options);

        T.eventSignature = "ev-reader-bnd";

        T.subViews = [];
        T.overlayViews = []; // page overlays
        T.modalView = null;

        T.langs = [];
        T.pageHistory = [];

        T.routeTemplate = _.template(T.routeTemplate); // compile route template
        T.template = _.template(templates.reader); // compile template

        // gestion globale des erreurs d'accès aux données
        $.ajaxSetup({
            statusCode: {
                401: function () {
                    if (T.app.token) {
                        if (T.app.onTokenExpired) {
                            T.app.onTokenExpired(T.app, T.app.token); // gestion de l'expiration du token par le front react
                        }
                        else {
                            // le token est tombé, on informe l'utilisateur et on recharge la page
                            T.notify({
                                text: STR.token_lost,
                                type: "error",
                                timeout: 3000
                            });
                            // et on recharge la page ?
                            setTimeout(function () {
                                window.location.reload(false);
                            }, 3000);
                        }
                    }
                },
                403: function () {
                    if (T.app.token && this.url.indexOf("print") == -1) {
                        // le token n'est pas correct pour ce document, on informe l'utilisateur seulement ... certainement qu'il faudrait retourner à la bibliothèque ?
                        T.notify({
                            text: STR.token_error,
                            type: "error",
                            timeout: 3000
                        });
                    }
                }
            }
        });

        // settings
        T.readSettings();
        $(window).on("unload." + T.eventSignature + " pagehide." + T.eventSignature, function () {
            // pagehide est nécessaire pour ios safari car unload n'est envoyé que dans certaines circonstances (https://webkit.org/blog/516/webkit-page-cache-ii-the-unload-event/)
            // dans le cas de chrome qui supporte unload et pagehide, writesettings sera appelé 2 fois ... mais pas grave
            T.writeSettings();
        });

        // fullscreen
        $(document).on("webkitfullscreenchange." + T.eventSignature + " mozfullscreenchange." + T.eventSignature + " fullscreenchange." + T.eventSignature + " MSFullscreenChange." + T.eventSignature, function (e) {
            T.onFullscreenChanged(e);
        });

        if (T.app.token) {
            var decoded = jwt_decode(T.app.token);

            debug("token :", decoded);
            T.printQuota = decoded.printQuota || decoded.pqu;
            T.allowText = decoded.ate;
            T.webClipper = decoded.wcl;
            if (decoded.bcd) {
                T.barcode = String(decoded.bcd);
                if (T.barcode.length < 12) {
                    T.barcode = "0".repeat(12 - T.barcode.length) + T.barcode; // ean13, 12 caractères, sinon on pad
                }
            }
            T.printCrypted = decoded.pro == "c" ? true : false;
            if (decoded.aup) {
                T.authorizedPages = quota.pagesFromString(decoded.aup, Number.MAX_VALUE, ";");
            }
        }

        //T.printQuota = "10/1w"; // debug simulate quota
        //T.printQuota = "0"; // debug simulate infinite quota
        T.allowText = 1; // debug simulate copy paste
        //T.printCrypted = true; // debug print pdf with password
        //T.authorizedPages = quota.pagesFromString("1;2-5;20", Number.MAX_VALUE, ";"); // debug partial access
        //T.webClipper = 1;
        //T.barcode = "123456789012";

        if (_.isArray(T.authorizedPages)) {
            T.isSampler = true;
        }

        // recherche dans le document entier, pour savoir dans quelle page chercher.
        // la taille du résultat sera configuré quand on aura récupéré le nombre de pages du document
        T.documentQueryModel = new BndPageQueryModel({
            filters: {
                documentUid: [T.publicationId + "_" + T.documentId]
            },
            source: ["number"],
            highlight: false,
            sort: "number" // sort by page number
        }, {
            pv5api: T.app.pv5api,
            token: T.app.token
        });
        T.listenTo(T.documentQueryModel, "sync", T.onDocumentSearchEnd);
        T._pageQueryModels = []; // search queries for each page

        T.documentModel = new DocumentModel({
            id: T.documentId,
            publicationId: T.publicationId
        }, {
            pv5api: T.app.pv5api,
            token: T.app.token
        });

        T.printQuotaModel = new PrintQuotaModel({
        }, {
            pv5api: T.app.pv5api,
            token: T.app.token
        });
        T.listenTo(T.printQuotaModel, "sync", T.onPrintQuotaLoaded);

        // DOCUMENT VIEW
        T.documentView = new DocumentView({
            model: T.documentModel,
            pageTemplate: templates.page,
            pageAuthorizationTemplate: templates.pageAuthorization,
            pageAuthorizationMessage: T.app.authorizationMessage || STR.default_content_auth_message,
            zoomMax: 2,
            zoomFav: T.zoomFav,
            zoomStepMultiplier: 1.4,
            tileHd: true,
            authorizedPages: T.authorizedPages
        });
        T.listenTo(T.documentView, "add:page-view", T.onPageViewAdded);
        T.listenTo(T.documentView, "render:page-view", T.onPageViewRendered);
        T.listenTo(T.documentView, "remove:page-view", T.onPageViewRemoved);
        T.subViews.push(T.documentView);

        // page thumbnail slider view
        T.pageSliderView = new PageSliderView({
            model: T.documentModel,
            templateKnob: templates.pageSliderKnob,
            templateThumb: templates.pageSliderThumb,
            authorizedPages: T.authorizedPages,
            fixedWidth: 30,
            usePageLabel: true
        });
        T.listenTo(T.pageSliderView, "drag:end", T.onSliderDragEnded);
        T.listenTo(T.pageSliderView, "click", T.onSliderClicked);
        T.subViews.push(T.pageSliderView);

        // mosaïque de vignettes
        T.thumbnailsView = new ThumbnailsView({
            model: T.documentModel,
            authorizedPages: T.authorizedPages,
            STR: STR,
            template: templates.thumbnail,
            templateCell: templates.thumbnailCell,
            usePageLabel: true
        });
        T.listenTo(T.thumbnailsView, "click", T.onThumbnailsClicked);
        T.subViews.push(T.thumbnailsView);

        T.bookmarksModel = new BookmarksModel({
            documentId: T.documentId,
            publicationId: T.publicationId
        }, {
            pv5api: T.app.pv5api,
            token: T.app.token
        });
        T.bookmarksView = new BookmarksView({
            STR: STR,
            model: T.bookmarksModel,
            nbVisibleLevels: 2
        });
        T.listenTo(T.bookmarksView, "click", T.onBookmarkClicked);
        T.subViews.push(T.bookmarksView);


        T.pageTermsView = new SearchInputView({
            model: T.documentQueryModel,
            fieldName: "query"
        });
        T.listenTo(T.pageTermsView, "submit", T.onSubmitSearch);
        T.subViews.push(T.pageTermsView);

        $(document).on("keydown." + T.eventSignature, function (e) {
            T.onKeyDown(e);
        });
        $(document).on("keyup." + T.eventSignature, function (e) {
            T.onKeyUp(e);
        });

        $(document).on("webclipperopen." + T.eventSignature, function (e) {
            T.onWebClipperOpen(e);
        });
        $(document).on("webclipperclose." + T.eventSignature, function (e) {
            T.onWebClipperClose(e);
        });

        T.listenTo(T.app, "app:notify", T.notify);

        T.listenTo(T.documentModel, "change:page", T.onPageChanged);// seul l'appel à documentView.gotoPage écrit la valeur dans ce modèle

        if (T.app.theme) {
            T.themeLoader = new ThemeLoaderBw({
                api: T.app.themeApi,
                id: T.app.theme,
                version: T.app.themeVersion,
                cacheBreaker: Date.now(),
                useTemplate: false
            });
            T.listenToOnce(T.themeLoader, "sync", T.onThemeLoaded);
            T.themeLoader.fetch();
        }
        else {
            // on ne charge pas de theme, cas kioskjs qui charge déjà un theme avec les styles  du reader
            T.onThemeLoaded(); // TODO voir si c'est toujours utilisé ? si oui il ne peut pas y avoir de test de bande passante
        }

        $(window).on("resize." + T.eventSignature, function () {
            T.onResize();
        });

    },

    onResize: function () {
        var T = this;

        T.checkPhone();
        T.$el.toggleClass("phone", T.isPhone);

        T.pageSliderView.resize();
        T.documentView.resize();

        T.thumbnailsView.onResize();

    },

    writeSettings: function () {
        var T = this,
            settings = {
                zoomFav: T.documentView.zoomFav,
                isFirstTime: false,
                displayQualityBis: T.displayQuality,
                navigationBar: T.navigationBar
            };
        localStorage.setItem("reader-settings", JSON.stringify(settings));
    },

    readSettings: function () {
        var T = this,
            settings = JSON.parse(localStorage.getItem("reader-settings"));
        if (settings) {
            T.zoomFav = settings.zoomFav || T.zoomFav;
            T.displayQuality = settings.displayQualityBis || "auto";
            T.navigationBar = settings.navigationBar || "show";
            if (!_.isUndefined(settings.isFirstTime)) {
                T.isFirstTime = settings.isFirstTime;
            }
        }
    },

    onThemeLoaded: function (e) {
        // load document
        var T = this;
        if (e) {
            T.bandwidth = e.bandwidth;
            debug("bandwidth: " + T.bandwidth + " Mbits/s");
        }
        T.render(); // on ne fait le rendu final que quand le theme est chargé
        T.listenToOnce(T.documentModel, "sync", T.onDocumentLoaded);
        T.documentModel.fetch({
            error: function () {
                T.notify({
                    text: STR.document_not_found,
                    type: "error",
                    timeout: 4000
                });
            }
        });
    },

    onDocumentLoaded: function () {
        var T = this;

        T.tealiumDocumentRef = {
            /*publication_title: T.documentModel.get("publicationTitle"),
            document_title: T.documentModel.get("title"),
            document_number: T.documentModel.get("id"),
            release_date: T.documentModel.get("published"),
            category: T.app.googleAnalytics.category,
            user_type: T.app.googleAnalytics.userType,
            user_ref: T.app.googleAnalytics.userRef,
            bandwidth: T.bandwidth*/
        };

        //T.track("open-reader");
        var server_pdf_max_pages = T.documentModel.get("serverPdfMaxPages");
        if (T.documentModel.get("nbPages") > server_pdf_max_pages) {
            // supprime la possibilité d'imprimer toutes les pages si le serveur ne le permet pas
            T.$("label[for='print-pdf-document']").remove();
            T.$(".server_pdf_max_pages").text(STR.server_pdf_max_pages(server_pdf_max_pages));
        }

        T.bookmarksModel.mtime = T.documentModel.get("mtime");

        T.updateMetadatas();

        // si le document déclare contenir du xml, chargement du xml et du theme utile
        //T.documentModel.set("reversed", true); //simulate arabic document
        //T.documentModel.set("hasVecto", false); // simulate VEC document

        // si le document est dispo en PDF et que cet platforme supporte le rendu vectoriel et que l'editeur autorise le vectoriel, on charge les libs et on charge le document
        // en mode accès partiel on interdit le vecto
        if (T.app.allowVecto && T.documentModel.get("hasVecto") && T.isPlatformSupportVecto() && (T.displayQuality == "high" || (T.displayQuality == "auto" && T.bandwidth >= T.app.vectoMinimalBandwidth)) && !_.isArray(T.authorizedPages)) {
            // on essaye de charger le premier chunk de pdf
            T.vectoChunk(0, T.rangeSize)
                .then(function (chunk) {
                    T.onFirstVectoLoaded(chunk);
                })
                .catch(function () {
                    // le pdf n'est finalement pas dispo, on switch sur les images
                    T.onDocumentLoadedPart2();
                });
        }
        else {
            T.onDocumentLoadedPart2();
        }
    },

    onFirstVectoLoaded: function (first_chunk) {
        var T = this;

        // ok pour vecto, on charge la lib
        $.getScript(T.app.pv5api + "/app/pdfjs/pdf.min.js", function () {

            pdfjsLib.GlobalWorkerOptions.workerSrc = T.app.pv5api + "/app/pdfjs/pdf.worker.min.js";

            var total = 0;
            var transport = new pdfjsLib.PDFDataRangeTransport(first_chunk.total, first_chunk.data);

            transport.requestDataRange = function (begin, end) {
                debug("request", begin, end, end - begin);
                T.vectoChunk(begin, end)
                    .then(function (chunk) {
                        transport.onDataProgress(total);
                        transport.onDataRange(begin, chunk.data);
                        total += (end - begin);
                    })
                    .catch(function (e) {
                        console.error(e);
                    });
            };

            pdfjsLib.getDocument({
                disableRange: false,
                disableStream: true,
                disableAutoFetch: true,
                rangeChunkSize: T.rangeSize,
                range: transport
            }).promise
                .then(function (pdf_document) {
                    T.vectoLoadingTask = pdf_document;
                    T.documentModel.set("pdfDocument", pdf_document);
                    T.onDocumentLoadedPart2();
                })
                .catch(function (e) {
                    // problème x ou y avec le pdf, on utilise les tuiles d'image sans avertir l'utilisateur
                    debug("PDF error, switching to tiles", e);
                    T.onDocumentLoadedPart2();
                });


        });
    },

    onDocumentLoadedPart2: function () {
        var T = this;

        T.track("open-reader");

        T.documentQueryModel.set("size", T.documentModel.get("nbPages"));
        T.documentView.gotoPage(T.reversePage(T.page), false);

        if (T.app.search && T.app.search.query && !T.isSampler) {
            // si on ouvre sur une page et qu'il y a une recherche valide et qu'on est pas en sampler
            T.documentQueryModel.set(T.app.search);
            T.displayMenu(true);
            T.displayMenuLine("search");
            T.documentQueryModel.search();
        }
    },


    isPlatformSupportVecto: function () {
        var is_ios = (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (/Mac/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1)); // à partir de ios 13 safari utilise le user-gent d'un Mac (https://stackoverflow.com/questions/9038625/detect-if-device-is-ios)
        if (/Android|webOS|Opera Mini/i.test(navigator.userAgent) || is_ios) {
            // en 2020, c'est encore trop juste niveau perf, on utilise les tuiles
            return false;
        }
        else {
            return true;
        }
    },

    isPageAuthorized: function (page) {
        var T = this;
        if (_.isArray(T.authorizedPages)) {
            return T.authorizedPages.indexOf(page) != -1;
        }
        else {
            return true;
        }
    },

    vectoChunk: function (begin, end) {
        var T = this;

        return new Promise(function (resolve, reject) {
            var url = T.documentModel.pdfUrl() + "/" + begin + "/" + (end - 1);
            url += "?mt=" + T.documentModel.get("mtime");
            var xhr = new XMLHttpRequest(url);
            xhr.open('GET', url);

            if (T.documentModel.token) {
                xhr.setRequestHeader("x-access-token", T.documentModel.token);
            }
            xhr.responseType = 'arraybuffer';
            xhr.onload = function () {

                // analyse du header content-range pour connaitre la taille totale du fichier
                var content_range = xhr.getResponseHeader('Content-Range');
                var total = 0;
                if (content_range) {
                    //bytes 0-262143/18920469
                    total = Number(_.last(content_range.split("/")));
                }
                else {
                    return reject(new Error("unable to find content-range header"));
                }

                // unscramble
                //console.log("scrambled:", xhr.response.toString());
                var chunk_size = T.chunkSize;
                var range_length = end - begin;
                if (range_length < 4 * chunk_size) {
                    chunk_size = Math.floor(range_length / 4);
                    if (chunk_size < 1) {
                        chunk_size = 1;
                    }
                }

                var seed = Number(String(T.publicationId) + String(T.documentId));
                var data = BufferScramble.unscramble(xhr.response, chunk_size, seed);
                //console.log("unscrambled:", data.toString());
                resolve({ data: data, total: total });
            };
            xhr.onerror = function () {
                reject(new Error("error fetching", begin, end, end - begin));
            };
            xhr.send();
        });
    },

    onPageChanged: function () {
        var T = this;

        T.updateRoute(T.pushRouteInHistory);
        T.pushRouteInHistory = false;

        T.highlightLinksInOverlays();


        T.track("open-page");
    },

    onPageViewAdded: function (page_view) {
        var T = this,
            page = page_view.page;

        if (!T.isPageAuthorized(page)) {
            return;
        }

        var page_model = T.documentModel.getPageModel(page);

        // overlay links
        var overlay_links_view = new OverlayLinksView({
            page: page,
            pageModel: page_model
        });
        T.listenTo(overlay_links_view, "click:link", T.onLinkClicked);
        T.overlayViews.push(overlay_links_view);

        // overlay search
        var page_query_model = new BndPageQueryModel({
            filters: {
                documentUid: [T.publicationId + "_" + T.documentId],
                number: [page]
            },
            highlight: true,
            highlightNumberOfFragments: 100,
            highlightFragmentSize: 100,
            highlightWordPosition: true,
            size: 1
        }, {
            pv5api: T.app.pv5api,
            token: T.app.token,
            page: page // pour la retrouver plus facilement par la suite
        });
        T._pageQueryModels.push(page_query_model);
        var search_view = new OverlayBndSearchView({
            page: page,
            pageModel: page_model,
            queryModel: page_query_model
        });
        T.overlayViews.push(search_view);

        if (T.barcode) {
            var barcode_view = new OverlayBarcodeView({
                page: page,
                pageModel: page_model,
                documentModel: T.documentModel,
                barcode: T.barcode,
                height: 4
            });
            T.overlayViews.push(barcode_view);
        }

        // selection pour copier/coller
        var selection = {};
        if (page == 1 || page == T.documentModel.get("nbPages")) {
            selection.x = 30;
            selection.y = 30;
            selection.width = 40;
            selection.height = 40;
        }
        else if (T.documentView.isPortrait) {
            if (page % 2) {
                // page impaire
                selection.x = 65;
                selection.y = 30;
            }
            else {
                // page paire
                selection.x = 15;
                selection.y = 30;
            }
            selection.width = 20;
            selection.height = 40;
        }
        else {
            // double page
            selection.x = 40;
            selection.y = 30;
            selection.width = 20;
            selection.height = 40;
        }

        var select_view = new OverlaySelectView({
            page: page,
            pageModel: page_model,
            hide: !T.selectOverlayStatus,
            selection: selection
        });
        T.listenTo(select_view, "select:start", T.onSelectStart);
        T.listenTo(select_view, "select:end", T.onSelectEnd);
        T.overlayViews.push(select_view);

        // lancer la recherche que si il le faut pour cette page
        if (T.isResultInPage(page)) {
            if (T.documentQueryModel.get("query")) {
                page_query_model.set("query", T.documentQueryModel.get("query"));
                page_query_model.search();
            }
        }

    },

    onPageViewRendered: function (page_view) {
        var T = this;

        if (!T.isPageAuthorized(page_view.page)) {
            return;
        }

        if (page_view.model.fetched) {
            var overlay_views = _.where(T.overlayViews, {
                page: page_view.page
            });

            overlay_views.forEach(function (overlay_view) {
                page_view.$tileContainer.append(overlay_view.el);
            });
        }
    },

    onPageViewRemoved: function (page_view) {
        var T = this;

        if (!T.isPageAuthorized(page_view.page)) {
            return;
        }

        T._pageQueryModels = _.difference(T._pageQueryModels, _.where(T._pageQueryModels, {
            page: page_view.page
        }));

        if (page_view.model.fetched) {
            var overlay_views = _.where(T.overlayViews, {
                page: page_view.page
            });
            overlay_views.forEach(function (overlay_view) {
                overlay_view.remove();
                T.stopListening(overlay_view);
                overlay_view.close();
            });
            T.overlayViews = _.difference(T.overlayViews, overlay_views);
        }
    },

    onLinkClicked: function (overlay_view, url) {
        var T = this;
        if (url) {
            var url_lower = url.toLowerCase();
            if (url_lower.indexOf("page:") === 0) {
                // url goto de sommaire
                var page = parseInt(url.substr(5), 10);
                T.track("inlink", page);
                T.documentView.gotoPage(page, true);
                T.pushRouteInHistory = true;
            } else if (url_lower.indexOf("mailto:") === 0) {
                // adresse mail
                window.location.href = url;
            } else {
                // site web
                if (!(url_lower.indexOf("http://") === 0 || url_lower.indexOf("https://") === 0)) {
                    // si l'url ne commence ni par http ni par https
                    url = "http://" + url;
                }

                window.open(url);
                T.track("outlink", url);
            }
        }
    },

    /**
     * détermine si l'espace dévolu au reader ressemble à un environnement smartphone
     * @return {Boolean} [description]
     */
    checkPhone: function () {

        this.isPhone = this.$el.width() <= 480 ? true : false;
        //return $(window).width() <= 480 ? true : false;
    },

    highlightLinksInOverlays: function () {
        var T = this;

        var page = T.documentModel.get("page");
        if (page > 1 && !T.documentView.isPortrait) {
            page = page % 2 ? page - 1 : page;
        }

        // highlight de l'entité dans l'overlay
        T.overlayViews.forEach(function (overlay_view) {
            if (overlay_view instanceof OverlayLinksView && overlay_view.page == page) {
                overlay_view.highlight();
            }
        });
    },

    updateRoute: function (push_route_in_history) {
        var T = this;
        var page = T.reversePage(T.documentModel.get("page"));
        var context = {
            publicationId: T.documentModel.get("publicationId"),
            documentId: T.documentModel.get("id"),
            page: page
        };

        T.pushPageHistory(page);

        if (T.app.onPageChanged) {
            T.app.onPageChanged(T.app, context);
        }

        // gestion bouton prev/next page
        T.$(".rbn-previous-page").toggleClass("disabled", page == 1);
        T.$(".rbn-next-page").toggleClass("disabled", page == T.documentModel.get("nbPages"));

        // mise à jour input pour rentrer le numéro de page
        var page_label = T.documentModel.pageLabelFromNumber(page);
        T.$(".rbn-page-edit-input").blur().val(page_label);

        if (T.app.useRouter) {

            var route = T.routeTemplate(context);

            T.app.router.navigate(
                route, {
                trigger: false,
                replace: !push_route_in_history
            }
            );
        }
    },

    updateMetadatas: function () {
        var T = this;
        if (!T.documentModel.fetched) return;
        var final_title = T.documentModel.get("title");
        if (T.documentModel.get("subtitle")) {
            final_title += " • " + T.documentModel.get("subtitle");
        }
        document.title = final_title;
        T.$(".document-title").html(final_title).attr("title", final_title);
        T.$(".rbn-page-edit-max").text(T.documentModel.get("nbPages"));
        T.onResize(); // le nombre de pages peut redimensionner le slider si > 999
    },

    onKeyDown: function (e) {
        var T = this,
            prevent = false,
            isEditing = false;

        if (/input|textarea|select/i.test(e.target.nodeName) || e.target.contentEditable == "true") {
            isEditing = true;
        }

        if (!isEditing) {
            // shortcuts only available if user is not entering text in an input
            if (e.keyCode == 39) {
                //"right" : next page or next article
                T.documentView.gotoPage("next", true);
                T.track("next-page");
                prevent = true;
            } else if (e.keyCode == 37) {
                //"left" : previous page or previous article
                T.documentView.gotoPage("previous", true);
                T.track("previous-page");
                prevent = true;
            } else if (e.keyCode == 9) {
                // tab
                T.onTocClicked();
                prevent = true;
            } else if (e.keyCode == 84 && e.altKey) {
                // alt + t : affiche le texte de la page pour debug
                window.open(T.documentModel.url() + "/page/" + T.documentModel.get("page") + "/text?mt=" + T.documentModel.get("mtime"));
                prevent = true;
            }
            else if (e.keyCode == 17) {
                // ctrl : temporarily disable tool
                T.$(".overlay-select").addClass("inactive");
            }
            /*else if (e.keyCode == 67 && (e.ctrlKey || e.metaKey)) {
                if (T.copyPasteMode) {
                    T.onCopyClicked();
                    prevent = true;
                }
            }*/
            else if (e.keyCode == 70 && (e.ctrlKey || e.metaKey) && !T.isSampler) {
                // ctrl + f
                T.displayMenu(true);
                T.displayMenuLine("search");
                T.$("#search-input-phrase").focus();
                prevent = true;
            }
        }

        if (prevent) {
            e.preventDefault();
        }
    },

    onKeyUp: function (e) {
        var T = this;

        if (e.keyCode == 17) {
            T.$(".overlay-select").removeClass("inactive");
        }
    },

    onWebClipperOpen: function () {
        debug("web clipper open");

    },

    onWebClipperClose: function () {
        debug("web clipper close");
    },


    onSliderDragEnded: function () {
        this.track("use-slider");
    },

    onSliderClicked: function () {
        this.track("use-slider");
    },

    onThumbnailsClicked: function (page) {
        var T = this;
        T.displayMenu(false);
        T.documentView.gotoPage(page, false);
        T.track("click-thumbnails");
    },

    onBookmarkClicked: function (page) {
        var T = this;
        if (T.isPhone) {
            T.displayToc(false);
        }
        T.documentView.gotoPage(page, false);
    },


    displayToc: function (show) {
        var T = this;

        if (show) {
            if (!T.bookmarksModel.fetched && !T.bookmarksModel.fetching) {
                T.bookmarksModel.fetch();
            }
            T.$el.addClass("show-panel");
            T.track("toc-panel");
        }
        else {
            T.$el.removeClass("show-panel");
        }
        T.sidePanel = show;
        T.onResize();
    },


    /**
     * go full screen
     */
    onFullscreenClicked: function () {
        var T = this;

        if (T.isFullscreen()) {
            T.exitFullscreen();
        } else {
            T.track("full-screen");
            T.enterFullscreen(document.body);
        }
    },

    onNextPage: function () {
        var T = this;
        T.documentView.gotoPage("next", true);
        T.track("next-page");
    },

    onPreviousPage: function () {
        var T = this;
        T.documentView.gotoPage("previous", true);
        T.track("previous-page");
    },

    onZoomInClicked: function () {
        var T = this;
        T.documentView.zoom("in", true);
    },

    onThumbnailCliked: function () {
        var T = this;
        T.displayMenu(true);
        T.displayMenuLine("thumbnails");
    },

    onShortcutPrintClicked: function () {
        var T = this;

        if (T.displayedMenuLine == "print") {
            T.displayMenu(false);
        }
        else {
            T.displayMenu(true);
            T.displayMenuLine("print");
        }
    },

    onShortcutSearchClicked: function () {
        var T = this;

        if (T.displayedMenuLine == "search") {
            T.displayMenu(false);
        }
        else {
            T.displayMenu(true);
            T.displayMenuLine("search");
        }
    },

    onShortcutShareClicked: function () {
        var T = this;
        if (T.displayedMenuLine == "share") {
            T.displayMenu(false);
        }
        else {
            T.displayMenu(true);
            T.displayMenuLine("share");
        }
    },

    onBookmarksCloseClicked: function () {
        this.displayToc(false);
    },

    onShortcutCopyClicked: function () {
        var T = this;
        if (T.displayedMenuLine == "copy") {
            T.displayMenu(false);
        }
        else {
            T.displayMenu(true);
            T.displayMenuLine("copy");
        }
    },

    onZoomOutClicked: function () {
        var T = this;
        T.documentView.zoom("out", true);
    },

    onHomeClicked: function () {
        var T = this;

        if (_.isFunction(T.app.onHomeClicked)) {
            T.app.onHomeClicked(T.app);
        }
        else if (T.app.homeUrl) {
            window.location = T.app.homeUrl;
        }
    },

    /**
     * Menu
     */

    onMenuClicked: function (e) {
        var T = this;
        if (!$(e.target).hasClass("menu")) return;
        T.displayMenu(!T.menuDisplayed);
    },

    displayMenu: function (show) {
        var T = this;
        debug("displayMenu", show);
        T.menuDisplayed = show;
        T.$(".tb-top .menu").toggleClass("on", T.menuDisplayed);
        T.$(".tb-top .menu .line .content").hide();
        T.$(".tb-top .menu .line").show();
        T.$(".tb-top .dropdown").removeClass("maximized");

        // disable shortcut on
        this.$(".rbn-shortcut.rbn-on").removeClass("rbn-on");

        if (show) {
            if (T.copyPasteMode) {
                T.enterCopyPasteMode(false);
            }
        }
        else {
            if (T.copyPasteMode) {
                T.enterCopyPasteMode(false);
            }
            if (T.thumbnailsView.enabled) {
                T.thumbnailsView.enable(false);
                T.$(".tb-top .toggle-mode").show();
            }
            T.displayedMenuLine = null;
        }
    },

    onMenuLineClicked: function (e) {
        var T = this;
        e.stopPropagation();

        if (!$(e.target).hasClass("header")) return;
        var action = $(e.target).parent().data("action");
        if (action) {
            T.displayMenuLine(action);
        }
    },

    displayMenuLine: function (action) {
        var T = this;

        if (action == "print" && T.printQuota && T.printQuota.indexOf("/") != -1) {
            // demande de la consommation
            T.printQuotaModel.fetch();
        }

        if (action == "print" || action == "search") {
            T.setMode("page");
        }

        if (action == "copy") {
            T.enterCopyPasteMode(true);
            T.$(".rbn-shortcut-copy").addClass("rbn-on");
            T.copiedText = null;
            T.$(".tb-top .dropdown .copy-text").addClass("disabled");
        }
        else if (action == "print") {
            T.$(".rbn-shortcut-print").addClass("rbn-on");
            T.track("print-panel");
        }
        else if (action == "share") {
            T.$(".rbn-shortcut-share").addClass("rbn-on");
            if (T.app.currentUrl) {
                var page = T.documentModel.get("page");
                var url = T.app.currentUrl(page);
                T.$("#share-url-text").text(url);
            }
            T.selectElementContents(T.$("#share-url-text")[0]);
        }
        else if (action == "search") {
            T.$(".rbn-shortcut-search").addClass("rbn-on");
            T.track("search", "click");
        }


        T.$(".tb-top .menu .line").hide();
        T.$(".tb-top .menu .line[data-action='" + action + "']").show();
        T.$(".tb-top .menu .line[data-action='" + action + "'] .content").show();

        if (action == "thumbnails") {
            T.track("open-thumbnails");
            T.$(".tb-top .dropdown").addClass("maximized");
            var thumbnails_page;
            if (T.mode == "page") {
                thumbnails_page = T.documentModel.get("page");
            }
            else {
                thumbnails_page = Number(T.entityPageLabel(0));
            }
            T.thumbnailsView.enable(true, thumbnails_page);
            T.$(".tb-top .toggle-mode").hide();
        }

        if (action == "search") {
            T.$("#search-input-phrase").focus();

        }
        T.displayedMenuLine = action;

    },

    onPrintFocus: function () {
        this.$("#print-pdf-some-page").prop("checked", true);
    },

    onSelectStart: function () {
        this.$(".tb-top .dropdown").addClass("select");
        this.copiedText = null;
        this.$(".tb-top .dropdown .copy-text").addClass("disabled");
    },

    onSelectEnd: function () {
        this.onCopySelectionEnd();
        this.$(".tb-top .dropdown").removeClass("select");
    },

    onShareUrlClicked: function () {
        var T = this;

        if (!T.app.currentUrl) return;

        var page = T.documentModel.get("page");
        var url = T.app.currentUrl(page);
        T.copyToClipboard(url);
        T.track("share");
    },

    onCopySelectionEnd: function () {
        // get selection
        var T = this;
        if (!T.copyPasteMode) return;

        // recherche de l'overlay courant
        var page = T.documentModel.get("page");
        if (page > 1 && !T.documentView.isPortrait) {
            page = page % 2 ? page - 1 : page;
        }

        T.track("copy");

        var page_model = T.documentModel.getPageModel(page),
            page_width = page_model.get("width"),
            page_height = page_model.get("height"),
            rectangle;


        // recherche de l'overlay de la page courante
        var overlay_views = _.where(T.overlayViews, {
            page: page
        });
        overlay_views.forEach(function (overlay_view) {
            if (overlay_view instanceof OverlaySelectView) {
                rectangle = {
                    left: Math.round(overlay_view.selection.x * page_width / 100),
                    top: Math.round(overlay_view.selection.y * page_height / 100),
                    right: Math.round((overlay_view.selection.x + overlay_view.selection.width) * page_width / 100),
                    bottom: Math.round((overlay_view.selection.y + overlay_view.selection.height) * page_height / 100)
                };
            }
        });

        if (rectangle) {

            // fetch text
            var url = page_model.textUrl(rectangle);
            var options = {
                url: url,
                headers: {
                },
                success: function (text) {

                    if (T.documentModel.get("reversed")) {
                        // on ne supprime pas les saut de ligne pour les documents arabes
                        // eslint-disable-next-line
                        text = text.replace(/[\x00-\x09\x0B\x0C\x0E-\x1F\x7F]/g, "").replace(/\s\s+/g, ' ');
                    }
                    else {
                        // eslint-disable-next-line
                        text = text.replace(/“ /g, "“").replace(/[\x00-\x09\x0B\x0C\x0E-\x1F\x7F]/g, "").replace(/\n/g, " ").replace(/\s\s+/g, ' ');
                    }

                    if (text.length) {
                        debug("clipboard text", text);
                        // enable button
                        T.$(".tb-top .dropdown .copy-text").removeClass("disabled");
                        T.copiedText = text;
                    }
                    else {
                        T.notify({
                            text: STR.copy_no_text,
                            type: "warning",
                            timeout: 4000
                        });
                    }
                },

                error: function (data, statut, erreur) {
                    T.notify({
                        text: erreur + " : " + data.responseJSON.message,
                        type: "error",
                        timeout: 6000
                    });
                }
            };
            if (T.app.token) {
                options.headers["x-access-token"] = T.app.token;
            }
            $.ajax(options);
        }

    },

    onCopyClicked: function (){
        if(this.copiedText){
            this.track("copy");
            this.copyToClipboard(this.copiedText);
        }
    },

    copyToClipboard: function (text) {
        var T = this;

        // sert pour la fonciton sélection de texte et pour la copie du code d'ouverture du pdf

        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function () {
                T.clipboardNotify(true, text);
            }, function () {
                T.clipboardNotify(false, text);
            });
        }
        else {
            // en 2019, la gestion de navigator.clipboard ne fonctionnait pas pour safari, 
            // on utilise la vielle méthode avec le textarea à la place ci-dessous
            var range = document.createRange();

            // from https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios
            var textArea = document.createElement("textarea");
            textArea.contentEditable = true;
            textArea.readOnly = false;
            textArea.value = text;
            document.body.appendChild(textArea);

            range.selectNodeContents(textArea);

            var s = window.getSelection();
            s.removeAllRanges();
            s.addRange(range);

            textArea.setSelectionRange(0, 999999);

            var success;
            try {
                success = document.execCommand('copy');
            } catch (e) {
                success = false;
            }
            T.clipboardNotify(success, text);
            document.body.removeChild(textArea);
        }

        // on créé une textarea cachée pour que l'extension web-clipper soit avertie d'une sélection de texte
        if (!T.$selectionEl) {
            T.$selectionEl = $("<textarea/>");
            T.$selectionEl.addClass("web-clipper-selection-text");
            T.$selectionEl.css({ display: "none" });
            T.$el.append(T.$selectionEl);
        }
        T.$selectionEl.val(text);
        T.$selectionEl.select();
        setTimeout(function () {
            T.$selectionEl.blur();
        }, 500);
    },

    clipboardNotify: function (success, text) {
        var T = this;
        if (success) {
            var str = STR.copy_ok;
            if (text) {
                str += " (" + text.substr(0, 20) + (text.length > 20 ? "…" : "") + ")";
            }
            T.notify({
                text: str,
                type: "info",
                timeout: 2000
            });
        } else {
            T.notify({
                text: STR.copy_nok,
                type: "error",
                timeout: 6000
            });
        }
    },

    enterCopyPasteMode: function (enter) {
        var T = this;
        T.copyPasteMode = enter;
        T.displaySelectOverlay(enter);
        T.$(".tb-top .dropdown").toggleClass("copy", enter);
    },

    displaySelectOverlay: function (show) {
        var T = this;
        T.selectOverlayStatus = show;
        T.$(".overlay-select").toggleClass("hide", !show);
    },

    displayPrintPassword: function (print_url, nb_pages) {
        var T = this;

        if (T.modalView) {
            T.modalView.close();
            T.modalView = null;
        }

        //
        var print_password_model = new PrintPasswordModel({
        }, {
            pv5api: T.app.pv5api,
            token: T.app.token
        });

        // affiche la modale qui présente le mot de passe du PDF
        var print_password_view = new PrintPasswordView({
            model: print_password_model,
            onNextCallback: function (pwd, password_token) {
                if (pwd) {

                    var final_print_url = print_url;
                    final_print_url += print_url.indexOf('?') == -1 ? "?" : "&";
                    final_print_url += "passwordToken=" + password_token;
                    window.open(final_print_url);
                    T.track('print', nb_pages);
                    //T.modalView.hide(); // si on cache, ios ne voudra plus ouvrir le lien
                }
            },
            onCopyCodeCallback: function (pwd) {
                if (pwd) {
                    T.copyToClipboard(pwd);
                }
            }

        });

        T.modalView = new ModalView({
            title: null,
            view: print_password_view,
            effect: "fade-in"
        });

        T.modalView.setElement($(".rbn-modal-print-password")).render();

        setTimeout(function () { T.modalView.show(); }, 50);

    },

    onRefreshClicked: function () {
        window.location.reload();
    },

    onPrefDisplayChanged: function () {
        var T = this;
        T.displayQuality = T.$('#pref-display').val();
        T.writeSettings();
    },

    onPrefNavigationChanged: function () {
        var T = this;
        T.navigationBar = T.$('#pref-navigation').val();
        T.writeSettings();

        if (T.navigationBar == "hide") {
            T.$(".tb-right").hide();
        }
        else {
            T.$(".tb-right").show();
        }

    },

    onTocClicked: function () {
        this.displayToc(!this.sidePanel);
    },

    onPageEditSubmited: function (e) {
        var T = this, page_label = T.$(".rbn-page-edit-input").blur().val();

        var page_number = T.documentModel.pageNumberFromLabel(page_label);

        if (page_number) {
            T.documentView.gotoPage(page_number);
            T.track("goto-page");
        }
        else {
            // soit page inconnue, soit page dans le 
            page_number = Number(page_label);
            if (page_number > 0 && page_number <= T.documentModel.get("nbPages")) {
                T.documentView.gotoPage(page_number);
                T.track("goto-page");
            }
            else {
                // notify
                T.notify({
                    text: "Impossible d'aller à la page \"" + page_label + "\"",
                    type: "warning",
                    timeout: 4000
                });
            }
        }
        e.preventDefault();
    },

    onPrintClicked: function (e) {
        var T = this,
            page_str = "1",
            error_str = null,
            need_reverse;

        e.stopPropagation(); // necessaire sur ios en 2019 sinon l'url ne s'ouvrira pas

        var type = T.$("input[name='print-group']:checked").val();
        if (type == "active-page") {
            page_str = T.pageLabel(0);
        } else if (type == "some-pages") {
            page_str = T.$("#print-text-some-pages").val().trim();

            // transforme les pages labels en number dans la string
            page_str = T.documentModel.convertPrintRangeLabel(page_str);

            if (!quota.checkPrintRangeSyntax(page_str, T.documentModel.get("nbPages"))) {
                error_str = STR.wrong_syntax_pages;
            }

            if (T.documentModel.get("reversed")) {
                need_reverse = true; // seule la série rentrée par l'utilisateur à besoin d'être retournée dans le cas d'un document arabe
            }
        }

        var nb_pages = quota.pagesFromString(page_str, T.documentModel.get("nbPages")).length;

        if (nb_pages > T.documentModel.get("serverPdfMaxPages")) {
            error_str = STR.print_quota_exceeded;
        }

        var max_pages = quota.counterFromString(T.printQuota);
        if (max_pages > 0 && T.printQuotaModel.get("counter") + nb_pages > max_pages) {
            error_str = STR.print_quota_exceeded;
        }

        if (T.authorizedPages && _.isArray(T.authorizedPages)) {
            // on checke que les pages demandées sont bien toutes autorisées
            var pages_requested = quota.pagesFromString(page_str, T.documentModel.get("nbPages"));
            var pages_intersection = _.intersection(T.authorizedPages, pages_requested);
            if (pages_intersection.length != pages_requested.length) {
                error_str = STR.print_pages_not_authorized;
            }
        }

        if (!error_str) {

            if (need_reverse) {
                page_str = quota.reversePrintRange(page_str, T.documentModel.get("nbPages"));
            }

            var token_user_print_model = new TokenUserPrintModel({
                documentId: T.documentId,
                publicationId: T.publicationId,
                pages: page_str
            }, {
                pv5api: T.app.pv5api,
                token: T.app.token,
            });

            T.printNbPages = nb_pages;

            T.listenToOnce(token_user_print_model, "sync", T.onTokenUserPrintGenerated);
            token_user_print_model.save();

        } else {
            T.notify({
                text: error_str,
                type: "warning",
                timeout: 8000
            });
        }
    },

    onTokenUserPrintGenerated: function (token_user_print_model) {
        var T = this;
        var url = T.app.pv5api + "/user-print";

        // on ajoute le nom de la publication en fin d'url pour que le titre de l'onglet soit présentable
        var title = STR.print + " : " + T.documentModel.get("publicationTitle");
        title = title.replace(/\//g, ' '); // si par hasard le nom de publication contient un /, sinon la route de pv5 ne sera plus vérifiée

        if (T.documentModel.get("title")) {
            title += " " + T.documentModel.get("title");
        }
        url += "/" + encodeURIComponent(title);

        url += "?lang=" + T.app.lang;

        if (T.app.token) {
            url += "&token=" + token_user_print_model.get("userPrintToken");
        }

        if (T.printCrypted) {
            // on affiche une modal avec un code
            T.displayMenu(false);
            T.displayPrintPassword(url, T.printNbPages);
        }
        else {
            var w = window.open(url); // ouvre le pdf dans un nouvel onglet, impossible d'afficher la boite d'impression directement en 2019
            if (w) {
                w.focus(); // important pour ios
                T.track('print', T.printNbPages);
                T.displayMenu(false);
            }
        }
    },

    pageLabel: function (pad) {
        var T = this;
        var page = T.documentModel.get("page");
        var page_label;
        if (T.documentModel.get("isDouble") && !T.documentView.isPortrait && page > 1 && page < T.documentModel.get("nbPages")) {
            if (page % 2) {
                page_label = StringUtil.pad(page - 1, pad) + "-" + StringUtil.pad(page, pad);
            } else {
                page_label = StringUtil.pad(page, pad) + "-" + StringUtil.pad(page + 1, pad);
            }
        } else {
            page_label = StringUtil.pad(page, pad);
        }
        return page_label;
    },


    track: function (event, arg) {
        var T = this;
        var event_name;

        if (!T.app.onTrackingEvent) return;
        if (!T.documentModel.fetched) return;

        if (event == "toc-panel") {
            event_name = "Sommaire";
        }
        else if (event == "open-thumbnails") {
            event_name = "Mosaique";
        }
        else if (event == "full-screen") {
            event_name = "Plein_ecran";
        }
        else if (event == "use-slider") {
            event_name = "Navigation_rapide";
        }
        else if (event == "next-page") {
            event_name = "Page_suivante";
        }
        else if (event == "previous-page") {
            event_name = "Page_precedente";
        }
        else if (event == "history-back") {
            event_name = "Revenir_sur_la_page_precedente";
        }
        else if (event == "goto-page") {
            event_name = "Aller_a";
        }
        else if (event == "share") {
            event_name = "Copier_url";
        }
        else if (event == "search") {
            if (arg == "click") {
                event_name = "Rechercher";
            }
            else if (arg == "go") {
                event_name = "Voir_les_mots_trouvés";
            }
            else {
                event_name = "Voir_le_mot_suivant";
            }
        }
        else if (event == "print") {
            event_name = "Imprimer";
        }
        else if (event == "copy") {
            event_name = "Copier";
        }

        if (event_name) {
            var document = T.documentModel.toJSON();
            delete (document.pdfDocument);
            T.app.onTrackingEvent(T.app, event_name, document);
        }
    },

    setMode: function (new_mode, options) {
        var T = this,
            page;

        options = options || {};

        if (!options.force && T.mode == new_mode) return;

        T.mode = new_mode;

        if (new_mode == "page") {
            T.$el.addClass("mode-page");
            T.documentView.enable = true;
            T.$(".tb-right").css("right", 0);
            T.documentView.resize();
            T.pageSliderView.resize();
            // recherche de la page correspondant à l'entité en cours
            if (options.page) {
                page = options.page;
            }

            var previous_page = T.documentModel.get("page");

            if (page) {
                T.documentView.gotoPage(page);
                if (page == previous_page) {
                    T.track("open-page");// on fait un tracking ici car le tracking sur page n'est pas déclenché si c'est la même page qui est affichée
                }
            }

        }
        T.track("change-mode");
    },

    /**
     * change button appearance when fullscreen change
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    onFullscreenChanged: function () {
        var T = this,
            fs = T.isFullscreen();

        T.$el.toggleClass("fullscreen", fs);
        T.$(".rbn-full-screen").toggleClass("on", fs); // mettre une class semble le plus stable, les pseudo class ne sont pas comprises par tous les navigateurs en 2015
        T.onResize();
    },

    isFullscreen: function () {
        return (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
    },

    enterFullscreen: function (el) {

        if (el.requestFullscreen) {
            el.requestFullscreen();
        } else if (el.webkitRequestFullscreen) {
            el.webkitRequestFullscreen();
        } else if (el.mozRequestFullScreen) {
            el.mozRequestFullScreen();
        } else if (el.msRequestFullscreen) {
            el.msRequestFullscreen();
        } else {
            throw new Error("Fullscreen not supported");
        }
    },

    exitFullscreen: function () {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    },


    /**
     * Display a sliding message from bottom
     * @param  {Object} data
     * {
     *      text:text,
     *      type:"error", //"error","info"
     *      timeout:10000
     *  }
     */
    notify: function (data) {
        var T = this;

        if (T.notifyTimer) {
            clearTimeout(T.notifyTimer);
        }

        T.$(".notify").addClass("show");
        T.$(".notify > p").attr("class", data.type).html(data.text);

        if (data.timeout) {
            T.notifyTimer = setTimeout(function () {
                T.notifyClose();
                T.notifyTimer = 0;
            }, data.timeout);
        }

    },

    notifyClose: function () {
        this.$(".notify").removeClass("show");
    },

    render: function () {
        var T = this;

        if (T.themeLoader && !T.themeLoader.fetched) return T;

        debug("render");

        var context = {
            STR: STR,
            webClipperMessage: T.app.webClipperMessage,
            fullscreenEnabled: document.fullscreenEnabled || document.mozFullscreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled
        };

        T.$el.html(T.template(context));
        T.$switchArticle = T.$(".switch-article");

        T.assign(T.documentView, ".document-view");
        T.assign(T.pageSliderView, ".page-slider");
        T.assign(T.thumbnailsView, ".line[data-action='thumbnails'] .content");
        T.assign(T.pageTermsView, "#search-input-phrase");
        T.assign(T.bookmarksView, ".rbn-bookmarks-view");


        T.$(".version").html(T.app.version);

        if (_.isUndefined(T.printQuota) || _.isNull(T.printQuota) || T.printQuota == "-1") {
            T.$(".line[data-action='print']").remove();
            T.$(".rbn-shortcut-print").remove();
        }
        else if (T.printQuota == "0") {
            // impression sans limites
            T.$(".line[data-action='print'] .quota").remove();
        }
        else {
            // impression avec quota
            T.renderQuota();
        }

        if (!T.allowText) {
            T.$(".line[data-action='copy']").remove();
            T.$(".rbn-shortcut-copy").remove();
        }


        if (T.navigationBar == "hide") {
            T.$(".tb-right").hide();
        }

        if (T.isSampler) {
            // on cache tout ce qui est recherche/impression/copier-coller/partage/mosaique/historique
            T.$(".line[data-action='search']").remove();
            T.$(".rbn-shortcut-search").remove();
            T.$(".line[data-action='print']").remove();
            T.$(".rbn-shortcut-print").remove();
            T.$(".line[data-action='copy']").remove();
            T.$(".rbn-shortcut-copy").remove();
            T.$(".line[data-action='share']").remove();
            T.$(".rbn-shortcut-share").remove();
            T.$(".line[data-action='thumbnails']").remove();
            T.$(".button.rbn-thumbnail").remove();
            T.$(".button.rbn-page-history").remove();

            // on ajoute un style global pour des ajustement en mode sampler (position zappette qui a moins de boutons par exemple)
            T.$el.addClass("sampler");
        }

        // preferences
        T.$('#pref-display option[value="' + T.displayQuality + '"]').prop('selected', true);
        T.$('#pref-navigation option[value="' + T.navigationBar + '"]').prop('selected', true);

        T.setMode(T.mode, { force: true });
        T.onResize();

        return T;
    },

    /**
     * remplit les valeurs de quota dans la boite d'impression
     */
    renderQuota: function () {
        var T = this;
        if (!T.printQuota) return;
        var nb_pages = quota.counterFromString(T.printQuota);
        var period = quota.periodFromString(T.printQuota);

        var unit = period.slice(-1);
        var unit_str;
        var number_of_unit = parseInt(period.substr(0, period.length - 1));

        unit_str = STR["print_period_" + unit + (number_of_unit > 1 ? "_plurial" : "")];

        var str_quota = "";

        // analyse de la période
        //str_quota = nb_pages + " pages par période de " + number_of_unit + " " + unit_str;
        str_quota = STR.print_quota_rule(nb_pages, number_of_unit + " " + unit_str);
        T.$("#quota-value").html(str_quota);
    },

    onPrintQuotaLoaded: function () {
        var T = this;
        T.$("#counter-value").html(STR.print_counter(T.printQuotaModel.get("counter")));
        T.$("#reset-value").html(new Date(T.printQuotaModel.get("resetAt")).toLocaleString());
    },

    computeScrollbarWidth: function () {
        var T = this;
        var $scroll_div = $("<div/>");
        $scroll_div.addClass("scrollbar-measure");
        T.$el.append($scroll_div);

        // Get the scrollbar width
        T.scrollbarWidth = $scroll_div[0].offsetWidth - $scroll_div[0].clientWidth;
        debug("scrollbar width:", T.scrollbarWidth); // Mac:  15

        // Delete the DIV 
        $scroll_div.remove();
    },

    /**
     * si le document est de type arabe, inverse la numérotation (fonctionne dans les 2 sens, reversed->original et original->reversed)
     */
    reversePage: function (page) {
        var T = this;
        if (T.documentModel.get("reversed")) {
            page = T.documentModel.get("nbPages") - page + 1;
        }
        return page;
    },

    /**
     * si le document est de type arabe, inverse la numérotation utilisée pour le tracking
     * @param {String} page_label "1" ou "2-3"
     */
    reversePageLabel: function (page_label) {
        var T = this;
        if (T.documentModel.get("reversed")) {
            var nb_pages = T.documentModel.get("nbPages");
            var page_label_spl = page_label.split("-");
            if (page_label_spl.length == 1) {
                var page = parseInt(page_label_spl[0]);
                page_label = String(nb_pages - page + 1);
            } else if (page_label_spl.length == 2) {
                var page_min = parseInt(page_label_spl[0]);
                var page_max = parseInt(page_label_spl[1]);
                page_label = String(nb_pages - page_max + 1) + "-" + String(nb_pages - page_min + 1);
            }
        }
        return page_label;
    },

    /**
     * Initiate a search in document from panel
     */
    onSubmitSearch: function () {
        var T = this;

        // reset all search query and overlays
        T.resetPageQuery();

        // disable next / prev button
        T.enableResultButtons(false);

        // initiate a new search in document if request is not empty
        if (T.documentQueryModel.get("query")) {

            T.$(".search-msg").text(STR.search_in_progress);

            T.documentQueryModel.search({
                error: function () {
                    T.$(".search-msg").text(STR.search_error);
                }
            });

            T.track("search", "go");
        }

    },

    /**
     * Disable/enable prev/next result  button
     * @param  {Bool} enable
     */
    enableResultButtons: function (enable) {
        var T = this;
        T.$(".content > .result").toggleClass("enable", enable);
    },


    onDocumentSearchEnd: function () {
        var T = this,
            hits = T.documentQueryModel.get("hits");

        var terms = "";
        if (T.documentQueryModel.get("query")) {
            terms += T.documentQueryModel.get("query");
        }

        if (hits.length) {
            T.notifyClose();
            _.each(T._pageQueryModels, function (page_query_model) {
                if (T.isResultInPage(page_query_model.page)) {
                    page_query_model.set("query", T.documentQueryModel.get("query"));
                    page_query_model.search();
                }
            });

            T.$(".search-msg").text(STR.search_found(terms, hits.length));
            T.enableResultButtons(true);

            //go to the first result
            T.gotoResult("nearest");
        } else {
            T.$(".search-msg").text('"' + terms + '"' + STR.search_not_found);
        }
    },

    /**
     * Reset page search queries and overlays
     */
    resetPageQuery: function () {
        var T = this;

        T.documentQueryModel.fetched = false;

        _.each(T._pageQueryModels, function (page_query_model) {
            page_query_model.fetched = false;
        });

        _.each(T.overlayViews, function (overlay_view) {
            if (overlay_view instanceof OverlayBndSearchView) {
                overlay_view.render();
            }
        });
    },

    /**
     * Determine if page is in result collection
     * @param  {Number}  p [description]
     * @return {Boolean}   [description]
     */
    isResultInPage: function (p) {
        var T = this,
            hits = T.documentQueryModel.get("hits"),
            found = false;

        if (T.documentQueryModel.fetched && hits.length) {
            hits.all(function (hit) {
                var page = hit.get("source").number[0];
                if (page == p) {
                    found = true;
                    return false;
                }
                return true;
            });
        }

        return found;
    },

    /**
     * Goto result, change page if needed
     * @param  {String} mode nearest, previous, next
     */
    gotoResult: function (mode) {
        var T = this,
            current_page = T.documentModel.get("page"),
            nearest_page = 0,
            results = T.documentQueryModel.get("hits"),
            result_index,
            results_reversed;

        if (T.documentQueryModel.fetched && results.length) {
            if (mode == "nearest") {
                // presque comme next et previous sauf qu'on regarde aussi dans la page courante
                if (T.documentModel.get("reversed")) {
                    // gestion doc reversed, on part de la fin et on remonte pour trouver la page la plus proche
                    results_reversed = results.first(results.length).reverse();
                    _.all(results_reversed, function (result) {
                        var page = result.get("source").number[0];
                        if (page <= current_page) {
                            nearest_page = page;
                            result_index = results.indexOf(result);
                            return false;
                        }
                        return true;
                    });
                    if (!nearest_page) {
                        result_index = results.length - 1;
                        nearest_page = results.last().get("source").number[0];
                    }
                }
                else {
                    results.all(function (result) {
                        var page = result.get("source").number[0];
                        if (page >= current_page) {
                            nearest_page = page;
                            result_index = results.indexOf(result);
                            return false;
                        }
                        return true;
                    });
                    if (!nearest_page) {
                        result_index = 0;
                        nearest_page = results.first().get("source").number[0];
                    }
                }
            } else if (mode == "next") {
                results.all(function (result) {
                    var page = result.get("source").number[0];
                    if (page > current_page) {
                        nearest_page = page;
                        result_index = results.indexOf(result);
                        return false;
                    }
                    return true;
                });
                if (!nearest_page) {
                    result_index = 0;
                    nearest_page = results.first().get("source").number[0];
                }
            } else if (mode == "previous") {
                results_reversed = results.first(results.length).reverse();
                _.all(results_reversed, function (result) {
                    var page = result.get("source").number[0];
                    if (page < current_page) {
                        nearest_page = page;
                        result_index = results.indexOf(result);
                        return false;
                    }
                    return true;
                });
                if (!nearest_page) {
                    result_index = results.length - 1;
                    nearest_page = results.last().get("source").number[0];
                }
            }

            if (nearest_page) {
                if (T.documentModel.get("reversed")) {
                    result_index = results.length - result_index - 1;
                }
                T.$(".search-index").text((result_index + 1) + " / " + results.length);
                if (nearest_page != current_page) {
                    T.documentView.gotoPage(nearest_page, true);// on va à la page
                }
            }
        }
    },

    onNextResult: function () {
        var T = this,
            direction = T.documentModel.get("reversed") ? "previous" : "next";

        T.gotoResult(direction);
        T.track("search", "next");
    },

    onPreviousResult: function () {
        var T = this,
            direction = T.documentModel.get("reversed") ? "next" : "previous";

        T.gotoResult(direction);
        T.track("search", "previous");
    },

    pushPageHistory: function (page) {
        var T = this;
        T.$(".rbn-page-history").toggleClass("disabled", this.pageHistory.length == 0);
        T.pageHistory.push(page);
    },

    onPageHistoryClicked: function () {
        var T = this;
        if (this.pageHistory.length < 2) {
            return;
        }
        T.pageHistory.pop();
        var page = T.pageHistory.pop();
        T.track("history-back");
        T.documentView.gotoPage(page);
    },

    selectElementContents: function (el) {
        var range = document.createRange();
        range.selectNodeContents(el);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    },

    /**
     * close each sub view and stop listening
     */
    close: function () {
        var T = this;

        T.writeSettings();

        T.subViews.forEach(function (view) {
            view.close();
        });
        T.subViews = null;
        T.overlayViews = null;
        T.$selectionEl = null;

        if (T.modalView) {
            T.modalView.close();
            T.modalView = null;
        }

        if (T.themeLoader) {
            T.themeLoader.close();
        }

        if (T.vectoLoadingTask) {
            T.documentModel.set("pdfDocument", null);
            T.vectoLoadingTask.destroy();
            T.vectoLoadingTask = null;
        }

        $.ajaxSetup({
            statusCode: {
                401: null,
                403: null
            }
        });

        $(document).off("." + T.eventSignature);
        $(window).off("." + T.eventSignature);

        T.stopListening();
        T.undelegateEvents();

        T.$el.empty();
    }

});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var atob = __webpack_require__(19);

function b64DecodeUnicode(str) {
  return decodeURIComponent(atob(str).replace(/(.)/g, function (m, p) {
    var code = p.charCodeAt(0).toString(16).toUpperCase();
    if (code.length < 2) {
      code = '0' + code;
    }
    return '%' + code;
  }));
}

module.exports = function(str) {
  var output = str.replace(/-/g, "+").replace(/_/g, "/");
  switch (output.length % 4) {
    case 0:
      break;
    case 2:
      output += "==";
      break;
    case 3:
      output += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }

  try{
    return b64DecodeUnicode(output);
  } catch (err) {
    return atob(output);
  }
};


/***/ }),
/* 19 */
/***/ (function(module, exports) {

/**
 * The code was extracted from:
 * https://github.com/davidchambers/Base64.js
 */

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function InvalidCharacterError(message) {
  this.message = message;
}

InvalidCharacterError.prototype = new Error();
InvalidCharacterError.prototype.name = 'InvalidCharacterError';

function polyfill (input) {
  var str = String(input).replace(/=+$/, '');
  if (str.length % 4 == 1) {
    throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
  }
  for (
    // initialize result and counters
    var bc = 0, bs, buffer, idx = 0, output = '';
    // get next character
    buffer = str.charAt(idx++);
    // character found in table? initialize bit storage and add its ascii value;
    ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
      // and if not first of each 4 characters,
      // convert the first 8 bits to one ascii character
      bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
  ) {
    // try to find character in table (0-63, not found => -1)
    buffer = chars.indexOf(buffer);
  }
  return output;
}


module.exports = typeof window !== 'undefined' && window.atob && window.atob.bind(window) || polyfill;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(21);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 21 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _handlebarsBase = __webpack_require__(9);

var base = _interopRequireWildcard(_handlebarsBase);

// Each of these augment the Handlebars object. No need to setup here.
// (This is done to easily share code between commonjs and browse envs)

var _handlebarsSafeString = __webpack_require__(33);

var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

var _handlebarsException = __webpack_require__(5);

var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

var _handlebarsUtils = __webpack_require__(4);

var Utils = _interopRequireWildcard(_handlebarsUtils);

var _handlebarsRuntime = __webpack_require__(34);

var runtime = _interopRequireWildcard(_handlebarsRuntime);

var _handlebarsNoConflict = __webpack_require__(36);

var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

// For compatibility and usage outside of module systems, make the Handlebars object a namespace
function create() {
  var hb = new base.HandlebarsEnvironment();

  Utils.extend(hb, base);
  hb.SafeString = _handlebarsSafeString2['default'];
  hb.Exception = _handlebarsException2['default'];
  hb.Utils = Utils;
  hb.escapeExpression = Utils.escapeExpression;

  hb.VM = runtime;
  hb.template = function (spec) {
    return runtime.template(spec, hb);
  };

  return hb;
}

var inst = create();
inst.create = create;

_handlebarsNoConflict2['default'](inst);

inst['default'] = inst;

exports['default'] = inst;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(4);

exports['default'] = function (instance) {
  instance.registerHelper('blockHelperMissing', function (context, options) {
    var inverse = options.inverse,
        fn = options.fn;

    if (context === true) {
      return fn(this);
    } else if (context === false || context == null) {
      return inverse(this);
    } else if (_utils.isArray(context)) {
      if (context.length > 0) {
        if (options.ids) {
          options.ids = [options.name];
        }

        return instance.helpers.each(context, options);
      } else {
        return inverse(this);
      }
    } else {
      if (options.data && options.ids) {
        var data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
        options = { data: data };
      }

      return fn(context, options);
    }
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(4);

var _exception = __webpack_require__(5);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('each', function (context, options) {
    if (!options) {
      throw new _exception2['default']('Must pass iterator to #each');
    }

    var fn = options.fn,
        inverse = options.inverse,
        i = 0,
        ret = '',
        data = undefined,
        contextPath = undefined;

    if (options.data && options.ids) {
      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
    }

    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    if (options.data) {
      data = _utils.createFrame(options.data);
    }

    function execIteration(field, index, last) {
      if (data) {
        data.key = field;
        data.index = index;
        data.first = index === 0;
        data.last = !!last;

        if (contextPath) {
          data.contextPath = contextPath + field;
        }
      }

      ret = ret + fn(context[field], {
        data: data,
        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
      });
    }

    if (context && typeof context === 'object') {
      if (_utils.isArray(context)) {
        for (var j = context.length; i < j; i++) {
          if (i in context) {
            execIteration(i, i, i === context.length - 1);
          }
        }
      } else if (global.Symbol && context[global.Symbol.iterator]) {
        var newContext = [];
        var iterator = context[global.Symbol.iterator]();
        for (var it = iterator.next(); !it.done; it = iterator.next()) {
          newContext.push(it.value);
        }
        context = newContext;
        for (var j = context.length; i < j; i++) {
          execIteration(i, i, i === context.length - 1);
        }
      } else {
        (function () {
          var priorKey = undefined;

          Object.keys(context).forEach(function (key) {
            // We're running the iterations one step out of sync so we can detect
            // the last iteration without have to scan the object twice and create
            // an itermediate keys array.
            if (priorKey !== undefined) {
              execIteration(priorKey, i - 1);
            }
            priorKey = key;
            i++;
          });
          if (priorKey !== undefined) {
            execIteration(priorKey, i - 1, true);
          }
        })();
      }
    }

    if (i === 0) {
      ret = inverse(this);
    }

    return ret;
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _exception = __webpack_require__(5);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('helperMissing', function () /* [args, ]options */{
    if (arguments.length === 1) {
      // A missing field in a {{foo}} construct.
      return undefined;
    } else {
      // Someone is actually trying to call something, blow up.
      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    }
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvaGVscGVyLW1pc3NpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozt5QkFBc0IsY0FBYzs7OztxQkFFckIsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxlQUFlLEVBQUUsaUNBQWdDO0FBQ3ZFLFFBQUksU0FBUyxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7O0FBRTFCLGFBQU8sU0FBUyxDQUFDO0tBQ2xCLE1BQU07O0FBRUwsWUFBTSwyQkFDSixtQkFBbUIsR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUNqRSxDQUFDO0tBQ0g7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJoZWxwZXItbWlzc2luZy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBFeGNlcHRpb24gZnJvbSAnLi4vZXhjZXB0aW9uJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2hlbHBlck1pc3NpbmcnLCBmdW5jdGlvbigvKiBbYXJncywgXW9wdGlvbnMgKi8pIHtcbiAgICBpZiAoYXJndW1lbnRzLmxlbmd0aCA9PT0gMSkge1xuICAgICAgLy8gQSBtaXNzaW5nIGZpZWxkIGluIGEge3tmb299fSBjb25zdHJ1Y3QuXG4gICAgICByZXR1cm4gdW5kZWZpbmVkO1xuICAgIH0gZWxzZSB7XG4gICAgICAvLyBTb21lb25lIGlzIGFjdHVhbGx5IHRyeWluZyB0byBjYWxsIHNvbWV0aGluZywgYmxvdyB1cC5cbiAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oXG4gICAgICAgICdNaXNzaW5nIGhlbHBlcjogXCInICsgYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXS5uYW1lICsgJ1wiJ1xuICAgICAgKTtcbiAgICB9XG4gIH0pO1xufVxuIl19


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(4);

var _exception = __webpack_require__(5);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('if', function (conditional, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#if requires exactly one argument');
    }
    if (_utils.isFunction(conditional)) {
      conditional = conditional.call(this);
    }

    // Default behavior is to render the positive path if the value is truthy and not empty.
    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  instance.registerHelper('unless', function (conditional, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#unless requires exactly one argument');
    }
    return instance.helpers['if'].call(this, conditional, {
      fn: options.inverse,
      inverse: options.fn,
      hash: options.hash
    });
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('log', function () /* message, options */{
    var args = [undefined],
        options = arguments[arguments.length - 1];
    for (var i = 0; i < arguments.length - 1; i++) {
      args.push(arguments[i]);
    }

    var level = 1;
    if (options.hash.level != null) {
      level = options.hash.level;
    } else if (options.data && options.data.level != null) {
      level = options.data.level;
    }
    args[0] = level;

    instance.log.apply(instance, args);
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxLQUFLLEVBQUUsa0NBQWlDO0FBQzlELFFBQUksSUFBSSxHQUFHLENBQUMsU0FBUyxDQUFDO1FBQ3BCLE9BQU8sR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztBQUM1QyxTQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7QUFDN0MsVUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUN6Qjs7QUFFRCxRQUFJLEtBQUssR0FBRyxDQUFDLENBQUM7QUFDZCxRQUFJLE9BQU8sQ0FBQyxJQUFJLENBQUMsS0FBSyxJQUFJLElBQUksRUFBRTtBQUM5QixXQUFLLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7S0FDNUIsTUFBTSxJQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxFQUFFO0FBQ3JELFdBQUssR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQztLQUM1QjtBQUNELFFBQUksQ0FBQyxDQUFDLENBQUMsR0FBRyxLQUFLLENBQUM7O0FBRWhCLFlBQVEsQ0FBQyxHQUFHLE1BQUEsQ0FBWixRQUFRLEVBQVEsSUFBSSxDQUFDLENBQUM7R0FDdkIsQ0FBQyxDQUFDO0NBQ0oiLCJmaWxlIjoibG9nLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2xvZycsIGZ1bmN0aW9uKC8qIG1lc3NhZ2UsIG9wdGlvbnMgKi8pIHtcbiAgICBsZXQgYXJncyA9IFt1bmRlZmluZWRdLFxuICAgICAgb3B0aW9ucyA9IGFyZ3VtZW50c1thcmd1bWVudHMubGVuZ3RoIC0gMV07XG4gICAgZm9yIChsZXQgaSA9IDA7IGkgPCBhcmd1bWVudHMubGVuZ3RoIC0gMTsgaSsrKSB7XG4gICAgICBhcmdzLnB1c2goYXJndW1lbnRzW2ldKTtcbiAgICB9XG5cbiAgICBsZXQgbGV2ZWwgPSAxO1xuICAgIGlmIChvcHRpb25zLmhhc2gubGV2ZWwgIT0gbnVsbCkge1xuICAgICAgbGV2ZWwgPSBvcHRpb25zLmhhc2gubGV2ZWw7XG4gICAgfSBlbHNlIGlmIChvcHRpb25zLmRhdGEgJiYgb3B0aW9ucy5kYXRhLmxldmVsICE9IG51bGwpIHtcbiAgICAgIGxldmVsID0gb3B0aW9ucy5kYXRhLmxldmVsO1xuICAgIH1cbiAgICBhcmdzWzBdID0gbGV2ZWw7XG5cbiAgICBpbnN0YW5jZS5sb2coLi4uYXJncyk7XG4gIH0pO1xufVxuIl19


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('lookup', function (obj, field, options) {
    if (!obj) {
      // Note for 5.0: Change to "obj == null" in 5.0
      return obj;
    }
    return options.lookupProperty(obj, field);
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9va3VwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxRQUFRLEVBQUUsVUFBUyxHQUFHLEVBQUUsS0FBSyxFQUFFLE9BQU8sRUFBRTtBQUM5RCxRQUFJLENBQUMsR0FBRyxFQUFFOztBQUVSLGFBQU8sR0FBRyxDQUFDO0tBQ1o7QUFDRCxXQUFPLE9BQU8sQ0FBQyxjQUFjLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxDQUFDO0dBQzNDLENBQUMsQ0FBQztDQUNKIiwiZmlsZSI6Imxvb2t1cC5qcyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKGluc3RhbmNlKSB7XG4gIGluc3RhbmNlLnJlZ2lzdGVySGVscGVyKCdsb29rdXAnLCBmdW5jdGlvbihvYmosIGZpZWxkLCBvcHRpb25zKSB7XG4gICAgaWYgKCFvYmopIHtcbiAgICAgIC8vIE5vdGUgZm9yIDUuMDogQ2hhbmdlIHRvIFwib2JqID09IG51bGxcIiBpbiA1LjBcbiAgICAgIHJldHVybiBvYmo7XG4gICAgfVxuICAgIHJldHVybiBvcHRpb25zLmxvb2t1cFByb3BlcnR5KG9iaiwgZmllbGQpO1xuICB9KTtcbn1cbiJdfQ==


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(4);

var _exception = __webpack_require__(5);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('with', function (context, options) {
    if (arguments.length != 2) {
      throw new _exception2['default']('#with requires exactly one argument');
    }
    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    var fn = options.fn;

    if (!_utils.isEmpty(context)) {
      var data = options.data;
      if (options.data && options.ids) {
        data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
      }

      return fn(context, {
        data: data,
        blockParams: _utils.blockParams([context], [data && data.contextPath])
      });
    } else {
      return options.inverse(this);
    }
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvd2l0aC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7O3FCQU1PLFVBQVU7O3lCQUNLLGNBQWM7Ozs7cUJBRXJCLFVBQVMsUUFBUSxFQUFFO0FBQ2hDLFVBQVEsQ0FBQyxjQUFjLENBQUMsTUFBTSxFQUFFLFVBQVMsT0FBTyxFQUFFLE9BQU8sRUFBRTtBQUN6RCxRQUFJLFNBQVMsQ0FBQyxNQUFNLElBQUksQ0FBQyxFQUFFO0FBQ3pCLFlBQU0sMkJBQWMscUNBQXFDLENBQUMsQ0FBQztLQUM1RDtBQUNELFFBQUksa0JBQVcsT0FBTyxDQUFDLEVBQUU7QUFDdkIsYUFBTyxHQUFHLE9BQU8sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUM7S0FDOUI7O0FBRUQsUUFBSSxFQUFFLEdBQUcsT0FBTyxDQUFDLEVBQUUsQ0FBQzs7QUFFcEIsUUFBSSxDQUFDLGVBQVEsT0FBTyxDQUFDLEVBQUU7QUFDckIsVUFBSSxJQUFJLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQztBQUN4QixVQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLEdBQUcsRUFBRTtBQUMvQixZQUFJLEdBQUcsbUJBQVksT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDO0FBQ2pDLFlBQUksQ0FBQyxXQUFXLEdBQUcseUJBQ2pCLE9BQU8sQ0FBQyxJQUFJLENBQUMsV0FBVyxFQUN4QixPQUFPLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUNmLENBQUM7T0FDSDs7QUFFRCxhQUFPLEVBQUUsQ0FBQyxPQUFPLEVBQUU7QUFDakIsWUFBSSxFQUFFLElBQUk7QUFDVixtQkFBVyxFQUFFLG1CQUFZLENBQUMsT0FBTyxDQUFDLEVBQUUsQ0FBQyxJQUFJLElBQUksSUFBSSxDQUFDLFdBQVcsQ0FBQyxDQUFDO09BQ2hFLENBQUMsQ0FBQztLQUNKLE1BQU07QUFDTCxhQUFPLE9BQU8sQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7S0FDOUI7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJ3aXRoLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtcbiAgYXBwZW5kQ29udGV4dFBhdGgsXG4gIGJsb2NrUGFyYW1zLFxuICBjcmVhdGVGcmFtZSxcbiAgaXNFbXB0eSxcbiAgaXNGdW5jdGlvblxufSBmcm9tICcuLi91dGlscyc7XG5pbXBvcnQgRXhjZXB0aW9uIGZyb20gJy4uL2V4Y2VwdGlvbic7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKGluc3RhbmNlKSB7XG4gIGluc3RhbmNlLnJlZ2lzdGVySGVscGVyKCd3aXRoJywgZnVuY3Rpb24oY29udGV4dCwgb3B0aW9ucykge1xuICAgIGlmIChhcmd1bWVudHMubGVuZ3RoICE9IDIpIHtcbiAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oJyN3aXRoIHJlcXVpcmVzIGV4YWN0bHkgb25lIGFyZ3VtZW50Jyk7XG4gICAgfVxuICAgIGlmIChpc0Z1bmN0aW9uKGNvbnRleHQpKSB7XG4gICAgICBjb250ZXh0ID0gY29udGV4dC5jYWxsKHRoaXMpO1xuICAgIH1cblxuICAgIGxldCBmbiA9IG9wdGlvbnMuZm47XG5cbiAgICBpZiAoIWlzRW1wdHkoY29udGV4dCkpIHtcbiAgICAgIGxldCBkYXRhID0gb3B0aW9ucy5kYXRhO1xuICAgICAgaWYgKG9wdGlvbnMuZGF0YSAmJiBvcHRpb25zLmlkcykge1xuICAgICAgICBkYXRhID0gY3JlYXRlRnJhbWUob3B0aW9ucy5kYXRhKTtcbiAgICAgICAgZGF0YS5jb250ZXh0UGF0aCA9IGFwcGVuZENvbnRleHRQYXRoKFxuICAgICAgICAgIG9wdGlvbnMuZGF0YS5jb250ZXh0UGF0aCxcbiAgICAgICAgICBvcHRpb25zLmlkc1swXVxuICAgICAgICApO1xuICAgICAgfVxuXG4gICAgICByZXR1cm4gZm4oY29udGV4dCwge1xuICAgICAgICBkYXRhOiBkYXRhLFxuICAgICAgICBibG9ja1BhcmFtczogYmxvY2tQYXJhbXMoW2NvbnRleHRdLCBbZGF0YSAmJiBkYXRhLmNvbnRleHRQYXRoXSlcbiAgICAgIH0pO1xuICAgIH0gZWxzZSB7XG4gICAgICByZXR1cm4gb3B0aW9ucy5pbnZlcnNlKHRoaXMpO1xuICAgIH1cbiAgfSk7XG59XG4iXX0=


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultDecorators = registerDefaultDecorators;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _decoratorsInline = __webpack_require__(31);

var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

function registerDefaultDecorators(instance) {
  _decoratorsInline2['default'](instance);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Z0NBQTJCLHFCQUFxQjs7OztBQUV6QyxTQUFTLHlCQUF5QixDQUFDLFFBQVEsRUFBRTtBQUNsRCxnQ0FBZSxRQUFRLENBQUMsQ0FBQztDQUMxQiIsImZpbGUiOiJkZWNvcmF0b3JzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHJlZ2lzdGVySW5saW5lIGZyb20gJy4vZGVjb3JhdG9ycy9pbmxpbmUnO1xuXG5leHBvcnQgZnVuY3Rpb24gcmVnaXN0ZXJEZWZhdWx0RGVjb3JhdG9ycyhpbnN0YW5jZSkge1xuICByZWdpc3RlcklubGluZShpbnN0YW5jZSk7XG59XG4iXX0=


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(4);

exports['default'] = function (instance) {
  instance.registerDecorator('inline', function (fn, props, container, options) {
    var ret = fn;
    if (!props.partials) {
      props.partials = {};
      ret = function (context, options) {
        // Create a new partials stack frame prior to exec.
        var original = container.partials;
        container.partials = _utils.extend({}, original, props.partials);
        var ret = fn(context, options);
        container.partials = original;
        return ret;
      };
    }

    props.partials[options.args[0]] = options.fn;

    return ret;
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMvaW5saW5lLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQXVCLFVBQVU7O3FCQUVsQixVQUFTLFFBQVEsRUFBRTtBQUNoQyxVQUFRLENBQUMsaUJBQWlCLENBQUMsUUFBUSxFQUFFLFVBQVMsRUFBRSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsT0FBTyxFQUFFO0FBQzNFLFFBQUksR0FBRyxHQUFHLEVBQUUsQ0FBQztBQUNiLFFBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUFFO0FBQ25CLFdBQUssQ0FBQyxRQUFRLEdBQUcsRUFBRSxDQUFDO0FBQ3BCLFNBQUcsR0FBRyxVQUFTLE9BQU8sRUFBRSxPQUFPLEVBQUU7O0FBRS9CLFlBQUksUUFBUSxHQUFHLFNBQVMsQ0FBQyxRQUFRLENBQUM7QUFDbEMsaUJBQVMsQ0FBQyxRQUFRLEdBQUcsY0FBTyxFQUFFLEVBQUUsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUMxRCxZQUFJLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQy9CLGlCQUFTLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztBQUM5QixlQUFPLEdBQUcsQ0FBQztPQUNaLENBQUM7S0FDSDs7QUFFRCxTQUFLLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxPQUFPLENBQUMsRUFBRSxDQUFDOztBQUU3QyxXQUFPLEdBQUcsQ0FBQztHQUNaLENBQUMsQ0FBQztDQUNKIiwiZmlsZSI6ImlubGluZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGV4dGVuZCB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJEZWNvcmF0b3IoJ2lubGluZScsIGZ1bmN0aW9uKGZuLCBwcm9wcywgY29udGFpbmVyLCBvcHRpb25zKSB7XG4gICAgbGV0IHJldCA9IGZuO1xuICAgIGlmICghcHJvcHMucGFydGlhbHMpIHtcbiAgICAgIHByb3BzLnBhcnRpYWxzID0ge307XG4gICAgICByZXQgPSBmdW5jdGlvbihjb250ZXh0LCBvcHRpb25zKSB7XG4gICAgICAgIC8vIENyZWF0ZSBhIG5ldyBwYXJ0aWFscyBzdGFjayBmcmFtZSBwcmlvciB0byBleGVjLlxuICAgICAgICBsZXQgb3JpZ2luYWwgPSBjb250YWluZXIucGFydGlhbHM7XG4gICAgICAgIGNvbnRhaW5lci5wYXJ0aWFscyA9IGV4dGVuZCh7fSwgb3JpZ2luYWwsIHByb3BzLnBhcnRpYWxzKTtcbiAgICAgICAgbGV0IHJldCA9IGZuKGNvbnRleHQsIG9wdGlvbnMpO1xuICAgICAgICBjb250YWluZXIucGFydGlhbHMgPSBvcmlnaW5hbDtcbiAgICAgICAgcmV0dXJuIHJldDtcbiAgICAgIH07XG4gICAgfVxuXG4gICAgcHJvcHMucGFydGlhbHNbb3B0aW9ucy5hcmdzWzBdXSA9IG9wdGlvbnMuZm47XG5cbiAgICByZXR1cm4gcmV0O1xuICB9KTtcbn1cbiJdfQ==


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createNewLookupObject = createNewLookupObject;

var _utils = __webpack_require__(4);

/**
 * Create a new object with "null"-prototype to avoid truthy results on prototype properties.
 * The resulting object can be used with "object[property]" to check if a property exists
 * @param {...object} sources a varargs parameter of source objects that will be merged
 * @returns {object}
 */

function createNewLookupObject() {
  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }

  return _utils.extend.apply(undefined, [Object.create(null)].concat(sources));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2ludGVybmFsL2NyZWF0ZS1uZXctbG9va3VwLW9iamVjdC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7OztxQkFBdUIsVUFBVTs7Ozs7Ozs7O0FBUTFCLFNBQVMscUJBQXFCLEdBQWE7b0NBQVQsT0FBTztBQUFQLFdBQU87OztBQUM5QyxTQUFPLGdDQUFPLE1BQU0sQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLFNBQUssT0FBTyxFQUFDLENBQUM7Q0FDaEQiLCJmaWxlIjoiY3JlYXRlLW5ldy1sb29rdXAtb2JqZWN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZXh0ZW5kIH0gZnJvbSAnLi4vdXRpbHMnO1xuXG4vKipcbiAqIENyZWF0ZSBhIG5ldyBvYmplY3Qgd2l0aCBcIm51bGxcIi1wcm90b3R5cGUgdG8gYXZvaWQgdHJ1dGh5IHJlc3VsdHMgb24gcHJvdG90eXBlIHByb3BlcnRpZXMuXG4gKiBUaGUgcmVzdWx0aW5nIG9iamVjdCBjYW4gYmUgdXNlZCB3aXRoIFwib2JqZWN0W3Byb3BlcnR5XVwiIHRvIGNoZWNrIGlmIGEgcHJvcGVydHkgZXhpc3RzXG4gKiBAcGFyYW0gey4uLm9iamVjdH0gc291cmNlcyBhIHZhcmFyZ3MgcGFyYW1ldGVyIG9mIHNvdXJjZSBvYmplY3RzIHRoYXQgd2lsbCBiZSBtZXJnZWRcbiAqIEByZXR1cm5zIHtvYmplY3R9XG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBjcmVhdGVOZXdMb29rdXBPYmplY3QoLi4uc291cmNlcykge1xuICByZXR1cm4gZXh0ZW5kKE9iamVjdC5jcmVhdGUobnVsbCksIC4uLnNvdXJjZXMpO1xufVxuIl19


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Build out our basic SafeString type


exports.__esModule = true;
function SafeString(string) {
  this.string = string;
}

SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
  return '' + this.string;
};

exports['default'] = SafeString;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL3NhZmUtc3RyaW5nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFDQSxTQUFTLFVBQVUsQ0FBQyxNQUFNLEVBQUU7QUFDMUIsTUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7Q0FDdEI7O0FBRUQsVUFBVSxDQUFDLFNBQVMsQ0FBQyxRQUFRLEdBQUcsVUFBVSxDQUFDLFNBQVMsQ0FBQyxNQUFNLEdBQUcsWUFBVztBQUN2RSxTQUFPLEVBQUUsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDO0NBQ3pCLENBQUM7O3FCQUVhLFVBQVUiLCJmaWxlIjoic2FmZS1zdHJpbmcuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBCdWlsZCBvdXQgb3VyIGJhc2ljIFNhZmVTdHJpbmcgdHlwZVxuZnVuY3Rpb24gU2FmZVN0cmluZyhzdHJpbmcpIHtcbiAgdGhpcy5zdHJpbmcgPSBzdHJpbmc7XG59XG5cblNhZmVTdHJpbmcucHJvdG90eXBlLnRvU3RyaW5nID0gU2FmZVN0cmluZy5wcm90b3R5cGUudG9IVE1MID0gZnVuY3Rpb24oKSB7XG4gIHJldHVybiAnJyArIHRoaXMuc3RyaW5nO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgU2FmZVN0cmluZztcbiJdfQ==


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.checkRevision = checkRevision;
exports.template = template;
exports.wrapProgram = wrapProgram;
exports.resolvePartial = resolvePartial;
exports.invokePartial = invokePartial;
exports.noop = noop;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _utils = __webpack_require__(4);

var Utils = _interopRequireWildcard(_utils);

var _exception = __webpack_require__(5);

var _exception2 = _interopRequireDefault(_exception);

var _base = __webpack_require__(9);

var _helpers = __webpack_require__(10);

var _internalWrapHelper = __webpack_require__(35);

var _internalProtoAccess = __webpack_require__(12);

function checkRevision(compilerInfo) {
  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
      currentRevision = _base.COMPILER_REVISION;

  if (compilerRevision >= _base.LAST_COMPATIBLE_COMPILER_REVISION && compilerRevision <= _base.COMPILER_REVISION) {
    return;
  }

  if (compilerRevision < _base.LAST_COMPATIBLE_COMPILER_REVISION) {
    var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
        compilerVersions = _base.REVISION_CHANGES[compilerRevision];
    throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
  } else {
    // Use the embedded version info since the runtime doesn't know about this revision yet
    throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
  }
}

function template(templateSpec, env) {
  /* istanbul ignore next */
  if (!env) {
    throw new _exception2['default']('No environment passed to template');
  }
  if (!templateSpec || !templateSpec.main) {
    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
  }

  templateSpec.main.decorator = templateSpec.main_d;

  // Note: Using env.VM references rather than local var references throughout this section to allow
  // for external users to override these as pseudo-supported APIs.
  env.VM.checkRevision(templateSpec.compiler);

  // backwards compatibility for precompiled templates with compiler-version 7 (<4.3.0)
  var templateWasPrecompiledWithCompilerV7 = templateSpec.compiler && templateSpec.compiler[0] === 7;

  function invokePartialWrapper(partial, context, options) {
    if (options.hash) {
      context = Utils.extend({}, context, options.hash);
      if (options.ids) {
        options.ids[0] = true;
      }
    }
    partial = env.VM.resolvePartial.call(this, partial, context, options);

    var extendedOptions = Utils.extend({}, options, {
      hooks: this.hooks,
      protoAccessControl: this.protoAccessControl
    });

    var result = env.VM.invokePartial.call(this, partial, context, extendedOptions);

    if (result == null && env.compile) {
      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
      result = options.partials[options.name](context, extendedOptions);
    }
    if (result != null) {
      if (options.indent) {
        var lines = result.split('\n');
        for (var i = 0, l = lines.length; i < l; i++) {
          if (!lines[i] && i + 1 === l) {
            break;
          }

          lines[i] = options.indent + lines[i];
        }
        result = lines.join('\n');
      }
      return result;
    } else {
      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
    }
  }

  // Just add water
  var container = {
    strict: function strict(obj, name, loc) {
      if (!obj || !(name in obj)) {
        throw new _exception2['default']('"' + name + '" not defined in ' + obj, {
          loc: loc
        });
      }
      return container.lookupProperty(obj, name);
    },
    lookupProperty: function lookupProperty(parent, propertyName) {
      var result = parent[propertyName];
      if (result == null) {
        return result;
      }
      if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
        return result;
      }

      if (_internalProtoAccess.resultIsAllowed(result, container.protoAccessControl, propertyName)) {
        return result;
      }
      return undefined;
    },
    lookup: function lookup(depths, name) {
      var len = depths.length;
      for (var i = 0; i < len; i++) {
        var result = depths[i] && container.lookupProperty(depths[i], name);
        if (result != null) {
          return depths[i][name];
        }
      }
    },
    lambda: function lambda(current, context) {
      return typeof current === 'function' ? current.call(context) : current;
    },

    escapeExpression: Utils.escapeExpression,
    invokePartial: invokePartialWrapper,

    fn: function fn(i) {
      var ret = templateSpec[i];
      ret.decorator = templateSpec[i + '_d'];
      return ret;
    },

    programs: [],
    program: function program(i, data, declaredBlockParams, blockParams, depths) {
      var programWrapper = this.programs[i],
          fn = this.fn(i);
      if (data || depths || blockParams || declaredBlockParams) {
        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
      } else if (!programWrapper) {
        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
      }
      return programWrapper;
    },

    data: function data(value, depth) {
      while (value && depth--) {
        value = value._parent;
      }
      return value;
    },
    mergeIfNeeded: function mergeIfNeeded(param, common) {
      var obj = param || common;

      if (param && common && param !== common) {
        obj = Utils.extend({}, common, param);
      }

      return obj;
    },
    // An empty object to use as replacement for null-contexts
    nullContext: Object.seal({}),

    noop: env.VM.noop,
    compilerInfo: templateSpec.compiler
  };

  function ret(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var data = options.data;

    ret._setup(options);
    if (!options.partial && templateSpec.useData) {
      data = initData(context, data);
    }
    var depths = undefined,
        blockParams = templateSpec.useBlockParams ? [] : undefined;
    if (templateSpec.useDepths) {
      if (options.depths) {
        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
      } else {
        depths = [context];
      }
    }

    function main(context /*, options*/) {
      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
    }

    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
    return main(context, options);
  }

  ret.isTop = true;

  ret._setup = function (options) {
    if (!options.partial) {
      var mergedHelpers = Utils.extend({}, env.helpers, options.helpers);
      wrapHelpersToPassLookupProperty(mergedHelpers, container);
      container.helpers = mergedHelpers;

      if (templateSpec.usePartial) {
        // Use mergeIfNeeded here to prevent compiling global partials multiple times
        container.partials = container.mergeIfNeeded(options.partials, env.partials);
      }
      if (templateSpec.usePartial || templateSpec.useDecorators) {
        container.decorators = Utils.extend({}, env.decorators, options.decorators);
      }

      container.hooks = {};
      container.protoAccessControl = _internalProtoAccess.createProtoAccessControl(options);

      var keepHelperInHelpers = options.allowCallsToHelperMissing || templateWasPrecompiledWithCompilerV7;
      _helpers.moveHelperToHooks(container, 'helperMissing', keepHelperInHelpers);
      _helpers.moveHelperToHooks(container, 'blockHelperMissing', keepHelperInHelpers);
    } else {
      container.protoAccessControl = options.protoAccessControl; // internal option
      container.helpers = options.helpers;
      container.partials = options.partials;
      container.decorators = options.decorators;
      container.hooks = options.hooks;
    }
  };

  ret._child = function (i, data, blockParams, depths) {
    if (templateSpec.useBlockParams && !blockParams) {
      throw new _exception2['default']('must pass block params');
    }
    if (templateSpec.useDepths && !depths) {
      throw new _exception2['default']('must pass parent depths');
    }

    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
  };
  return ret;
}

function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
  function prog(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var currentDepths = depths;
    if (depths && context != depths[0] && !(context === container.nullContext && depths[0] === null)) {
      currentDepths = [context].concat(depths);
    }

    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
  }

  prog = executeDecorators(fn, prog, container, depths, data, blockParams);

  prog.program = i;
  prog.depth = depths ? depths.length : 0;
  prog.blockParams = declaredBlockParams || 0;
  return prog;
}

/**
 * This is currently part of the official API, therefore implementation details should not be changed.
 */

function resolvePartial(partial, context, options) {
  if (!partial) {
    if (options.name === '@partial-block') {
      partial = options.data['partial-block'];
    } else {
      partial = options.partials[options.name];
    }
  } else if (!partial.call && !options.name) {
    // This is a dynamic partial that returned a string
    options.name = partial;
    partial = options.partials[partial];
  }
  return partial;
}

function invokePartial(partial, context, options) {
  // Use the current closure context to save the partial-block if this partial
  var currentPartialBlock = options.data && options.data['partial-block'];
  options.partial = true;
  if (options.ids) {
    options.data.contextPath = options.ids[0] || options.data.contextPath;
  }

  var partialBlock = undefined;
  if (options.fn && options.fn !== noop) {
    (function () {
      options.data = _base.createFrame(options.data);
      // Wrapper function to get access to currentPartialBlock from the closure
      var fn = options.fn;
      partialBlock = options.data['partial-block'] = function partialBlockWrapper(context) {
        var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

        // Restore the partial-block from the closure for the execution of the block
        // i.e. the part inside the block of the partial call.
        options.data = _base.createFrame(options.data);
        options.data['partial-block'] = currentPartialBlock;
        return fn(context, options);
      };
      if (fn.partials) {
        options.partials = Utils.extend({}, options.partials, fn.partials);
      }
    })();
  }

  if (partial === undefined && partialBlock) {
    partial = partialBlock;
  }

  if (partial === undefined) {
    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
  } else if (partial instanceof Function) {
    return partial(context, options);
  }
}

function noop() {
  return '';
}

function initData(context, data) {
  if (!data || !('root' in data)) {
    data = data ? _base.createFrame(data) : {};
    data.root = context;
  }
  return data;
}

function executeDecorators(fn, prog, container, depths, data, blockParams) {
  if (fn.decorator) {
    var props = {};
    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
    Utils.extend(prog, props);
  }
  return prog;
}

function wrapHelpersToPassLookupProperty(mergedHelpers, container) {
  Object.keys(mergedHelpers).forEach(function (helperName) {
    var helper = mergedHelpers[helperName];
    mergedHelpers[helperName] = passLookupPropertyOption(helper, container);
  });
}

function passLookupPropertyOption(helper, container) {
  var lookupProperty = container.lookupProperty;
  return _internalWrapHelper.wrapHelper(helper, function (options) {
    return Utils.extend({ lookupProperty: lookupProperty }, options);
  });
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.wrapHelper = wrapHelper;

function wrapHelper(helper, transformOptionsFn) {
  if (typeof helper !== 'function') {
    // This should not happen, but apparently it does in https://github.com/wycats/handlebars.js/issues/1639
    // We try to make the wrapper least-invasive by not wrapping it, if the helper is not a function.
    return helper;
  }
  var wrapper = function wrapper() /* dynamic arguments */{
    var options = arguments[arguments.length - 1];
    arguments[arguments.length - 1] = transformOptionsFn(options);
    return helper.apply(this, arguments);
  };
  return wrapper;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2ludGVybmFsL3dyYXBIZWxwZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBTyxTQUFTLFVBQVUsQ0FBQyxNQUFNLEVBQUUsa0JBQWtCLEVBQUU7QUFDckQsTUFBSSxPQUFPLE1BQU0sS0FBSyxVQUFVLEVBQUU7OztBQUdoQyxXQUFPLE1BQU0sQ0FBQztHQUNmO0FBQ0QsTUFBSSxPQUFPLEdBQUcsU0FBVixPQUFPLDBCQUFxQztBQUM5QyxRQUFNLE9BQU8sR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztBQUNoRCxhQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsR0FBRyxrQkFBa0IsQ0FBQyxPQUFPLENBQUMsQ0FBQztBQUM5RCxXQUFPLE1BQU0sQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFLFNBQVMsQ0FBQyxDQUFDO0dBQ3RDLENBQUM7QUFDRixTQUFPLE9BQU8sQ0FBQztDQUNoQiIsImZpbGUiOiJ3cmFwSGVscGVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGZ1bmN0aW9uIHdyYXBIZWxwZXIoaGVscGVyLCB0cmFuc2Zvcm1PcHRpb25zRm4pIHtcbiAgaWYgKHR5cGVvZiBoZWxwZXIgIT09ICdmdW5jdGlvbicpIHtcbiAgICAvLyBUaGlzIHNob3VsZCBub3QgaGFwcGVuLCBidXQgYXBwYXJlbnRseSBpdCBkb2VzIGluIGh0dHBzOi8vZ2l0aHViLmNvbS93eWNhdHMvaGFuZGxlYmFycy5qcy9pc3N1ZXMvMTYzOVxuICAgIC8vIFdlIHRyeSB0byBtYWtlIHRoZSB3cmFwcGVyIGxlYXN0LWludmFzaXZlIGJ5IG5vdCB3cmFwcGluZyBpdCwgaWYgdGhlIGhlbHBlciBpcyBub3QgYSBmdW5jdGlvbi5cbiAgICByZXR1cm4gaGVscGVyO1xuICB9XG4gIGxldCB3cmFwcGVyID0gZnVuY3Rpb24oLyogZHluYW1pYyBhcmd1bWVudHMgKi8pIHtcbiAgICBjb25zdCBvcHRpb25zID0gYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXTtcbiAgICBhcmd1bWVudHNbYXJndW1lbnRzLmxlbmd0aCAtIDFdID0gdHJhbnNmb3JtT3B0aW9uc0ZuKG9wdGlvbnMpO1xuICAgIHJldHVybiBoZWxwZXIuYXBwbHkodGhpcywgYXJndW1lbnRzKTtcbiAgfTtcbiAgcmV0dXJuIHdyYXBwZXI7XG59XG4iXX0=


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (Handlebars) {
  /* istanbul ignore next */
  var root = typeof global !== 'undefined' ? global : window,
      $Handlebars = root.Handlebars;
  /* istanbul ignore next */
  Handlebars.noConflict = function () {
    if (root.Handlebars === Handlebars) {
      root.Handlebars = $Handlebars;
    }
    return Handlebars;
  };
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL25vLWNvbmZsaWN0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxVQUFVLEVBQUU7O0FBRWxDLE1BQUksSUFBSSxHQUFHLE9BQU8sTUFBTSxLQUFLLFdBQVcsR0FBRyxNQUFNLEdBQUcsTUFBTTtNQUN4RCxXQUFXLEdBQUcsSUFBSSxDQUFDLFVBQVUsQ0FBQzs7QUFFaEMsWUFBVSxDQUFDLFVBQVUsR0FBRyxZQUFXO0FBQ2pDLFFBQUksSUFBSSxDQUFDLFVBQVUsS0FBSyxVQUFVLEVBQUU7QUFDbEMsVUFBSSxDQUFDLFVBQVUsR0FBRyxXQUFXLENBQUM7S0FDL0I7QUFDRCxXQUFPLFVBQVUsQ0FBQztHQUNuQixDQUFDO0NBQ0giLCJmaWxlIjoibm8tY29uZmxpY3QuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbihIYW5kbGViYXJzKSB7XG4gIC8qIGlzdGFuYnVsIGlnbm9yZSBuZXh0ICovXG4gIGxldCByb290ID0gdHlwZW9mIGdsb2JhbCAhPT0gJ3VuZGVmaW5lZCcgPyBnbG9iYWwgOiB3aW5kb3csXG4gICAgJEhhbmRsZWJhcnMgPSByb290LkhhbmRsZWJhcnM7XG4gIC8qIGlzdGFuYnVsIGlnbm9yZSBuZXh0ICovXG4gIEhhbmRsZWJhcnMubm9Db25mbGljdCA9IGZ1bmN0aW9uKCkge1xuICAgIGlmIChyb290LkhhbmRsZWJhcnMgPT09IEhhbmRsZWJhcnMpIHtcbiAgICAgIHJvb3QuSGFuZGxlYmFycyA9ICRIYW5kbGViYXJzO1xuICAgIH1cbiAgICByZXR1cm4gSGFuZGxlYmFycztcbiAgfTtcbn1cbiJdfQ==


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

var DocumentModel = __webpack_require__(38);

/**
 * BndDocumentModel : modèle de document pour la bnd, contient les données de l'enregistrement elastic en plus des données standard de document pv
 */

module.exports = DocumentModel.extend({
    
    defaults: {
        subtitle: null
    },

    urlRoot: function () {
        return this.pv5api + "/bnd-document/" + this.get("publicationId");
    }

});


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var BaseModel = __webpack_require__(6);
var PageModel = __webpack_require__(39);
var PageList = __webpack_require__(40);

var debug = __webpack_require__(2)("models:DocumentModel");    //https://github.com/visionmedia/debug


/**
 * DocumentModel
 */

module.exports = BaseModel.extend({

    pv5api: null,
    useTokenCookie: false, // utilisation du token passé par cookie pour les appels aux pages et images

    defaults: {
        nbPages: 0,          // nombre de pages du pdf
        publicationId: 0,    // identifiant de publication dans pv5
        publicationTitle: null,
        published: null,     // release date
        title: null,         // document title
        isDouble: false,     // double or simple page production
        pages: null,         // page models collection
        page: 0,             // current page number (left page if double)
        isTextMissing: false,// text of document available
        isXml: false,        // xml description available
        toc: 0,              // toc pdf page
        logisticId: null,           // identifiant du logisticien
        documentLogisticId: 0,      // identifiant du document chez le logisticien ci-dessus
        publicationLogisticId: 0,   // identifiant de la publication chez le logisticien ci-dessus
        mtime: 0,            // timestamp de modification du zpa (ajouté à la volée par le serveur)
        reversed: false,     // sens de lecture inversé
        hasToc: false,        // toc.json disponible dans le xml
        hasLayout: false,      // layout.json disponible dans xml
        hasPDF: false,        // pdf available
        lang: null,
        pdfDocument: null, // document pdf chargé par la lib pdfjs https://mozilla.github.io/pdf.js/api/draft/module-pdfjsLib-PDFDocumentProxy.html
        serverPdfMaxPages: 100, // nombre de pages limite par pdf généré pour l'impression
        pageList: null, // tableau de correspondance page num / page label
        displayTitle: null // nom d'affichage du document, remplace pub title / doc title / release date dans le reader par exemple
    },

    urlRoot: function () {
        return this.pv5api + "/document/" + this.get("publicationId");
    },

    /**
     * @param  {Object} attributes
     * @param  {Object} attributes.id document id
     * @param  {Object} attributes.publicationId publication id
     * @param  {Object} options
     * @param  {String} options.pv5api
     */
    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);

        var T = this;
        debug("initialize");
        _.extend(T, options);

        if (T.useTokenCookie) {
            T.withCredentials = true;
        }

        this.set({
            "pages": new Backbone.Collection()
        });
    },

    /**
     * get page model from collection, fetch it if not already done
     * @param  {Number} page
     * @return {PageModel}
     */
    getPageModel: function (page) {
        // get page from collection and fetch if necessary
        var T = this;

        if (!page || page < 1 || page > T.get("nbPages")) {
            return;
        }

        var page_model = T.get("pages").get(page);

        if (!page_model) {
            var page_options = {
                pv5api: T.pv5api,
                isDocumentDouble: T.get("isDouble"),
                mtime: T.get("mtime")
            };
            if (T.token) {
                if (T.useTokenCookie) {
                    page_options.withCredentials = true; // pour que ça soit le token du cookie qui soit utilisé
                }
                else {
                    page_options.token = T.token; // pour que le token se retrouve dans l'url
                }
            }
            page_model = new PageModel(
                {
                    id: page,
                    publicationId: T.get("publicationId"),
                    documentId: T.get("id")
                },
                page_options
            );
            T.get("pages").add(page_model);
            page_model.fetch();
        }

        return page_model;
    },

    thumbnailUrl: function (page) {
        var T = this;
        return T.pageUrl(page) + "/thumbnail";
    },

    pageUrl: function (page) {
        var T = this;
        return T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("id") + "/page/" + page;
    },

    pdfUrl: function () {
        var T = this;
        return T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("id") + "/vecto";
    },

    pageLabelFromNumber: function (page) {
        var page_label, page_number;
        var page_list = this.get("pageList");
        if (page_list) {
            page_number = Number(page);
            page_label = page_list[page_number - 1];
        }
        else {
            page_label = page;
        }
        return page_label;
    },

    pageNumberFromLabel: function (page_label){
        return this.get("pageList").indexOf(page_label) + 1;
    },

    convertPrintRangeLabel: function(page_str){
        var final_page_str = "";
        if (page_str.length) {
            var page_spl = page_str.split(",");
            for (var i = 0; i < page_spl.length; i++) {
                if(final_page_str.length){
                    final_page_str += ","
                }
                var page_interval = page_spl[i];
                var page_interval_spl = page_interval.split("-");
                if(page_interval_spl.length == 1){
                    final_page_str += this.pageNumberFromLabel(page_interval_spl[0].trim())
                }
                else if(page_interval_spl.length == 2){
                    final_page_str += this.pageNumberFromLabel(page_interval_spl[0].trim()) + "-" + this.pageNumberFromLabel(page_interval_spl[1].trim());
                }
            }
        }
        return final_page_str;
    },

    parse: function (data) {
        if (data.pageList) {
            data.pageList = PageList.uncompress(data.pageList);
        }
        return data;
    }

});


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var BaseModel = __webpack_require__(6);

var debug = __webpack_require__(2)("models:PageModel");    //https://github.com/visionmedia/debug

/**
 * PageModel
 */
module.exports = BaseModel.extend({

    pv5api: null,

    defaults: {
        documentId: 0,
        documentTitle: null,
        publicationId: 0,
        publicationTitle: null,
        published: null,
        width: 0,
        height: 0,
        tileSize: 512,     // widelook tile size parameter
        divider: 2,        // widelook divider parameter
        label: [],
        number: [],
        links: [],
        nbLevels: 0,
        isDouble: false
    },

    /**
     * @param  {Object} attributes
     * @param  {Object} attributes.id page number
     * @param  {Object} attributes.documentId document id
     * @param  {Object} attributes.publicationId publication id
     * @param  {Object} options
     * @param  {String} options.pv5api
     */
    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);
        debug("initialize");
        _.extend(this, options);
    },

    url: function () {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId(),
            query_string = [];
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    serverId: function () {
        var T = this,
            id = T.get("id");
        if (T.isDocumentDouble) {
            if (id != 1 && id % 2) {
                id = id - 1; // si le document est produit en double page, il n'y a des données que pour les pages paires
            }
        }
        return id;
    },

    _computeNbLevels: function (imageWidth, imageHeight, divider, tileSize) {
        var nbLevels = 1,
            val = Math.max(imageWidth, imageHeight);

        while (val > tileSize) {
            val = val / divider;
            nbLevels++;
        }

        //console.log("Nb levels: "+nbLevels);
        return nbLevels;
    },

    tileUrl: function (row, column, level) {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId() + "/tile/" + row + "/" + column + "/" + level,
            query_string = [];
        if (T.token) {
            query_string.push("token=" + T.token);
        }
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    thumbnailUrl: function () {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId() + "/thumbnail",
            query_string = [];
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    svgUrl: function (sub) {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId() + "/svg/" + sub,
            query_string = [];
        if (T.token) {
            query_string.push("token=" + T.token);
        }
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    textUrl: function (rectangle) {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/page/" + T.serverId() + "/text",
            query_string = [];
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        if (rectangle) {
            query_string.push("rectangle=" + rectangle.top + "," + rectangle.left + "," + rectangle.bottom + "," + rectangle.right);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    parse: function (data) {
        data.nbLevels = this._computeNbLevels(data.width, data.height, data.divider || 2, data.tileSize || 512);
        data.isDouble = data.number.length == 2 ? true : false;
        return data;
    }

});

/***/ }),
/* 40 */
/***/ (function(module, exports) {

/**
 * PageList permet de stocker de manière optimisée l'équivalence entre un numéro de page et un label de page.
 * ["A","B","1","2","3","D1"] <=> "1:A;2:B;3-5:-2;6:D1"
 * A lire : la page 1 s'appelle "A", les pages de 3 à 5 sont des nombres qui se suivent et il faut ajouter -2 pour avoir le label correspondant
 * Avec des gros documents le gain est plus flagrant ;)
 * Les cas possibles de numérotation non continues sont :
 * * en italie la numérotation commence à 0
 * * un feuillet intégré en fin de documents
 * * chez dalloz, certaines publications on une numérotation qui se suit d'un numéro à l'autre
 */
var PageList = {
    /**
     * transforme un tableau de labels de page en un format compressé
     * @param  {Array} page_label_array tableau de labels de pages, par exemple : ["A","B","1","2","3","D1"]
     */
    compress:function(page_label_array){
        var compressed=[], page_value, previous_value=-10000, start_page_index=0, end_page_index=0, diff_index=0;
        page_label_array.forEach(function(page_label,page_index){
            page_value=parseInt(page_label, 10);    // 12

            if(isNaN(page_value)){
                // c'est un libellé A,III, etc
                // si il y avait une série en cours, on la finie
                if(start_page_index){
                    compressed.push(start_page_index+"-"+end_page_index+":"+diff_index);
                    start_page_index=0; end_page_index=0; diff_index=0; previous_value=-10000;
                }
                compressed.push((page_index+1)+":"+page_label);
            }
            else{
                // c'est un nombre, est-ce qu'il suit le nombre précédent ?
                if(previous_value+1==page_value){
                    // série en cours
                    end_page_index=page_index+1;
                }
                else{
                    // série terminée, on ferme la série courante si elle existe et on en commence une autre
                    if(start_page_index){
                        compressed.push(start_page_index+"-"+end_page_index+":"+diff_index);
                    }


                    diff_index=page_value-page_index-1;
                    start_page_index=page_index+1;
                    end_page_index=start_page_index;
                }
                previous_value=page_value;
            }
        });

        // dernière série si elle existe
        if(start_page_index){
            compressed.push(start_page_index+"-"+end_page_index+":"+diff_index);
        }

        return compressed.join(";");
    },

    /**
     * transforme une string qui définit l'équivalence page index/label compressée en un tableau de labels de pages
     * la page 1 est en 0
     * @param  {String} compressed_string "1:A;2:B;3-5:-2;6:D1"
     * @return {Array}                   [description]
     */
    uncompress:function(compressed_string) {
        var compressed_array=compressed_string.split(";");
        var page_labels=[];
        compressed_array.forEach(function(equivalence){
           var equivalence_splitted=equivalence.split(":");
           if(equivalence_splitted.length==2){
               var page_index=equivalence_splitted[0];
               var page_index_split=page_index.split("-");
               var page_label=equivalence_splitted[1];
               if(page_index_split.length==1){
                   //6:D1
                  page_labels[parseInt(page_index_split[0])-1]=page_label;
               }
               else if(page_index_split.length==2){
                   //3-5:-2
                   var start=parseInt(page_index_split[0]);
                   var end=parseInt(page_index_split[1]);
                   if(start<=end){
                       var page_label_int=parseInt(page_label);
                       for(var i=start;i<=end;i++){
                           page_labels[i-1]=String(i+page_label_int);
                       }
                   }
               }
           }
        });
        return page_labels;
    }
};

module.exports = PageList;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var BaseModel = __webpack_require__(6);

var debug = __webpack_require__(2)("models:PrintQuotaModel");    //https://github.com/visionmedia/debug

/**
 * PrintQuotaModel : récupération de l'état du quota d'impression pour le token passé
 */
module.exports = BaseModel.extend({

    pv5api: null,

    defaults: {
        counter: 0,
        resetAt: null,
        config: null
    },

    /**
     * @param  {Object} attributes
     * @param  {Object} options
     * @param  {String} options.pv5api
     * @param  {String} options.token
     */
    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);
        debug("initialize");
        _.extend(this, options);
    },

    url: function () {
        var T = this;
        return T.pv5api + "/print-quota";
    }

});

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var BaseModel = __webpack_require__(6);

var debug = __webpack_require__(2)("models:PrintPasswordModel");    //https://github.com/visionmedia/debug

/**
 * PrintPasswordModel : récupération des options supplémentaires pour le token passé
 */
module.exports = BaseModel.extend({

    pv5api: null,

    defaults: {
        passwordToken: null
    },

    /**
     * @param  {Object} attributes
     * @param  {Object} options
     * @param  {String} options.pv5api
     * @param  {String} options.token
     */
    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);
        debug("initialize");
        _.extend(this, options);
    },

    url: function () {
        var T = this;
        return T.pv5api + "/print-password";
    }

});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var $ = __webpack_require__(3);
var _ = __webpack_require__(0);
Backbone.$ = $;

var DomUtil = __webpack_require__(13);
var PageView = __webpack_require__(44);

var debug = __webpack_require__(2)("views:DocumentView");

/**
 * DocumentView : display a pv5 document
 * Triggers
 * - "change:page-position" :
 * - "add:page-view"        :
 * - "render:page-view"
 * - "refresh:page-view"    : todo
 * - "remove:page-view"     : todo
 */
module.exports = Backbone.View.extend({

    model: null, // DocumentModel
    elWidth: 0, // width of main el
    elHeight: 0, // height of main el
    isPortrait: false, // interface orientation
    pageViews: null, // array of pageViews
    zoomMax: 1,
    zoomFav: 1,
    zoomStepMultiplier: 2, // multiplication du zoom sur zoom in / zoom out
    enable: true,
    startFit: null, // fit initial demandé
    tileHd: false,
    authorizedPages: null,
    embed: false, // en mode embed on désactive touch-action:none (bug de scroll à partir d'ios 14)
    hasPointerEvent: false,

    events: {
        "contextmenu": "preventDefault", // Disables context menu
        "MSHoldVisual": "preventDefault", // Disables visual
        //"touchmove": "preventDefault", // Stop page from panning on iPhone OS.
        "dragstart": "preventDefault", // disable Firefox's default drag and drop behavior
        "pointerdown": "onDragStart", // à commenter pour forcer l'utilisation des events touch
        "touchstart": "onDragStart",
        "webkitTransitionEnd": "onTransitionEnd",
        "transitionend": "onTransitionEnd"
    },

    /**
     * @param  {Object}         options
     * @param  {DocumentModel}  options.documentModel
     * @param  {Element}        options.el element to attach this view
     * @param  {String}         options.pageTemplate page placeholder underscore template (optional)
     * @param  {String}         options.pageAuthorizationTemplate page authorization template, underscore template (optional)
     */
    initialize: function (options) {
        var T = this;

        _.extend(T, options);

        T.hasPointerEvent = window.PointerEvent ? true : false;
        //T.hasPointerEvent = false; // à décommenter pour forcer l'utilisation des events touch

        T.pageViews = [];
        T._dragStartPoint = {
            x: 0,
            y: 0
        };
        T._dragStartLeft = 0;
        T._pendingPage = 0;
        T._pointers = {};


        T.listenTo(T.model, "sync", T.onDocumentLoaded);
        T.listenTo(T.model, "change:page", T.onPageChanged);

        T.$documentContainer = $("<div/>", {
            class: "container"
        });

        if (!T.embed) {
            T.$documentContainer.css("touch-action", "none");
        }

        debug(navigator.userAgent.toLowerCase());

        T.transitionStyle = DomUtil.styleSupport("transition");
    },

    isPageAuthorized: function (page) {
        var T = this;
        if (_.isArray(T.authorizedPages)) {
            return T.authorizedPages.indexOf(page) != -1;
        }
        else {
            return true;
        }
    },

    onDocumentLoaded: function () {
        var T = this;
        T.render();
    },

    onTransitionEnd: function (e) {
        var T = this;
        if (e.target == T.$documentContainer[0] && e.originalEvent.propertyName == "left" && T._pendingPage) {
            T.model.set("page", T._pendingPage);
            T.preloadNextPage(T._pendingPage);
            T.preloadPreviousPage(T._pendingPage);
            T.removeUnusedPages();
            T._pendingPage = 0;
        }
    },

    preventDefault: function (e) {
        e.preventDefault();
    },

    render: function () {
        var T = this;

        if (!T.model.fetched) {
            return;
        }

        T.$documentContainer.appendTo(T.el);

        debug("render");
        T.resize();
    },

    onPagePositionChanged: function (page_view) {
        this.trigger("change:page-position", page_view);
    },

    onPageZoomFavChanged: function (page_view) {
        this.zoomFav = page_view.zoomFav;
    },

    onPageRendered: function (page_view) {
        this.trigger("render:page-view", page_view);
    },

    /**
     * update elements sizes when a size or
     * @return {[type]} [description]
     */
    resize: function () {
        var T = this;
        if (!T.model.fetched) return;
        if (!T.enable) return;

        T.elHeight = T.$el.height();
        T.elWidth = T.$el.width();

        var prev_orientation = T.isPortrait;
        T.isPortrait = (T.elWidth < T.elHeight) ? true : false;

        var nbScreens = T.model.get("nbPages");

        if (T.pageViews.length && prev_orientation != T.isPortrait) {
            //
            T.pageViews.forEach(function (view) {
                T.unloadPage(view.page);
            });
            T.loadPage(T.model.get("page"));
        }

        T.$documentContainer.css({
            width: T.elWidth * nbScreens
        });

        T.refresh();
        T.scrollTo(T.pagePosition(T.model.get("page")), false);
    },

    onDragStart: function (e) {
        var T = this,
            new_page_x, new_page_y;
        //console.log("drag start doc "+e.type);
        //e.preventDefault();
        if (T._pendingPage) return;
        if (e.type == "touchstart" && T.hasPointerEvent) return; // ignore les events touch si le navigateur supporte les pointers events

        var nb_touches_before = Object.keys(T._pointers).length;

        if (T.hasPointerEvent) {
            T._pointers[e.originalEvent.pointerId] = {
                pageX: e.pageX,
                pageY: e.pageY
            };
            new_page_x = e.pageX;
            new_page_y = e.pageY;
        }
        else {
            var touches = e.originalEvent.changedTouches;
            for (var i = 0; i < touches.length; i++) {
                T._pointers[touches[i].identifier] = {
                    pageX: touches[i].pageX,
                    pageY: touches[i].pageY
                };
            }
            new_page_x = touches[0].pageX;
            new_page_y = touches[0].pageY;
        }

        debug("drag start " + Object.keys(T._pointers).length + " pointers");

        var keys = _.keys(T._pointers);

        if (keys.length == 1) {
            T._dragStartPoint.x = new_page_x;
            T._dragStartPoint.y = new_page_y;
            T._dragStartLeft = -T.pagePosition(T.model.get("page"));
        } else {
            T._abortDrag = true;
        }

        if (nb_touches_before == 0) {
            if (T.hasPointerEvent) {
                $(window).on("pointermove.pv5-doc", function (e) {
                    T.onDragMove(e);
                });
                $(window).on("pointerup.pv5-doc", function (e) {
                    T.onDragEnd(e);
                });
                $(window).on("pointercancel.pv5-doc", function (e) {
                    T.onDragEnd(e);
                });
            }
            else {
                $(window).on("touchmove.pv5-doc", function (e) {
                    T.onDragMove(e);
                });
                $(window).on("touchend.pv5-doc", function (e) {
                    T.onDragEnd(e);
                });
                $(window).on("touchcancel.pv5-doc", function (e) {
                    T.onDragEnd(e);
                });
            }
        }

        //console.log(T._dragStartPoint.x+" "+T._dragStartPoint.x+" "+T._dragStartLeft);
    },

    onDragMove: function (e) {
        var T = this,
            new_page_x;
        //e.preventDefault();
        if (T._abortDrag) return;

        var page_view = T.currentPageView();

        //console.log("drag move doc "+e.type);
        if (T.hasPointerEvent) {
            T._pointers[e.originalEvent.pointerId] = {
                pageX: e.pageX,
                pageY: e.pageY
            };
            new_page_x = e.pageX;
        }
        else {
            var touches = e.originalEvent.changedTouches;
            for (var i = 0; i < touches.length; i++) {
                T._pointers[touches[i].identifier] = {
                    pageX: touches[i].pageX,
                    pageY: touches[i].pageY
                };
            }
            new_page_x = touches[0].pageX;
        }

        var keys = _.keys(T._pointers);
        if (keys.length == 1) {
            T.$el.addClass("grabbing");
            if (page_view) {
                if (!page_view.isZoomed()) {
                    T.scrollTo(-T._dragStartLeft + (T._dragStartPoint.x - new_page_x), false);
                }
            }
        }
    },

    onDragEnd: function (e) {
        var T = this;

        if (T.hasPointerEvent) {
            delete T._pointers[e.originalEvent.pointerId];
        }
        else {
            var touches = e.originalEvent.changedTouches;
            for (var i = 0; i < touches.length; i++) {
                delete T._pointers[touches[i].identifier];
            }
        }

        var keys = _.keys(T._pointers);

        //console.log("drag end doc "+e.type);
        debug("drag end " + Object.keys(T._pointers).length + " pointers");

        var left = T.$documentContainer[0].offsetLeft,
            delta = T._dragStartLeft - left,
            tolerance = 40,
            page = T.model.get("page"),
            last_page = T.model.get("nbPages"),
            abort = false;

        if (T._abortDrag) {
            abort = true;
        } else {
            //console.log("drag end doc");
            if (Math.abs(delta) < tolerance) {
                abort = true;
            } else {
                if (delta > 0) {
                    if (page == last_page) {
                        abort = true;
                    } else {
                        T.gotoPage("next", true);
                    }
                } else if (delta < 0) {
                    if (page == 1) {
                        abort = true;
                    } else {
                        T.gotoPage("previous", true);
                    }
                }
            }
        }
        if (abort) {
            T.scrollTo(-T._dragStartLeft, true);
        }
        if (!keys.length) {
            $(window).off(".pv5-doc");
            T._abortDrag = false;
            T.$el.removeClass("grabbing");
        }
    },

    /**
     * zoom current page
     * @param  {String|Number} zoom  command ("in"|"out"|"fit") or value (0->1)
     * @param  {Bool} animated
     */
    zoom: function (zoom, animated) {
        var T = this,
            page_view = T.currentPageView();
        page_view.zoom(zoom, animated);
    },


    isZoomed: function () {
        var T = this;
        return T.currentPageView().isZoomed();
    },

    /**
     * Return current page view from pageviews array
     * @return {PageView}
     */
    currentPageView: function () {
        var T = this;
        var p = T.model.get("page");
        if (T.model.get("isDouble") && !T.isPortrait) {
            if (p > 1) {
                p = (p % 2) ? p - 1 : p;
            }
        }
        return _.findWhere(T.pageViews, {
            page: p
        });
    },

    /**
     * move to a page
     * @param  {String|Number} page  a page
     * @param  {Bool} animated
     * @param  {Object} fitted_rectangle rectangle to fit in view {"x":"200","y":"200","w":"300","h":"400"}
     *
     */
    gotoPage: function (page, animated, fitted_rectangle) {

        var T = this,
            page_dest = 0,
            current = T.model.get("page"),
            nbPages = T.model.get("nbPages");

        if (T._pendingPage) return;

        if (_.isString(page)) {
            if (page == "previous") {
                if (T.model.get("isDouble") && !T.isPortrait) {
                    page_dest = (current % 2) ? current - 3 : current - 2;
                } else {
                    page_dest = current - 1;
                }
            } else if (page == "next") {
                if (T.model.get("isDouble") && !T.isPortrait) {
                    page_dest = (current % 2) ? current + 1 : current + 2;
                } else {
                    page_dest = current + 1;
                }
            } else {
                page_dest = parseInt(page, 10);
            }
        } else {
            page_dest = page;
        }

        // clamp
        if (page_dest > nbPages) {
            page_dest = nbPages;
        } else if (page_dest < 1) {
            page_dest = 1;
        }

        T.loadPage(page_dest, fitted_rectangle);

        // make destination the official current page at the end of animation
        T._pendingPage = page_dest;

        // now scroll
        T.scrollTo(T.pagePosition(page_dest), animated);
    },

    /**
     * load or preload a page and construct the view
     */
    loadPage: function (p, startFit) {
        var T = this;

        if (T.model.get("isDouble") && !T.isPortrait) {
            if (p > 1) {
                p = (p % 2) ? p - 1 : p;
            }
        }

        var page_view = _.findWhere(T.pageViews, {
            page: p
        });

        if (!page_view) {
            // create page view and append it to document container
            page_view = new PageView({
                page: p,
                startFit: startFit,
                documentModel: T.model,
                template: T.pageTemplate,
                authorizationTemplate: T.pageAuthorizationTemplate,
                authorizationMessage: T.pageAuthorizationMessage,
                zoomMax: T.zoomMax,
                zoomFav: T.zoomFav,
                zoomStepMultiplier: T.zoomStepMultiplier,
                isPortrait: T.isPortrait,
                tileHd: T.tileHd,
                authorizedPage: T.isPageAuthorized(p)
            });

            T.listenTo(page_view, "change:position", T.onPagePositionChanged);
            T.listenTo(page_view, "change:zoom-fav", T.onPageZoomFavChanged);
            T.listenTo(page_view, "render", T.onPageRendered);
            T.pageViews.push(page_view);

            page_view.$el.css({
                left: T.pagePosition(p),
                width: T.elWidth,
                height: T.elHeight
            });

            T.$documentContainer.append(page_view.el);
            T.trigger("add:page-view", page_view);
            page_view.render();
        } else {
            page_view.zoomFav = T.zoomFav;
            T.onPagePositionChanged(page_view); //generate a position changed
        }
    },

    unloadPage: function (p) {
        var T = this;
        var page_view = _.findWhere(T.pageViews, {
            page: p
        });
        if (page_view) {
            T.stopListening(page_view);
            page_view.remove();
            page_view.close();
            T.pageViews = _.without(T.pageViews, page_view);
            debug("unload page " + p);
            T.trigger("remove:page-view", page_view);
        }
    },

    /**
     * construct next page view. A appeler dans les temps mort, en dehors d'une animation
     * @param  {Number} p the current page
     */
    preloadNextPage: function (p) {
        var T = this;
        // preload next page
        var page_preload;
        if (T.model.get("isDouble") && !T.isPortrait) {
            page_preload = p + 2;
        } else {
            page_preload = p + 1;
        }
        if (page_preload <= T.model.get("nbPages")) {
            T.loadPage(page_preload);
        }
    },

    preloadPreviousPage: function (p) {
        var T = this;
        // preload next page
        var page_preload;
        if (T.model.get("isDouble") && !T.isPortrait) {
            page_preload = p - 2;
        } else {
            page_preload = p - 1;
        }
        if (page_preload > 0) {
            T.loadPage(page_preload);
        }
    },

    removeUnusedPages: function () {
        var T = this,
            page = T.model.get("page"),
            page_max, page_min;


        //compute page min / max
        if (T.model.get("isDouble") && !T.isPortrait) {
            page_max = page + 2;
            page_min = page - 2;
        } else {
            page_max = page + 1;
            page_min = page - 1;
        }

        T.pageViews.forEach(function (view) {
            if (view.page < page_min || view.page > page_max) {
                T.unloadPage(view.page);
            }
        });
    },

    /**
     * Called when page was changed in document model
     */
    onPageChanged: function () {
        var T = this;
        if (!T.enable) return;
        if (!T._pendingPage) {
            T.gotoPage(T.model.get("page"), false);
        }
    },

    /**
     * Update page view positions and size
     */
    refresh: function () {
        var T = this;
        T.pageViews.forEach(function (view) {
            view.$el.css({
                left: T.pagePosition(view.page),
                width: T.elWidth,
                height: T.elHeight,
                isPortrait: T.isPortrait
            });
            view.resize();
        });
    },

    /**
     * retrieve page position from page number and view configuration
     * @return {Number} page left position
     */
    pagePosition: function (page) {
        var T = this,
            pos = 0;

        if (T.model.get("isDouble")) {
            if (T.isPortrait) {
                pos = (page - 1) * T.elWidth;
            } else {
                var page_left = (page % 2) ? page - 1 : page; // left page
                pos = T.elWidth * (page_left / 2);
            }
        } else {
            pos = (page - 1) * T.elWidth;
        }

        return pos;
    },

    /**
     * scroll document container horizontally
     * @param  {[type]} position_x [description]
     * @param  {[type]} animated   [description]
     */
    scrollTo: function (position_x, animated) {
        var T = this,
            previous_left = T.$documentContainer.css("left"),
            the_css = {
                left: -position_x
            };

        the_css[T.transitionStyle] = animated ? "left 0.5s ease-out" : "none";
        //console.log("scroll to:"+position_x);
        T.$documentContainer.css(the_css);

        if (parseInt(previous_left) == parseInt(the_css.left) || !animated) {
            // generate a transition a fake event
            T.onTransitionEnd({
                target: T.$documentContainer[0],
                originalEvent: {
                    propertyName: "left"
                }
            });
        }

    },

    close: function () {
        var T = this;

        T.$documentContainer.remove();

        T.pageViews.forEach(function (view) {
            T.unloadPage(view.page);
        });

        $(window).off(".pv5-doc");

        T.stopListening();
        T.undelegateEvents();
    }

});


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var $ = __webpack_require__(3);
var _ = __webpack_require__(0);
Backbone.$ = $;

var DomUtil = __webpack_require__(13);

var debug = __webpack_require__(2)("views:PageView"); //https://github.com/visionmedia/debug


/**
 * PageView: a domument page view
 * Triggers:
 * - "render"
 */
module.exports = Backbone.View.extend({

	documentModel: null, // DocumentModel
	model: null, // PageModel
	template: null, // external template for place holder
	className: "page-view",
	zoomMax: 1, // maximum zoom value : 1 = full image resolution
	page: 0,
	startFit: null, // rectangle qui doit apparaitre initialement, en coordonnées image
	isPortrait: false,
	usePDF: false,
	zoomFav: 1,
	reversed: false,
	tileHd: false, // utilise le niveau de tuile supérieur
	authorizedPage: true,
	authorizationTemplate: null,
	authorizationMessage: null,
	hasPointerEvent: false,
	zoomStepMultiplier: 2, // multiplication du zoom sur zoom in / zoom out

	// private
	_x: 0, // x image position
	_y: 0, // y image position
	_zoom: -1, // current zoom
	_zoomFit: 1, // zoom value fiting entire image into viewport, computed when size change
	_animating: false, // animation in progress
	_dragEvents: null, //
	_dragStartPoint: null,
	_dragStartPagePoint: null,
	_lastTap: 0,

	events: {
		"DOMMouseScroll": "onMouseWheel",
		"mousewheel": "onMouseWheel",
		"wheel": "onMouseWheel",
		"pointerdown": "onDragStart", // à commenter pour forcer l'utilisation des events touch
		"touchstart": "onDragStart",
		"webkitTransitionEnd": "onTransitionEnd",
		"transitionend": "onTransitionEnd"
	},

	/**
	 * @param  {Object}         options
	 * @param  {DocumentModel}  options.documentModel we use this model to gain some production properties and to get a reference to the pageModel
	 * @param  {Number}         options.page left page number
	 * @param  {String}         options.template page placeholder underscore template (optional)
	 */
	initialize: function (options) {
		var T = this;
		_.extend(T, options);

		T.hasPointerEvent = window.PointerEvent ? true : false;
		//T.hasPointerEvent = false; // à décommenter pour forcer l'utilisation des events touch

		T._dragStartPoint = {
			x: 0,
			y: 0
		};
		T._dragStartPagePoint = {
			x: 0,
			y: 0
		};
		T._dragEvents = [];
		T._pointers = {};
		T._computeCache = {}; // cache some computing values
		T._tiles = {}; // contains all tiles
		T._visible = []; // ids of visible tiles

		T._lockX = false;

		T.model = T.documentModel.getPageModel(T.page);
		if (T.documentModel.get("pdfDocument")) {
			T.usePDF = true;
		}

		T.listenTo(T.model, "sync", T.render);

		if (T.template) {
			T.template = _.template(T.template); // compile template
		}

		if (T.authorizationTemplate) {
			T.authorizationTemplate = _.template(T.authorizationTemplate); // compile template
		}

		T.transitionStyle = DomUtil.styleSupport("transition");

		// load this low res image before any tile
		if (!T.usePDF && T.authorizedPage) {
			$("<img/>").attr("src", T.model.thumbnailUrl());
		}

	},

	render: function () {
		var T = this,
			context = T.model.toJSON();

		debug("render " + T.model.get("id") + ", fetched: " + T.model.fetched);

		if (T.template) {
			if (T.documentModel.get("reversed")) {
				context.id = T.documentModel.get("nbPages") - parseInt(context.id) + 1;
			}
			T.$el.html(T.template(context));
		}

		if (T.model.fetched) {
			T.$tileContainer = $("<div/>", {
				class: "tile-container",
			}).appendTo(T.el);

			if (!T.usePDF && T.authorizedPage) {
				T.$tileContainer.css({
					backgroundImage: "url(" + T.model.thumbnailUrl() + ")"
				});
			}

			if (!T.authorizedPage) {
				T.renderPageAuthorization();
			}

			var fit_values = T._computeFit();
			T._zoomFit = fit_values.z;

			// on vérifie que le zoom favori est bien supérieur à zoomfit (possible si on passe d'un document à un autre avec des formats différents)
			if(T.zoomFav < T._zoomFit * 1.2){
				T.saveZoomFav(T._zoomFit * 2);
			}

			if (T.startFit) {
				T.fitRectangle(T.startFit);
			} else {
				T.fit(false);
			}

		}

		T.trigger("render", T);
	},

	/**
	 * fit tileContainer into main element
	 * @param  {Bool} animated
	 */
	fit: function (animated) {
		var T = this,
			fit_values = T._computeFit();

		if (!fit_values) return;

		T.setPosition(fit_values.x, fit_values.y, fit_values.z, true, animated);
	},

	_computeFit: function () {
		var T = this;
		if (!T.model.fetched) return;
		var x = 0,
			y = 0,
			z = 1,
			elW = T.$el.width(),
			elH = T.$el.height(),
			imW = T.model.get("width"),
			imH = T.model.get("height");

		if (T.isPortrait && T.model.get("isDouble")) {
			imW /= 2;
		}

		z = elW / imW;
		if (z * imH > elH) {
			z = elH / imH;
			x = ((elW / z) - imW) / 2;
		} else {
			y = ((elH / z) - imH) / 2;
		}
		return {
			x: x,
			y: y,
			z: z
		};
	},

	/**
	 * zoome la page pour que la view affiche le rectangle passé en paramètre
	 * @param  {Object} rect rectangle en coordonnées image {"x":"200","y":"200","width":"300","height":"400"}
	 * @param  {Bool} animated
	 */
	fitRectangle: function (rect, animated) {
		var T = this;
		if (!T.model.fetched) return;
		var x = 0,
			y = 0,
			z = 1,
			elW = T.$el.width(),
			elH = T.$el.height();

		z = elW / rect.width;
		if (z * rect.height > elH) {
			z = elH / rect.height;
			x = -(rect.x + (rect.width / 2) - ((elW / z) / 2));
			y = -rect.y;
		} else {
			x = -rect.x;
			y = -(rect.y + (rect.height / 2) - ((elH / z) / 2)); //((elH / z) - imH) / 2;
		}

		T.setPosition(x, y, z, true, animated);
	},

	/**
	 * set tileContainer position
	 * @param {Int} x        x position in image coordinates
	 * @param {Int} y        y position in image coordinates
	 * @param {Float} zoom
	 * @param {Bool} animated
	 */
	setPosition: function (x, y, zoom, clamp, animated) { // jshint ignore:line
		var T = this;
		if (!T.model.fetched) return;
		if (!T.$tileContainer) return;

		if (clamp) {
			var pt = T._clampPosition(x, y, zoom);
			x = pt.x;
			y = pt.y;
		}

		if (T._x == x && T._y == y && T._zoom == zoom) {
			return;
		}

		// on arrondit à l'entier car le css des browsers fonctionnent en entier
		// donc si il y a juste une variation de la partie après la virgule, ça ne déclenchera pas d'animation
		var new_vpx = Math.round(x * zoom),
			new_vpy = Math.round(y * zoom),
			old_vpx = Math.round(T.$tileContainer[0].offsetLeft),
			old_vpy = Math.round(T.$tileContainer[0].offsetTop);

		if (new_vpx == old_vpx && new_vpy == old_vpy) {
			animated = false;
		}

		T._x = x;
		T._y = y;
		T._zoom = zoom;

		T.trigger("change:position", T);

		var style = {};

		style[T.transitionStyle] = animated ? "left 0.5s, width 0.5s, height 0.5s, top 0.5s" : "none";

		T.$tileContainer.css(style);

		style = {
			width: T.model.get("width") * zoom,
			height: T.model.get("height") * zoom,
			left: new_vpx,
			top: new_vpy
		};
		T.$tileContainer.css(style);

		if (animated) {
			//debug("animating true");
			T._animating = true;
			T.hideTiles();
		} else {
			if (T._animating) {
				T.onAnimationEnd();
			}
			else {
				T.refresh();
			}
		}
	},

	resize: function () {
		var T = this,
			fit_values,
			was_zoomed = T.isZoomed();

		fit_values = T._computeFit();
		if (!fit_values) return;

		T._zoomFit = fit_values.z;

		if (was_zoomed) {
			// on était zoomé dans le doc, on se repositionne vers les mêmes positions
			var z = T._clampZoom(T._zoom);
			T.setPosition(T._x, T._y, z, true, false);
			T.refresh(); // force refresh
		} else {
			// on était en mode fit
			T.fit(false);
		}
	},

	getPosition: function () {
		var T = this;
		return {
			x: T._x,
			y: T._y,
			zoom: T._zoom
		};
	},

	refreshPDF: function () {
		// version qui calcule un canvas à chaque zoom
		var T = this;

		if (T._animating) {
			//debug("refresh PDF " + T.page + " aborted due to animation");
			return;
		}

		// on ne rien faire si le zoom n'a pas changé depuis le dernier refresh
		if (T._zoom == T._lastZoom) {
			//debug("refresh PDF " + T.page + " aborted due to zoom not changed since last time");
			return;
		}

		T._lastZoom = T._zoom;

		var nb_pages;
		if (T.isPortrait) {
			nb_pages = 1;
		}
		else {
			nb_pages = T.model.get("isDouble") ? 2 : 1;
		}

		for (var i = 0; i < nb_pages; i++) {
			T.renderPDFPage(i);
		}
	},

	renderPDFPage: function (i) {
		var T = this, nb_pages, canvas_width, canvas_height, canvas_width_percent;
		var resolution = T._zoom;

		debug("render page " + (T.page + i) + " " + resolution);

		T.documentModel.get("pdfDocument").getPage(T.page + i).then(function (page) {
			if (!T.$tileContainer) return; // l'objet page a été supprimé lors d'un redimensionnement par exemple
			var tile_id = "T-PDF-" + (T.page + i) + "-" + String(resolution);
			var left;

			if (T.isPortrait) {
				nb_pages = 1;
				if (T.model.get("isDouble")) {
					canvas_width = Math.ceil(T.$tileContainer.width() / 2);
					if (T.isLeftPage()) {
						left = 0;
					}
					else {
						left = "50%";
					}
					canvas_width_percent = 50;
				}
				else {
					left = 0;
					canvas_width = Math.ceil(T.$tileContainer.width() / nb_pages);
					canvas_width_percent = 100;
				}
			}
			else {
				nb_pages = T.model.get("isDouble") ? 2 : 1;
				left = (100 / nb_pages) * i + "%";
				canvas_width = Math.ceil(T.$tileContainer.width() / nb_pages);
				canvas_width_percent = 100 / nb_pages;
			}

			canvas_height = Math.ceil(T.$tileContainer.height());



			//debug("create canvas");
			var $tile = $('<canvas/>', {
				class: "tile-pdf-" + i,
				id: tile_id,
				css: {
					position: "absolute",
					top: 0,
					left: left,
					backgroundColor: "transparent",
				}
			});

			if (window.devicePixelRatio > 1) {
				// on met plus de pixels pour les écrans type retina
				canvas_width *= 1.4;
				canvas_height *= 1.4;
				$tile.css({
					width: canvas_width_percent + "%",
					height: "100%"
				});
			}
			else {
				$tile.css({
					width: canvas_width,
					height: canvas_height
				});
			}

			var canvas = $tile[0];

			var viewport_original = page.getViewport({ scale: 1 });

			var scale = canvas_width / viewport_original.width;
			var viewport = page.getViewport({ scale: scale });

			var context = canvas.getContext('2d');
			canvas.height = canvas_height;
			canvas.width = canvas_width;

			var renderContext = {
				canvasContext: context,
				viewport: viewport,
				enableWebGL: true
			};

			page.render(renderContext).promise.then(function () {

				if (T._animating) {
					// le rendu se finit pendant qu'une animation est en cours, on ne fait rien avec la tuile, un refresh sera appelé à la fin de l'animation
					//debug("animation in progress");
					T._lastZoom = 0;
				}
				else {
					if (!T.$tileContainer) return; // l'objet page a été supprimé lors d'un redimensionnement par exemple
					T.$('.tile-pdf-' + i).remove();

					if (window.devicePixelRatio == 1) {
						// plus d'animation en cours, on met une taille en pixel pour que le texte soit bien net, pour ne pas avoir des dixièmes de pixels
						$tile.css({
							width: canvas_width,
							height: canvas_height,
						});
					}
					T.$tileContainer.append($tile);
				}

			});
		});
	},

	renderPageAuthorization: function () {
		var T = this;
		if (!T.authorizationTemplate) return;
		if (!T.$tileContainer) return; // l'objet page a été supprimé lors d'un redimensionnement par exemple

		var context = T.model.toJSON();

		if (T.documentModel.get("reversed")) {
			context.id = T.documentModel.get("nbPages") - parseInt(context.id) + 1;
		}

		context.thumbnailUrl = T.model.thumbnailUrl();

		var message;

		if (_.isFunction(T.authorizationMessage)) {
			var content_model = T.documentModel.toJSON();
			content_model.documentId = content_model.id;
			content_model.documentTitle = content_model.title;
			delete (content_model.id);
			delete (content_model.title);
			content_model.contentType = "page";
			content_model.pages = T.model.get("number");
			message = T.authorizationMessage(content_model);
		}
		else {
			message = T.authorizationMessage;
		}

		context.authorizationMessage = message;


		T.$tileContainer.empty();
		T.$tileContainer.addClass("page-auth-container");

		var html_code = T.authorizationTemplate(context);
		if (T.isPortrait && T.model.get("isDouble")) {
			T.$tileContainer.append($(html_code).addClass("mid"));
			T.$tileContainer.append($(html_code).addClass("mid"));
		}
		else {
			T.$tileContainer.append(html_code);
		}
	},

	/**
	 * tiles management (create/remove/position) depending of zoom and position into viewport
	 */
	refresh: function () {
		var T = this;

		if (T._pinching) return;

		if (!T.authorizedPage) {
			return;
		}

		if (T.usePDF) {
			T.refreshPDF();
			return;
		}

		var imTileSize = T.model.get("tileSize");

		// recherche du niveau de tuiles à charger en fonction du zoom
		// on cache les dernières valeurs obtenue si le zoom ne change pas pour éviter des calculs
		var ll, zdiv, its, t1, t2, nbtht, nbtvt;
		if (T._computeCache.zoom == T._zoom) {
			ll = T._computeCache.ll;
			zdiv = T._computeCache.zdiv;
			its = T._computeCache.its;
			t1 = T._computeCache.t1;
			t2 = T._computeCache.t2;
			nbtht = T._computeCache.nbtht;
			nbtvt = T._computeCache.nbtvt;
		} else {
			ll = T._determineLevel(T._zoom);
			zdiv = T._zoom / ll.z;
			its = imTileSize / ll.z; //taille d une tuile de ce level dans le repère de l image
			t1 = T.model.get("width") * ll.z; //largeur de l'image de ce level
			t2 = T.model.get("height") * ll.z; //hauteur de l'image de ce level
			nbtht = Math.ceil(t1 / imTileSize); // nombre total de tuiles horizontales
			nbtvt = Math.ceil(t2 / imTileSize); // nombre total de tuiles verticales

			T._computeCache = {
				ll: ll,
				zdiv: zdiv,
				its: its,
				t1: t1,
				t2: t2,
				nbtht: nbtht,
				nbtvt: nbtvt,
				zoom: T._zoom
			};
		}

		//viewport dans le repère de l image
		var ivpw = T.$el.width() / T._zoom;
		var ivph = T.$el.height() / T._zoom;

		var firstTileH = Math.floor(-T._x / its); // first tile
		var firstTileV = Math.floor(-T._y / its);
		if (firstTileH < 0) firstTileH = 0;
		if (firstTileV < 0) firstTileV = 0;

		var lastTileH = Math.floor((-T._x + ivpw) / its); // last tile
		var lastTileV = Math.floor((-T._y + ivph) / its);
		if (lastTileH > nbtht - 1) lastTileH = nbtht - 1;
		if (lastTileV > nbtvt - 1) lastTileV = nbtvt - 1;

		//IM.log("Page:"+T.numbering+" firstTileH:"+firstTileH+" firstTileV:"+firstTileV+" X:"+T._iX+" lastTileH:"+lastTileH+" lastTileV:"+lastTileV);

		// we hide all the tiles that are no longer useful
		for (var k = 0; k < T._visible.length; k++) {
			var $tile_visible = T._tiles[T._visible[k]],
				data = $tile_visible.pv5data;
			if (data.level == ll.l) {
				if (!(data.h >= firstTileH && data.h <= lastTileH && data.v >= firstTileV && data.v <= lastTileV)) {
					$tile_visible.hide();
				}
			} else {
				$tile_visible.hide();
			}
		}

		T._visible = [];

		// positionnement/chargement tuiles si nécéssaire
		var hDst, wDst, yDst, xDst;
		xDst = yDst = wDst = hDst = 0;
		yDst = Math.round(((firstTileV * its)) * T._zoom);

		for (var j = firstTileV; j <= lastTileV; j++) {
			xDst = Math.round(((firstTileH * its)) * T._zoom);
			if (j == nbtvt - 1)
				hDst = Math.round((t2 - (imTileSize * (nbtvt - 1))) * zdiv);
			else
				hDst = Math.round(imTileSize * zdiv);

			for (var i = firstTileH; i <= lastTileH; i++) {
				if (i == nbtht - 1)
					wDst = Math.round((t1 - (imTileSize * (nbtht - 1))) * zdiv); //dernière tuile horizontale
				else
					wDst = Math.round(imTileSize * zdiv);

				//console.log("Page:"+T.page+" Level:"+ll.l+" line:"+j+" col:"+i);
				var tile_id = "T-" + ll.l + "-" + i + "-" + j;
				var $tile = T._tiles[tile_id];

				if (!$tile) {
					// not found, create a new tile
					$tile = $("<img/>", {
						class: "tile",
						id: tile_id,
						src: T.model.tileUrl(i, j, ll.l),
						draggable: false
					});
					$tile.pv5data = {
						level: ll.l,
						h: i,
						v: j
					};
					T._tiles[tile_id] = $tile;
					T.$tileContainer.append($tile);
					//console.log("new tile "+i+" "+j+" "+ll.l);
				}

				if ($tile) {
					T._visible.push(tile_id);
					$tile.css({
						width: wDst,
						height: hDst,
						top: yDst,
						left: xDst,
						display: ""
					});
				}

				xDst += wDst;
			}
			yDst += hDst;
		}

	},

	/**
	 * zoom current page
	 * @param  {String|float} zoom  command ("in"|"out") or value (0->1)
	 * @param  {Bool} animated
	 */
	zoom: function (zoom, animated) {
		var T = this,
			z = 1,
			pt = {
				x: T.$el.width() / 2,
				y: T.$el.height() / 2
			};

		T._vpToImage(pt);

		if (_.isString(zoom)) {
			if (zoom == "in") {
				z = T._zoom * T.zoomStepMultiplier;
			} else if (zoom == "out") {
				z = T._zoom / T.zoomStepMultiplier;
			} else if (zoom == "fit") {
				T.fit(animated);
				return;
			} else {
				// unsupported command
				return;
			}
		} else {
			z = zoom;
		}

		z = T._clampZoom(z);

		T.zoomCentered(pt.x, pt.y, z, T.$el.width() / 2, T.$el.height() / 2, true, animated);

	},

	/**
	 * zoome la page, centré sur le le point passé
	 * @param {int} x position x dans le repère de l'image
	 * @param {int} y position y dans le repère de l'image
	 * @param {float} s nouveau facteur de zoom
	 * @param {int} vpx position x dans le repère du viewport
	 * @param {int} vpy position y dans le repère du viewport
	 * @param {bool} clamp autorise ou non à dépasser les limite du viewport
	 * @param {bool} animated zoome animé ou zoom direct
	 */
	zoomCentered: function (x, y, s, vpx, vpy, clamp, animated) { // jshint ignore:line
		var T = this,
			newX = 0,
			newY = -y + (vpy / s);

		if (!T.authorizedPage) return;

		//console.log("old: "+T._zoom+" new: "+s);
		if (T.isPortrait) {
			if (T.model.get("isDouble")) {
				if (T.isLeftPage()) {
					newX = -x + (vpx / s);
				} else {
					newX = -x + (vpx / s) - T.model.get("width") / 2;
				}
			} else {
				newX = -x + (vpx / s);
			}
		} else {
			newX = -x + (vpx / s);
		}
		//IM.log("X:"+x+" Y:"+y+" S:"+s);
		T.setPosition(newX, newY, s, clamp, animated);
	},

	/**
	 * donne la correspondance entre un point dans le viewport et un point dans l'image originale
	 * @param {Object} pt {x:0,y:0} point demandé, le résultat sera retourné dans cet objet directement
	 * @ignore
	 */
	_vpToImage: function (pt) {
		var T = this,
			x,
			y;

		if (T.model.get("isDouble")) {
			if (T.isPortrait) {
				if (T.isLeftPage()) {
					x = (pt.x / T._zoom) - T._x;
					y = (pt.y / T._zoom) - T._y;
				} else {
					x = (pt.x / T._zoom) - T._x - T.model.get("width") / 2; // todo, à vérifier
					y = (pt.y / T._zoom) - T._y;
				}
			} else {
				x = (pt.x / T._zoom) - T._x;
				y = (pt.y / T._zoom) - T._y;
			}
		} else {
			x = (pt.x / T._zoom) - T._x;
			y = (pt.y / T._zoom) - T._y;
		}

		pt.x = x;
		pt.y = y;
	},

	/**
	 * limite une position x,y en fonction d'un facteur de zoom
	 * @param {Object} pt {x:0,y:0} point demandé, le résultat sera retourné dans cet objet directement
	 * @param {float} z zoom demandé
	 * @ignore
	 */
	_clampPosition: function (x, y, z) { // jshint ignore:line

		var T = this,
			newX = x,
			newY = y,
			elW = T.$el.width(),
			elH = T.$el.height(),
			maxX = 0,
			minX = 0,
			imWidth = T.model.get("width"),
			imHeight = T.model.get("height");

		//todo : mettre le calcule de min et max une seule fois sur resize
		// clamp X
		if (T.isPortrait) {
			if (T.model.get("isDouble")) {
				if (T.isLeftPage()) {
					maxX -= ((imWidth / 2) - (elW / z)); // ok
					if (newX > minX) newX = minX;
					if (newX < maxX) newX = maxX;
				} else {
					minX = -(imWidth / 2); //ok
					maxX = -imWidth + (elW / z);
					if (newX < maxX) newX = maxX;
					if (newX > minX) newX = minX;
				}
			} else {
				maxX -= (imWidth - (elW / z)); // page simple centrée; ok
				if (maxX > 0) maxX /= 2; // cas où on a dézoomé assez et donc on centre horizontalement
				if (newX > minX) newX = minX;
				if (newX < maxX) newX = maxX;
			}
		} else {
			maxX -= (imWidth - (elW / z));
			if (maxX > 0) maxX /= 2; // cas où on a dézoomé assez et donc on centre horizontalement
			if (newX > minX) newX = minX;
			if (newX < maxX) newX = maxX;
		}

		//console.log("x: "+x+" MIN X:"+minX+" MAX X:"+maxX+" vp W :"+elW);

		// clamp Y
		var maxY = -(imHeight - (elH / z));
		if (maxY > 0) maxY /= 2; // cas où on a dézoomé assez et donc on centre verticalement
		if (newY > 0) newY = 0;
		if (newY < maxY) newY = maxY;

		//IM.log("MAX Y:"+maxY);
		return ({
			x: newX,
			y: newY
		});
	},

	_clampZoom: function (z) {
		var T = this;
		if (z > T.zoomMax) {
			z = T.zoomMax;
		} else if (z < T._zoomFit) {
			z = T._zoomFit;
		}
		return z;
	},

	/**
	 * determine image level needed for this image zoom value
	 * @param  {float} zoom
	 * @return {int}   image level
	 */
	_determineLevel: function (zoom) {
		var T = this,
			v = 1,
			l = 0,
			imLevels = T.model.get("nbLevels"),
			imDivider = T.model.get("divider");

		if (zoom > 0 && zoom < 1) {
			for (var k = 0; k < imLevels; k++) {
				v /= imDivider;
				if (v < zoom) {
					v *= imDivider;
					break;
				}
				l++;
			}
		}

		// en 2019 : force le niveau supérieur
		if (T.tileHd) {
			l--; v *= imDivider;
		}

		if (l >= imLevels) {
			l = imLevels - 1;
		} else if (l < 0) {
			l = 0;
			v = 1;
		}
		//debug("levels",l,v);
		return {
			l: l,
			z: v
		};
	},

	isZoomed: function () {
		var T = this;
		return (T._zoom >= T._zoomFit * 1.1) ? true : false;
	},

	onMouseWheel: function (ev) {
		var T = this,
			wheelDeltaY,
			new_zoom,
			e = ev.originalEvent;

		if (e.wheelDeltaX) {
			wheelDeltaY = e.wheelDeltaY / 12;
		} else if (e.wheelDelta) {
			wheelDeltaY = e.wheelDelta / 12;
		} else if (e.detail) {
			wheelDeltaY = -e.detail * 3;
		} else {
			return; //unknown case
		}

		new_zoom = T._zoom * Math.pow(2, 1 / 3 * (wheelDeltaY ? wheelDeltaY / Math.abs(wheelDeltaY) : 0));
		new_zoom = T._clampZoom(new_zoom);

		if (new_zoom != T._zoom) {
			var offset = T.$el.offset(),
				mouseX = e.pageX - offset.left,
				mouseY = e.pageY - offset.top,
				pt = {
					x: mouseX,
					y: mouseY
				};

			T._vpToImage(pt);
			//console.log(pt.x+" "+pt.y);
			T.zoomCentered(pt.x, pt.y, new_zoom, mouseX, mouseY, true, true);
			T.saveZoomFav(T._zoom);
		}

		// lignes ci-dessous necessaires pour le fonctionnement en iframe pour que l'action de zoom par scroll ne se transforme pas en scroll de la page web qui contient l'iframe
		e.stopPropagation();
		e.preventDefault();
	},

	onTransitionEnd: function (e) {
		var T = this;
		//debug("transition end", e.originalEvent.propertyName);
		if (e.target == T.$tileContainer[0] && e.originalEvent.propertyName == "width") {
			T.onAnimationEnd();
			e.stopPropagation();
		}
	},

	onAnimationEnd: function () {
		var T = this;
		T._animating = false;
		debug("animating end");
		T.refresh();
	},

	onDragStart: function (e) {
		var T = this,
			offset,
			pt,
			new_page_x, new_page_y;
		e.preventDefault();
		if (!T.$tileContainer) return;
		if (e.type == "touchstart" && T.hasPointerEvent) return; // ignore les events touch si le navigateur supporte les pointers events

		var nb_touches_before = Object.keys(T._pointers).length;

		if (T.hasPointerEvent) {
			T._pointers[e.originalEvent.pointerId] = {
				pageX: e.pageX,
				pageY: e.pageY
			};
			new_page_x = e.pageX;
			new_page_y = e.pageY;
		}
		else {
			var touches = e.originalEvent.changedTouches;
			for (var i = 0; i < touches.length; i++) {
				T._pointers[touches[i].identifier] = {
					pageX: touches[i].pageX,
					pageY: touches[i].pageY
				};
			}
			new_page_x = touches[0].pageX;
			new_page_y = touches[0].pageY;
		}

		debug("drag start " + Object.keys(T._pointers).length + " pointers");

		var keys = _.keys(T._pointers);

		if (keys.length == 1) {
			var now = Date.now(),
				isTapTap = false;

			if (now - T._lastTap < 400) {
				// double tap
				isTapTap = true;
			}

			if (isTapTap) {
				if (T.isZoomed()) {
					T.fit(true);
				} else {
					offset = T.$el.offset();
					pt = {
						x: new_page_x - offset.left,
						y: new_page_y - offset.top
					};
					T._vpToImage(pt);
					T.zoomCentered(pt.x, pt.y, T.zoomFav, T.$el.width() / 2, T.$el.height() / 2, true, true);
				}
				e.preventDefault();
			}

			T._lockTested = false;
			T._dragStartPagePoint.x = T._x;
			T._dragStartPagePoint.y = T._y;
			// en 2015 firefox donne le timlestamp en micro secondes au lieu de millisecondes ... bug ?
			// du coup on ne peut pas utiliser le timeStamp, on stocke la date
			e.pv5TimeStamp = now;
			T._dragEvents = [e]; // inertia management

			T._dragStartPoint.x = new_page_x;
			T._dragStartPoint.y = new_page_y;

			T._lastTap = now;
		} else if (keys.length == 2) {

			var t1 = T._pointers[keys[0]];
			var t2 = T._pointers[keys[1]];

			var midX = (Math.abs(((t2.pageX - t1.pageX) / 2)) + t1.pageX);
			var midY = (Math.abs(((t2.pageY - t1.pageY) / 2)) + t1.pageY);
			offset = T.$el.offset();
			pt = {
				x: midX - offset.left,
				y: midY - offset.top
			};
			T._vpToImage(pt);
			T._touchStartMidPt = pt;
			T._touchStartDist = Math.sqrt(Math.pow((t1.pageX - t2.pageX), 2) + Math.pow((t1.pageY - t2.pageY), 2));
			T._touchStartScale = T._zoom;
		}

		if (nb_touches_before == 0) {
			if (T.hasPointerEvent) {
				$(window).on("pointermove.pv5-page", function (e) { T.onDragMove(e); });
				$(window).on("pointerup.pv5-page", function (e) { T.onDragEnd(e); });
				$(window).on("pointercancel.pv5-page", function (e) { T.onDragEnd(e); });
			}
			else {
				$(window).on("touchmove.pv5-page", function (e) { T.onDragMove(e); });
				$(window).on("touchend.pv5-page", function (e) { T.onDragEnd(e); });
				$(window).on("touchcancel.pv5-page", function (e) { T.onDragEnd(e); });
			}
		}

	},

	onDragMove: function (e) {
		//console.log("Drag move");
		var T = this,
			x, y, new_page_x, new_page_y;

		//e.preventDefault();

		if (T.hasPointerEvent) {
			T._pointers[e.originalEvent.pointerId] = {
				pageX: e.pageX,
				pageY: e.pageY
			};
			new_page_x = e.pageX;
			new_page_y = e.pageY;
		}
		else {
			var touches = e.originalEvent.changedTouches;
			for (var i = 0; i < touches.length; i++) {
				T._pointers[touches[i].identifier] = {
					pageX: touches[i].pageX,
					pageY: touches[i].pageY
				};
			}
			new_page_x = touches[0].pageX;
			new_page_y = touches[0].pageY;
		}

		var keys = _.keys(T._pointers);
		if (keys.length == 1) {
			if (!T._pinching) {
				var now = Date.now();

				if (!T._lockTested && now - T._lastTap > 50) {
					// determine if we can lock a direction
					var deltaX = Math.abs(T._dragStartPoint.x - new_page_x);
					var deltaY = Math.abs(T._dragStartPoint.y - new_page_y);

					if (deltaY > deltaX * 1.5) {
						T._lockX = true;
					}

					T._lockTested = true;
				}

				if (T._lockX) {
					x = T._x;
				} else {
					x = T._dragStartPagePoint.x - ((T._dragStartPoint.x - new_page_x) / T._zoom);
				}

				y = T._dragStartPagePoint.y - ((T._dragStartPoint.y - new_page_y) / T._zoom);

				T.setPosition(x, y, T._zoom, true, false);


				// inertia management
				if (T._dragEvents.length) {
					e.pv5TimeStamp = now;
					if (e.pv5TimeStamp - T._dragEvents[T._dragEvents.length - 1].pv5TimeStamp > 40) {
						//console.log("add event "+e.originalEvent.timestamp);
						T._dragEvents.push(e);
						if (T._dragEvents.length > 2) {
							T._dragEvents.shift();
						}
					}
				}
			}
		} else if (keys.length == 2) {

			// pinch
			var t1 = T._pointers[keys[0]];
			var t2 = T._pointers[keys[1]];
			var midX = (Math.abs(((t2.pageX - t1.pageX) / 2)) + t1.pageX);
			var midY = (Math.abs(((t2.pageY - t1.pageY) / 2)) + t1.pageY);
			var dist = Math.sqrt(Math.pow((t1.pageX - t2.pageX), 2) + Math.pow((t1.pageY - t2.pageY), 2));
			var scale = dist / T._touchStartDist;
			var newS = scale * T._touchStartScale;
			newS = T._clampZoom(newS);

			if (!T._pinching) {
				T.hideTiles();
				T._pinching = true;
			}
			var offset = T.$el.offset();
			//var pt={x:midX-offset.left,y:midY-offset.top};
			//T._vpToImage(pt);

			//T.zoomCentered(pt.x,pt.y,newS,midX-offset.left,midY-offset.top,true,false);
			T.zoomCentered(T._touchStartMidPt.x, T._touchStartMidPt.y, newS, midX - offset.left, midY - offset.top, false, false);
		}
	},

	onDragEnd: function (e) {
		var T = this, new_page_x, new_page_y;

		//console.log("Drag end");


		if (T.hasPointerEvent) {
			delete T._pointers[e.originalEvent.pointerId];
			new_page_x = e.pageX;
			new_page_y = e.pageY;
		}
		else {
			var touches = e.originalEvent.changedTouches;
			for (var i = 0; i < touches.length; i++) {
				delete T._pointers[touches[i].identifier];
			}
			new_page_x = touches[0].pageX;
			new_page_y = touches[0].pageY;
		}

		debug("drag end " + Object.keys(T._pointers).length + " pointers");

		var keys = _.keys(T._pointers);

		if (!T._pinching && T._dragEvents.length > 1) {
			// inertia management
			// http://stackoverflow.com/questions/4443526/jquery-ui-drag-easing-inertia
			// http://james.padolsey.com/javascript/fun-with-jquerys-animate/

			var x1, x2,
				y1, y2,
				t1, t2; // Time

			var minDistance = 30; // Minimum px distance object must be dragged to enable momentum.
			var lastE = T._dragEvents.shift();

			x1 = lastE.pageX;
			y1 = lastE.pageY;
			t1 = lastE.pv5TimeStamp;
			x2 = new_page_x;
			y2 = new_page_y;
			t2 = Date.now();

			// Deltas
			var dX = x2 - x1,
				dY = y2 - y1,
				dMs = Math.max(t2 - t1, 1);

			// Speeds
			var speedX = Math.max(Math.min(dX / dMs, 1), -1),
				speedY = Math.max(Math.min(dY / dMs, 1), -1);

			// Distance moved (Euclidean distance)
			var distance = Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));

			var lockedX = T._lockX;

			T._lockX = false;

			if (distance > minDistance) {
				// Momentum
				//console.log("start momentum");
				var lastStepTime = new Date();
				$({
					count: 100
				}).animate({
					count: 0
				}, {
					duration: Math.max(Math.abs(speedX), Math.abs(speedY)) * 1500,
					step: function () {
						speedX *= (this.count / 100);
						speedY *= (this.count / 100);

						var now = Date.now();
						var stepDuration = now - lastStepTime;

						lastStepTime = now;

						//console.log("count: "+this.count+" speedY: "+speedY +" stepDuration:" +stepDuration);

						var new_x, new_y;
						if (lockedX) {
							new_x = T._x;
						} else {
							new_x = (T._x + ((speedX * stepDuration / 4) / T._zoom));
						}

						new_y = (T._y + ((speedY * stepDuration / 4) / T._zoom));

						T.setPosition(new_x, new_y, T._zoom, true, false);
					}
				});
			}
		}

		if (!keys.length) {
			$(window).off(".pv5-page");
			if (T._pinching) {
				T._pinching = false;
				T.saveZoomFav(T._zoom);
				T.setPosition(T._x, T._y, T._zoom, true, true);
				T.refresh();
			}
		}
	},

	/**
	 * save favorite zoom
	 * @param  {[type]} z [description]
	 * @return {[type]}   [description]
	 */
	saveZoomFav: function (z) {
		var T = this;
		if (z > T._zoomFit * 1.4) {
			T.zoomFav = z;
			T.trigger("change:zoom-fav", T);
		}
	},

	/**
	 * Hide all hd tiles, only background while be shown. Call refresh to reactivate tiles.
	 * This functionality is used while animating
	 */
	hideTiles: function () {
		var T = this;

		if (T.usePDF) {
			var nb_pages = T.model.get("isDouble") ? 2 : 1;
			if (window.devicePixelRatio <= 1) {
				// on passe en % pour faire l'animation
				T.$('canvas').css({
					width: (100 / nb_pages) + "%",
					height: "100%"
				});
			}
		}
		else {
			T.$(".tile").hide();
		}
	},

	/**
	 * Check if page displayed is a left page, useful only if we are in portrait orientation
	 * @return {Boolean}
	 */
	isLeftPage: function () {
		return this.page % 2 ? false : true;
	},

	close: function () {
		var T = this;
		T.$tileContainer = null;
		T._dragEvents = [];
		T._pointers = {};
		T._visible = [];
		T._tiles = {};
		T.stopListening();
		T.undelegateEvents();
	}

});

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * utility class working with strings
 */
var StringUtil = {

    dashToCamel:function(str){
        return str.toLowerCase().replace(/-(.)/g, function(m, g) {
                return g.toUpperCase();
        });
    },

    camelToDash:function(str) { 
        return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
    },

    underscoreToCamel:function(str){
        return str.toLowerCase().replace(/_(.)/g, function(m, g) {
                return g.toUpperCase();
        });
    },

    camelToUnderscore:function(str) { 
        return str.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase();
    },

    pad:function(number,length,c){
        var str = String(number);
        c = c || "0";
        while (str.length < length)
            str = c + str;
        return str;
    }
    
};

module.exports = StringUtil;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(3);
Backbone.$ = $;

var debug = __webpack_require__(2)("views:OverlayLinksView");

/**
 * Affiche l'emplacement des entités
 * Trigger:
 * - "click:entity":
 */
module.exports = Backbone.View.extend({

    pageModel: null,
    className: "overlay overlay-links",
    hasPointerEvent: false,
    isHighlighted: false,

    events: {
        "pointerdown .link": "onPointerDown",
        "pointerup .link": "onPointerUp",
        "touchstart .link": "onPointerDown",
        "touchend .link": "onPointerUp"
    },

    initialize: function (options) {
        var T = this;
        _.extend(T, options);

        T.hasPointerEvent = window.PointerEvent ? true : false;

        T.pointerPageX = 0;
        T.pointerPageY = 0;
        T.lastUp = 0;
        T.listenTo(T.pageModel, "sync", T.render);
        T.render();
    },

    render: function () {
        var T = this;

        T.$el.html("");
        if (T.pageModel.fetched) {
            debug("render links page " + T.page);
            var page_width = T.pageModel.get("width");
            var page_height = T.pageModel.get("height");
            var css;
            _.each(T.pageModel.get("links"), function (link) {
                var title;
                if (link.url.indexOf("page:") == 0) {
                    title = link.url.replace("page:", "p.");
                }
                else if (link.url.indexOf("modal://") == 0) {
                    title = link.url.replace("modal://", "");
                }
                else if (link.url.indexOf("video://") == 0) {
                    title = ""; // les éléments vidéo sont créé quand on affiche réellement la page, cf fonction highlight
                    css = "link-video";
                }
                else {
                    title = link.url;
                }

                var $div = $("<div/>", {
                    class: css || "link",
                    title: title
                }).data({
                    url: link.url
                });

                $div.css({
                    top: ((link.y / page_height) * 100) + "%",
                    left: ((link.x / page_width) * 100) + "%",
                    height: ((link.height / page_height) * 100) + "%",
                    width: ((link.width / page_width) * 100) + "%"
                });
                T.$el.append($div);

            });
            if (T.isHighlighted) {
                T.highlight();
            }
        }
    },

    onPointerDown: function (e) {
        var T = this;

        if (e.type == "touchstart" && T.hasPointerEvent) return; // ignore les events touch si le navigateur supporte les pointers events

        T.pointerPageX = e.pageX;
        T.pointerPageY = e.pageY;

        if (T.clickTimer) {
            clearTimeout(T.clickTimer);
            //debug("click clear timeout");
            T.clickTimer = null;
        }

    },

    onPointerUp: function (e) {
        var T = this;

        if (e.type == "touchend" && T.hasPointerEvent) return; // ignore les events touch si le navigateur supporte les pointers events

        var distance = Math.sqrt(Math.pow(T.pointerPageX - e.pageX, 2) + Math.pow(T.pointerPageY - e.pageY, 2));

        var now = Date.now();


        if (distance < 4 && now - T.lastUp > 500) {
            //debug("click set timeout");
            T.clickTimer = setTimeout(function () {
                debug("link clicked");
                T.trigger("click:link", T, $(e.target).data("url"));
            }, 500);
        }

        T.lastUp = now;
    },

    analyseUrl: function (url) {
        // youtube ?
        var final_url, type, video_id;

        var video_url = new URL(url);
        video_url.protocol = "https:";
        if (["youtu.be"].indexOf(video_url.hostname) != -1) {
            type = "youtube";
            video_id = video_url.pathname.split("/")[1];
            // youtu.be/aPCCzzVKO6w
            final_url = "https://www.youtube.com/embed/" + video_id + "?autoplay=1&mute=1";
        }
        else if (["www.youtube.com"].indexOf(video_url.hostname) != -1 && video_url.pathname.split("/")[1] == "watch") {
            type = "youtube";
            video_id = video_url.searchParams.get("v");
            // www.youtube.com/watch?v=3RK9eEc9rxQ
            final_url = "https://www.youtube.com/embed/" + video_id + "?autoplay=1&mute=1";
        }
        else if (["dai.ly"].indexOf(video_url.hostname) != -1) {
            type = "dailymotion";
            video_id = video_url.pathname.split("/")[1];
            // dai.ly/xw6eqt
            final_url = "https://www.dailymotion.com/embed/video/" + video_id + "?autoplay=1&mute=1";
        }
        else if (video_url.pathname.endsWith(".mp4")) {
            type = "video";
            final_url = video_url.href;
        }

        return {
            url: final_url,
            type: type
        };
    },

    constructVideo: function () {

        var T = this;

        var $videos = T.$(".link-video");

        $videos.each(
            function () {
                var $video_box = $(this);
                var url = $video_box.data("url")
                var result = T.analyseUrl(url);
                $video_box.html("");
                if (result.type == "video") {
                    var $video = $('<video controls="" autoplay muted name="media"><source src="' + result.url + '" type="video/mp4"></video>');
                    $video_box.append($video);
                }
                else if (result.type == "youtube" || result.type == "dailymotion") {
                    var $iframe = $('<iframe frameborder="0" src="' + result.url + '" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
                    $video_box.append($iframe);
                }
            }
        )


    },

    deconstructVideo: function () {
        var T = this;
        var $videos = T.$(".link-video");
        $videos.each(
            function () {
                var $video_box = $(this);
                $video_box.html("");
            }
        )
    },

    highlight: function () {
        var T = this;
        T.$el.removeClass("hl");
        T.isHighlighted = true;
        setTimeout(function () { T.$el.addClass("hl"); }, 1);

        // construction des éléments vidéo en autoplay et muted ici
        T.constructVideo();
    },

    unhighlight: function () {
        this.isHighlighted = false;
        this.deconstructVideo();
    },

    close: function () {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }
});


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);

/**
 * Quota permet d'interpréter la syntaxe de quota d'impression utilisé chez immanens
 * ex: 10/1w pour dire 10 impressions autorisées par tranche d'une semaine, avec remise à zéro le lundi 00:00
 */
module.exports = {

    /**
     * Calcule quelle sera la date de la prochaine remise à 0 en fonction de la période passée et de la date courante
     */
    computeResetDate: function (period) {

        // analyse de la syntaxe : doit commencer par un nombre et doit finir par une lettre parmi m, w, d, h
        var unit = period.slice(-1);
        var number_of_unit = parseInt(period.substr(0, period.length - 1));

        var today = new Date();
        var reset_date = new Date();
        var dd = today.getDate();
        var mm = today.getMonth(); //January is 0!

        if (unit == "m") {
            // recherche du début du X mois suivant
            reset_date.setDate(1);
            reset_date.setMonth(mm + number_of_unit);
            reset_date.setHours(0, 0, 0, 0);
        }
        else if (unit == "w") {
            // week
            reset_date = getMonday(today);
            reset_date.setDate(reset_date.getDate() + number_of_unit * 7);
            reset_date.setHours(0, 0, 0, 0);
        }
        else if (unit == "d") {
            // day
            reset_date.setDate(dd + number_of_unit);
            reset_date.setHours(0, 0, 0, 0);
        }
        else if (unit == "h") {
            // hour
            var hh = today.getHours();
            reset_date.setHours(hh + number_of_unit, 0, 0, 0);
        }
        else {
            throw (new Error("unsupported period unit " + unit));
        }

        return reset_date;
    },

    counterFromString: function (config_string) {
        return parseInt(config_string.split("/")[0]);
    },

    periodFromString: function (config_string) {
        return config_string.split("/")[1];
    },

    /**
     * retourne un tableau de pages à partir d'une string d'impression
     * page syntax : 1-5, 8, 11-13
     */
    pagesFromString: function (pages_string, nbPagesMax, separator) {
        var pages = [];
        separator = separator || ",";
        var page_spl = pages_string.split(separator);

        page_spl.forEach(function (page_interval) {
            var page_interval_spl = page_interval.split("-");
            if (page_interval_spl.length == 1) {
                var page = parseInt(page_interval_spl[0]);
                pages.push(page);
            }
            else if (page_interval_spl.length > 1) {
                var page_min = parseInt(page_interval_spl[0]);
                if (page_min < 0) {
                    page_min = 1;
                }
                var page_max = parseInt(page_interval_spl[1]);

                if (page_max < page_min) {
                    page_max = page_min;
                }
                if (page_max - page_min > nbPagesMax - 1) {
                    page_max = page_min + nbPagesMax - 1;
                }

                for (var i = page_min; i <= page_max; i++) {
                    pages.push(i);
                }
            }
        });

        pages = _.uniq(pages);
        pages = pages.sort(function (a, b) {
            return a - b;
        });
        pages = pages.slice(0, nbPagesMax);

        return pages;
    },

    /**
     * vérifie que la syntaxe est correcte et qu'elle ne dépasse pas le nombre max de page
     */
    checkPrintRangeSyntax: function (page_str, max_page) {
        if (page_str.length) {
            var page_spl = page_str.split(",");
            for (var i = 0; i < page_spl.length; i++) {
                var page_interval = page_spl[i];
                var page_interval_spl = page_interval.split("-");
                if (page_interval_spl.length == 1) {
                    var page = parseInt(page_interval_spl[0]);
                    if (isNaN(page) || page < 1 || page > max_page) {
                        return false;
                    }
                } else if (page_interval_spl.length == 2) {
                    var page_min = parseInt(page_interval_spl[0]);
                    var page_max = parseInt(page_interval_spl[1]);
                    if (isNaN(page_min) || page_min < 1 || page_min > max_page) {
                        return false;
                    }
                    if (isNaN(page_max) || page_max < 1 || page_max > max_page) {
                        return false;
                    }
                    if (page_min > page_max) {
                        return false;
                    }
                } else {
                    return false;
                }
            }
        } else {
            return false;
        }
        return true;
    },

    /**
     * inverse la série de page pour les documents arabes, la syntaxe devra être valide
     */
    reversePrintRange: function (page_str, nb_pages) {
        if (page_str && page_str.length) {
            var page_spl = page_str.split(",");
            var reversed_page_str = "";
            for (var i = 0; i < page_spl.length; i++) {
                var page_interval = page_spl[i];
                var page_interval_spl = page_interval.split("-");
                if (page_interval_spl.length == 1) {
                    var page = parseInt(page_interval_spl[0]);
                    if (reversed_page_str.length) {
                        reversed_page_str = "," + reversed_page_str;
                    }
                    reversed_page_str = String(nb_pages - page + 1) + reversed_page_str;
                } else if (page_interval_spl.length == 2) {
                    var page_min = parseInt(page_interval_spl[0]);
                    var page_max = parseInt(page_interval_spl[1]);
                    if (reversed_page_str.length) {
                        reversed_page_str = "," + reversed_page_str;
                    }
                    reversed_page_str = String(nb_pages - page_max + 1) + "-" + String(nb_pages - page_min + 1) + reversed_page_str;
                }
            }
            page_str = reversed_page_str;
        }
        return page_str;
    }

};

/**
 * retourne le lundi précédent la date en argument
 */
function getMonday(d) {
    d = new Date(d);
    var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(d.setDate(diff));
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(3);
Backbone.$ = $;

var debug = __webpack_require__(2)("views:PageSliderView"); //https://github.com/visionmedia/debug

/**
 * PageSliderView: Display a page thumbnail slider like ibooks
 */
module.exports = Backbone.View.extend({

    model: null, // DocumentModel
    knobMinWidth: 40,
    knobMaxWidth: 100,
    templateKnob: null,
    templateThumb: null,
    fixedWidth: 0,
    authorizedPages: null,
    hasPointerEvent: false,
    embed: false, // en mode embed on désactive touch-action:none (bug de scroll à partir d'ios 14)
    usePageLabel: false,

    events: {
        "pointerdown .knob": "onDragStart",
        "touchstart .knob": "onDragStart",
        "click": "onClick"
    },

    initialize: function (options) {
        var T = this;

        _.extend(T, options);

        T.hasPointerEvent = window.PointerEvent ? true : false;

        //T.hasPointerEvent = false;

        if (T.fixedWidth) {
            T.knobMinWidth = T.fixedWidth;
            T.knobMaxWidth = T.fixedWidth;
        }

        T._knobWidth = 0;
        T._step = 0;
        T._pointers = {};
        T._dragStartPoint = {
            x: 0,
            y: 0
        };
        T._dragStartLeft = 0;


        if (T.templateKnob) {
            T.templateKnob = _.template(T.templateKnob); // compile template
        }

        if (T.templateThumb) {
            T.templateThumb = _.template(T.templateThumb); // compile template
        }

        T.listenTo(T.model, "sync", T.render);
        T.listenTo(T.model, "change:page", T.update);
    },

    render: function () {
        var T = this;

        if (T.model.fetched) {
            var context = T.model.toJSON();

            if (T.templateKnob) {
                T.$el.html("");
                T.$knob = $(T.templateKnob(context));
                T.$el.append(T.$knob);

                T.$thumb = $(T.templateThumb(context));
                T.$el.append(T.$thumb);
                T.$thumb.hide();

                if (!T.embed) {
                    T.$el.css("touch-action", "none");
                }
            }
            T.resize();
        }
        return T;
    },

    /**
     * adjust slider size from nb pages and container width
     */
    resize: function () {
        var T = this;

        if (!T.model.fetched) return;

        T._elWidth = T.$el.width();
        T._elHeight = T.$el.height();

        T._knobWidth = T._elWidth / (T.model.get("nbPages") - 1);

        if (T._knobWidth < T.knobMinWidth) {
            T._knobWidth = T.knobMinWidth;
        } else if (T._knobWidth > T.knobMaxWidth) {
            T._knobWidth = T.knobMaxWidth;
        }

        T._step = (T._elWidth - T._knobWidth) / (T.model.get("nbPages") - 1);


        T.$knob.css({
            width: T._knobWidth
        });

        T.update();

    },

    update: function () {
        var T = this;
        if (!T.model.fetched) return;
        var page = T.model.get("page") || 1;
        var knob_left = T._step * (page - 1);

        // console.log("page "+ page+" el width: "+T._elWidth +" left:"+ knob_left +" knob:"+ T._knobWidth );

        // move slider to current page
        T.$knob.css({
            left: knob_left
        });
    },

    onDragStart: function (e) {
        var T = this, new_page_x, new_page_y;
        e.preventDefault();
        if (e.type == "touchstart" && T.hasPointerEvent) return; // ignore les events touch si le navigateur supporte les pointers events
        var touches;

        var nb_touches_before = Object.keys(T._pointers).length;

        if (T.hasPointerEvent) {
            T._pointers[e.originalEvent.pointerId] = {
                pageX: e.pageX,
                pageY: e.pageY
            };
            new_page_x = e.pageX;
            new_page_y = e.pageY;
        }
        else {
            var touches = e.originalEvent.changedTouches;
            for (var i = 0; i < touches.length; i++) {
                T._pointers[touches[i].identifier] = {
                    pageX: touches[i].pageX,
                    pageY: touches[i].pageY
                };
            }
            new_page_x = touches[0].pageX;
            new_page_y = touches[0].pageY;
        }

        var keys = _.keys(T._pointers);

        if (keys.length == 1) {
            T._dragStartPoint.x = new_page_x;
            T._dragStartPoint.y = new_page_y;

            T._dragStartLeft = T.knobPosition();
            //T._gotoPage=T.pageFromKnobPosition(T.knobPosition());
            var page = T.pageFromKnobPosition(T.knobPosition());
            T.updateThumb(page);
            T.$thumb.show();
        } else {
            T._abortDrag = true;
        }

        if (nb_touches_before == 0) {
            if (T.hasPointerEvent) {
                T._dragStartPoint.x = new_page_x;
                T._dragStartPoint.y = new_page_y;

                $(window).on("pointermove.pv5-slider", function (e) {
                    T.onDragMove(e);
                });
                $(window).on("pointerup.pv5-slider", function (e) {
                    T.onDragEnd(e);
                });
                $(window).on("pointercancel.pv5-slider", function (e) {
                    T.onDragEnd(e);
                });
            }
            else {
                T._dragStartPoint.x = new_page_x;
                T._dragStartPoint.y = new_page_y;

                $(window).on("touchmove.pv5-slider", function (e) {
                    T.onDragMove(e);
                });
                $(window).on("touchend.pv5-slider", function (e) {
                    T.onDragEnd(e);
                });
                $(window).on("touchcancel.pv5-slider", function (e) {
                    T.onDragEnd(e);
                });
            }
        }

        //console.log(T._dragStartPoint.x+" "+T._dragStartPoint.x+" "+T._dragStartLeft);*/
    },

    onDragMove: function (e) {
        var T = this;

        if (T._abortDrag) return;
        var new_page_x;
        e.preventDefault();
        //console.log("drag move doc "+e.type);
        if (T.hasPointerEvent) {
            T._pointers[e.originalEvent.pointerId] = {
                pageX: e.pageX,
                pageY: e.pageY
            };
            new_page_x = e.pageX;
        }
        else {
            var touches = e.originalEvent.changedTouches;
            for (var i = 0; i < touches.length; i++) {
                T._pointers[touches[i].identifier] = {
                    pageX: touches[i].pageX,
                    pageY: touches[i].pageY
                };
            }
            new_page_x = touches[0].pageX;
        }

        var keys = _.keys(T._pointers);
        if (keys.length == 1) {

            var knob_left = T._dragStartLeft - (T._dragStartPoint.x - new_page_x);
            T.knobPosition(knob_left);
            T.$el.addClass("grabbing");
            var page = T.pageFromKnobPosition(T.knobPosition());
            if (T._previousPageThumb != page) {
                T.updateThumb(page);
                T._previousPageThumb = page;
            }
        }
    },

    onDragEnd: function (e) {
        var T = this;

        if (T.hasPointerEvent) {
            delete T._pointers[e.originalEvent.pointerId];
        }
        else {
            var touches = e.originalEvent.changedTouches;
            for (var i = 0; i < touches.length; i++) {
                delete T._pointers[touches[i].identifier];
            }

        }

        var keys = _.keys(T._pointers);

        //console.log("drag end doc "+e.type);
        if (!keys.length) {
            $(window).off(".pv5-slider");
            T._abortDrag = false;
            var page = T.pageFromKnobPosition(T.knobPosition());
            debug("gotopage " + page);
            T.trigger("drag:end");
            T.model.set({
                "page": page
            });
            T.$el.removeClass("grabbing");
            T.$thumb.hide();
        }

    },

    onClick: function (e) {
        var T = this;
        if (e.target == T.el) {
            var x = e.pageX - T.$el.offset().left - (T._knobWidth / 2);
            if (x < 0) {
                x = 0;
            }
            var page = T.pageFromKnobPosition(x);
            debug("click slider position : " + x + " page : " + page);
            T.trigger("click");
            T.model.set({
                "page": page
            });
        }
    },

    updateThumb: function (page) {
        var T = this, str_page;

        if (T.usePageLabel) {
            str_page = T.model.pageLabelFromNumber(page);
        }
        else {
            if (T.model.get("reversed")) {
                str_page = String(T.model.get("nbPages") - page + 1);
            }
            else {
                str_page = String(page);
            }
        }

        T.$(".page").html(str_page);
        if (T.model.get("isDouble")) {
            if (page > 1) {
                page = (page % 2) ? page - 1 : page;
            }
            T.$(".cover").toggleClass("double-page", !(page == 1 || page == T.model.get("nbPages")));
        }

        if (T.bgTimer) {
            clearTimeout(T.bgTimer);
            T.bgTimer = 0;
        }
        if (page != T.bgPage) {
            T.$(".cover").css({
                backgroundImage: "none"
            });
        }

        T.bgPage = page;

        //  on attend un peu avant d'affecter l'image ça évite de charger toutes les images lors d'un long drag
        T.bgTimer = setTimeout(function () {
            T.$thumb.toggleClass("page-not-authorized", !T.isPageAuthorized(page));
            T.$(".cover").css({
                backgroundImage: "url(" + T.model.thumbnailUrl(page) + ")"
            });
        }, 100);

    },

    pageFromKnobPosition: function (p) {
        var T = this,
            page;
        page = Math.round(p / T._step);
        return page + 1;
    },

    isPageAuthorized: function (page) {
        var T = this;
        if (_.isArray(T.authorizedPages)) {
            return T.authorizedPages.indexOf(page) != -1;
        }
        else {
            return true;
        }
    },


    knobPosition: function (p) {
        var T = this;
        if (p) {
            //console.log(p);
            // clamp poision
            if (p < 0) {
                p = 0;
            } else if (p > T._elWidth - T._knobWidth) {
                p = T._elWidth - T._knobWidth;
            }

            var knob_left = p;

            T.$knob.css({
                left: knob_left
            });
        } else {
            return parseInt(T.$knob.css("left"));
        }

    },

    close: function () {
        var T = this;
        T.$knob = null;
        T.stopListening();
        T.undelegateEvents();
    }

});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(3);
Backbone.$ = $;

var debug = __webpack_require__(2)("views:OverlayBarcodeView");

var EAN13_STRUCTURE = [
    'LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG',
    'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'
];

var BINARIES = {
    'L': [ // The L (left) type of encoding
        '0001101', '0011001', '0010011', '0111101', '0100011',
        '0110001', '0101111', '0111011', '0110111', '0001011'
    ],
    'G': [ // The G type of encoding
        '0100111', '0110011', '0011011', '0100001', '0011101',
        '0111001', '0000101', '0010001', '0001001', '0010111'
    ],
    'R': [ // The R (right) type of encoding
        '1110010', '1100110', '1101100', '1000010', '1011100',
        '1001110', '1010000', '1000100', '1001000', '1110100'
    ]
};

var SIDE_BIN = '101';
var MIDDLE_BIN = '01010';



/**
 * Affiche un code barre
 * Trigger:
 */
module.exports = Backbone.View.extend({

    pageModel: null,
    documentModel: null,
    barcode: null,
    placement: "midlast",
    height: 10, // hauteur du code barre en mm
    //className: "overlay", // pas de class pour que l'élément ne soit pas facilement sélectionnable dans puppeteer

    initialize: function (options) {
        var T = this;
        _.extend(T, options);
        T.listenTo(T.pageModel, "sync", T.render);
        T.render();
    },

    checksum: function (number) {
        var res = number
            .substr(0, 12)
            .split('')
            .map(function(n){return +n;})
            .reduce(function(sum, a, idx) {return idx % 2 ? sum + a * 3 : sum + a;}, 0);

        return (10 - (res % 10)) % 10;
    },

    encode: function (data, structure) {
        var encoded = data
            .split('')
            .map(function(val, idx) { return BINARIES[structure[idx]];})
            .map(function(val, idx) { return val ? val[data[idx]] : '';});
        return encoded.join('');
    },

    generate: function (ean, options) {
        // from https://github.com/lindell/JsBarcode/tree/master/src/barcodes/EAN_UPC
        if (!ean || ean.length != 12 || ean.search(/^[0-9]{12}$/) !== 0) throw new Error('Invalid EAN 13, should have 12 digits');

        ean += this.checksum(ean);

        var ean_code = SIDE_BIN;

        const left_str = ean.substr(1, 6);
        const structure = EAN13_STRUCTURE[ean[0]];
        ean_code += this.encode(left_str, structure);

        ean_code += MIDDLE_BIN;

        const right_str = ean.substr(7, 6);
        ean_code += this.encode(right_str, 'RRRRRR');

        ean_code += SIDE_BIN;

        //console.log(ean_code);

        var height = options.height || 100;
        var bar_width = options.barWidth || 1;
        var width = 95 * bar_width;
        var svg_str = '<svg width="100%" preserveAspectRatio="none" viewBox="0 0 ' + width + ' ' + height + '" xmlns="http://www.w3.org/2000/svg" version="1.1">';
        
        // bars
        var bar_pos = 0;

        function addBar(start, end) {
            var line = '<rect x="' + start + '" y="0" width="' + (end - start) + '" height="' + height + '"/>';
            svg_str += line;
        }


        var black_bar_start = -1;
        for (var i = 0; i < ean_code.length; i++) {
            // lines
            if (ean_code[i] == "1") {
                if (black_bar_start == -1) {
                    black_bar_start = bar_pos; // nouvelle barre
                }
            } else {
                if (black_bar_start != -1) {
                    addBar(black_bar_start, bar_pos);
                    black_bar_start = -1;
                }
            }
            bar_pos += bar_width;
        }

        if (black_bar_start!=-1) {
            addBar(black_bar_start, bar_pos);
        }

        // end
        svg_str += '</svg >';
        return svg_str;
    },

    render: function () {
        var T = this;

        T.$el.html("");

        if (T.pageModel.fetched) {
            debug("render barcode " + T.page);
            var page_width = T.pageModel.get("width");
            var page_height = T.pageModel.get("height");

            var barcode_width, barcode_height, barcode_left;
            var align = null;

            var $div = $("<div/>");

            if (T.placement == "midlast") {

                // algo plcement à la fin et au milieu
                var nb_pages = T.documentModel.get("nbPages");
                var middle_page = nb_pages / 2;
                var last_page = nb_pages;
                var page_to_tag;

                if (T.pageModel.get("number").indexOf(last_page) != -1) {
                    page_to_tag = last_page;
                } else if (T.pageModel.get("number").indexOf(middle_page) != -1) {
                    page_to_tag = middle_page;
                }

                if (page_to_tag) {
                    align = T.pageModel.get("isDouble") ? (page_to_tag % 2 ? "right" : "left") : "center";

                    barcode_height = Math.round(T.height * (T.pageModel.get("dpi") / 25.4)); // pixel
                    barcode_width = barcode_height * 10;
                }
                else {
                    // pas de page à taguer avec le code barre
                    return;
                }
            }
            else {
                throw new Error("unsupported barcode placement");
            }

            if (align == "center") {
                barcode_left = Math.round(page_width / 2 - barcode_width / 2);
            }
            else if (align == "left") {
                barcode_left = Math.round(page_width / 4 - barcode_width / 2);
            }
            else if (align == "right") {
                barcode_left = Math.round(page_width / 4 * 3 - barcode_width / 2);
            }

            $div.css({
                "position": "absolute",
                "display": "block",
                "z-index": 40,
                "background-color": "white",
                bottom: 0,
                left: (barcode_left / page_width * 100) + "%",
                height: ((barcode_height / page_height) * 100) + "%",
                width: ((barcode_width / page_width) * 100) + "%"
            });

            var $svg = $(this.generate(T.barcode, { height: 100, barWidth: 4 }));
            $div.append($svg);
            T.$el.append($div);
        }
    },

    close: function () {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }
});


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(3);
Backbone.$ = $;

/**
 * outil pour découpage d'une zone rectangulaire
 * Trigger:
 */
module.exports = Backbone.View.extend({

    className: "overlay overlay-select",
    model: null, // PageModel
    minWidth: 0,
    maxWidth: 100,
    minHeight: 0,
    maxHeight: 100,
    events: {
        "pointerdown": "onDragStart",
        "touchstart": "onDragStart"
    },
    hasPointerEvent: false,

    initialize: function (options) {
        var T = this;

        T.selection = {
            x: 30,
            y: 30,
            width: 40,
            height: 40
        };

        _.extend(T, options);

        T.hasPointerEvent = window.PointerEvent ? true : false;

        T._pointers = {};
        T._dragStartPoint = { x: 0, y: 0 };
        T._dragStartSelection = {};
        T._abortDrag = false;

        if (T.hide) {
            T.$el.addClass("hide");
        }

        if (!T.pageModel.fetched) {
            T.listenToOnce(T.pageModel, "sync", T.render);
        }
        else {
            T.render();
        }
    },

    render: function () {
        var T = this,
            d = "<div/>";

        T.$el.html("");

        if (T.pageModel.fetched) {
            T.$cacheTop = $(d, {
                class: "cache top",
            });
            T.$el.append(T.$cacheTop);
            T.$cacheLeft = $(d, {
                class: "cache left",
            });
            T.$el.append(T.$cacheLeft);
            T.$cacheRight = $(d, {
                class: "cache right",
            });
            T.$el.append(T.$cacheRight);
            T.$cacheBottom = $(d, {
                class: "cache bottom",
            });
            T.$el.append(T.$cacheBottom);

            T.$handleCenter = $(d, {
                class: "handle center",
            });
            T.$handleCenter.data("handle", "center");
            T.$el.append(T.$handleCenter);

            T.$handleLeft = $(d, {
                class: "handle left",
            });
            T.$handleLeft.data("handle", "left");
            T.$el.append(T.$handleLeft);

            T.$handleTop = $(d, {
                class: "handle top",
            });
            T.$handleTop.data("handle", "top");
            T.$el.append(T.$handleTop);

            T.$handleRight = $(d, {
                class: "handle right",
            });
            T.$handleRight.data("handle", "right");
            T.$el.append(T.$handleRight);

            T.$handleBottom = $(d, {
                class: "handle bottom",
            });
            T.$handleBottom.data("handle", "bottom");
            T.$el.append(T.$handleBottom);

            T.layout();
        }
    },

    _clampWidth: function (width) {
        var T = this;
        if (width < T.minWidth) {
            width = T.minWidth;
        } else if (width > T.maxWidth) {
            width = T.maxWidth;
        }
        return width;
    },

    _clampHeight: function (height) {
        var T = this;
        if (height < T.minHeight) {
            height = T.minHeight;
        } else if (height > T.maxHeight) {
            height = T.maxHeight;
        }
        return height;
    },

    setSelection: function (new_sel, clamp) {
        var T = this,
            x = new_sel.x,
            y = new_sel.y,
            height = new_sel.height,
            width = new_sel.width;

        if (clamp) {
            // clamp size
            width = T._clampWidth(width);
            height = T._clampHeight(height);

            // clamp position
            if (x < 0) {
                x = 0;
            }
            if (y < 0) {
                y = 0;
            }
            if (x + width > 100) {
                width = 100 - x;
            }
            if (y + height > 100) {
                height = 100 - y;
            }
        }

        T.selection.x = x;
        T.selection.y = y;
        T.selection.width = width;
        T.selection.height = height;
        T.layout();
    },

    layout: function () {
        var T = this;

        // place each cache and handles
        T.$cacheTop.css({
            height: T.selection.y + "%"
        });
        T.$cacheBottom.css({
            top: (T.selection.y + T.selection.height) + "%",
            height: (100 - T.selection.height - T.selection.y) + "%"
        });
        T.$cacheLeft.css({
            top: T.selection.y + "%",
            height: T.selection.height + "%",
            width: T.selection.x + "%"
        });
        T.$cacheRight.css({
            top: T.selection.y + "%",
            height: T.selection.height + "%",
            width: (100 - T.selection.x - T.selection.width) + "%"
        });
        T.$handleCenter.css({
            top: (T.selection.y + (T.selection.height / 2)) + "%",
            left: (T.selection.x + (T.selection.width / 2)) + "%"
        });
        T.$handleLeft.css({
            top: (T.selection.y + (T.selection.height / 2)) + "%",
            left: T.selection.x + "%"
        });
        T.$handleRight.css({
            top: (T.selection.y + (T.selection.height / 2)) + "%",
            left: T.selection.x + T.selection.width + "%"
        });
        T.$handleTop.css({
            top: T.selection.y + "%",
            left: T.selection.x + (T.selection.width / 2) + "%"
        });
        T.$handleBottom.css({
            top: (T.selection.y + T.selection.height) + "%",
            left: T.selection.x + (T.selection.width / 2) + "%"
        });

    },

    onDragStart: function (e) {
        var T = this, new_page_x, new_page_y;

        if (T.$el.hasClass("inactive")) {
            return;
        }

        if (e.type == "touchstart" && T.hasPointerEvent) return; // ignore les events touch si le navigateur supporte les pointers events

        e.preventDefault();
        e.stopPropagation();

        var nb_touches_before = Object.keys(T._pointers).length;

        if (T.hasPointerEvent) {
            T._pointers[e.originalEvent.pointerId] = {
                pageX: e.pageX,
                pageY: e.pageY
            };
            new_page_x = e.pageX;
            new_page_y = e.pageY;
        }
        else {
            var touches = e.originalEvent.changedTouches;
            for (var i = 0; i < touches.length; i++) {
                T._pointers[touches[i].identifier] = {
                    pageX: touches[i].pageX,
                    pageY: touches[i].pageY
                };
            }
            new_page_x = touches[0].pageX;
            new_page_y = touches[0].pageY;
        }

        var keys = _.keys(T._pointers);

        if (keys.length == 1) {
            T._dragStartPoint.x = new_page_x;
            T._dragStartPoint.y = new_page_y;

            T._dragHandle = $(e.target).data("handle");
            if (T._dragHandle) {
                // handle drag
                T._dragStartSelection = _.clone(T.selection);
            }
            else {
                // new selection
                var offset = T.$el.offset(),
                    page_x = (new_page_x - offset.left) * 100 / T.$el.width(),
                    page_y = (new_page_y - offset.top) * 100 / T.$el.height();
                T._dragStartSelection.x = page_x;
                T._dragStartSelection.y = page_y;
                T._dragStartSelection.width = T.minWidth;
                T._dragStartSelection.height = T.minHeight;
            }
            T.trigger("select:start");
        }
        else {
            T._abortDrag = true;
        }

        if (nb_touches_before == 0) {
            if (T.hasPointerEvent) {
                $(window).on("pointermove.ov-sel", function (e) { T.onDragMove(e); });
                $(window).on("pointerup.ov-sel", function (e) { T.onDragEnd(e); });
                $(window).on("pointercancel.ov-sel", function (e) { T.onDragEnd(e); });
            }
            else {
                $(window).on("touchmove.ov-sel", function (e) { T.onDragMove(e); });
                $(window).on("touchend.ov-sel", function (e) { T.onDragEnd(e); });
                $(window).on("touchcancel.ov-sel", function (e) { T.onDragEnd(e); });
            }
        }

    },

    onDragMove: function (e) { //jshint ignore: line
        var T = this, new_page_x, new_page_y;

        if (T._abortDrag) return;

        //console.log("drag move doc "+e.type);
        if (T.hasPointerEvent) {
            T._pointers[e.originalEvent.pointerId] = {
                pageX: e.pageX,
                pageY: e.pageY
            };
            new_page_x = e.pageX;
            new_page_y = e.pageY;
        }
        else {
            var touches = e.originalEvent.changedTouches;
            for (var i = 0; i < touches.length; i++) {
                T._pointers[touches[i].identifier] = {
                    pageX: touches[i].pageX,
                    pageY: touches[i].pageY
                };
            }
            new_page_x = touches[0].pageX;
            new_page_y = touches[0].pageY;
        }

        var keys = _.keys(T._pointers);
        if (keys.length == 1) {
            var dX = (new_page_x - T._dragStartPoint.x) * 100 / T.$el.width(), // %
                dY = (new_page_y - T._dragStartPoint.y) * 100 / T.$el.height(), // %
                clamp = false;

            //console.log("dx: "+dX);

            var new_sel = _.clone(T._dragStartSelection);

            if (T._dragHandle) {
                if (T._dragHandle == "center") {
                    new_sel.x = T._dragStartSelection.x + dX;
                    if (new_sel.x < 0) {
                        new_sel.x = 0;
                    }
                    if (new_sel.x + new_sel.width > 100) {
                        new_sel.x = 100 - new_sel.width;
                    }
                    new_sel.y = T._dragStartSelection.y + dY;
                    if (new_sel.y < 0) {
                        new_sel.y = 0;
                    }
                    if (new_sel.y + new_sel.height > 100) {
                        new_sel.y = 100 - new_sel.height;
                    }
                }
                else if (T._dragHandle == "left") {
                    new_sel.width = T._clampWidth(T._dragStartSelection.width - dX);
                    new_sel.x = T._dragStartSelection.x + T._dragStartSelection.width - new_sel.width;
                    if (new_sel.x < 0) {
                        new_sel.x = 0;
                        new_sel.width = T._dragStartSelection.width + T._dragStartSelection.x;
                    }
                }
                else if (T._dragHandle == "right") {
                    new_sel.width = T._clampWidth(T._dragStartSelection.width + dX);
                    if (T._dragStartSelection.x + new_sel.width > 100) {
                        new_sel.width = 100 - T._dragStartSelection.x;
                    }
                }
                else if (T._dragHandle == "top") {
                    new_sel.height = T._clampHeight(T._dragStartSelection.height - dY);
                    new_sel.y = T._dragStartSelection.y + T._dragStartSelection.height - new_sel.height;
                    if (new_sel.y < 0) {
                        new_sel.y = 0;
                        new_sel.height = T._dragStartSelection.height + T._dragStartSelection.y;
                    }
                }
                else if (T._dragHandle == "bottom") {
                    new_sel.height = T._clampHeight(T._dragStartSelection.height + dY);
                    if (T._dragStartSelection.y + new_sel.height > 100) {
                        new_sel.height = 100 - T._dragStartSelection.y;
                    }
                }
            }
            else {

                if (dX < 0) {
                    new_sel.x = T._dragStartSelection.x + dX;
                    if (new_sel.x >= 0) {
                        new_sel.width = -dX;
                    }
                    else {
                        new_sel.width = T.selection.width; // on dépasse le bord gauche, la taille ne bouge pas
                    }
                }
                else {
                    new_sel.width = dX;
                }

                if (dY < 0) {
                    new_sel.y = T._dragStartSelection.y + dY;
                    if (new_sel.y >= 0) {
                        new_sel.height = -dY;
                    }
                    else {
                        new_sel.height = T.selection.height; // on dépasse le bord haut, la taille ne bouge pas
                    }
                }
                else {
                    new_sel.height = dY;
                }

                clamp = true;
            }
            T.setSelection(new_sel, clamp);
        }

    },

    onDragEnd: function (e) {
        var T = this;

        if (T.hasPointerEvent) {
			delete T._pointers[e.originalEvent.pointerId];
		}
		else {
			var touches = e.originalEvent.changedTouches;
			for (var i = 0; i < touches.length; i++) {
				delete T._pointers[touches[i].identifier];
			}
		}

        var keys = _.keys(T._pointers);

        //console.log("drag end doc "+e.type);
        if (!keys.length) {
            $(window).off(".ov-sel");
            T._abortDrag = false;
            T.trigger("select:end");
            //T.$el.removeClass("grabbing");
        }
    },

    close: function () {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }
});


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone    = __webpack_require__(1);
var $           = __webpack_require__(3);
var _           = __webpack_require__(0);
Backbone.$      = $;

var debug       = __webpack_require__(2)("views:SearchInputView");    //https://github.com/visionmedia/debug

// SearchInputView : bind a text input and a query model
module.exports = Backbone.View.extend({

    model:null,
    fieldName:null,

    events: {
        "keypress": "onKeyPress",
        "blur":     "onBlur",
        "focus":    "onFocus"
    },

    initialize:function(options){
        var T=this;
        _.extend(T, options);
        T.listenTo(T.model, "change:"+T.fieldName, T.render); 
    },

    render: function(){
        var T=this;
        debug("render "+T.fieldName);
        T.$el.val(T.model.get(T.fieldName));
        return T;
    },

    search: function () {
        var T=this;
        T.model.search();    
    },

    getInputValue:function(){
        return this.$el.val();
    },

    onBlur:function(){
        var T=this;
        T.model.set(T.fieldName,T.getInputValue());
    },

    onFocus:function(){
        var T=this;
        setTimeout(function(){
            T.$el.select();
        },0);
    },

    onKeyPress: function (ev) {
        var T=this;
        if (ev.keyCode === 13) { // enter key pressed
            ev.preventDefault();
            T.model.set(T.fieldName,T.getInputValue());
            T.$el.blur(); // pour refermer le clavier android
            T.trigger("submit");
        }
    },

    close:function(){
        var T=this;
        T.stopListening();
        T.undelegateEvents();
    }

});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BufferScramble = {

    computeMap: function (buffer_length, chunk_size, seed) {
        var MAX_INT32 = 2147483647;
        var MINSTD = 16807;

        function nextInteger() {
            seed *= MINSTD;
            seed %= MAX_INT32;
            return seed;
        }

        var last_chunk_size = buffer_length % chunk_size;
        var nb_chunks = Math.floor(buffer_length / chunk_size);
        if (last_chunk_size) {
            nb_chunks++;
        }

        var map = [];
        var offset = 0;

        for (var i = 0; i < nb_chunks; i++) {

            map.push({
                origin: i,
                offset: offset,
                size: chunk_size,
                order: nextInteger()
            });

            offset += chunk_size;
        };

        // on corrige la taille du dernier élément si différent de 0
        if (last_chunk_size && map.length) {
            map[map.length - 1].size = last_chunk_size;
        }

        map = map.sort(function (a, b) {
            return a.order - b.order;
        });

        return map;
    },

    scrambleNode: function (buf_src, chunk_size, seed) {
        // TODO : voir pour ne pas recalculer à chaque la map à chaque fois
        var map = this.computeMap(buf_src.byteLength, chunk_size, seed);

        var buf_dest = new Buffer(buf_src.byteLength);
        
        var offset = 0, i, chunk;
        for (i=0;i<map.length;i++) {
            chunk = map[i];
                    buf_dest.set(buf_src.slice(chunk.offset, chunk.offset + chunk.size), offset);
            offset += chunk.size;
        }

        /*for (var i = 0; i < view_dest.length; i++) {
            view_dest[i] = view_dest[i] ^ 0x1;
        }*/

        return buf_dest;
    },

    unscramble: function (buf_src, chunk_size, seed) {
        // TODO : voir pour ne pas recalculer à chaque la map à chaque fois
        var map = this.computeMap(buf_src.byteLength, chunk_size, seed);

        var buf_dest = new ArrayBuffer(buf_src.byteLength);
        var view_dest = new Uint8Array(buf_dest);
        var view_src = new Uint8Array(buf_src);

        var offset = 0, i, chunk;
        for (i=0;i<map.length;i++) {
            chunk = map[i];
            view_dest.set(view_src.slice(offset, offset + chunk.size), chunk.offset);
            offset += chunk.size;
        }

        /*for (var i = 0; i < view_dest.length; i++) {
            view_dest[i] = view_dest[i] ^ 0x1;
        }*/

        return view_dest;
    }
};

module.exports = BufferScramble;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var BaseModel = __webpack_require__(6);

var debug = __webpack_require__(2)("models:TokenUserPrintModel");    //https://github.com/visionmedia/debug

/**
 * TokenUserPrintModel : récup d'un token d'impression en échange
 */
module.exports = BaseModel.extend({

    pv5api: null,

    defaults: {
        documentId: null,
        publicationId: null,
        pages: null,
        userPrintToken: null
    },

    /**
     * @param  {Object} attributes
     * @param  {Object} options
     * @param  {String} options.pv5api
     * @param  {String} options.token
     */
    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);
        debug("initialize");
        _.extend(this, options);
    },

    url: function () {
        var T = this;
        return T.pv5api + "/token-user-print";
    }

});

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);

var debug = __webpack_require__(2)("views:ThumbnailsView"); //https://github.com/visionmedia/debug
var $ = __webpack_require__(3);


/**
 * ThumbnailsView: recherche et affiche le code que devra rentrer l'utilisateur pour décrypter le pdf
 */
module.exports = Backbone.View.extend({

    model: null, // documentModel
    authorizedPages: null,
    timer: null,
    cellsLoaded: null,
    nbCellsLoaded: 0,
    template:null, 
    templateCell: null,
    nbColumns: 0,
    cellWidth: 320,
    cellHeight: 280,
    nbCells: 0,
    enabled: false,
    isDouble: true,
    nbPages: 0,
    selectedCell: -1,
    page: 1,
    previousScrollPos: -1,
    STR: null,
    usePageLabel: false,

    events: {
        "click .rbn-thumbnails-cell": "onCellClicked",
        "scroll": "onScroll"
    },

    initialize: function (options) {
        var T = this;
        _.extend(T, options);

        T.cellsLoaded = [];

        // compile templates
        T.template = _.template(T.template);
        T.templateCell = _.template(T.templateCell), 

        T.listenTo(T.model, "sync", T.render);
    },

    loadCell: function (cell_idx, cell_el, preload) {
        var T = this;

        var pages_label, page;

        // on prend en compte la double page et la dernière page
        if(T.usePageLabel){
            if (T.isDouble) {
                page = cell_idx ? cell_idx * 2 : 1;
                if (page == 1) {
                    pages_label = T.model.pageLabelFromNumber(1);
                }
                else if (page == T.nbPages) {
                    pages_label = T.model.pageLabelFromNumber(page);
                }
                else {
                    pages_label = T.model.pageLabelFromNumber(page) + " - " + T.model.pageLabelFromNumber(page + 1);
                }
            }
            else {
                page = cell_idx + 1;
                pages_label = T.model.pageLabelFromNumber(page);
            }
        }
        else{
            if (T.isDouble) {
                page = cell_idx ? cell_idx * 2 : 1;
                if (page == 1) {
                    pages_label = "1";
                }
                else if (page == T.nbPages) {
                    pages_label = String(page);
                }
                else {
                    pages_label = String(page) + " - " + String(page + 1);
                }
            }
            else {
                page = cell_idx + 1;
                pages_label = String(page);
            }
        }

        var context = {
            STR: this.STR,
            thumbnailUrl: preload ? null : T.model.thumbnailUrl(page),
            pagesLabel: pages_label
        };
        $(cell_el).html(T.templateCell(context));
    },

    refresh: function () {
        var T = this;
        if (!T.enabled) return;

        // détermine les cellules visibles
        var offset = T.el.scrollTop;
 
        var first_cell = Math.floor(T.el.scrollTop / T.cellHeight) * T.nbColumns - T.preload; // pour avoir un préload
        var last_cell = Math.ceil((T.el.scrollTop + T.el.offsetHeight) / T.cellHeight) * T.nbColumns - 1 + T.preload; // pour avoir un préload
        if (last_cell >= T.nbCells) {
            last_cell = T.nbCells - 1;
        }
        if (first_cell < 0) {
            first_cell = 0;
        }
        for (var i = first_cell; i <= last_cell; i++) {
            if (!T.cellsLoaded[i]) {
                var cell_el = document.getElementById("c" + i);
                T.loadCell(i, cell_el);
                T.cellsLoaded[i] = true;
                T.nbCellsLoaded++;
            }
        }
        debug("refresh", offset, first_cell, last_cell, T.nbCellsLoaded);
    },

    resize: function () {
        var T = this;
        if (!T.enabled) return;
        debug("resize");
        T.computeColumns();

        var width_percent = 100 / T.nbColumns;

        for (var i = 0; i < T.nbCells; i++) {
            var $cell_el = T.$("#c" + String(i));
            $cell_el[0].style.width = width_percent + "%";
        }
        return T;
    },

    onResize: function () {
        var T = this;
        T.resize();
        T.refresh();
        return T;
    },

    selectPage: function (page) {
        var T = this, cell_index;

        var select_class = "rbn-selected";
        if (T.isDouble) {
            cell_index = Math.floor(page / 2);
        }
        else {
            cell_index = page - 1;
        }

        var $cell_selected = T.$("#c" + T.selectedCell);
        $cell_selected.removeClass(select_class);
        var $cell = T.$("#c" + cell_index);
        $cell.addClass(select_class);

        // rend la cellule visible si ce n'est pas déjà le cas
        var line_y = Math.floor(cell_index / T.nbColumns) * T.cellHeight;

        if (line_y < T.el.scrollTop || line_y + T.cellHeight > T.el.scrollTop + T.el.offsetHeight) {
            // on déplace seulement si on la cellule n'est pas totalement visible
            T.el.scrollTop = line_y;
        }

        T.selectedCell = cell_index;
    },

    onScroll: function () {
        var T = this;
        if (T.timer) {
            clearTimeout(T.timer);
            T.timer = null;
        }
        if (Math.abs(T.previousScrollPos - T.el.scrollTop) < 10) {
            T.refresh();   // prise en compte de la vitesse, ici la décélération
        }
        else {
            T.timer = setTimeout(function () { T.refresh(); }, 50); // on attends n ms avant de refaire le cacul des celluyles à charger
        }

        T.previousScrollPos = T.el.scrollTop;
    },

    onCellClicked: function (e) {
        var page, cell, T = this;
        cell = Number(e.currentTarget.id.substr(1));
        if (T.isDouble) {
            if (cell == 0) {
                page = 1;
            }
            else if (cell == T.nbCells - 1) {
                page = cell * 2;
            }
            else {
                page = cell * 2;

                // left or right side ?
                var rect = e.currentTarget.getBoundingClientRect();
                var x = e.clientX - rect.left;
                if (x > rect.width / 2) { // left or right side ?
                    page++;
                }
                //debug("x position " + x);
            }
        }
        else {
            page = cell + 1;
        }
        debug("cell clicked " + cell + " page " + page);
        this.trigger("click", page);
    },

    enable: function (enable, page) {
        var T = this;
        T.enabled = enable;
        if (enable) {
            if (!T.constructed) {
                T.construct();
            }
            T.resize();
            T.selectPage(page); // select current page and make it visible
            T.refresh();
        }
    },

    computeColumns: function () {
        var T = this;
        T.nbColumns = Math.floor(T.el.offsetWidth / T.cellWidth);
        if (T.nbColumns < 1) {
            T.nbColumns = 1;
        }

        T.isDouble = T.model.get("isDouble");
        T.nbPages = T.model.get("nbPages");
        T.nbCells = T.isDouble ? T.nbPages / 2 + 1 : T.nbPages;
        T.preload = T.nbColumns < 3 ? 3: T.nbColumns;
    },

    construct: function () {
        var T = this;
        var $grid_el = T.$(".rbn-thumbnails-grid");
        var cell_width_percent = 100 / T.nbColumns;

        for (var i = 0; i < T.nbCells; i++) {
            var cell_el = document.createElement("div");
            cell_el.classList.add("rbn-thumbnails-cell");
            cell_el.id = "c" + String(i);
            cell_el.style.height = T.cellHeight + "px";
            cell_el.style.width = cell_width_percent + "%";
            T.loadCell(i, cell_el, true);
            $grid_el[0].appendChild(cell_el);
            T.cellsLoaded[i] = false;
        }
        T.constructed = true;
    },

    render: function () {
        var T = this;
        debug("render");

        var context = {
            STR: T.STR
        };

        if (T.model.fetched) {
            T.$el.html(T.template(context));
            T.computeColumns();
            if (T.enabled) {
                T.construct();
            }
        }

        return T;
    },

    close: function () {
        var T = this;
        if (T.timer) {
            clearTimeout(T.timer);
            T.timer = null;
        }
        T.model = null;
        T.authorizedPages = null;
        T.stopListening();
        T.undelegateEvents();
    }

});

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var BaseModel = __webpack_require__(6);

var debug = __webpack_require__(2)("models:BookmarksModel");    //https://github.com/visionmedia/debug

/**
 * BookmarksModel
 */
module.exports = BaseModel.extend({

    pv5api: null,
    mtime: 0,

    defaults: {
        documentId: 0,
        publicationId: 0,
        bookmarks: null,
        bookmarksPerPage: null
    },

    initialize: function (attributes, options) {
        BaseModel.prototype.initialize.apply(this, arguments);
        debug("initialize");
        _.extend(this, options);
    },

    url: function () {
        var T = this,
            url = T.pv5api + "/document/" + T.get("publicationId") + "/" + T.get("documentId") + "/bookmarks",
            query_string = [];
        if (T.mtime) {
            query_string.push("mt=" + T.mtime);
        }
        return T.addQueryStringArrayToUrl(url, query_string);
    },

    parse: function (response) {
        // parse xml
        var $ = Backbone.$;
        var $xml = $(response);
        var $bookmarks = $xml.find("bookmark");

        var all_bookmarks = [];
        var order = 1;
        var level = 0;
        var parents = [];
        $bookmarks.each(function () {
            var $bookmark = $(this);
            var $parent_bm = $bookmark.parent().closest("bookmark");
            var parent_level = Number($parent_bm.attr("level"));
            var level = parent_level + 1 || 0;
            $bookmark.attr("level", level);

            var new_bookmark = {
                title: $bookmark.find("title:first").text(),
                page: Number($bookmark.find("destination:first").attr("page")),
                level: level,
                order: order
            }
            parents[level] = new_bookmark;

            if (level > 0) {
                new_bookmark.parent = parents[parent_level];
            }

            all_bookmarks.push(new_bookmark);

            order++;
        });

        var bookmarks_per_page = all_bookmarks.map(function (bm) { return bm });

        // sort per page and order
        bookmarks_per_page.sort(function (bm_a, bm_b) {
            if (bm_a.page > bm_b.page) {
                return 1;
            }
            else if (bm_a.page < bm_b.page) {
                return -1;
            }
            else {
                // même page on trie par order
                return bm_a.order - bm_b.order;
            }

        });

        // les bookmarks sont forcément rangés par page croissante dans le pdf
        //console.table(all_bookmarks);
        //console.table(bookmarks_per_page);


        return {
            bookmarks: all_bookmarks,
            bookmarksPerPage: bookmarks_per_page
        };
    },

    /**
     * Retourne le bookmark correspondant à la page demandée ainsi que le path vers ce bookmark
     * @param {Number} page 
     */
    getPageBookmark: function (page) {
        var bms = this.get("bookmarksPerPage");

        // binary search, must be sorter
        // https://stackoverflow.com/questions/4431259/formal-way-of-getting-closest-values-in-array-in-javascript-given-a-value-and-a/4431347
        var lo = -1, hi = bms.length;
        while (hi - lo > 1) {
            var mid = Math.round((lo + hi) / 2);
            if (bms[mid].page <= page) {
                lo = mid;
            } else {
                hi = mid;
            }
        }

        var parents = [];
        var bookmark = bms[lo];

        if (bookmark) {

            // on s'assure qu'il n'y a pas un niveau inférieur avec la même page
            var desc_index = lo + 1;
            while (desc_index < bms.length) {
                if (bms[desc_index].page == bookmark.page) {
                    bookmark = bms[desc_index];
                }
                else {
                    break;
                }
                desc_index++;
            }

            // remonte la chaine de parents pour avoir le path 
            var bm_it = bookmark;
            while (bm_it.parent) {
                parents.push(bm_it.parent.title);
                bm_it = bm_it.parent;
            }
        }

        return {
            bookmark: bookmark,
            parents: parents.reverse()
        }
    },

    fetch: function (options) {
        options = options || {};
        options.dataType = "xml";
        return BaseModel.prototype.fetch.call(this, options);
    }

});


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);

var debug = __webpack_require__(2)("theme-loader-bw"); //https://github.com/visionmedia/debug

/**
 * Load template and style from a theme. This version verify bandwidth
 * Triggers
 * - sync
 */
var ThemeLoaderBw = function (options) {
    var T = this;

    T.api = null;
    T.id = null;
    T.cacheBreaker = null;
    T.version = null;
    T.hackStyleExt = false; // ajoute .css à la route de récupération du style

    T.templateTag = null;
    T.styleTag = null;

    T.useTemplate = true;

    _.extend(T, options);
    _.extend(T, Backbone.Events); // trigger stuff

    T.fetched = false;
};

ThemeLoaderBw.prototype.addQueryString = function (url, name, value) {
    if (value) {
        url += (url.indexOf("?") == -1 ? "?" : "&");
        url += name + "=" + value;
    }
    return url;
};


/**
 * Load handlebars templates (compiled and packaged in one javascript) and style
 */
ThemeLoaderBw.prototype.fetch = function () {
    var T = this;

    if (T.useTemplate) {
        var script = document.createElement("script");

        var template_url = T.api + "/theme/" + T.id + "/template";
        template_url = T.addQueryString(template_url, "cbrk", T.cacheBreaker);
        template_url = T.addQueryString(template_url, "version", T.version);

        script.src = template_url;
        script.type = "text/javascript";

        script.addEventListener("load", function () {
            debug("templates loaded");
            //on supprime l'éventuel theme précédent
            if (T.templateTag) {
                T.templateTag.parentNode.removeChild(T.templateTag);
            }
            T.templateTag = script;
            T.loadCss();
        });
        document.getElementsByTagName("head")[0].appendChild(script);
    }
    else {
        T.loadCss();
    }
};

ThemeLoaderBw.prototype.loadCss = function () {
    var T = this;

    var css = document.createElement("link");
    css.rel = "stylesheet";
    css.type = "text/css";

    var css_url = T.api + "/theme/" + T.id + "/style";
    if (T.hackStyleExt) {
        css_url += ".css";
    }
    css_url = T.addQueryString(css_url, "cbrk", T.cacheBreaker);
    css_url = T.addQueryString(css_url, "version", T.version);

    css.href = css_url;

    // onload ne fonctionne pas avec toutes les versions de webkit sur le chargement de css
    // donc on utilise une méthode basée sur un timeout (http://www.phpied.com/when-is-a-stylesheet-really-loaded/)
    var cssnum = document.styleSheets.length;
    var ti = setInterval(function () {
        if (document.styleSheets.length > cssnum) {
            clearInterval(ti);

            //on supprime l'éventuel theme précédent
            if (T.styleTag) {
                T.styleTag.parentNode.removeChild(T.styleTag);
            }
            T.styleTag = css;

            debug("style loaded");
            T.fetched = true;
            T.trigger("sync", T.id);

            if (T.abort) {
                T.close(); // pour gérer le cas où on est en train de charger le script/css
            }
        }
    }, 10);

    document.getElementsByTagName("head")[0].appendChild(css);
};


ThemeLoaderBw.prototype.addQueryString = function (url, name, value) {
    if (value) {
        url += (url.indexOf("?") == -1 ? "?" : "&");
        url += name + "=" + value;
    }
    return url;
};


/**
 * Load handlebars templates (compiled and packaged in one javascript) and style
 */
ThemeLoaderBw.prototype.fetch = function () {
    var T = this;

    if (T.useTemplate) {
        var script = document.createElement("script");

        var template_url = T.api + "/theme/" + T.id + "/template";
        template_url = T.addQueryString(template_url, "cbrk", T.cacheBreaker);
        template_url = T.addQueryString(template_url, "version", T.version);

        script.src = template_url;
        script.type = "text/javascript";

        script.addEventListener("load", function () {
            debug("templates loaded");
            //on supprime l'éventuel theme précédent
            if (T.templateTag) {
                T.templateTag.parentNode.removeChild(T.templateTag);
            }
            T.templateTag = script;
            T.loadCss();
        });
        document.getElementsByTagName("head")[0].appendChild(script);
    }
    else {
        T.loadCss();
    }
};

/**
 * Load css via xhr with blob method, return loading speed (Mbit/s)
 */
ThemeLoaderBw.prototype.loadCss = function () {
    var T = this;

    var css_url = T.api + "/theme/" + T.id + "/style";
    if (T.hackStyleExt) {
        css_url += ".css";
    }
    css_url = T.addQueryString(css_url, "cbrk", T.cacheBreaker);
    css_url = T.addQueryString(css_url, "version", T.version);

    var xhr = new XMLHttpRequest();
    var startTime, endTime, fileSize;

    xhr.onreadystatechange = function () {

        if (xhr.readyState === 2) {
            // après chargement headers, on déclenche le chrono
            startTime = performance.now();
        }
        else if (xhr.readyState === 4 && xhr.status === 200) {

            endTime = performance.now();
            fileSize = xhr.responseText.length;

            // Calculate the connection-speed
            var speed = (fileSize * 8) / ((endTime - startTime) / 1000) / 1000000;

            var blob = new Blob([xhr.responseText], { type: 'text/css' });
            var link = document.createElement("link");
            link.rel = "stylesheet";
            link.type = "text/css";
            link.href = window.URL.createObjectURL(blob);
            document.querySelector("head").appendChild(link);

            //on supprime l'éventuel theme précédent
            if (T.styleTag) {
                T.styleTag.parentNode.removeChild(T.styleTag);
            }
            T.styleTag = link;

            debug("style loaded");
            T.fetched = true;
            T.trigger("sync", { themeId: T.id, bandwidth: Math.round(speed) });

            if (T.abort) {
                T.close(); // pour gérer le cas où on est en train de charger le script/css
            }
        }
    };

    xhr.open("GET", css_url, true);
    xhr.send();
};



/**
 * Décharge les scripts et les styles chargés précédement
 */
ThemeLoaderBw.prototype.close = function () {
    var T = this;
    T.abort = true; // pour gérer le cas où on est en train de charger le script/css
    if (T.templateTag) {
        T.templateTag.parentNode.removeChild(T.templateTag);
        T.templateTag = null;
    }
    if (T.styleTag) {
        T.styleTag.parentNode.removeChild(T.styleTag);
        T.styleTag = null;
    }
};

module.exports = ThemeLoaderBw;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
//var $ = require("jquery");

var template = __webpack_require__(58);

/**
 * 
 * ModalView : boite de dialog bloquante, occupe tout l'espace
 * inspiré de https://tympanus.net/Development/ModalWindowEffects/
 * Trigger:
 *     - abort
 *
 */
module.exports = Backbone.View.extend({

    template: _.template(template), // compile template
    message: null,
    title: null,
    className: "rbn-modal",
    view:null,
    effect:"slide-in-bottom", // fade-in-scale, slide-in-right, slide-in-bottom, fade-in (without blured 3d)

    events: {
        "click >.rbn-modal-overlay": "onOverlayClicked",
    },

    initialize: function(options) {
        var T=this;
        _.extend(T, options);
    },

    render: function() {
        var T = this,
            context = {
                title:T.title,
                message: T.message,
                effect:T.effect
            };
        T.$el.html(T.template(context));
        if(T.view){
            T.assign(T.view,".rbn-modal-body");
        }
        return T;
    },

    onOverlayClicked:function(){
        this.hide();
        this.trigger("abort");
    },

    show: function() {
        this.$el.addClass("rbn-modal-show");
    },

    hide: function() {
        this.$el.removeClass("rbn-modal-show");
    },

    close: function() {
        var T = this;

        if(T.view){
            T.view.close();
            T.view=null;
        }

        T.undelegateEvents();
        T.stopListening();
    }

});

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "<div class=rbn-modal-overlay></div> <div class=\"rbn-modal-dialog rbn-modal-effect-<%=effect%>\"> <div class=rbn-modal-content> <%if(title){%><h3><%=title%></h3><%}%> <div class=rbn-modal-body> <%=message%> </div> </div> </div>";

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var jwt_decode = __webpack_require__(8);
var STR = __webpack_require__(7);

var debug = __webpack_require__(2)("views:PrintPasswordView"); //https://github.com/visionmedia/debug
var template = __webpack_require__(60);


/**
 * PrintPasswordView: recherche et affiche le code que devra rentrer l'utilisateur pour décrypter le pdf
 */
module.exports = Backbone.View.extend({

    model: null, // PrintOptionsModel
    className: "rbn-print-password-view",
    template: _.template(template), // compile template

    events: {
        "click .rbn-next": "onNextClicked",
        "click .rbn-copy-code": "onCopyCodeClicked"
    },

    initialize: function (options) {
        var T = this;
        T.decodedPassword = null;
        _.extend(T, options);

        T.listenTo(T.model, "sync", T.render);
        T.model.fetch();
    },

    onNextClicked: function (e) {
        var T = this;
        e.stopPropagation();
        T.onNextCallback(T.decodedPassword,T.model.get("passwordToken"));
    },

    onCopyCodeClicked: function (e) {
        var T = this;
        e.stopPropagation();
        T.onCopyCodeCallback(T.decodedPassword);
    },

    render: function () {
        var T = this;
        debug("render");

        var context = {
            STR: STR,
            pwd: null
        };

        if (T.model.fetched) {
            var decoded = jwt_decode(T.model.get("passwordToken"));
            if (decoded.pwd) {
                T.decodedPassword = context.pwd = decoded.pwd;
            }
        }
        T.$el.html(T.template(context));
        return T;
    },

    close: function () {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }

});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports = "<div class=rbn-modal-title><%=STR.print_pwd%></div> <div class=rbn-code><%=pwd?pwd:\"...\"%></div> <div class=rbn-action> <div class=\"rbn-copy-code <%=pwd?\"\":\"rbn-disable\"%>\"><%=STR.print_copy_code%></div> <div class=\"rbn-next <%=pwd?\"\":\"rbn-disable\"%>\"><%=STR.print_next%></div> </div>";

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(3);
Backbone.$ = $;

var debug = __webpack_require__(2)("views:BookmarksView");

/**
 * BookmarksView: affiche l'arbre de bookmarks qui viennent du pdf
 * inspiré de https://www.howtocreate.co.uk/tutorials/jsexamples/listCollapseExample.html
 */
module.exports = Backbone.View.extend({

    enabled: false,
    model: null, // BookmarksModel
    nbVisibleLevels: 1, 

    events: {
        "click span.bm-title": "onBookmarkClicked",
        "click li.bm-collapsable > span.bm-icon": "onIconClicked"
    },

    initialize: function (options) {
        var T = this;
        _.extend(T, options);
        T.listenTo(T.model, "sync", T.onBookmarksLoaded);
    },

    onBookmarksLoaded: function () {
        var T = this;
        T.render();
    },

    render: function () {
        var T = this;
        if (!T.model.fetched) {
            //T.$el.html("Chargement ...");
            return;
        }
        debug("render");

        var bm, next_bm, bms = T.model.get('bookmarks');

        var previous_level = 0;
        var i = 0;
        var $base_ul = $("<ul/>"), $new_ul;
        var $current_ul = $base_ul, $current_li;
        for (i = 0; i < bms.length; i++) {
            bm = bms[i];
            next_bm = bms[i + 1];

            if (bm.level > previous_level) {
                $new_ul = $("<ul/>");
                $current_li.append($new_ul);
                $current_ul = $new_ul;
            } else if (bm.level < previous_level) {
                var diff_level = previous_level - bm.level;
                for (var j = 0; j < diff_level; j++) {
                    $current_ul = $current_ul.parent().parent();
                }
            }

            var $new_li = $("<li/>");
            
            var $new_span_icon = $("<span/>");

            if (next_bm && next_bm.level > bm.level) {
                // il y a des enfants
                $new_li.addClass("bm-collapsable");
                if(bm.level > T.nbVisibleLevels - 2 ){
                    $new_li.addClass("bm-closed"); // on ferme les niveaux supérieurs
                }
            }
            else {
                $new_li.addClass("bm-not-collapsable");
            }
            $new_span_icon.addClass("bm-icon");
            $new_li.append($new_span_icon);
            
            var $new_span_title = $("<span/>");
            $new_span_title.text(bm.title);
            $new_span_title.data("page", bm.page);
            $new_span_title.addClass("bm-title");
            $new_li.append($new_span_title);

            $current_ul.append($new_li);
            $current_li = $new_li;
            
            previous_level = bm.level;
        }
        //str += "</ul>".repeat(previous_level + 1);
        T.$el.append($base_ul);

        // gestion collapsing
    },


    onBookmarkClicked: function (e) {
        var $bm = $(e.currentTarget);
        var page = $bm.data("page");
        this.trigger("click", page);
    },

    onIconClicked: function(e){
        var $icon = $(e.currentTarget);
        $icon.parent().toggleClass("bm-closed");
    },

    close: function () {
        var T = this;
        T.stopListening();
        T.undelegateEvents();
    }

});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var debug = __webpack_require__(2)("models:BndPageQueryModel");
var Backbone = __webpack_require__(1);

// BndPageQueryModel : recherche bnd dans une page, ne supporte pas le mode collapse ni les aggregations de l'api car pas besoin dans le contexte reader
module.exports = Backbone.Model.extend({
    pv5api: null,

    defaults: {
        query: null,  // query string
        from: 0,
        size: 10,
        total: null,
        sort: null,
        filters: null,
        highlight: false,
        highlightWordPosition: false,
        highlightNumberOfFragments: 4,
        highlightFragmentSize: 200,
        hits: null
    },

    initialize: function (attributes, options) {
        var T = this;

        Backbone.Model.prototype.initialize.apply(T, arguments);

        _.extend(T, options);
        debug("initialize");
        T.set(
            {
                hits: new Backbone.Collection(),          // results collection
            }
        );
    },

    search: function () {
        return this.fetch();
    },

    // overide sync to call elasticsearch
    sync: function (method, model, options/*, defaults*/) {
        var T = this;

        // only read is allowed
        if (method !== "read") {
            throw new Error("method not allowed " + method);
        }

        var data = T.toJSON();
        delete (data.hits);
        delete (data.total);

        // JSON request options
        var params = {
            type: "POST",
            dataType: "json",
            jsonp: false,
            contentType: "application/json",
            crossDomain: true,
            data: JSON.stringify(data),
            url: model.pv5api + "/bnd-search/page"
        };

        // ajout token
        if (T.token) {
            if (!params.headers) {
                params.headers = {};
            }
            params.headers["x-access-token"] = T.token;
        }

        params = _.extend(params, options);
        var xhr = Backbone.ajax(params);
        model.trigger("request", model, xhr, options);
        return xhr;
    },

    // override fetch method to update local collections
    // instead of recreating the model
    fetch: function (defaults, options) {
        //console.log("fetch");
        options = options ? _.clone(options) : {};
        defaults = defaults || {};

        var T = this;
        var success_cb = options.success;
        var error_cb = options.error;

        T.fetching = true;

        options.success = function (res, status, xhr) {

            T.fetched = true;
            T.fetching = false;

            if (_.isFunction(T.parse)) {
                res = T.parse(res, xhr);
            }

            T.get("hits").reset(res.hits);

            if (success_cb) {
                success_cb(T, res);
            }
            T.trigger("sync", T, res, options);
        };
        options.error = function (xhr) {
            T.fetching = false;
            if (error_cb) {
                error_cb(T, xhr, options);
            }
            T.trigger("error", T, xhr, options);
        };

        return T.sync("read", T, options, defaults);
    },

    /*parse: function (response) {
        return response;
    },*/

});

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);
var $ = __webpack_require__(3);
Backbone.$ = $;

var debug = __webpack_require__(2)("views:OverlayBndSearchView");

/**
 * overlay view displaying results from search
 */
module.exports = Backbone.View.extend({

    pageModel: null,             // PageModel
    queryModel: null,            // BndPageQueryModel
    className: "overlay overlay-search",
    events: {
    },

    initialize: function (options) {
        var T = this;
        _.extend(T, options);
        if (T.hide) {
            T.$el.addClass("hide");
        }
        T.listenTo(T.pageModel, "sync", T.render);
        T.listenTo(T.queryModel, "sync", T.render);
        T.render();
    },

    render: function () {
        var T = this;

        T.$el.html("");
        if (T.queryModel.fetched && T.pageModel.fetched) {
            debug("render search page " + T.page);

            if (T.queryModel.get("hits").length) {
                var width = T.pageModel.get("width"),
                    height = T.pageModel.get("height");

                T.queryModel.get("hits").each(function (hit) {
                    var hl = hit.get("highlight");

                    if (hl && hl.positions) {

                        _.each(hl.positions, function (word_pos) {
                            var $div = $("<div/>", {
                                class: "result"
                            });
                            $div.css({
                                top: (word_pos.p[1] * 100 / height) + "%",
                                left: (word_pos.p[0] * 100 / width) + "%",
                                height: ((word_pos.p[3] - word_pos.p[1]) * 100 / height) + "%",
                                width: ((word_pos.p[2] - word_pos.p[0]) * 100 / width) + "%"
                            });
                            T.$el.append($div);
                        });
                    }

                });

            }
        }
    },

    close: function () {
        var T = this;
        T.pageModel = null;
        T.queryModel = null;
        T.stopListening();
        T.undelegateEvents();
    }
});

/***/ }),
/* 64 */
/***/ (function(module, exports) {

module.exports = "<div class=reader> <div class=tb-top> <div class=container> <div class=rbn-home></div> <div class=page-title> <span class=document-title></span> </div> <div class=rbn-shortcuts> <div class=\"rbn-shortcut rbn-shortcut-search\" title=Rechercher></div> <div class=\"rbn-shortcut rbn-shortcut-print\" title=Imprimer></div> <div class=\"rbn-shortcut rbn-shortcut-copy\" title=Copier/coller></div> <div class=\"rbn-shortcut rbn-shortcut-share\" title=\"Copier l'URL\"></div> </div> <div class=\"menu button\"> <div class=dropdown> <div class=line data-action=search> <div class=header> <%=STR.search%> </div> <div class=content> <div class=search-container> <input type=text id=search-input-phrase placeholder=\"<%=STR.search_placeholder%>\"> <div class=search-go></div> </div> <p class=search-msg></p> <div class=result> <div class=search-nav> <div class=search-previous><%=STR.search_previous_page%></div> <div class=search-index></div> <div class=search-next><%=STR.search_next_page%></div> </div> </div> </div> </div> <div class=line data-action=thumbnails> <div class=header> <%=STR.thumbnails%> </div> <div class=content> </div> </div> <div class=line data-action=print> <div class=header> <%=STR.print%> </div> <div class=content> <div class=quota> <div><%=STR.print_quota%> : <span id=quota-value></span></div> <div><%=STR.print_quota_consumed%> : <span id=counter-value></span></div> <div><%=STR.print_quota_reset%> : <span id=reset-value></span></div> </div> <div> <input type=radio name=print-group id=print-pdf-page checked=checked value=active-page /> <label for=print-pdf-page class=side-label><%=STR.print_active_page%></label> </div> <div> <input type=radio name=print-group id=print-pdf-some-page value=some-pages /> <label for=print-pdf-some-page class=side-label><%=STR.print_selected_pages%> <span class=server_pdf_max_pages></span></label> <input type=text id=print-text-some-pages placeholder=\"<%=STR.print_example%>\"> </div> <p><em><%=STR.authorize_popup%></em></p> <div class=action> <div class=print-document><%=STR.print%></div> </div> </div> </div> <div class=line data-action=copy> <div class=header> <%=STR.copy%> </div> <div class=content> <p><%=STR.copy_select_zone%></p> <p class=copy-move-ctrl><%=STR.copy_move_ctrl%></p> <div class=action> <div class=\"copy-text disabled\"><%=STR.copy_text%></div> </div> </div> </div> <div class=line data-action=share> <div class=header> <%=STR.share%> </div> <div class=content> <p><%=STR.share_select%></p> <p></p><div id=share-url-text contenteditable=true tabindex=1 oncut=return!1 onpaste=return!1 onkeydown=return!!event.metaKey></div><p></p> <div class=action> <div class=share-url><%=STR.share_url%></div> </div> </div> </div> <div class=line data-action=preferences> <div class=header> <%=STR.preferences%> </div> <div class=content> <div class=pref-line> <label for=pref-display> <%=STR.pref_display_label%> </label> <select name=pref-display id=pref-display> <option value=auto> <%=STR.pref_display_auto%> </option> <option value=high> <%=STR.pref_display_high%> </option> <option value=normal> <%=STR.pref_display_normal%> </option> </select> </div> <div class=pref-line> <label for=pref-navigation> <%=STR.pref_navigation_label%> </label> <select name=pref-navigation id=pref-navigation> <option value=show> <%=STR.pref_navigation_show%> </option> <option value=hide> <%=STR.pref_navigation_hide%> </option> </select> </div> <p class=note><%=STR.pref_note%></p> <div class=action> <div class=refresh><%=STR.refresh%></div> </div> </div> </div> <div class=line data-action=about> <div class=header> <%=STR.about%> </div> <div class=content> <p>Immanens reader-bnd <span class=version></span></p> </div> </div> </div> </div> </div> </div> <div class=main-view> <div class=side-panel> <div class=rbn-bookmarks-view></div> <div class=rbn-bookmarks-close title=\"Fermer le sommaire\"></div> </div> <div class=middle-panel> <div class=tb-right> <div class=container> <div class=\"rbn-page-history button\" title=\"Retourner à la page précédente dans l'historique\"></div> <div class=\"rbn-next-page button\" title=\"Aller à la page suivante\"></div> <div class=\"rbn-previous-page button\" title=\"Aller à la page précédente\"></div> <div class=\"rbn-zoom-in button\" title=Zoomer></div> <div class=\"rbn-zoom-out button\" title=Dézoomer></div> <div class=\"rbn-thumbnail button\" title=\"Voir la mosaïque de pages\"></div> <%if(fullscreenEnabled){%><div class=\"rbn-full-screen button\" title=\"Plein écran\"></div><%}%> </div> </div> <div class=document-view></div> <div class=tb-bottom> <div class=rbn-nav> <div class=\"button toc\" title=\"Afficher le sommaire (TAB)\"><span><%=STR.toc%></span></div> </div> <div class=page-slider></div> <div class=rbn-page-edit-container> <div class=rbn-page-edit-label>Page</div> <form class=rbn-page-edit-form> <input class=rbn-page-edit-input /> </form> <div class=rbn-page-edit-separator>/</div> <div class=rbn-page-edit-max></div> </div> </div> </div> </div> </div> <div class=notify> <p></p> </div> <div class=rbn-modal-print-password></div>";

/***/ }),
/* 65 */
/***/ (function(module, exports) {

module.exports = "<div class=loading><%=id%></div>";

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports = "<div class=knob> <div class=knob-inside> </div> </div>";

/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = "<div class=thumb> <div class=cover></div> <div class=info><span class=page></span> / <%=nbPages%></div> </div>";

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = "<div class=one-page-auth> <div style=\"background-image:url(<%=thumbnailUrl%>)\" class=page-auth-thumb></div> <div class=page-auth-msg><%=authorizationMessage%></div> </div>";

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = "<div class=rbn-thumbnails-grid></div>";

/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports = "<div class=rbn-pages-image><%if(thumbnailUrl){%><img src=\"<%=thumbnailUrl%>\"/><%}%></div> <div class=rbn-pages-label><span><%=pagesLabel%></span></div>";

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var QueryString = __webpack_require__(72); // https://github.com/hapijs/qs
var _ = __webpack_require__(0);


var UrlUtil = {

    /**
     * parse query string and return only fields specified in whitelist array
     * @param  {String} queryString
     * @param  {Array of Strings} whiteList
     * @return {Object}
     */
    parseQueryString: function(query_string, white_list) {
        var qs_obj = QueryString.parse(query_string);
        var qs_obj_filtered = _.pick(qs_obj, white_list);
        return qs_obj_filtered;
    },

    /**
     * generate query string based on fields specified in whithelist array
     * @param  {Object} obj
     * @param  {Array of Strings} whiteList
     * @return {String}          an url query string
     */
    generateQueryString: function(obj, white_list) {
        var qs = QueryString.stringify(obj, {
            filter: function(prefix, value) {
                prefix = prefix.split("[")[0];
                if (prefix === "") {
                    return value;
                } else {
                    if (white_list.indexOf(prefix) != -1) {
                        if (value) // ignore 0, null and ""
                            return value;
                        else
                            return;
                    } else {
                        return;
                    }
                }
            }
        });
        return qs;
    },

    /**
     * Generate a facebook share link
     * @param  {String} app_id  see https://developers.facebook.com/
     * @param  {Object} options display + caption + description + link + redirect_uri + picture (see https://developers.facebook.com/docs/sharing/reference/feed-dialog/v2.4)
     * @return {String}         can be used in a new page with window.open(url_share, "_blank");
     */
    shareFacebook: function(app_id, options) {
        var url_share = "https://www.facebook.com/dialog/feed?app_id=" + app_id;

        _.each(
            options,
            function(value, key) {
                url_share += "&" + key + "=" + encodeURIComponent(value);
            }
        );

        return url_share;
    },

    /**
     * Generate a twitter share link : https://dev.twitter.com/web/tweet-button/web-intent
     * @param  {String} message
     * @param  {String} link
     * @return {String}             can be used in a new page with window.open(url_share, "_blank");
     */
    shareTwitter: function(message, link, via) {
        return "https://twitter.com/intent/tweet?url=" + encodeURIComponent(link) + "&text=" + encodeURIComponent(message) + "&via=" + encodeURIComponent(via);
    },

    /**
     * transforme une string en une url lisible en ascii
     * @param  {String} str [description]
     * @return {String}     [description]
     */
    slugify: function(str) {

        if (!str) {
            return "";
        }

        var i, ch, pos, new_str = "";

        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        // on met les caractères les plus courants au début

        var fr = "'èéêôçîûàïáäâëìíòóöùúüñ,";
        var to = "-eeeociuaiaaaeiiooouuun-";

        for (i = 0; i < str.length; i++) {
            ch = str.charAt(i);
            pos = fr.indexOf(ch);
            new_str += (pos == -1) ? ch : to.charAt(pos);
        }

        new_str = new_str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes

        return new_str;
    },

    /**
     * update or create meta tag in head.
     * @param {String} attr
     * @param {String} value
     * @param {String} content
     */
    meta: function(attr, value, content) {
        var meta = document.head.querySelector("[" + attr + "='" + value + "']");
        if (meta) {
            meta.content = content;
        } else {
            meta = document.createElement("meta");
            meta.setAttribute(attr,value);
            meta.content = content;
            document.head.appendChild(meta);
        }
    }



};

module.exports = UrlUtil;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Stringify = __webpack_require__(73);
var Parse = __webpack_require__(74);


// Declare internals

var internals = {};


module.exports = {
    stringify: Stringify,
    parse: Parse
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Utils = __webpack_require__(14);


// Declare internals

var internals = {
    delimiter: '&',
    arrayPrefixGenerators: {
        brackets: function (prefix, key) {

            return prefix + '[]';
        },
        indices: function (prefix, key) {

            return prefix + '[' + key + ']';
        },
        repeat: function (prefix, key) {

            return prefix;
        }
    },
    strictNullHandling: false,
    skipNulls: false,
    encode: true
};


internals.stringify = function (obj, prefix, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort) {

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    }
    else if (Utils.isBuffer(obj)) {
        obj = obj.toString();
    }
    else if (obj instanceof Date) {
        obj = obj.toISOString();
    }
    else if (obj === null) {
        if (strictNullHandling) {
            return encode ? Utils.encode(prefix) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' ||
        typeof obj === 'number' ||
        typeof obj === 'boolean') {

        if (encode) {
            return [Utils.encode(prefix) + '=' + Utils.encode(obj)];
        }
        return [prefix + '=' + obj];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (Array.isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        if (Array.isArray(obj)) {
            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
        else {
            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix, strictNullHandling, skipNulls, encode, filter));
        }
    }

    return values;
};


module.exports = function (obj, options) {

    options = options || {};
    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
    var strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;
    var skipNulls = typeof options.skipNulls === 'boolean' ? options.skipNulls : internals.skipNulls;
    var encode = typeof options.encode === 'boolean' ? options.encode : internals.encode;
    var sort = typeof options.sort === 'function' ? options.sort : null;
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    }
    else if (Array.isArray(options.filter)) {
        objKeys = filter = options.filter;
    }

    var keys = [];

    if (typeof obj !== 'object' ||
        obj === null) {

        return '';
    }

    var arrayFormat;
    if (options.arrayFormat in internals.arrayPrefixGenerators) {
        arrayFormat = options.arrayFormat;
    }
    else if ('indices' in options) {
        arrayFormat = options.indices ? 'indices' : 'repeat';
    }
    else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (sort) {
        objKeys.sort(sort);
    }

    for (var i = 0, il = objKeys.length; i < il; ++i) {
        var key = objKeys[i];

        if (skipNulls &&
            obj[key] === null) {

            continue;
        }

        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix, strictNullHandling, skipNulls, encode, filter, sort));
    }

    return keys.join(delimiter);
};


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// Load modules

var Utils = __webpack_require__(14);


// Declare internals

var internals = {
    delimiter: '&',
    depth: 5,
    arrayLimit: 20,
    parameterLimit: 1000,
    strictNullHandling: false,
    plainObjects: false,
    allowPrototypes: false,
    allowDots: false
};


internals.parseValues = function (str, options) {

    var obj = {};
    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);

    for (var i = 0, il = parts.length; i < il; ++i) {
        var part = parts[i];
        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;

        var key, val;
        if (pos === -1) {
            key = Utils.decode(part);
            val = options.strictNullHandling ? null : '';
        } else {
            key = Utils.decode(part.slice(0, pos));
            val = Utils.decode(part.slice(pos + 1));
        }
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            obj[key] = [].concat(obj[key]).concat(val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};


internals.parseObject = function (chain, val, options) {

    if (!chain.length) {
        return val;
    }

    var root = chain.shift();

    var obj;
    if (root === '[]') {
        obj = [];
        obj = obj.concat(internals.parseObject(chain, val, options));
    }
    else {
        obj = options.plainObjects ? Object.create(null) : {};
        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
        var index = parseInt(cleanRoot, 10);
        var indexString = '' + index;
        if (!isNaN(index) &&
            root !== cleanRoot &&
            indexString === cleanRoot &&
            index >= 0 &&
            (options.parseArrays &&
             index <= options.arrayLimit)) {

            obj = [];
            obj[index] = internals.parseObject(chain, val, options);
        }
        else {
            obj[cleanRoot] = internals.parseObject(chain, val, options);
        }
    }

    return obj;
};


internals.parseKeys = function (key, val, options) {

    if (!key) {
        return;
    }

    // Transform dot notation to bracket notation

    if (options.allowDots) {
        key = key.replace(/\.([^\.\[]+)/g, '[$1]');
    }

    // The regex chunks

    var parent = /^([^\[\]]*)/;
    var child = /(\[[^\[\]]*\])/g;

    // Get the parent

    var segment = parent.exec(key);

    // Stash the parent if it exists

    var keys = [];
    if (segment[1]) {
        // If we aren't using plain objects, optionally prefix keys
        // that would overwrite object prototype properties
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1])) {

            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(segment[1]);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {

        ++i;
        if (!options.plainObjects &&
            Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {

            if (!options.allowPrototypes) {
                continue;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return internals.parseObject(keys, val, options);
};


module.exports = function (str, options) {

    options = options || {};
    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
    options.parseArrays = options.parseArrays !== false;
    options.allowDots = typeof options.allowDots === 'boolean' ? options.allowDots : internals.allowDots;
    options.plainObjects = typeof options.plainObjects === 'boolean' ? options.plainObjects : internals.plainObjects;
    options.allowPrototypes = typeof options.allowPrototypes === 'boolean' ? options.allowPrototypes : internals.allowPrototypes;
    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
    options.strictNullHandling = typeof options.strictNullHandling === 'boolean' ? options.strictNullHandling : internals.strictNullHandling;

    if (str === '' ||
        str === null ||
        typeof str === 'undefined') {

        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0, il = keys.length; i < il; ++i) {
        var key = keys[i];
        var newObj = internals.parseKeys(key, tempObj[key], options);
        obj = Utils.merge(obj, newObj, options);
    }

    return Utils.compact(obj);
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Backbone = __webpack_require__(1);

// require à faire une fois

/**
 * ajoute un racourci pour la syntaxe setElement un peu pénible
 * @param  {[type]} view     [description]
 * @param  {[type]} selector [description]
 * @return {[type]}          [description]
 */
Backbone.View.prototype.assign = function(view, selector) {
   view.setElement(this.$(selector)).render();
   return this;
};


/**
 * modification history pour gérer correctement les %20 et les accentués : sans cette modification cela provoque des appels au router même si on fait trigger:false
 * buggé dans la v1.3.3 et plus mis à jour apparement
 * https://github.com/jashkenas/backbone/issues/4025
 */
// Checks the current URL to see if it has changed, and if it has,
// calls `loadUrl`, normalizing across the hidden iframe.
Backbone.history.checkUrl=function(/*e*/) {
    var T=Backbone.history;
    var current = T.getFragment();

    // If the user pressed the back button, the iframe's hash will have
    // changed and we should use that for comparison.
    if (current === T.fragment && T.iframe) {
    current = T.getHash(T.iframe.contentWindow);
    }

    // immanens
    current=T.decodeFragment(current.replace(Backbone.History.pathStripper, ''));

    if (current === T.fragment) return false;
    if (T.iframe) T.navigate(current);
    T.loadUrl();
};

// Save a fragment into the hash history, or replace the URL state if the
// 'replace' option is passed. You are responsible for properly URL-encoding
// the fragment in advance.
//
// The options object can contain `trigger: true` if you wish to have the
// route callback be fired (not usually desirable), or `replace: true`, if
// you wish to modify the current URL without adding an entry to the history.
Backbone.history.navigate=function(fragment, options) {
    if (!Backbone.History.started) return false;
    if (!options || options === true) options = {trigger: !!options};

    // Normalize the fragment.
    fragment = this.getFragment(fragment || '');

    // Don't include a trailing slash on the root.
    var rootPath = this.root;
    if (fragment === '' || fragment.charAt(0) === '?') {
    rootPath = rootPath.slice(0, -1) || '/';
    }
    var url = rootPath + fragment;

    // Strip the hash and decode for matching.
    // immanens
    // https://github.com/jashkenas/backbone/pull/4026/files
    fragment = fragment.replace(Backbone.History.pathStripper, '');

    // Decode for matching.
    var decodedFragment = this.decodeFragment(fragment);

    if (this.fragment === decodedFragment) return;
    this.fragment = decodedFragment;

    // If pushState is available, we use it to set the fragment as a real URL.
    if (this._usePushState) {
    this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

    // If hash changes haven't been explicitly disabled, update the hash
    // fragment to store history.
    } else if (this._wantsHashChange) {
    this._updateHash(this.location, fragment, options.replace);
    if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
        var iWindow = this.iframe.contentWindow;

        // Opening and closing the iframe tricks IE7 and earlier to push a
        // history entry on hash-tag change.  When replace is true, we don't
        // want this.
        if (!options.replace) {
        iWindow.document.open();
        iWindow.document.close();
        }

        this._updateHash(iWindow.location, fragment, options.replace);
    }

    // If you've told us that you explicitly don't want fallback hashchange-
    // based history, then `navigate` becomes a page refresh.
    } else {
    return this.location.assign(url);
    }
    if (options.trigger) return this.loadUrl(fragment);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(77);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(117)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/pattern-replace-loader/index.js??ref--1-2!./reader.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/pattern-replace-loader/index.js??ref--1-2!./reader.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(78)();
// imports


// module
exports.push([module.i, ".app-reader *{\r\n    padding:0;\r\n    margin:0;\r\n    box-sizing: border-box;\r\n    -webkit-touch-callout: none; /* prevent callout to copy image, etc when tap to hold */\r\n    -webkit-text-size-adjust: none; /* prevent webkit from resizing text to fit */\r\n    -webkit-tap-highlight-color: rgba(0,0,0,0);\r\n}\r\n\r\n.app-reader input {\r\n    background-color: field;\r\n    color: fieldtext;\r\n}\r\n\r\n.app-reader *:focus {\r\n    outline:none;\r\n}\r\n\r\n.app-reader .container {\r\n    content:none;\r\n    display:block;\r\n    width:100%;\r\n    margin:0;\r\n    padding:0;\r\n}\r\n\r\n@-moz-document url-prefix() {\r\n    /* hide the system icon for loading images */\r\n    img:-moz-loading {\r\n        visibility: hidden;\r\n    }\r\n    /* hide the system icon for broken images */\r\n    img:-moz-broken {\r\n        -moz-force-broken-image-icon: 0;\r\n    }\r\n}\r\n\r\n/**\r\n * SCROLLBARS\r\n */\r\n .app-reader .scrollbar-measure {\r\n\twidth: 100px;\r\n\theight: 100px;\r\n\toverflow: scroll;\r\n\tposition: absolute;\r\n\ttop: -9999px;\r\n}\r\n\r\n.app-reader ::-webkit-scrollbar {\r\n    width: 0.5em;\r\n    height: 0.5em;\r\n}\r\n\r\n.app-reader ::-webkit-scrollbar-track {\r\n    /*box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);*/\r\n    background: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.app-reader ::-webkit-scrollbar-thumb {\r\n    background: rgba(100, 100, 100, 0.8);\r\n}\r\n\r\n.app-reader ::-webkit-scrollbar-corner,\r\n.app-reader ::-webkit-scrollbar-thumb:window-inactive {\r\n    background: rgba(100, 100, 100, 0.4);\r\n}\r\n\r\n/* pour supprimer les effets de bootstrap, logiquement il faudrait que pv5 utilise une convention de nom style BEM pour éliminer ce genre de conflit */\r\n.app-reader .overlay, .app-reader .overlay:before, .app-reader .container:before {\r\n    all: initial;\r\n}\r\n.app-reader .overlay{\r\n    cursor: inherit;\r\n}\r\n\r\n.app-reader{\r\n    font-family: sans-serif;\r\n    font-weight: 400;\r\n    font-style: normal;\r\n    font-size: 15px;\r\n    -webkit-font-smoothing: antialiased;\r\n    color: #0E1C2C;\r\n    line-height: normal;\r\n    height: 100%;\r\n}\r\n.app-reader input:focus,\r\n.app-reader select:focus,\r\n.app-reader textarea:focus,\r\n.app-reader button:focus {\r\n    outline: none;\r\n}\r\n\r\n.app-reader .absolute-center {\r\n  margin: auto;\r\n  position: absolute;\r\n  top: 0; left: 0; bottom: 0; right: 0;\r\n}\r\n\r\n.app-reader section {\r\n    clear: both;\r\n}\r\n\r\n.app-reader .reader{\r\n    height: 100%;\r\n    width:100%;\r\n    position:relative;\r\n    overflow: hidden;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.app-reader input[type=\"checkbox\"], .app-reader input[type=\"radio\"] {\r\n    position: absolute;\r\n    left: -9999px;\r\n}\r\n\r\n.app-reader .side-label {\r\n    display: block;\r\n    position: relative;\r\n    margin: 10px 0;\r\n    padding-left: 20px;\r\n    cursor: pointer;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n}\r\n.app-reader .side-label::before, .app-reader .side-label::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n}\r\n.app-reader .side-label::before {\r\n    display: block;\r\n    width: 12px;\r\n    height: 12px;\r\n    border: 1px solid #fff;\r\n    margin-top: 1px;\r\n    box-sizing:content-box;\r\n}\r\n.app-reader .side-label::after {\r\n    display: none;\r\n    width: 8px;\r\n    height: 8px;\r\n    margin:  4px 3px;\r\n    background-color: #fff;\r\n}\r\n.app-reader input:checked + .side-label::after {\r\n    display: block;\r\n}\r\n\r\n.app-reader.fullscreen .reader{\r\n    top:0;\r\n    left:0;\r\n    width: 100%;\r\n    height: 100%;\r\n    position: fixed;\r\n}\r\n\r\n    /* toolbar top start */\r\n    .app-reader .reader .tb-top{\r\n        background-color: #fff;\r\n        height:80px;\r\n        width:100%;\r\n        z-index:40;\r\n        -webkit-user-select: none;\r\n        -moz-user-select: none;\r\n        -ms-user-select: none;\r\n        user-select: none;\r\n        box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\r\n        color: #000;\r\n    }\r\n        .app-reader .reader .tb-top .container{\r\n            display:flex;\r\n            max-width: unset;\r\n        }\r\n        .app-reader .reader .tb-top .container > *{\r\n            height: 80px;\r\n        }\r\n            .app-reader .reader .tb-top .container .rbn-shortcuts{\r\n                white-space: nowrap;\r\n                margin-left: 30px;\r\n            }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut{\r\n                    width: 40px;\r\n                    height: 40px;\r\n                    display: inline-block;\r\n                    margin-top: 20px;\r\n                    margin-right: 4px;\r\n                    cursor: pointer;\r\n                    background-repeat: no-repeat;\r\n                    background-position: center center;\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-search{\r\n                    background-image: url(" + __webpack_require__(79) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-search:hover{\r\n                    background-image: url(" + __webpack_require__(80) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-search.rbn-on{\r\n                    background-image: url(" + __webpack_require__(81) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-search.rbn-on:hover{\r\n                    background-image: url(" + __webpack_require__(82) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-print{\r\n                    background-image: url(" + __webpack_require__(83) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-print:hover{\r\n                    background-image: url(" + __webpack_require__(84) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-print.rbn-on{\r\n                    background-image: url(" + __webpack_require__(85) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-print.rbn-on:hover{\r\n                    background-image: url(" + __webpack_require__(86) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-share{\r\n                    background-image: url(" + __webpack_require__(87) + ");\r\n                    margin-right: 8px;\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-share:hover{\r\n                    background-image: url(" + __webpack_require__(88) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-share.rbn-on{\r\n                    background-image: url(" + __webpack_require__(89) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-share.rbn-on:hover{\r\n                    background-image: url(" + __webpack_require__(90) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-copy{\r\n                    background-image: url(" + __webpack_require__(91) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-copy:hover{\r\n                    background-image: url(" + __webpack_require__(92) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-copy.rbn-on{\r\n                    background-image: url(" + __webpack_require__(93) + ");\r\n                }\r\n                .app-reader .reader .tb-top .container .rbn-shortcut-copy.rbn-on:hover{\r\n                    background-image: url(" + __webpack_require__(94) + ");\r\n                }\r\n            .app-reader .reader .tb-top .container .button{\r\n                width:80px;\r\n                background-repeat: no-repeat;\r\n                background-position: center center;\r\n                background-size: 16px 16px;\r\n                cursor: pointer;\r\n            }\r\n            .app-reader .reader .tb-top .container .button.on{\r\n                background-color: #014571;\r\n                background-size: 16px;\r\n                background-image: url(" + __webpack_require__(95) + ");\r\n            }        \r\n                .app-reader .reader .tb-top .container .button .dropdown{\r\n                    background-color: #014571;\r\n                    display: none;\r\n                    position: absolute;\r\n                    z-index: 999;\r\n                    border: 1px solid #014571;\r\n                    top:80px;\r\n                    right: 0;\r\n                }\r\n                .app-reader .reader .tb-top .container .button.on .dropdown{\r\n                    display:block;\r\n                    cursor: default;\r\n                    padding: 6px 20px 6px;\r\n                }\r\n                    .app-reader .reader .tb-top .container .button .dropdown.maximized{\r\n                        width: 100%;\r\n                        height: calc(100% - 60px);\r\n                    }\r\n                    .app-reader .reader .tb-top .container .button .dropdown .line{\r\n                        color: #fff;\r\n                        white-space: nowrap;\r\n                    }\r\n                        .app-reader .reader .tb-top .container .button .dropdown.maximized .line{\r\n                            width: 100%;\r\n                            height: 100%;\r\n                        }\r\n                        .app-reader .reader .tb-top .container .button .dropdown .line .header{\r\n                            line-height: 46px;\r\n                            cursor: pointer;\r\n                            font-weight: 600;\r\n                            font-size: 1.1em;\r\n                        }\r\n                        .app-reader .reader .tb-top .container .button .dropdown .line .content{\r\n                            display:none;\r\n                            border-top: 1px solid #ccc;\r\n                            width: 320px;\r\n                            \r\n                        }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .action{\r\n                                text-align: right;\r\n                                padding: 10px 0;\r\n                            }\r\n\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .search-container{\r\n                                display:flex;\r\n                                margin-top:10px;\r\n                            }\r\n                                .app-reader .reader .tb-top .container .button .dropdown .content .search-container > input{\r\n                                    flex:1;\r\n                                    margin-right: 10px;\r\n                                }\r\n                                .app-reader .reader .tb-top .container .button .dropdown .content .search-container .search-go{\r\n                                    height:24px;\r\n                                    width: 24px;\r\n                                    cursor: pointer;\r\n                                    background-repeat: no-repeat;\r\n                                    background-position: center center;\r\n                                    background-image: url(" + __webpack_require__(96) + ");\r\n                                    background-size: 24px;\r\n                                }\r\n                                .app-reader .reader .tb-top .container .button .dropdown .content .search-container .search-go:hover{\r\n                                    background-image: url(" + __webpack_require__(97) + ");\r\n                                }\r\n                            \r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .action .print-document,\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .search-previous,\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .search-next,\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .copy-text,\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .refresh,\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .share-url,\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .goto-web-store\r\n                            {\r\n                                height:36px;\r\n                                background-repeat: no-repeat;\r\n                                background-position: 6px center;\r\n                                line-height: 32px;\r\n                                background-size: 16px;\r\n                                cursor: pointer;\r\n                                color: #fff;\r\n                                background-color: #0E1C2C;\r\n                                border: 2px solid #0E1C2C;\r\n                                border-radius: 6px;\r\n                                padding: 0 8px 0 8px;\r\n                                display: inline-block;\r\n                                font-weight: 700;\r\n                            }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .action .print-document:hover,\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .search-previous:hover,\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .search-next:hover,\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .copy-text:hover,\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .refresh:hover,\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .share-url:hover,\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .web-store:hover {\r\n                                color: #fff;\r\n                                background-color: #1B73AD;\r\n                                border: 2px solid #1B73AD;\r\n                            }\r\n                                .app-reader .reader .tb-top .container .button .dropdown.copy{\r\n                                    transition: opacity 0.2s;\r\n                                    opacity:1;\r\n                                }\r\n                                .app-reader .reader .tb-top .container .button .dropdown.copy.select{\r\n                                    opacity:0.1;\r\n                                }\r\n\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .copy-text.disabled{\r\n                                opacity: 0.3;\r\n                                cursor: default;\r\n                            }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content .copy-text.disabled:hover{\r\n                                background-color: #0E1C2C;\r\n                                border: 2px solid #0E1C2C;\r\n                            }\r\n\r\n                            .app-reader .reader .tb-top .container .button .dropdown .content input[type=\"text\"]{\r\n                                font-size: 14px;\r\n                                border: none;\r\n                                line-height: 24px;\r\n                                height:24px;\r\n                                width:100%;\r\n                                padding: 0 6px;\r\n                                color: #000;\r\n                            }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .line .content .quota{\r\n                                padding: 10px 0;\r\n                                color: #e6e6e6;\r\n                                border-bottom: 1px solid #e6e6e6;\r\n                                font-size: 13px;                    \r\n                            }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .line .content .quota span{\r\n                                color: #fff;\r\n                            }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .line[data-action=about] .content{\r\n                                padding:10px 0;\r\n                            }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .line[data-action=thumbnails] .content{\r\n                                width: calc(100% - 20px);\r\n                                height: calc(100% - 40px);\r\n                                background: #e5e5e5;\r\n                                position: absolute;\r\n                                top: 10px;\r\n                                left: 10px;\r\n                                border: none;\r\n                                overflow-y: auto;\r\n                                overflow-x: hidden;\r\n                                -webkit-overflow-scrolling: touch;\r\n                            }\r\n                                .app-reader .reader .tb-top .container .button .dropdown .line[data-action=thumbnails] .content .rbn-thumbnails-grid {\r\n                                    display: flex;\r\n                                    flex-wrap: wrap;\r\n                                    width: 100%;\r\n                                }\r\n                                    .app-reader .reader .tb-top .container .button .dropdown .line[data-action=thumbnails] .content .rbn-thumbnails-grid .rbn-thumbnails-cell{\r\n                                        display: flex;\r\n                                        box-sizing: border-box;\r\n                                        color: #000;\r\n                                        flex-direction: column;\r\n                                        padding: 30px 10px;\r\n                                        cursor: pointer;\r\n                                        \r\n                                    }\r\n                                    .app-reader .reader .tb-top .container .button .dropdown .line[data-action=thumbnails] .content .rbn-thumbnails-grid .rbn-thumbnails-cell .rbn-pages-image{\r\n                                        flex:1;\r\n                                        position: relative;\r\n                                        /*background: pink;*/\r\n                                    }\r\n                                    .app-reader .reader .tb-top .container .button .dropdown .line[data-action=thumbnails] .content .rbn-thumbnails-grid .rbn-thumbnails-cell .rbn-pages-image > img{\r\n                                        display: block;\r\n                                        position: absolute;\r\n                                        left: 0;\r\n                                        right: 0;\r\n                                        bottom: 0;\r\n                                        margin: auto;\r\n                                        max-width: 100%;\r\n                                        max-height: 100%;\r\n                                        border: 1px solid darkgray;\r\n                                    }\r\n                                    .app-reader .reader .tb-top .container .button .dropdown .line[data-action=thumbnails] .content .rbn-thumbnails-grid .rbn-thumbnails-cell .rbn-pages-label{\r\n                                        height: 26px;\r\n                                        line-height: 26px;\r\n                                        font-size: 16px;\r\n                                        text-align: center;\r\n                                        font-weight: 500;\r\n                                    }\r\n                                        .app-reader .reader .tb-top .container .button .dropdown .line[data-action=thumbnails] .content .rbn-thumbnails-grid .rbn-thumbnails-cell .rbn-pages-label > span{\r\n                                            display: inline-block;\r\n                                            padding: 0 10px;\r\n                                            padding: 0 10px;\r\n                                            min-width: 200px;\r\n                                        }\r\n                                        .app-reader .reader .tb-top .container .button .dropdown .line[data-action=thumbnails] .content .rbn-thumbnails-grid .rbn-thumbnails-cell.rbn-selected .rbn-pages-label > span{\r\n                                            border-bottom: 3px solid #004471;\r\n                                            color:#000;\r\n                                            font-weight: 700;\r\n                                        }\r\n                    \r\n                            .app-reader .reader .tb-top .container .button .dropdown .line .content p{\r\n                                margin: 10px 0;\r\n                                color: lightgray;    \r\n                                white-space: normal;\r\n                                line-height: 1.4em;              \r\n                            }\r\n                            \r\n                            .app-reader .reader .tb-top .container .button .dropdown .line .content .search-nav{\r\n                                display: flex;\r\n                            }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .line .content .search-index{\r\n                                flex:1;\r\n                                text-align: center;\r\n                                line-height: 36px;\r\n                                margin: 0 6px;\r\n                            }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .line .content .search-nav{\r\n                                margin:10px 0;\r\n                            }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .line .content .result{\r\n                                height: 0;\r\n                                overflow: hidden;\r\n                            }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .line .content .result.enable{\r\n                                height:unset;\r\n                            }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .line .content .copy-move-ctrl,\r\n                            .app-reader .reader .tb-top .container .button .dropdown .line .content em{\r\n                                color: #fff;\r\n                                font-size: .9em;\r\n                                font-weight:700;\r\n                                white-space: break-spaces;\r\n                                font-style: normal;\r\n                            }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .line[data-action=preferences] .content > div.pref-line{\r\n                                display: flex;\r\n                                padding: 10px 0;\r\n                                color: lightgray;\r\n                                white-space: normal;\r\n                                line-height: 1.4em;\r\n                            }\r\n                                .app-reader .reader .tb-top .container .button .dropdown .line[data-action=preferences] .content > div.pref-line label{\r\n                                    margin-right:10px;\r\n                                }\r\n                                .app-reader .reader .tb-top .container .button .dropdown .line[data-action=preferences] .content > div.pref-line select{\r\n                                    flex:1;\r\n                                }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .line[data-action=share] .content > #share-url-text{\r\n                                background-color: #fff;\r\n                                color:#000;\r\n                                width: 100%;\r\n                                height: auto;\r\n                                white-space: break-spaces;\r\n                                text-align: center;\r\n                                padding: 6px;\r\n                            }\r\n                            .app-reader .reader .tb-top .container .button .dropdown .line .content .note{\r\n                                color: #fff;\r\n                                font-size: .9em;\r\n                                font-weight:700;\r\n                            }\r\n            .app-reader .reader .tb-top .container .menu{    \r\n                background-image: url(" + __webpack_require__(98) + ");\r\n                background-size: 24px;\r\n            }\r\n            .app-reader .reader .tb-top .container .menu:not(.on):hover{\r\n                background-image: url(" + __webpack_require__(99) + ");\r\n            }  \r\n            .app-reader .reader .tb-top .container .rbn-home{        \r\n                width:80px;\r\n                line-height: 80px;\r\n                background-repeat: no-repeat;\r\n                background-position: center;\r\n                background-image: url(" + __webpack_require__(100) + ");\r\n                background-size: 24px;\r\n                cursor: pointer;\r\n            }\r\n            .app-reader .reader .tb-top .container .rbn-home:hover{\r\n                background-image: url(" + __webpack_require__(101) + ");\r\n            }\r\n            .app-reader .reader .tb-top .container .page-title{        \r\n                flex:1;\r\n                line-height: 80px;\r\n                white-space: nowrap;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n            }\r\n            .app-reader .reader .tb-top .container .document-title{        \r\n                font-size: 18px;\r\n                font-weight:700;\r\n                color: #0E1C2C;\r\n            }\r\n            \r\n        /* toolbar top end */\r\n\r\n    .app-reader .reader .main-view{\r\n        width: 100%;\r\n        flex:1;\r\n        background-color: #E5E5E5;\r\n        display: flex;\r\n        overflow: hidden;\r\n    }\r\n        .app-reader .reader .main-view .side-panel{\r\n            width:0px;\r\n            height: 100%;\r\n            z-index: 30;\r\n            background-color: #fff;\r\n            overflow: hidden;\r\n            position: relative;\r\n        }\r\n        .app-reader.show-panel .reader .main-view .side-panel{\r\n            width:500px;\r\n            border-right:1px solid #ccc;\r\n        }\r\n\r\n        .app-reader .reader .main-view .middle-panel{\r\n            flex:1;\r\n            display: flex;\r\n            flex-direction: column;\r\n            overflow: hidden;\r\n        }\r\n\r\n   \r\n    /* document view start */\r\n    .app-reader.mode-page .reader .document-view{\r\n        flex:1;\r\n        overflow: hidden;\r\n        -webkit-user-select: none;\r\n        -moz-user-select: none;\r\n        -ms-user-select: none;\r\n        user-select: none;\r\n        cursor: -webkit-grab;\r\n        width: 100%;\r\n        height: 100%;\r\n        transform:  scale(1);\r\n    }\r\n\r\n    .app-reader.mode-article .reader .document-view{\r\n        display:none;\r\n        \r\n    }\r\n    \r\n    .app-reader .reader .document-view.grabbing{\r\n        cursor: move;\r\n        cursor: -webkit-grabbing;\r\n    }\r\n        .app-reader .reader .document-view .container{\r\n            height: 100%;\r\n            position: absolute;\r\n        }\r\n        .app-reader .reader .document-view .container .page-view{\r\n            position: absolute;\r\n            display: -webkit-flex;\r\n            display: flex;\r\n            -webkit-flex-direction: column;\r\n            flex-direction: column;\r\n            -webkit-justify-content: center;\r\n            justify-content: center;\r\n            text-align: center;\r\n            overflow: hidden;\r\n        }\r\n            .app-reader .reader .document-view .container .page-view .loading{\r\n                color: rgba(255,255,255,0.5);\r\n                font-size: 60px;\r\n            }\r\n            .app-reader .reader .document-view .container .page-view .tile-container{\r\n                position: absolute;\r\n                background-color: #fff;\r\n                box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\r\n                overflow: hidden;\r\n                background-size: cover;\r\n                /*opacity: .7;*/\r\n            }\r\n                .app-reader .reader .document-view .container .page-view .tile{\r\n                    position: absolute;\r\n                    z-index:10;\r\n                }\r\n                .app-reader .reader .document-view .container .page-view .tile:-moz-loading {\r\n                    visibility: hidden;\r\n                }\r\n    /* document view end */\r\n\r\n\r\n\r\n    /* document view custom start*/\r\n            .app-reader .reader .document-view .container .page-view .tile-container.page-auth-container{\r\n                display: flex;\r\n                background-color: #000;\r\n                align-items: center;\r\n                justify-content: space-evenly;\r\n            }\r\n            \r\n                .app-reader .reader .document-view .container .page-view .tile-container.page-auth-container .one-page-auth{\r\n                    padding: 20px;\r\n                    width: 100%;\r\n                }\r\n                .app-reader .reader .document-view .container .page-view .tile-container.page-auth-container .one-page-auth.mid{\r\n                    width: 50%;\r\n                }\r\n                    .app-reader .reader .document-view .container .page-view .tile-container.page-auth-container .one-page-auth .page-auth-thumb{\r\n                        height: 200px;\r\n                        width: 320px;\r\n                        display: inline-block;\r\n                        margin-bottom: 10px;\r\n                        background-repeat: no-repeat;\r\n                        background-size: contain;\r\n                        background-position: center;\r\n                    }\r\n            .app-reader .reader .document-view .container .page-view .tile-container .overlay-entity-zones .zone{\r\n                position: absolute;\r\n                z-index:20;\r\n                cursor: pointer;\r\n                opacity: 0;\r\n            }\r\n            .app-reader .reader .document-view .container .page-view .tile-container .overlay-entity-zones .zone.hl{\r\n                background-color: rgba(0, 166, 255, 0.3);\r\n                /*box-shadow: 0 0 0 3px red;*/\r\n                animation: fadeinout 4s linear 1 forwards;\r\n            }\r\n            @keyframes fadeinout {\r\n              0% { opacity: 0; }\r\n              25% { opacity: 1; }\r\n              75% { opacity: 1; }\r\n              100% { opacity: 0; }\r\n            }\r\n            @keyframes blinker {\r\n                0% { opacity: 0.0; }\r\n                50% { opacity: 1.0; }\r\n                100% { opacity: 0.0; }\r\n            }\r\n            .app-reader .reader .document-view .container .page-view .tile-container .overlay-links .link{\r\n                position: absolute;\r\n                z-index:30;\r\n                background-color: rgba(0, 166, 255, 0.3);\r\n                cursor: pointer;\r\n                opacity: 0;\r\n            }\r\n            .app-reader .reader .document-view .container .page-view .tile-container .overlay-links.hl .link{\r\n                animation: blinker 0.5s linear 3;\r\n            }\r\n            .app-reader .reader .document-view .container .page-view .tile-container .overlay-links .link:hover{\r\n                opacity: 1;\r\n            }\r\n\r\n            .app-reader .reader .document-view .container .page-view .tile-container .overlay-search.hide{\r\n                display: none;\r\n            }\r\n            .app-reader .reader .document-view .container .page-view .tile-container .overlay-search .result{\r\n                position: absolute;\r\n                background-color:#ffff00;\r\n                /*box-shadow: 0px 0px 0px 1px #fc7b68;*/\r\n                z-index:24;\r\n                mix-blend-mode: multiply;\r\n            }\r\n            .app-reader .reader.inverted .document-view .container .page-view .tile-container .overlay-search .result{\r\n                background-color:#0000ff;\r\n                mix-blend-mode: overlay;\r\n                /*box-shadow: 0px 0px 0px 1px #0ff;*/\r\n            }\r\n\r\n            .app-reader .reader .document-view .container .page-view .tile-container .overlay-select{\r\n                position: absolute;\r\n                z-index:40;\r\n                width: 100%;\r\n                height: 100%;\r\n                left: 0;\r\n                top: 0;\r\n                cursor: crosshair;\r\n            }\r\n            .app-reader .reader .document-view .container .page-view .tile-container .overlay-select.inactive{\r\n                cursor: inherit;\r\n            }\r\n            .app-reader .reader .document-view .container .page-view .tile-container .overlay-select.hide{\r\n                display: none;\r\n            }\r\n                .app-reader .reader .document-view .container .page-view .tile-container .overlay-select .cache{\r\n                    background-color: #000;\r\n                    opacity: 0.6;\r\n                    position: absolute;\r\n                }\r\n                .app-reader .reader .document-view .container .page-view .tile-container .overlay-select .cache.top{\r\n                    top:0;\r\n                    left:0;\r\n                    width:100%;\r\n                }\r\n                .app-reader .reader .document-view .container .page-view .tile-container .overlay-select .cache.left{\r\n                    left:0;\r\n                }\r\n                .app-reader .reader .document-view .container .page-view .tile-container .overlay-select .cache.right{\r\n                    right:0;\r\n                }\r\n                .app-reader .reader .document-view .container .page-view .tile-container .overlay-select .cache.bottom{\r\n                    top:0;\r\n                    left:0;\r\n                    width:100%;\r\n                }\r\n                .app-reader .reader .document-view .container .page-view .tile-container .overlay-select .handle{\r\n                    position: absolute;\r\n                    width: 20px;\r\n                    height: 20px;\r\n                    border-radius: 20px;\r\n                    box-shadow: inset 0 0 0 10px;\r\n                    margin-left:-10px;\r\n                    margin-top:-10px;\r\n                    opacity: 0.7;\r\n                    color:#f00;\r\n                }\r\n                .app-reader .reader.inverted .document-view .container .page-view .tile-container .overlay-select .handle{\r\n                    color:#0ff;\r\n                }\r\n                .app-reader .reader .document-view .container .page-view .tile-container .overlay-select .handle:hover,\r\n                .app-reader .reader .document-view .container .page-view .tile-container .overlay-select .handle:active{\r\n                    opacity: 1;\r\n                    box-shadow: inset 0 0 0 3px;\r\n                }\r\n                .app-reader .reader .document-view .container .page-view .tile-container .overlay-select .handle.center{\r\n                    color:#FFA500;\r\n                    cursor: move;\r\n                }\r\n                .app-reader .reader.inverted .document-view .container .page-view .tile-container .overlay-select .handle.center{\r\n                    color:#005Aff;\r\n                }\r\n                .app-reader .reader .document-view .container .page-view .tile-container .overlay-select .handle.top,\r\n                .app-reader .reader .document-view .container .page-view .tile-container .overlay-select .handle.bottom{\r\n                    cursor: n-resize;\r\n                }\r\n                .app-reader .reader .document-view .container .page-view .tile-container .overlay-select .handle.left,\r\n                .app-reader .reader .document-view .container .page-view .tile-container .overlay-select .handle.right{\r\n                    cursor: e-resize;\r\n                }\r\n\r\n    /* document view custom end*/\r\n    \r\n    .app-reader .reader .tb-right{\r\n        \r\n        height: auto;\r\n        width: 64px;\r\n        right:0;\r\n        top:calc( 50% - 176px);\r\n        position:absolute;\r\n        z-index:30;\r\n        -webkit-user-select: none;\r\n        -moz-user-select: none;\r\n        -ms-user-select: none;\r\n        user-select: none;\r\n        transition: height 0.4s, top 0.4s;\r\n        overflow: hidden;\r\n        border-top-left-radius: 6px;\r\n        border-bottom-left-radius: 6px;\r\n        padding-top: 8px;\r\n        padding-bottom: 8px;\r\n        background-color: rgba(0, 11, 22, 0.7);\r\n    }\r\n    .app-reader.sampler .reader .tb-right{\r\n        top:calc( 50% - 128px);\r\n    }\r\n        .app-reader .reader .tb-right .container{\r\n            display:flex;\r\n            flex-direction: column;\r\n        }\r\n            .app-reader .reader .tb-right .container .button{\r\n                height:48px;\r\n                width:64px;\r\n                background-repeat: no-repeat;\r\n                background-position: center center;\r\n                background-size: 32px;\r\n                cursor: pointer; \r\n            }\r\n            .app-reader .reader .tb-right .container .button.on{\r\n                background-color: rgba(34,34,34,.7);\r\n            }\r\n            .app-reader .reader .tb-right .container .button.disabled{\r\n                opacity:0.5;\r\n                cursor: default;\r\n            }\r\n            .app-reader .reader .tb-right .container .button:active{\r\n                background-color: rgba(34,34,34,.4);\r\n            }\r\n            .app-reader .reader .tb-right .container .button.disabled:active{\r\n                background-color: transparent;\r\n            }\r\n            .app-reader .reader .tb-right .container .rbn-next-page{\r\n                padding-top: 8px;\r\n                background-image: url(" + __webpack_require__(102) + ");\r\n            }\r\n            .app-reader .reader .tb-right .container .rbn-previous-page{\r\n                background-image: url(" + __webpack_require__(103) + ");\r\n            }\r\n            .app-reader .reader .tb-right .container .rbn-zoom-in{\r\n                background-image: url(" + __webpack_require__(104) + ");\r\n            }\r\n            .app-reader .reader .tb-right .container .rbn-zoom-out{\r\n                background-image: url(" + __webpack_require__(105) + ");\r\n            }                \r\n            .app-reader .reader .tb-right .container .rbn-full-screen{\r\n                background-image: url(" + __webpack_require__(106) + ");  \r\n            }\r\n            .app-reader .reader .tb-right .container .rbn-page-history{\r\n                background-image: url(" + __webpack_require__(107) + ");\r\n                background-size: 24px;\r\n            }\r\n            .app-reader .reader .tb-right .container .rbn-thumbnail{\r\n                background-image: url(" + __webpack_require__(108) + ");\r\n            }\r\n            \r\n\r\n    /* TOOLBAR BOTTOM */\r\n    .app-reader .reader .tb-bottom{\r\n        background-color: #fff;\r\n        height:80px;\r\n        width:100%;\r\n        z-index:34;\r\n        -webkit-user-select: none;\r\n        -moz-user-select: none;\r\n        -ms-user-select: none;\r\n        user-select: none;\r\n        bottom: 0;\r\n        box-shadow: 0px -4px 10px rgba(0, 0, 0, 0.1);\r\n        display: flex;\r\n    }\r\n        .app-reader .reader .tb-bottom .button{\r\n            height:48px;\r\n            background-repeat: no-repeat;\r\n            background-position: 16px center;\r\n            line-height: 44px;\r\n            background-size: 24px;\r\n            cursor: pointer;\r\n            color: #001B2D;\r\n            background-color: transparent;\r\n            border: 2px solid #001B2D;\r\n            border-radius: 8px;\r\n            padding: 0 16px 0 48px;\r\n            display: inline-block;\r\n            font-weight: 600;\r\n            font-size: 16px;\r\n        }\r\n        .app-reader .reader .tb-bottom .button.toc{\r\n            background-color: #0E1C2C;\r\n            border: 2px solid #0E1C2C;\r\n            color: #fff;\r\n            background-image: url(" + __webpack_require__(109) + ");\r\n        }\r\n        .app-reader.show-panel .reader .tb-bottom .button.toc{\r\n            background-color: #014571;\r\n            border: 2px solid #014571;\r\n        }\r\n        .app-reader .reader .tb-bottom .button.toc:hover{\r\n            background-color: #1B73AD;\r\n            border: 2px solid #1B73AD;\r\n        }\r\n  \r\n        .app-reader .reader .tb-bottom .rbn-nav{\r\n            margin: 16px 32px 16px 32px;\r\n        }\r\n        .app-reader .reader .tb-bottom .page-slider{\r\n            flex:1;\r\n            margin: 37px 0px 37px 0px;\r\n        }\r\n        .app-reader.mode-page .reader .tb-bottom .page-slider{\r\n            display:block;\r\n        }\r\n        .app-reader .reader .tb-bottom .rbn-page-edit-container{\r\n            display: flex;\r\n            margin-left: 32px;\r\n            margin-right: 32px;\r\n            color: #0E1C2C;\r\n            line-height: 80px;\r\n            font-size: 16px;\r\n            font-weight: 400;\r\n        }\r\n            .app-reader .reader .tb-bottom .rbn-page-edit-container .rbn-page-edit-input{\r\n                border: 1px solid #B3B9BF;\r\n                border-radius: 4px;\r\n                width: 80px;\r\n                height: 48px;\r\n                text-align: center;\r\n                margin: 0 16px;\r\n                font-family: \"Poppins\";\r\n                color:#0E1C2C;\r\n                font-size: 16px;\r\n            }\r\n            .app-reader .reader .tb-bottom .rbn-page-edit-separator{\r\n                margin-right: 6px;\r\n            }\r\n            .app-reader .reader .tb-bottom .rbn-page-edit-max{\r\n                min-width: 32px;\r\n            }\r\n\r\n        /* page slider start */\r\n        .app-reader .reader .page-slider{\r\n            background-color: #E6E8EA;\r\n            height:8px;\r\n            width:100%;\r\n            z-index:20;\r\n            border-radius: 4px;\r\n            cursor: pointer;\r\n        }\r\n        .app-reader .reader .page-slider .knob{\r\n            position:relative;\r\n            height:40px;\r\n            top:-17px;\r\n            cursor: grab;\r\n        }\r\n        .app-reader .reader .page-slider.grabbing .knob{\r\n            cursor: grabbing;\r\n        }\r\n            .app-reader .reader .page-slider .knob .knob-inside{\r\n                position:absolute;\r\n                background-color: #fff;\r\n                height:30px;\r\n                width:100%;\r\n                top: 5px;\r\n                border-radius: 50%;\r\n                border: 2px solid #0E1C2C;\r\n            }\r\n            .app-reader .reader .page-slider .knob .knob-inside:hover{\r\n                border: 2px solid #1B73AD;\r\n            }\r\n\r\n        .app-reader .reader .page-slider .thumb{\r\n            position:absolute;\r\n            background-color: rgba(0, 11, 22, 0.7);\r\n            height:200px;\r\n            width:260px;\r\n            bottom:90px;\r\n            left:calc(50% - 130px);\r\n        }\r\n        .app-reader.show-panel .reader .page-slider .thumb{\r\n            left:calc(50% + 70px);\r\n        }\r\n            .app-reader .reader .page-slider .thumb .cover{\r\n                width:240px;\r\n                height:160px;\r\n                left:10px;\r\n                top: 10px;\r\n                position: absolute;\r\n                background-repeat: no-repeat;\r\n                background-size: 50% 100%;\r\n                background-position:center center;\r\n            }\r\n            \r\n            .app-reader .reader .page-slider .thumb .cover.double-page{\r\n                background-size: 100% 100%\r\n            }\r\n            .app-reader .reader .page-slider .thumb .info{\r\n                text-align: center;\r\n                color: #fff;\r\n                line-height: 30px;\r\n                bottom: 0;\r\n                width: 100%;\r\n                position: absolute;\r\n            }\r\n            .app-reader .reader .page-slider .thumb.page-not-authorized .info{\r\n                color: gray;\r\n            }\r\n            .app-reader .reader .page-slider .thumb.page-not-authorized .cover{\r\n                opacity: 0.4;\r\n            }\r\n        /* page slider end */\r\n    \r\n    \r\n\r\n.app-reader .notify{\r\n    position: fixed;\r\n    bottom: -100px;\r\n    width: 800px;\r\n    left: 50%;\r\n    margin-left: -400px;\r\n    z-index: 800;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    -webkit-transition: bottom 700ms, opacity 700ms;\r\n    transition: bottom 700ms, opacity 700ms;\r\n    opacity: 0;\r\n}\r\n\r\n.app-reader .notify.show{\r\n    bottom: 100px;\r\n    opacity: 1;\r\n}\r\n\r\n    .app-reader .notify > p{\r\n        display: inline-block;\r\n        background: rgba(255,255,255,0.97);\r\n        padding: 12px 25px;\r\n        margin-bottom: 0;\r\n        font-size: 16px;\r\n        font-weight: 500;\r\n    }\r\n\r\n    .app-reader .notify > p.error{\r\n        background: #D9534F;\r\n        color: #fff;\r\n    }\r\n\r\n    .app-reader .notify > p.info{\r\n        background:#0E1C2C;\r\n        color:#fff;\r\n    }\r\n\r\n    .app-reader .notify > p.warning{\r\n        background:#ec6446;\r\n        color:#fff;\r\n    }\r\n\r\n/* Mobile Phones Portrait */\r\n.app-reader.phone .reader .tb-top .rbn-shortcut{\r\n    display:none;\r\n}\r\n\r\n.app-reader.phone .reader .tb-bottom .button>span{\r\n    display:none;\r\n}\r\n.app-reader.phone .reader .tb-bottom .button{\r\n    border-color: #fff;\r\n    background-position: center;\r\n}\r\n.app-reader.phone .reader .tb-bottom .page-slider{\r\n    border: none;\r\n    margin-left:0;\r\n}\r\n.app-reader.phone .reader .tb-bottom .rbn-page-edit-label,\r\n.app-reader.phone .reader .tb-bottom .rbn-page-edit-separator,\r\n.app-reader.phone .reader .tb-bottom .rbn-page-edit-max {\r\n    display:none;\r\n}\r\n.app-reader.phone .reader .tb-bottom .rbn-nav{\r\n    margin-right: 10px;\r\n    margin-left: 16px;\r\n}\r\n.app-reader.phone .reader .tb-bottom .rbn-page-edit-container{\r\n    margin: 0;\r\n}\r\n.app-reader.phone .reader .main-view .side-panel {\r\n    position: absolute;\r\n    width: 0;\r\n    height: calc(100% - 160px);\r\n}\r\n.app-reader.phone.show-panel .reader .main-view .side-panel {\r\n    position: absolute;\r\n    width: 100%;\r\n    z-index: 32;\r\n}\r\n\r\n/*\r\n * BOOKMARKS\r\n */\r\n.rbn-bookmarks-close{\r\n    width: 42px;\r\n    height: 42px;\r\n    background-image: url(" + __webpack_require__(110) + ");\r\n    background-repeat: no-repeat;\r\n    background-size: 16px;\r\n    background-position: center;\r\n    position: absolute;\r\n    right: 0px;\r\n    top: 0px;\r\n    cursor: pointer;\r\n}\r\n.rbn-bookmarks-close:hover{\r\n    background-image: url(" + __webpack_require__(111) + ");\r\n}\r\n.rbn-bookmarks-view{\r\n    color:#0E1C2C;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    font-size: 16px;\r\n    line-height: 22px;\r\n    padding: 6px;\r\n    height: 100%;\r\n    -webkit-overflow-scrolling: touch;\r\n    position: relative;\r\n}\r\n    .rbn-bookmarks-view li{\r\n        margin: 16px 0;\r\n        cursor: pointer;\r\n    }\r\n        .rbn-bookmarks-view li.bm-collapsable > span.bm-icon{\r\n            cursor: pointer;\r\n            display: inline-block;\r\n            width: 20px;\r\n            text-align: center;\r\n            margin-right: 8px;\r\n            background-repeat: no-repeat;\r\n            background-size: 10px;\r\n            background-position: center;\r\n            height: 12px;\r\n            background-image: url(" + __webpack_require__(112) + ");\r\n        }\r\n        .rbn-bookmarks-view li.bm-collapsable > span.bm-title:hover{\r\n            color:#1B73AD;\r\n        }\r\n        .rbn-bookmarks-view li.bm-collapsable > span.bm-icon:hover{\r\n            background-image: url(" + __webpack_require__(113) + ");\r\n        }\r\n        .rbn-bookmarks-view li.bm-collapsable.bm-closed > span.bm-icon{\r\n            background-image: url(" + __webpack_require__(114) + ");\r\n            background-size: 6px 10px;\r\n        }\r\n        .rbn-bookmarks-view li.bm-collapsable.bm-closed > span.bm-icon:hover{\r\n            background-image: url(" + __webpack_require__(115) + ");\r\n        }\r\n        .rbn-bookmarks-view li.bm-collapsable.bm-closed > ul{\r\n            display:none;\r\n        }\r\n        .rbn-bookmarks-view li.bm-not-collapsable > span.bm-icon{\r\n            display: inline-block;\r\n            width: 20px;\r\n            text-align: center;\r\n            margin-right: 8px;\r\n            background-repeat: no-repeat;\r\n            background-size: 6px;\r\n            background-image: url(" + __webpack_require__(116) + ");\r\n            background-position: center;\r\n            height: 12px;\r\n        }\r\n        .rbn-bookmarks-view li.bm-not-collapsable > span.bm-title:hover{\r\n            color:#1B73AD;\r\n        }\r\n        .rbn-bookmarks-view ul{\r\n            list-style-type:none;\r\n            margin: 18px;\r\n        }\r\n\r\n/**\r\n * MODAL\r\n */\r\n .rbn-modal-dialog {\r\n    position: fixed;\r\n    top: 50%;\r\n    left: 50%;\r\n    width: 70%;\r\n    max-width: 840px;\r\n    min-width: 420px;\r\n    height: auto;\r\n    z-index: 2000;\r\n    visibility: hidden;\r\n    transform: translateX(-50%) translateY(-50%);\r\n\r\n}\r\n\r\n\r\n.rbn-modal-show > .rbn-modal-dialog{\r\n    visibility: visible;\r\n}\r\n\r\n.rbn-modal-overlay {\r\n    position: fixed;\r\n    width: 100%;\r\n    height: 100%;\r\n    visibility: hidden;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 600;\r\n    opacity: 0;\r\n    background: rgba(0,0,0,.5);\r\n    transition: all 0.3s;\r\n}\r\n\r\n.rbn-modal-show > .rbn-modal-overlay {\r\n    opacity: 1;\r\n    visibility: visible;\r\n}\r\n\r\n/* Modal Content styles */\r\n.rbn-modal-content {\r\n\tcolor: #000;\r\n\tbackground: #fff;\r\n\tposition: relative;\r\n\tborder-radius: 3px;\r\n\tmargin: 0 auto;\r\n}\r\n\r\n.rbn-modal-content h3 {\r\n\tmargin: 0;\r\n\tpadding: 0.5em 1em;\r\n\ttext-align: left;\r\n\tfont-size: 1.2em;\r\n\tfont-weight: 700;\r\n\topacity: 0.8;\r\n\tbackground: rgba(0,0,0,0.1);\r\n\tborder-radius: 3px 3px 0 0;\r\n}\r\n\r\n.rbn-modal-content > .rbn-modal-body{\r\n    padding: 0.5em 1em;\r\n}\r\n\r\n.rbn-modal-print-password .rbn-modal-dialog{\r\n    max-width: 460px;\r\n    min-width: 310px;\r\n}\r\n\r\n    .rbn-modal-print-password .rbn-modal-dialog .rbn-modal-content{\r\n        background-color: #333f4b;\r\n        color:#fff;\r\n        padding: 6px;\r\n    }\r\n\r\n        .rbn-modal-print-password .rbn-modal-dialog .rbn-modal-title{\r\n            line-height: 46px;\r\n            font-weight: 600;\r\n            font-size: 1.1em;          \r\n        }\r\n        .rbn-modal-print-password .rbn-modal-dialog .rbn-modal-content .rbn-code{\r\n            border-top: 1px solid #ccc;\r\n            text-align: center;\r\n            font-size: 3em;\r\n            line-height: 200px;\r\n        }\r\n\r\n        .rbn-modal-print-password .rbn-modal-dialog .rbn-modal-content .rbn-action{\r\n            text-align: right;\r\n        }\r\n\r\n        .rbn-modal-print-password .rbn-modal-dialog .rbn-modal-content .rbn-next,\r\n        .rbn-modal-print-password .rbn-modal-dialog .rbn-modal-content .rbn-copy-code{\r\n            height: 36px;\r\n            background-repeat: no-repeat;\r\n            background-position: 6px center;\r\n            line-height: 32px;\r\n            background-size: 16px;\r\n            cursor: pointer;\r\n            color: #fff;\r\n            background-color: transparent;\r\n            border: 2px solid #fff;\r\n            border-radius: 6px;\r\n            padding: 0 8px 0 8px;\r\n            display: inline-block;\r\n            font-weight: 700;\r\n            user-select: none;\r\n            margin-left:6px;\r\n        }\r\n         \r\n        .rbn-modal-print-password .rbn-modal-dialog .rbn-modal-content .rbn-next:hover,\r\n        .rbn-modal-print-password .rbn-modal-dialog .rbn-modal-content .rbn-copy-code:hover{\r\n            background-color: #5394EB;\r\n            border: 2px solid #5394EB;\r\n        }\r\n\r\n         \r\n        .rbn-modal-print-password .rbn-modal-dialog .rbn-modal-content .rbn-next.rbn-disable,\r\n        .rbn-modal-print-password .rbn-modal-dialog .rbn-modal-content .rbn-copy-code.rbn-disable{\r\n            opacity:.5;\r\n        }\r\n\r\n        .rbn-modal-print-password .rbn-modal-dialog .rbn-modal-content .rbn-next.rbn-disable:hover,\r\n        .rbn-modal-print-password .rbn-modal-dialog .rbn-modal-content .rbn-copy-code.rbn-disable:hover{\r\n            background-color: transparent;\r\n            border: 2px solid #fff;\r\n            cursor: initial;\r\n        }\r\n\r\n/* Effect 1: Fade in and scale up */\r\n.rbn-modal-effect-fade-in-scale .rbn-modal-content {\r\n\t-webkit-transform: scale(0.7);\r\n\t-moz-transform: scale(0.7);\r\n\t-ms-transform: scale(0.7);\r\n\ttransform: scale(0.7);\r\n\topacity: 0;\r\n\t-webkit-transition: all 0.3s;\r\n\t-moz-transition: all 0.3s;\r\n\ttransition: all 0.3s;\r\n}\r\n\r\n.rbn-modal-show .rbn-modal-effect-fade-in-scale .rbn-modal-content {\r\n\t-webkit-transform: scale(1);\r\n\t-moz-transform: scale(1);\r\n\t-ms-transform: scale(1);\r\n\ttransform: scale(1);\r\n\topacity: 1;\r\n}\r\n\r\n/* Effect 2: Slide from the right */\r\n.rbn-modal-effect-slide-in-right .rbn-modal-content {\r\n\t-webkit-transform: translateX(20%);\r\n\t-moz-transform: translateX(20%);\r\n\t-ms-transform: translateX(20%);\r\n\ttransform: translateX(20%);\r\n\topacity: 0;\r\n\t-webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);\r\n\t-moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);\r\n\ttransition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);\r\n}\r\n\r\n.rbn-modal-show .rbn-modal-effect-slide-in-right .rbn-modal-content {\r\n\t-webkit-transform: translateX(0);\r\n\t-moz-transform: translateX(0);\r\n\t-ms-transform: translateX(0);\r\n\ttransform: translateX(0);\r\n\topacity: 1;\r\n}\r\n\r\n/* Effect 3: Slide from the bottom */\r\n.rbn-modal-effect-slide-in-bottom .rbn-modal-content {\r\n\t-webkit-transform: translateY(20%);\r\n\t-moz-transform: translateY(20%);\r\n\t-ms-transform: translateY(20%);\r\n\ttransform: translateY(20%);\r\n\topacity: 0;\r\n\t-webkit-transition: all 0.3s;\r\n\t-moz-transition: all 0.3s;\r\n\ttransition: all 0.3s;\r\n}\r\n\r\n.rbn-modal-show .rbn-modal-effect-slide-in-bottom .rbn-modal-content {\r\n\t-webkit-transform: translateY(0);\r\n\t-moz-transform: translateY(0);\r\n\t-ms-transform: translateY(0);\r\n\ttransform: translateY(0);\r\n\topacity: 1;\r\n}\r\n\r\n/* effect 4 : only opacity */\r\n.rbn-modal-effect-fade-in > .rbn-modal-content {\r\n\topacity: 0;\r\n\t-webkit-transition: all 0.3s;\r\n\t-moz-transition: all 0.3s;\r\n\ttransition: all 0.3s;\r\n}\r\n\r\n.rbn-modal-show > .rbn-modal-dialog.rbn-modal-effect-fade-in > .rbn-modal-content {\r\n\topacity: 1;\r\n}", ""]);

// exports


/***/ }),
/* 78 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M19 27C23.4183 27 27 23.4183 27 19C27 14.5817 23.4183 11 19 11C14.5817 11 11 14.5817 11 19C11 23.4183 14.5817 27 19 27Z' stroke='%230E1C2C' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M29 28.9999L24.65 24.6499' stroke='%230E1C2C' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%230E1C2C' stroke-width='2' /%3E %3C/svg%3E\""

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M19 27C23.4183 27 27 23.4183 27 19C27 14.5817 23.4183 11 19 11C14.5817 11 11 14.5817 11 19C11 23.4183 14.5817 27 19 27Z' stroke='%231B73AD' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M29 28.9999L24.65 24.6499' stroke='%231B73AD' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%231B73AD' stroke-width='2' /%3E %3C/svg%3E\""

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%23014571' stroke-width='2' fill='%23014571'/%3E %3Cpath d='M19 27C23.4183 27 27 23.4183 27 19C27 14.5817 23.4183 11 19 11C14.5817 11 11 14.5817 11 19C11 23.4183 14.5817 27 19 27Z' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M29 28.9999L24.65 24.6499' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E\""

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%231B73AD' stroke-width='2' fill='%231B73AD'/%3E %3Cpath d='M19 27C23.4183 27 27 23.4183 27 19C27 14.5817 23.4183 11 19 11C14.5817 11 11 14.5817 11 19C11 23.4183 14.5817 27 19 27Z' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M29 28.9999L24.65 24.6499' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E\""

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M14 17V10H26V17' stroke='%230E1C2C' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M14 26H12C11.4696 26 10.9609 25.7893 10.5858 25.4142C10.2107 25.0391 10 24.5304 10 24V19C10 18.4696 10.2107 17.9609 10.5858 17.5858C10.9609 17.2107 11.4696 17 12 17H28C28.5304 17 29.0391 17.2107 29.4142 17.5858C29.7893 17.9609 30 18.4696 30 19V24C30 24.5304 29.7893 25.0391 29.4142 25.4142C29.0391 25.7893 28.5304 26 28 26H26' stroke='%230E1C2C' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M26 22H14V30H26V22Z' stroke='%230E1C2C' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%230E1C2C' stroke-width='2' /%3E %3C/svg%3E\""

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M14 17V10H26V17' stroke='%231B73AD' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M14 26H12C11.4696 26 10.9609 25.7893 10.5858 25.4142C10.2107 25.0391 10 24.5304 10 24V19C10 18.4696 10.2107 17.9609 10.5858 17.5858C10.9609 17.2107 11.4696 17 12 17H28C28.5304 17 29.0391 17.2107 29.4142 17.5858C29.7893 17.9609 30 18.4696 30 19V24C30 24.5304 29.7893 25.0391 29.4142 25.4142C29.0391 25.7893 28.5304 26 28 26H26' stroke='%231B73AD' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M26 22H14V30H26V22Z' stroke='%231B73AD' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%231B73AD' stroke-width='2' /%3E %3C/svg%3E\""

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%23004471' fill='%23004471' stroke-width='2' /%3E %3Cpath d='M14 17V10H26V17' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M14 26H12C11.4696 26 10.9609 25.7893 10.5858 25.4142C10.2107 25.0391 10 24.5304 10 24V19C10 18.4696 10.2107 17.9609 10.5858 17.5858C10.9609 17.2107 11.4696 17 12 17H28C28.5304 17 29.0391 17.2107 29.4142 17.5858C29.7893 17.9609 30 18.4696 30 19V24C30 24.5304 29.7893 25.0391 29.4142 25.4142C29.0391 25.7893 28.5304 26 28 26H26' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M26 22H14V30H26V22Z' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E\""

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%231B73AD' fill='%231B73AD' stroke-width='2' /%3E %3Cpath d='M14 17V10H26V17' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M14 26H12C11.4696 26 10.9609 25.7893 10.5858 25.4142C10.2107 25.0391 10 24.5304 10 24V19C10 18.4696 10.2107 17.9609 10.5858 17.5858C10.9609 17.2107 11.4696 17 12 17H28C28.5304 17 29.0391 17.2107 29.4142 17.5858C29.7893 17.9609 30 18.4696 30 19V24C30 24.5304 29.7893 25.0391 29.4142 25.4142C29.0391 25.7893 28.5304 26 28 26H26' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M26 22H14V30H26V22Z' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E\""

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%230E1C2C' stroke-width='2'/%3E %3Cpath d='M10.28 20C10.28 17.948 11.948 16.28 14 16.28H18.8V14H14C10.688 14 8 16.688 8 20C8 23.312 10.688 26 14 26H18.8V23.72H14C11.948 23.72 10.28 22.052 10.28 20ZM15.2 21.2H24.8V18.8H15.2V21.2ZM26 14H21.2V16.28H26C28.052 16.28 29.72 17.948 29.72 20C29.72 22.052 28.052 23.72 26 23.72H21.2V26H26C29.312 26 32 23.312 32 20C32 16.688 29.312 14 26 14Z' fill='%230E1C2C'/%3E %3C/svg%3E\""

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%231B73AD' stroke-width='2'/%3E %3Cpath d='M10.28 20C10.28 17.948 11.948 16.28 14 16.28H18.8V14H14C10.688 14 8 16.688 8 20C8 23.312 10.688 26 14 26H18.8V23.72H14C11.948 23.72 10.28 22.052 10.28 20ZM15.2 21.2H24.8V18.8H15.2V21.2ZM26 14H21.2V16.28H26C28.052 16.28 29.72 17.948 29.72 20C29.72 22.052 28.052 23.72 26 23.72H21.2V26H26C29.312 26 32 23.312 32 20C32 16.688 29.312 14 26 14Z' fill='%231B73AD'/%3E %3C/svg%3E\""

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%23004471' stroke-width='2' fill='%23004471'/%3E %3Cpath d='M10.28 20C10.28 17.948 11.948 16.28 14 16.28H18.8V14H14C10.688 14 8 16.688 8 20C8 23.312 10.688 26 14 26H18.8V23.72H14C11.948 23.72 10.28 22.052 10.28 20ZM15.2 21.2H24.8V18.8H15.2V21.2ZM26 14H21.2V16.28H26C28.052 16.28 29.72 17.948 29.72 20C29.72 22.052 28.052 23.72 26 23.72H21.2V26H26C29.312 26 32 23.312 32 20C32 16.688 29.312 14 26 14Z' fill='%23fff'/%3E %3C/svg%3E\""

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%231B73AD' stroke-width='2' fill='%231B73AD'/%3E %3Cpath d='M10.28 20C10.28 17.948 11.948 16.28 14 16.28H18.8V14H14C10.688 14 8 16.688 8 20C8 23.312 10.688 26 14 26H18.8V23.72H14C11.948 23.72 10.28 22.052 10.28 20ZM15.2 21.2H24.8V18.8H15.2V21.2ZM26 14H21.2V16.28H26C28.052 16.28 29.72 17.948 29.72 20C29.72 22.052 28.052 23.72 26 23.72H21.2V26H26C29.312 26 32 23.312 32 20C32 16.688 29.312 14 26 14Z' fill='%23fff'/%3E %3C/svg%3E\""

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M10 9.3H30C30.3866 9.3 30.7 9.6134 30.7 10V30C30.7 30.3866 30.3866 30.7 30 30.7H10C9.6134 30.7 9.3 30.3866 9.3 30V10C9.3 9.6134 9.6134 9.3 10 9.3Z' fill='white' stroke='white' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M13 11.3H21C21.3866 11.3 21.7 11.6134 21.7 12V22C21.7 22.3866 21.3866 22.7 21 22.7H13C12.6134 22.7 12.3 22.3866 12.3 22V12C12.3 11.6134 12.6134 11.3 13 11.3Z' stroke='%230E1C2C' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M25 14H17C15.8954 14 15 14.8954 15 16V26C15 27.1046 15.8954 28 17 28H25C26.1046 28 27 27.1046 27 26V16C27 14.8954 26.1046 14 25 14Z' fill='white' /%3E %3Cpath d='M19 17.3H27C27.3866 17.3 27.7 17.6134 27.7 18V28C27.7 28.3866 27.3866 28.7 27 28.7H19C18.6134 28.7 18.3 28.3866 18.3 28V18C18.3 17.6134 18.6134 17.3 19 17.3Z' stroke='%230E1C2C' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' /%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%230E1C2C' stroke-width='2' /%3E %3C/svg%3E\""

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M10 9.3H30C30.3866 9.3 30.7 9.6134 30.7 10V30C30.7 30.3866 30.3866 30.7 30 30.7H10C9.6134 30.7 9.3 30.3866 9.3 30V10C9.3 9.6134 9.6134 9.3 10 9.3Z' fill='white' stroke='white' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M13 11.3H21C21.3866 11.3 21.7 11.6134 21.7 12V22C21.7 22.3866 21.3866 22.7 21 22.7H13C12.6134 22.7 12.3 22.3866 12.3 22V12C12.3 11.6134 12.6134 11.3 13 11.3Z' stroke='%231B73AD' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M25 14H17C15.8954 14 15 14.8954 15 16V26C15 27.1046 15.8954 28 17 28H25C26.1046 28 27 27.1046 27 26V16C27 14.8954 26.1046 14 25 14Z' fill='white' /%3E %3Cpath d='M19 17.3H27C27.3866 17.3 27.7 17.6134 27.7 18V28C27.7 28.3866 27.3866 28.7 27 28.7H19C18.6134 28.7 18.3 28.3866 18.3 28V18C18.3 17.6134 18.6134 17.3 19 17.3Z' stroke='%231B73AD' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' /%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%231B73AD' stroke-width='2' /%3E %3C/svg%3E\""

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%23004471' stroke-width='2' fill='%23004471'/%3E %3Cpath d='M10 9.3H30C30.3866 9.3 30.7 9.6134 30.7 10V30C30.7 30.3866 30.3866 30.7 30 30.7H10C9.6134 30.7 9.3 30.3866 9.3 30V10C9.3 9.6134 9.6134 9.3 10 9.3Z' fill='%23004471' stroke='%23004471' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M13 11.3H21C21.3866 11.3 21.7 11.6134 21.7 12V22C21.7 22.3866 21.3866 22.7 21 22.7H13C12.6134 22.7 12.3 22.3866 12.3 22V12C12.3 11.6134 12.6134 11.3 13 11.3Z' stroke='%23fff' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M25 14H17C15.8954 14 15 14.8954 15 16V26C15 27.1046 15.8954 28 17 28H25C26.1046 28 27 27.1046 27 26V16C27 14.8954 26.1046 14 25 14Z' fill='%23004471' /%3E %3Cpath d='M19 17.3H27C27.3866 17.3 27.7 17.6134 27.7 18V28C27.7 28.3866 27.3866 28.7 27 28.7H19C18.6134 28.7 18.3 28.3866 18.3 28V18C18.3 17.6134 18.6134 17.3 19 17.3Z' stroke='%23fff' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E\""

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%231B73AD' stroke-width='2' fill='%231B73AD'/%3E %3Cpath d='M10 9.3H30C30.3866 9.3 30.7 9.6134 30.7 10V30C30.7 30.3866 30.3866 30.7 30 30.7H10C9.6134 30.7 9.3 30.3866 9.3 30V10C9.3 9.6134 9.6134 9.3 10 9.3Z' fill='%231B73AD' stroke='%231B73AD' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M13 11.3H21C21.3866 11.3 21.7 11.6134 21.7 12V22C21.7 22.3866 21.3866 22.7 21 22.7H13C12.6134 22.7 12.3 22.3866 12.3 22V12C12.3 11.6134 12.6134 11.3 13 11.3Z' stroke='%23fff' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M25 14H17C15.8954 14 15 14.8954 15 16V26C15 27.1046 15.8954 28 17 28H25C26.1046 28 27 27.1046 27 26V16C27 14.8954 26.1046 14 25 14Z' fill='%231B73AD' /%3E %3Cpath d='M19 17.3H27C27.3866 17.3 27.7 17.6134 27.7 18V28C27.7 28.3866 27.3866 28.7 27 28.7H19C18.6134 28.7 18.3 28.3866 18.3 28V18C18.3 17.6134 18.6134 17.3 19 17.3Z' stroke='%23fff' stroke-width='2.6' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E\""

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%23fff' d='M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z'/%3E%3C/svg%3E\""

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%230E1C2C' stroke-width='2' fill='%230E1C2C'/%3E %3Cpath d='M19 27C23.4183 27 27 23.4183 27 19C27 14.5817 23.4183 11 19 11C14.5817 11 11 14.5817 11 19C11 23.4183 14.5817 27 19 27Z' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M29 28.9999L24.65 24.6499' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E\""

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='1' y='1' width='38' height='38' rx='7' stroke='%231B73AD' stroke-width='2' fill='%231B73AD'/%3E %3Cpath d='M19 27C23.4183 27 27 23.4183 27 19C27 14.5817 23.4183 11 19 11C14.5817 11 11 14.5817 11 19C11 23.4183 14.5817 27 19 27Z' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M29 28.9999L24.65 24.6499' stroke='%23fff' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E\""

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%230E1C2C' d='M6 12c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zm9 0c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zm9 0c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3z'/%3E%3C/svg%3E\""

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%231B73AD' d='M6 12c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zm9 0c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3zm9 0c0 1.657-1.343 3-3 3s-3-1.343-3-3 1.343-3 3-3 3 1.343 3 3z'/%3E%3C/svg%3E\""

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%230E1C2C' d='M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z'/%3E%3C/svg%3E\""

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%231B73AD' d='M16.67 0l2.83 2.829-9.339 9.175 9.339 9.167-2.83 2.829-12.17-11.996z'/%3E%3C/svg%3E\""

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M12 24L20 16L12 8' stroke='white' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E\""

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M20 24L12 16L20 8' stroke='white' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E\""

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M16 7.70361V24.2962' stroke='white' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M7.7037 16H24.2963' stroke='white' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round'/%3E %3C/svg%3E\""

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M7.7037 16H24.2963' stroke='white' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E\""

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Crect x='5' y='5' width='2.7' height='8' rx='1.35' fill='white'/%3E %3Crect x='5' y='5' width='8' height='2.7' rx='1.35' fill='white'/%3E %3Crect x='24.3' y='5' width='2.7' height='8' rx='1.35' fill='white'/%3E %3Crect x='19' y='5' width='8' height='2.7' rx='1.35' fill='white'/%3E %3Crect x='5' y='19' width='2.7' height='8' rx='1.35' fill='white'/%3E %3Crect x='5' y='24.3008' width='8' height='2.7' rx='1.35' fill='white'/%3E %3Crect x='24.3' y='19' width='2.7' height='8' rx='1.35' fill='white'/%3E %3Crect x='19' y='24.3008' width='8' height='2.7' rx='1.35' fill='white'/%3E %3C/svg%3E\""

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='24' height='21' viewBox='0 0 24 21' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M13.4506 5.53857H11.8682V11.8682L17.4066 15.1913L18.1978 13.8937L13.4506 11.077V5.53857Z' fill='white' /%3E %3Cpath d='M13.7143 0C8.03429 0 3.42858 4.60571 3.42858 10.2857H4.0243e-06L4.57143 14.8571L9.14286 10.2857H5.71429C5.71429 5.86286 9.29143 2.28571 13.7143 2.28571C18.1371 2.28571 21.7143 5.86286 21.7143 10.2857C21.7143 14.7086 18.1371 18.2857 13.7143 18.2857C11.9886 18.2857 10.3886 17.7257 9.07429 16.8L7.45143 18.4457C9.18857 19.7714 11.36 20.5714 13.7143 20.5714C19.3943 20.5714 24 15.9657 24 10.2857C24 4.60571 19.3943 0 13.7143 0Z' fill='white' /%3E %3C/svg%3E\""

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cmask id='path-1-inside-1_767_16069' fill='white'%3E %3Crect x='17' y='3' width='10' height='12' rx='2' /%3E %3C/mask%3E %3Crect x='17' y='3' width='10' height='12' rx='2' stroke='white' stroke-width='5.2' mask='url(%23path-1-inside-1_767_16069)' /%3E %3Cmask id='path-2-inside-2_767_16069' fill='white'%3E %3Crect x='5' y='3' width='10' height='12' rx='2' /%3E %3C/mask%3E %3Crect x='5' y='3' width='10' height='12' rx='2' stroke='white' stroke-width='5.2' mask='url(%23path-2-inside-2_767_16069)' /%3E %3Cmask id='path-3-inside-3_767_16069' fill='white'%3E %3Crect x='5' y='17' width='10' height='12' rx='2' /%3E %3C/mask%3E %3Crect x='5' y='17' width='10' height='12' rx='2' stroke='white' stroke-width='5.2' mask='url(%23path-3-inside-3_767_16069)' /%3E %3Cmask id='path-4-inside-4_767_16069' fill='white'%3E %3Crect x='17' y='17' width='10' height='12' rx='2' /%3E %3C/mask%3E %3Crect x='17' y='17' width='10' height='12' rx='2' stroke='white' stroke-width='5.2' mask='url(%23path-4-inside-4_767_16069)' /%3E %3C/svg%3E\""

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M9.75 12H19.5' stroke='%23FFF' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M9.75 5.25H19.5' stroke='%23FFF' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Cpath d='M9.75 18.75H19.5' stroke='%23FFF' stroke-width='2.66667' stroke-linecap='round' stroke-linejoin='round' /%3E %3Ccircle cx='5.625' cy='5.25' r='1.125' fill='%23FFF' /%3E %3Ccircle cx='5.625' cy='12' r='1.125' fill='%23FFF' /%3E %3Ccircle cx='5.625' cy='18.75' r='1.125' fill='%23FFF' /%3E %3C/svg%3E\""

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%230E1C2C' d='M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z'/%3E%3C/svg%3E\""

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24'%3E%3Cpath fill='%231B73AD' d='M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z'/%3E%3C/svg%3E\""

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M10 0L5 6L0 0L10 0Z' fill='%230E1C2C' /%3E %3C/svg%3E\""

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M10 0L5 6L0 0L10 0Z' fill='%231B73AD' /%3E %3C/svg%3E\""

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M0 7.15493e-08L6 5L1.19249e-07 10L0 7.15493e-08Z' fill='%230E1C2C' /%3E %3C/svg%3E\""

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='6' height='10' viewBox='0 0 6 10' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M0 7.15493e-08L6 5L1.19249e-07 10L0 7.15493e-08Z' fill='%231B73AD' /%3E %3C/svg%3E\""

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = "\"data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Ccircle cx='3' cy='3' r='3' fill='%230E1C2C' /%3E %3C/svg%3E\""

/***/ }),
/* 117 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app-bundle.js